import { c as commonjsGlobal } from "./_commonjsHelpers-Dn0DSpot.js";
var indexMinimal = {}, minimal$1 = {}, aspromise = asPromise;
function asPromise(c, o) {
  for (var i = new Array(arguments.length - 1), e = 0, t = 2, n = !0; t < arguments.length; )
    i[e++] = arguments[t++];
  return new Promise(function(u, l) {
    i[e] = function(a) {
      if (n)
        if (n = !1, a)
          l(a);
        else {
          for (var d = new Array(arguments.length - 1), p = 0; p < d.length; )
            d[p++] = arguments[p];
          u.apply(null, d);
        }
    };
    try {
      c.apply(o || null, i);
    } catch (f) {
      n && (n = !1, l(f));
    }
  });
}
var base64$1 = {};
(function(c) {
  var o = c;
  o.length = function(u) {
    var l = u.length;
    if (!l)
      return 0;
    for (var f = 0; --l % 4 > 1 && u.charAt(l) === "="; )
      ++f;
    return Math.ceil(u.length * 3) / 4 - f;
  };
  for (var i = new Array(64), e = new Array(123), t = 0; t < 64; )
    e[i[t] = t < 26 ? t + 65 : t < 52 ? t + 71 : t < 62 ? t - 4 : t - 59 | 43] = t++;
  o.encode = function(u, l, f) {
    for (var a = null, d = [], p = 0, y = 0, s; l < f; ) {
      var h = u[l++];
      switch (y) {
        case 0:
          d[p++] = i[h >> 2], s = (h & 3) << 4, y = 1;
          break;
        case 1:
          d[p++] = i[s | h >> 4], s = (h & 15) << 2, y = 2;
          break;
        case 2:
          d[p++] = i[s | h >> 6], d[p++] = i[h & 63], y = 0;
          break;
      }
      p > 8191 && ((a || (a = [])).push(String.fromCharCode.apply(String, d)), p = 0);
    }
    return y && (d[p++] = i[s], d[p++] = 61, y === 1 && (d[p++] = 61)), a ? (p && a.push(String.fromCharCode.apply(String, d.slice(0, p))), a.join("")) : String.fromCharCode.apply(String, d.slice(0, p));
  };
  var n = "invalid encoding";
  o.decode = function(u, l, f) {
    for (var a = f, d = 0, p, y = 0; y < u.length; ) {
      var s = u.charCodeAt(y++);
      if (s === 61 && d > 1)
        break;
      if ((s = e[s]) === void 0)
        throw Error(n);
      switch (d) {
        case 0:
          p = s, d = 1;
          break;
        case 1:
          l[f++] = p << 2 | (s & 48) >> 4, p = s, d = 2;
          break;
        case 2:
          l[f++] = (p & 15) << 4 | (s & 60) >> 2, p = s, d = 3;
          break;
        case 3:
          l[f++] = (p & 3) << 6 | s, d = 0;
          break;
      }
    }
    if (d === 1)
      throw Error(n);
    return f - a;
  }, o.test = function(u) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(u);
  };
})(base64$1);
var eventemitter = EventEmitter;
function EventEmitter() {
  this._listeners = {};
}
EventEmitter.prototype.on = function(o, i, e) {
  return (this._listeners[o] || (this._listeners[o] = [])).push({
    fn: i,
    ctx: e || this
  }), this;
};
EventEmitter.prototype.off = function(o, i) {
  if (o === void 0)
    this._listeners = {};
  else if (i === void 0)
    this._listeners[o] = [];
  else
    for (var e = this._listeners[o], t = 0; t < e.length; )
      e[t].fn === i ? e.splice(t, 1) : ++t;
  return this;
};
EventEmitter.prototype.emit = function(o) {
  var i = this._listeners[o];
  if (i) {
    for (var e = [], t = 1; t < arguments.length; )
      e.push(arguments[t++]);
    for (t = 0; t < i.length; )
      i[t].fn.apply(i[t++].ctx, e);
  }
  return this;
};
var float = factory(factory);
function factory(c) {
  return typeof Float32Array < "u" ? function() {
    var o = new Float32Array([-0]), i = new Uint8Array(o.buffer), e = i[3] === 128;
    function t(l, f, a) {
      o[0] = l, f[a] = i[0], f[a + 1] = i[1], f[a + 2] = i[2], f[a + 3] = i[3];
    }
    function n(l, f, a) {
      o[0] = l, f[a] = i[3], f[a + 1] = i[2], f[a + 2] = i[1], f[a + 3] = i[0];
    }
    c.writeFloatLE = e ? t : n, c.writeFloatBE = e ? n : t;
    function r(l, f) {
      return i[0] = l[f], i[1] = l[f + 1], i[2] = l[f + 2], i[3] = l[f + 3], o[0];
    }
    function u(l, f) {
      return i[3] = l[f], i[2] = l[f + 1], i[1] = l[f + 2], i[0] = l[f + 3], o[0];
    }
    c.readFloatLE = e ? r : u, c.readFloatBE = e ? u : r;
  }() : function() {
    function o(e, t, n, r) {
      var u = t < 0 ? 1 : 0;
      if (u && (t = -t), t === 0)
        e(1 / t > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), n, r);
      else if (isNaN(t))
        e(2143289344, n, r);
      else if (t > 34028234663852886e22)
        e((u << 31 | 2139095040) >>> 0, n, r);
      else if (t < 11754943508222875e-54)
        e((u << 31 | Math.round(t / 1401298464324817e-60)) >>> 0, n, r);
      else {
        var l = Math.floor(Math.log(t) / Math.LN2), f = Math.round(t * Math.pow(2, -l) * 8388608) & 8388607;
        e((u << 31 | l + 127 << 23 | f) >>> 0, n, r);
      }
    }
    c.writeFloatLE = o.bind(null, writeUintLE), c.writeFloatBE = o.bind(null, writeUintBE);
    function i(e, t, n) {
      var r = e(t, n), u = (r >> 31) * 2 + 1, l = r >>> 23 & 255, f = r & 8388607;
      return l === 255 ? f ? NaN : u * (1 / 0) : l === 0 ? u * 1401298464324817e-60 * f : u * Math.pow(2, l - 150) * (f + 8388608);
    }
    c.readFloatLE = i.bind(null, readUintLE), c.readFloatBE = i.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var o = new Float64Array([-0]), i = new Uint8Array(o.buffer), e = i[7] === 128;
    function t(l, f, a) {
      o[0] = l, f[a] = i[0], f[a + 1] = i[1], f[a + 2] = i[2], f[a + 3] = i[3], f[a + 4] = i[4], f[a + 5] = i[5], f[a + 6] = i[6], f[a + 7] = i[7];
    }
    function n(l, f, a) {
      o[0] = l, f[a] = i[7], f[a + 1] = i[6], f[a + 2] = i[5], f[a + 3] = i[4], f[a + 4] = i[3], f[a + 5] = i[2], f[a + 6] = i[1], f[a + 7] = i[0];
    }
    c.writeDoubleLE = e ? t : n, c.writeDoubleBE = e ? n : t;
    function r(l, f) {
      return i[0] = l[f], i[1] = l[f + 1], i[2] = l[f + 2], i[3] = l[f + 3], i[4] = l[f + 4], i[5] = l[f + 5], i[6] = l[f + 6], i[7] = l[f + 7], o[0];
    }
    function u(l, f) {
      return i[7] = l[f], i[6] = l[f + 1], i[5] = l[f + 2], i[4] = l[f + 3], i[3] = l[f + 4], i[2] = l[f + 5], i[1] = l[f + 6], i[0] = l[f + 7], o[0];
    }
    c.readDoubleLE = e ? r : u, c.readDoubleBE = e ? u : r;
  }() : function() {
    function o(e, t, n, r, u, l) {
      var f = r < 0 ? 1 : 0;
      if (f && (r = -r), r === 0)
        e(0, u, l + t), e(1 / r > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), u, l + n);
      else if (isNaN(r))
        e(0, u, l + t), e(2146959360, u, l + n);
      else if (r > 17976931348623157e292)
        e(0, u, l + t), e((f << 31 | 2146435072) >>> 0, u, l + n);
      else {
        var a;
        if (r < 22250738585072014e-324)
          a = r / 5e-324, e(a >>> 0, u, l + t), e((f << 31 | a / 4294967296) >>> 0, u, l + n);
        else {
          var d = Math.floor(Math.log(r) / Math.LN2);
          d === 1024 && (d = 1023), a = r * Math.pow(2, -d), e(a * 4503599627370496 >>> 0, u, l + t), e((f << 31 | d + 1023 << 20 | a * 1048576 & 1048575) >>> 0, u, l + n);
        }
      }
    }
    c.writeDoubleLE = o.bind(null, writeUintLE, 0, 4), c.writeDoubleBE = o.bind(null, writeUintBE, 4, 0);
    function i(e, t, n, r, u) {
      var l = e(r, u + t), f = e(r, u + n), a = (f >> 31) * 2 + 1, d = f >>> 20 & 2047, p = 4294967296 * (f & 1048575) + l;
      return d === 2047 ? p ? NaN : a * (1 / 0) : d === 0 ? a * 5e-324 * p : a * Math.pow(2, d - 1075) * (p + 4503599627370496);
    }
    c.readDoubleLE = i.bind(null, readUintLE, 0, 4), c.readDoubleBE = i.bind(null, readUintBE, 4, 0);
  }(), c;
}
function writeUintLE(c, o, i) {
  o[i] = c & 255, o[i + 1] = c >>> 8 & 255, o[i + 2] = c >>> 16 & 255, o[i + 3] = c >>> 24;
}
function writeUintBE(c, o, i) {
  o[i] = c >>> 24, o[i + 1] = c >>> 16 & 255, o[i + 2] = c >>> 8 & 255, o[i + 3] = c & 255;
}
function readUintLE(c, o) {
  return (c[o] | c[o + 1] << 8 | c[o + 2] << 16 | c[o + 3] << 24) >>> 0;
}
function readUintBE(c, o) {
  return (c[o] << 24 | c[o + 1] << 16 | c[o + 2] << 8 | c[o + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (c) {
  }
  return null;
}
var utf8$2 = {};
(function(c) {
  var o = c;
  o.length = function(e) {
    for (var t = 0, n = 0, r = 0; r < e.length; ++r)
      n = e.charCodeAt(r), n < 128 ? t += 1 : n < 2048 ? t += 2 : (n & 64512) === 55296 && (e.charCodeAt(r + 1) & 64512) === 56320 ? (++r, t += 4) : t += 3;
    return t;
  }, o.read = function(e, t, n) {
    var r = n - t;
    if (r < 1)
      return "";
    for (var u = null, l = [], f = 0, a; t < n; )
      a = e[t++], a < 128 ? l[f++] = a : a > 191 && a < 224 ? l[f++] = (a & 31) << 6 | e[t++] & 63 : a > 239 && a < 365 ? (a = ((a & 7) << 18 | (e[t++] & 63) << 12 | (e[t++] & 63) << 6 | e[t++] & 63) - 65536, l[f++] = 55296 + (a >> 10), l[f++] = 56320 + (a & 1023)) : l[f++] = (a & 15) << 12 | (e[t++] & 63) << 6 | e[t++] & 63, f > 8191 && ((u || (u = [])).push(String.fromCharCode.apply(String, l)), f = 0);
    return u ? (f && u.push(String.fromCharCode.apply(String, l.slice(0, f))), u.join("")) : String.fromCharCode.apply(String, l.slice(0, f));
  }, o.write = function(e, t, n) {
    for (var r = n, u, l, f = 0; f < e.length; ++f)
      u = e.charCodeAt(f), u < 128 ? t[n++] = u : u < 2048 ? (t[n++] = u >> 6 | 192, t[n++] = u & 63 | 128) : (u & 64512) === 55296 && ((l = e.charCodeAt(f + 1)) & 64512) === 56320 ? (u = 65536 + ((u & 1023) << 10) + (l & 1023), ++f, t[n++] = u >> 18 | 240, t[n++] = u >> 12 & 63 | 128, t[n++] = u >> 6 & 63 | 128, t[n++] = u & 63 | 128) : (t[n++] = u >> 12 | 224, t[n++] = u >> 6 & 63 | 128, t[n++] = u & 63 | 128);
    return n - r;
  };
})(utf8$2);
var pool_1 = pool;
function pool(c, o, i) {
  var e = i || 8192, t = e >>> 1, n = null, r = e;
  return function(l) {
    if (l < 1 || l > t)
      return c(l);
    r + l > e && (n = c(e), r = 0);
    var f = o.call(n, r, r += l);
    return r & 7 && (r = (r | 7) + 1), f;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = o;
  var c = requireMinimal();
  function o(n, r) {
    this.lo = n >>> 0, this.hi = r >>> 0;
  }
  var i = o.zero = new o(0, 0);
  i.toNumber = function() {
    return 0;
  }, i.zzEncode = i.zzDecode = function() {
    return this;
  }, i.length = function() {
    return 1;
  };
  var e = o.zeroHash = "\0\0\0\0\0\0\0\0";
  o.fromNumber = function(r) {
    if (r === 0)
      return i;
    var u = r < 0;
    u && (r = -r);
    var l = r >>> 0, f = (r - l) / 4294967296 >>> 0;
    return u && (f = ~f >>> 0, l = ~l >>> 0, ++l > 4294967295 && (l = 0, ++f > 4294967295 && (f = 0))), new o(l, f);
  }, o.from = function(r) {
    if (typeof r == "number")
      return o.fromNumber(r);
    if (c.isString(r))
      if (c.Long)
        r = c.Long.fromString(r);
      else
        return o.fromNumber(parseInt(r, 10));
    return r.low || r.high ? new o(r.low >>> 0, r.high >>> 0) : i;
  }, o.prototype.toNumber = function(r) {
    if (!r && this.hi >>> 31) {
      var u = ~this.lo + 1 >>> 0, l = ~this.hi >>> 0;
      return u || (l = l + 1 >>> 0), -(u + l * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, o.prototype.toLong = function(r) {
    return c.Long ? new c.Long(this.lo | 0, this.hi | 0, !!r) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!r };
  };
  var t = String.prototype.charCodeAt;
  return o.fromHash = function(r) {
    return r === e ? i : new o(
      (t.call(r, 0) | t.call(r, 1) << 8 | t.call(r, 2) << 16 | t.call(r, 3) << 24) >>> 0,
      (t.call(r, 4) | t.call(r, 5) << 8 | t.call(r, 6) << 16 | t.call(r, 7) << 24) >>> 0
    );
  }, o.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, o.prototype.zzEncode = function() {
    var r = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ r) >>> 0, this.lo = (this.lo << 1 ^ r) >>> 0, this;
  }, o.prototype.zzDecode = function() {
    var r = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ r) >>> 0, this.hi = (this.hi >>> 1 ^ r) >>> 0, this;
  }, o.prototype.length = function() {
    var r = this.lo, u = (this.lo >>> 28 | this.hi << 4) >>> 0, l = this.hi >>> 24;
    return l === 0 ? u === 0 ? r < 16384 ? r < 128 ? 1 : 2 : r < 2097152 ? 3 : 4 : u < 16384 ? u < 128 ? 5 : 6 : u < 2097152 ? 7 : 8 : l < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(c) {
    var o = c;
    o.asPromise = aspromise, o.base64 = base64$1, o.EventEmitter = eventemitter, o.float = float, o.inquire = inquire_1, o.utf8 = utf8$2, o.pool = pool_1, o.LongBits = requireLongbits(), o.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), o.global = o.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, o.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), o.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), o.isInteger = Number.isInteger || /* istanbul ignore next */
    function(n) {
      return typeof n == "number" && isFinite(n) && Math.floor(n) === n;
    }, o.isString = function(n) {
      return typeof n == "string" || n instanceof String;
    }, o.isObject = function(n) {
      return n && typeof n == "object";
    }, o.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    o.isSet = function(n, r) {
      var u = n[r];
      return u != null && n.hasOwnProperty(r) ? typeof u != "object" || (Array.isArray(u) ? u.length : Object.keys(u).length) > 0 : !1;
    }, o.Buffer = function() {
      try {
        var t = o.inquire("buffer").Buffer;
        return t.prototype.utf8Write ? t : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), o._Buffer_from = null, o._Buffer_allocUnsafe = null, o.newBuffer = function(n) {
      return typeof n == "number" ? o.Buffer ? o._Buffer_allocUnsafe(n) : new o.Array(n) : o.Buffer ? o._Buffer_from(n) : typeof Uint8Array > "u" ? n : new Uint8Array(n);
    }, o.Array = typeof Uint8Array < "u" ? Uint8Array : Array, o.Long = /* istanbul ignore next */
    o.global.dcodeIO && /* istanbul ignore next */
    o.global.dcodeIO.Long || /* istanbul ignore next */
    o.global.Long || o.inquire("long"), o.key2Re = /^true|false|0|1$/, o.key32Re = /^-?(?:0|[1-9][0-9]*)$/, o.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, o.longToHash = function(n) {
      return n ? o.LongBits.from(n).toHash() : o.LongBits.zeroHash;
    }, o.longFromHash = function(n, r) {
      var u = o.LongBits.fromHash(n);
      return o.Long ? o.Long.fromBits(u.lo, u.hi, r) : u.toNumber(!!r);
    };
    function i(t, n, r) {
      for (var u = Object.keys(n), l = 0; l < u.length; ++l)
        (t[u[l]] === void 0 || !r) && (t[u[l]] = n[u[l]]);
      return t;
    }
    o.merge = i, o.lcFirst = function(n) {
      return n.charAt(0).toLowerCase() + n.substring(1);
    };
    function e(t) {
      function n(r, u) {
        if (!(this instanceof n))
          return new n(r, u);
        Object.defineProperty(this, "message", { get: function() {
          return r;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, n) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), u && i(this, u);
      }
      return n.prototype = Object.create(Error.prototype, {
        constructor: {
          value: n,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return t;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), n;
    }
    o.newError = e, o.ProtocolError = e("ProtocolError"), o.oneOfGetter = function(n) {
      for (var r = {}, u = 0; u < n.length; ++u)
        r[n[u]] = 1;
      return function() {
        for (var l = Object.keys(this), f = l.length - 1; f > -1; --f)
          if (r[l[f]] === 1 && this[l[f]] !== void 0 && this[l[f]] !== null)
            return l[f];
      };
    }, o.oneOfSetter = function(n) {
      return function(r) {
        for (var u = 0; u < n.length; ++u)
          n[u] !== r && delete this[n[u]];
      };
    }, o.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, o._configure = function() {
      var t = o.Buffer;
      if (!t) {
        o._Buffer_from = o._Buffer_allocUnsafe = null;
        return;
      }
      o._Buffer_from = t.from !== Uint8Array.from && t.from || /* istanbul ignore next */
      function(r, u) {
        return new t(r, u);
      }, o._Buffer_allocUnsafe = t.allocUnsafe || /* istanbul ignore next */
      function(r) {
        return new t(r);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$4 = requireMinimal(), BufferWriter$1, LongBits$1 = util$4.LongBits, base64 = util$4.base64, utf8$1 = util$4.utf8;
function Op(c, o, i) {
  this.fn = c, this.len = o, this.next = void 0, this.val = i;
}
function noop() {
}
function State(c) {
  this.head = c.head, this.tail = c.tail, this.len = c.len, this.next = c.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op(noop, 0, 0), this.tail = this.head, this.states = null;
}
var create$1 = function c() {
  return util$4.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$1();
Writer$1.alloc = function c(o) {
  return new util$4.Array(o);
};
util$4.Array !== Array && (Writer$1.alloc = util$4.pool(Writer$1.alloc, util$4.Array.prototype.subarray));
Writer$1.prototype._push = function c(o, i, e) {
  return this.tail = this.tail.next = new Op(o, i, e), this.len += i, this;
};
function writeByte(c, o, i) {
  o[i] = c & 255;
}
function writeVarint32(c, o, i) {
  for (; c > 127; )
    o[i++] = c & 127 | 128, c >>>= 7;
  o[i] = c;
}
function VarintOp(c, o) {
  this.len = c, this.next = void 0, this.val = o;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$1.prototype.uint32 = function c(o) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (o = o >>> 0) < 128 ? 1 : o < 16384 ? 2 : o < 2097152 ? 3 : o < 268435456 ? 4 : 5,
    o
  )).len, this;
};
Writer$1.prototype.int32 = function c(o) {
  return o < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(o)) : this.uint32(o);
};
Writer$1.prototype.sint32 = function c(o) {
  return this.uint32((o << 1 ^ o >> 31) >>> 0);
};
function writeVarint64(c, o, i) {
  for (; c.hi; )
    o[i++] = c.lo & 127 | 128, c.lo = (c.lo >>> 7 | c.hi << 25) >>> 0, c.hi >>>= 7;
  for (; c.lo > 127; )
    o[i++] = c.lo & 127 | 128, c.lo = c.lo >>> 7;
  o[i++] = c.lo;
}
Writer$1.prototype.uint64 = function c(o) {
  var i = LongBits$1.from(o);
  return this._push(writeVarint64, i.length(), i);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function c(o) {
  var i = LongBits$1.from(o).zzEncode();
  return this._push(writeVarint64, i.length(), i);
};
Writer$1.prototype.bool = function c(o) {
  return this._push(writeByte, 1, o ? 1 : 0);
};
function writeFixed32(c, o, i) {
  o[i] = c & 255, o[i + 1] = c >>> 8 & 255, o[i + 2] = c >>> 16 & 255, o[i + 3] = c >>> 24;
}
Writer$1.prototype.fixed32 = function c(o) {
  return this._push(writeFixed32, 4, o >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function c(o) {
  var i = LongBits$1.from(o);
  return this._push(writeFixed32, 4, i.lo)._push(writeFixed32, 4, i.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function c(o) {
  return this._push(util$4.float.writeFloatLE, 4, o);
};
Writer$1.prototype.double = function c(o) {
  return this._push(util$4.float.writeDoubleLE, 8, o);
};
var writeBytes = util$4.Array.prototype.set ? function c(o, i, e) {
  i.set(o, e);
} : function c(o, i, e) {
  for (var t = 0; t < o.length; ++t)
    i[e + t] = o[t];
};
Writer$1.prototype.bytes = function c(o) {
  var i = o.length >>> 0;
  if (!i)
    return this._push(writeByte, 1, 0);
  if (util$4.isString(o)) {
    var e = Writer$1.alloc(i = base64.length(o));
    base64.decode(o, e, 0), o = e;
  }
  return this.uint32(i)._push(writeBytes, i, o);
};
Writer$1.prototype.string = function c(o) {
  var i = utf8$1.length(o);
  return i ? this.uint32(i)._push(utf8$1.write, i, o) : this._push(writeByte, 1, 0);
};
Writer$1.prototype.fork = function c() {
  return this.states = new State(this), this.head = this.tail = new Op(noop, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function c() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function c() {
  var o = this.head, i = this.tail, e = this.len;
  return this.reset().uint32(e), e && (this.tail.next = o.next, this.tail = i, this.len += e), this;
};
Writer$1.prototype.finish = function c() {
  for (var o = this.head.next, i = this.constructor.alloc(this.len), e = 0; o; )
    o.fn(o.val, i, e), e += o.len, o = o.next;
  return i;
};
Writer$1._configure = function(c) {
  BufferWriter$1 = c, Writer$1.create = create$1(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer = writer;
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util$3 = requireMinimal();
function BufferWriter() {
  Writer.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$3._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$3.Buffer && util$3.Buffer.prototype instanceof Uint8Array && util$3.Buffer.prototype.set.name === "set" ? function(o, i, e) {
    i.set(o, e);
  } : function(o, i, e) {
    if (o.copy)
      o.copy(i, e, 0, o.length);
    else
      for (var t = 0; t < o.length; )
        i[e++] = o[t++];
  };
};
BufferWriter.prototype.bytes = function c(o) {
  util$3.isString(o) && (o = util$3._Buffer_from(o, "base64"));
  var i = o.length >>> 0;
  return this.uint32(i), i && this._push(BufferWriter.writeBytesBuffer, i, o), this;
};
function writeStringBuffer(c, o, i) {
  c.length < 40 ? util$3.utf8.write(c, o, i) : o.utf8Write ? o.utf8Write(c, i) : o.write(c, i);
}
BufferWriter.prototype.string = function c(o) {
  var i = util$3.Buffer.byteLength(o);
  return this.uint32(i), i && this._push(writeStringBuffer, i, o), this;
};
BufferWriter._configure();
var reader = Reader$1, util$2 = requireMinimal(), BufferReader$1, LongBits = util$2.LongBits, utf8 = util$2.utf8;
function indexOutOfRange(c, o) {
  return RangeError("index out of range: " + c.pos + " + " + (o || 1) + " > " + c.len);
}
function Reader$1(c) {
  this.buf = c, this.pos = 0, this.len = c.length;
}
var create_array = typeof Uint8Array < "u" ? function c(o) {
  if (o instanceof Uint8Array || Array.isArray(o))
    return new Reader$1(o);
  throw Error("illegal buffer");
} : function c(o) {
  if (Array.isArray(o))
    return new Reader$1(o);
  throw Error("illegal buffer");
}, create = function c() {
  return util$2.Buffer ? function(i) {
    return (Reader$1.create = function(t) {
      return util$2.Buffer.isBuffer(t) ? new BufferReader$1(t) : create_array(t);
    })(i);
  } : create_array;
};
Reader$1.create = create();
Reader$1.prototype._slice = util$2.Array.prototype.subarray || /* istanbul ignore next */
util$2.Array.prototype.slice;
Reader$1.prototype.uint32 = /* @__PURE__ */ function c() {
  var o = 4294967295;
  return function() {
    if (o = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (o = (o | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (o = (o | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (o = (o | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (o = (o | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return o;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return o;
  };
}();
Reader$1.prototype.int32 = function c() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function c() {
  var o = this.uint32();
  return o >>> 1 ^ -(o & 1) | 0;
};
function readLongVarint() {
  var c = new LongBits(0, 0), o = 0;
  if (this.len - this.pos > 4) {
    for (; o < 4; ++o)
      if (c.lo = (c.lo | (this.buf[this.pos] & 127) << o * 7) >>> 0, this.buf[this.pos++] < 128)
        return c;
    if (c.lo = (c.lo | (this.buf[this.pos] & 127) << 28) >>> 0, c.hi = (c.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return c;
    o = 0;
  } else {
    for (; o < 3; ++o) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (c.lo = (c.lo | (this.buf[this.pos] & 127) << o * 7) >>> 0, this.buf[this.pos++] < 128)
        return c;
    }
    return c.lo = (c.lo | (this.buf[this.pos++] & 127) << o * 7) >>> 0, c;
  }
  if (this.len - this.pos > 4) {
    for (; o < 5; ++o)
      if (c.hi = (c.hi | (this.buf[this.pos] & 127) << o * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return c;
  } else
    for (; o < 5; ++o) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (c.hi = (c.hi | (this.buf[this.pos] & 127) << o * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return c;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function c() {
  return this.uint32() !== 0;
};
function readFixed32_end(c, o) {
  return (c[o - 4] | c[o - 3] << 8 | c[o - 2] << 16 | c[o - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function c() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function c() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function c() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var o = util$2.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, o;
};
Reader$1.prototype.double = function c() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var o = util$2.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, o;
};
Reader$1.prototype.bytes = function c() {
  var o = this.uint32(), i = this.pos, e = this.pos + o;
  if (e > this.len)
    throw indexOutOfRange(this, o);
  if (this.pos += o, Array.isArray(this.buf))
    return this.buf.slice(i, e);
  if (i === e) {
    var t = util$2.Buffer;
    return t ? t.alloc(0) : new this.buf.constructor(0);
  }
  return this._slice.call(this.buf, i, e);
};
Reader$1.prototype.string = function c() {
  var o = this.bytes();
  return utf8.read(o, 0, o.length);
};
Reader$1.prototype.skip = function c(o) {
  if (typeof o == "number") {
    if (this.pos + o > this.len)
      throw indexOutOfRange(this, o);
    this.pos += o;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(c) {
  switch (c) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (c = this.uint32() & 7) !== 4; )
        this.skipType(c);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + c + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(c) {
  BufferReader$1 = c, Reader$1.create = create(), BufferReader$1._configure();
  var o = util$2.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$2.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[o](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[o](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[o](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[o](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[o](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader = reader;
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util$1 = requireMinimal();
function BufferReader(c) {
  Reader.call(this, c);
}
BufferReader._configure = function() {
  util$1.Buffer && (BufferReader.prototype._slice = util$1.Buffer.prototype.slice);
};
BufferReader.prototype.string = function c() {
  var o = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + o, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + o, this.len));
};
BufferReader._configure();
var rpc = {}, service = Service, util = requireMinimal();
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
function Service(c, o, i) {
  if (typeof c != "function")
    throw TypeError("rpcImpl must be a function");
  util.EventEmitter.call(this), this.rpcImpl = c, this.requestDelimited = !!o, this.responseDelimited = !!i;
}
Service.prototype.rpcCall = function c(o, i, e, t, n) {
  if (!t)
    throw TypeError("request must be specified");
  var r = this;
  if (!n)
    return util.asPromise(c, r, o, i, e, t);
  if (!r.rpcImpl) {
    setTimeout(function() {
      n(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return r.rpcImpl(
      o,
      i[r.requestDelimited ? "encodeDelimited" : "encode"](t).finish(),
      function(l, f) {
        if (l)
          return r.emit("error", l, o), n(l);
        if (f === null) {
          r.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(f instanceof e))
          try {
            f = e[r.responseDelimited ? "decodeDelimited" : "decode"](f);
          } catch (a) {
            return r.emit("error", a, o), n(a);
          }
        return r.emit("data", f, o), n(null, f);
      }
    );
  } catch (u) {
    r.emit("error", u, o), setTimeout(function() {
      n(u);
    }, 0);
    return;
  }
};
Service.prototype.end = function c(o) {
  return this.rpcImpl && (o || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(c) {
  var o = c;
  o.Service = service;
})(rpc);
var roots = {};
(function(c) {
  var o = c;
  o.build = "minimal", o.Writer = writer, o.BufferWriter = writer_buffer, o.Reader = reader, o.BufferReader = reader_buffer, o.util = requireMinimal(), o.rpc = rpc, o.roots = roots, o.configure = i;
  function i() {
    o.util._configure(), o.Writer._configure(o.BufferWriter), o.Reader._configure(o.BufferReader);
  }
  i();
})(indexMinimal);
var minimal = indexMinimal;
const $Reader = minimal.Reader, $Writer = minimal.Writer, $util = minimal.util, $root = minimal.roots.default || (minimal.roots.default = {}), attestation = $root.attestation = (() => {
  const c = {};
  return c.Fatquote = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.epid = null, o.prototype.dcap = null, o.prototype.nitro = null, o.prototype.snp = null, o.prototype.dcapMrsigner = null;
    let i;
    return Object.defineProperty(o.prototype, "fatquote", {
      get: $util.oneOfGetter(i = ["epid", "dcap", "nitro", "snp", "dcapMrsigner"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.epid != null && Object.hasOwnProperty.call(t, "epid") && $root.attestation.FatquoteEpid.encode(t.epid, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.dcap != null && Object.hasOwnProperty.call(t, "dcap") && $root.attestation.FatquoteDcap.encode(t.dcap, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.nitro != null && Object.hasOwnProperty.call(t, "nitro") && $root.attestation.FatquoteNitro.encode(t.nitro, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.snp != null && Object.hasOwnProperty.call(t, "snp") && $root.attestation.FatquoteSnp.encode(t.snp, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.dcapMrsigner != null && Object.hasOwnProperty.call(t, "dcapMrsigner") && $root.attestation.FatquoteDcapMrsigner.encode(t.dcapMrsigner, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.attestation.Fatquote();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.epid = $root.attestation.FatquoteEpid.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.dcap = $root.attestation.FatquoteDcap.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.nitro = $root.attestation.FatquoteNitro.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.snp = $root.attestation.FatquoteSnp.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.epid != null && t.hasOwnProperty("epid")) {
        n.fatquote = 1;
        {
          let r = $root.attestation.FatquoteEpid.verify(t.epid);
          if (r)
            return "epid." + r;
        }
      }
      if (t.dcap != null && t.hasOwnProperty("dcap")) {
        if (n.fatquote === 1)
          return "fatquote: multiple values";
        n.fatquote = 1;
        {
          let r = $root.attestation.FatquoteDcap.verify(t.dcap);
          if (r)
            return "dcap." + r;
        }
      }
      if (t.nitro != null && t.hasOwnProperty("nitro")) {
        if (n.fatquote === 1)
          return "fatquote: multiple values";
        n.fatquote = 1;
        {
          let r = $root.attestation.FatquoteNitro.verify(t.nitro);
          if (r)
            return "nitro." + r;
        }
      }
      if (t.snp != null && t.hasOwnProperty("snp")) {
        if (n.fatquote === 1)
          return "fatquote: multiple values";
        n.fatquote = 1;
        {
          let r = $root.attestation.FatquoteSnp.verify(t.snp);
          if (r)
            return "snp." + r;
        }
      }
      if (t.dcapMrsigner != null && t.hasOwnProperty("dcapMrsigner")) {
        if (n.fatquote === 1)
          return "fatquote: multiple values";
        n.fatquote = 1;
        {
          let r = $root.attestation.FatquoteDcapMrsigner.verify(t.dcapMrsigner);
          if (r)
            return "dcapMrsigner." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.attestation.Fatquote)
        return t;
      let n = new $root.attestation.Fatquote();
      if (t.epid != null) {
        if (typeof t.epid != "object")
          throw TypeError(".attestation.Fatquote.epid: object expected");
        n.epid = $root.attestation.FatquoteEpid.fromObject(t.epid);
      }
      if (t.dcap != null) {
        if (typeof t.dcap != "object")
          throw TypeError(".attestation.Fatquote.dcap: object expected");
        n.dcap = $root.attestation.FatquoteDcap.fromObject(t.dcap);
      }
      if (t.nitro != null) {
        if (typeof t.nitro != "object")
          throw TypeError(".attestation.Fatquote.nitro: object expected");
        n.nitro = $root.attestation.FatquoteNitro.fromObject(t.nitro);
      }
      if (t.snp != null) {
        if (typeof t.snp != "object")
          throw TypeError(".attestation.Fatquote.snp: object expected");
        n.snp = $root.attestation.FatquoteSnp.fromObject(t.snp);
      }
      if (t.dcapMrsigner != null) {
        if (typeof t.dcapMrsigner != "object")
          throw TypeError(".attestation.Fatquote.dcapMrsigner: object expected");
        n.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.fromObject(t.dcapMrsigner);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.epid != null && t.hasOwnProperty("epid") && (r.epid = $root.attestation.FatquoteEpid.toObject(t.epid, n), n.oneofs && (r.fatquote = "epid")), t.dcap != null && t.hasOwnProperty("dcap") && (r.dcap = $root.attestation.FatquoteDcap.toObject(t.dcap, n), n.oneofs && (r.fatquote = "dcap")), t.nitro != null && t.hasOwnProperty("nitro") && (r.nitro = $root.attestation.FatquoteNitro.toObject(t.nitro, n), n.oneofs && (r.fatquote = "nitro")), t.snp != null && t.hasOwnProperty("snp") && (r.snp = $root.attestation.FatquoteSnp.toObject(t.snp, n), n.oneofs && (r.fatquote = "snp")), t.dcapMrsigner != null && t.hasOwnProperty("dcapMrsigner") && (r.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.toObject(t.dcapMrsigner, n), n.oneofs && (r.fatquote = "dcapMrsigner")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/attestation.Fatquote";
    }, o;
  }(), c.FatquoteEpid = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.iasResponseBody = $util.newBuffer([]), o.prototype.iasCertificate = $util.newBuffer([]), o.prototype.iasSignature = $util.newBuffer([]), o.prototype.iasRootCaDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.iasResponseBody != null && Object.hasOwnProperty.call(e, "iasResponseBody") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.iasResponseBody), e.iasCertificate != null && Object.hasOwnProperty.call(e, "iasCertificate") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.iasCertificate), e.iasSignature != null && Object.hasOwnProperty.call(e, "iasSignature") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.iasSignature), e.iasRootCaDer != null && Object.hasOwnProperty.call(e, "iasRootCaDer") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.iasRootCaDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.FatquoteEpid();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.iasResponseBody = e.bytes();
            break;
          }
          case 2: {
            r.iasCertificate = e.bytes();
            break;
          }
          case 3: {
            r.iasSignature = e.bytes();
            break;
          }
          case 4: {
            r.iasRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.iasResponseBody != null && e.hasOwnProperty("iasResponseBody") && !(e.iasResponseBody && typeof e.iasResponseBody.length == "number" || $util.isString(e.iasResponseBody)) ? "iasResponseBody: buffer expected" : e.iasCertificate != null && e.hasOwnProperty("iasCertificate") && !(e.iasCertificate && typeof e.iasCertificate.length == "number" || $util.isString(e.iasCertificate)) ? "iasCertificate: buffer expected" : e.iasSignature != null && e.hasOwnProperty("iasSignature") && !(e.iasSignature && typeof e.iasSignature.length == "number" || $util.isString(e.iasSignature)) ? "iasSignature: buffer expected" : e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && !(e.iasRootCaDer && typeof e.iasRootCaDer.length == "number" || $util.isString(e.iasRootCaDer)) ? "iasRootCaDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteEpid)
        return e;
      let t = new $root.attestation.FatquoteEpid();
      return e.iasResponseBody != null && (typeof e.iasResponseBody == "string" ? $util.base64.decode(e.iasResponseBody, t.iasResponseBody = $util.newBuffer($util.base64.length(e.iasResponseBody)), 0) : e.iasResponseBody.length >= 0 && (t.iasResponseBody = e.iasResponseBody)), e.iasCertificate != null && (typeof e.iasCertificate == "string" ? $util.base64.decode(e.iasCertificate, t.iasCertificate = $util.newBuffer($util.base64.length(e.iasCertificate)), 0) : e.iasCertificate.length >= 0 && (t.iasCertificate = e.iasCertificate)), e.iasSignature != null && (typeof e.iasSignature == "string" ? $util.base64.decode(e.iasSignature, t.iasSignature = $util.newBuffer($util.base64.length(e.iasSignature)), 0) : e.iasSignature.length >= 0 && (t.iasSignature = e.iasSignature)), e.iasRootCaDer != null && (typeof e.iasRootCaDer == "string" ? $util.base64.decode(e.iasRootCaDer, t.iasRootCaDer = $util.newBuffer($util.base64.length(e.iasRootCaDer)), 0) : e.iasRootCaDer.length >= 0 && (t.iasRootCaDer = e.iasRootCaDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.iasResponseBody = "" : (n.iasResponseBody = [], t.bytes !== Array && (n.iasResponseBody = $util.newBuffer(n.iasResponseBody))), t.bytes === String ? n.iasCertificate = "" : (n.iasCertificate = [], t.bytes !== Array && (n.iasCertificate = $util.newBuffer(n.iasCertificate))), t.bytes === String ? n.iasSignature = "" : (n.iasSignature = [], t.bytes !== Array && (n.iasSignature = $util.newBuffer(n.iasSignature))), t.bytes === String ? n.iasRootCaDer = "" : (n.iasRootCaDer = [], t.bytes !== Array && (n.iasRootCaDer = $util.newBuffer(n.iasRootCaDer)))), e.iasResponseBody != null && e.hasOwnProperty("iasResponseBody") && (n.iasResponseBody = t.bytes === String ? $util.base64.encode(e.iasResponseBody, 0, e.iasResponseBody.length) : t.bytes === Array ? Array.prototype.slice.call(e.iasResponseBody) : e.iasResponseBody), e.iasCertificate != null && e.hasOwnProperty("iasCertificate") && (n.iasCertificate = t.bytes === String ? $util.base64.encode(e.iasCertificate, 0, e.iasCertificate.length) : t.bytes === Array ? Array.prototype.slice.call(e.iasCertificate) : e.iasCertificate), e.iasSignature != null && e.hasOwnProperty("iasSignature") && (n.iasSignature = t.bytes === String ? $util.base64.encode(e.iasSignature, 0, e.iasSignature.length) : t.bytes === Array ? Array.prototype.slice.call(e.iasSignature) : e.iasSignature), e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && (n.iasRootCaDer = t.bytes === String ? $util.base64.encode(e.iasRootCaDer, 0, e.iasRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.iasRootCaDer) : e.iasRootCaDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteEpid";
    }, o;
  }(), c.FatquoteDcap = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcapQuote = $util.newBuffer([]), o.prototype.tcbInfo = $util.newBuffer([]), o.prototype.qeIdentity = $util.newBuffer([]), o.prototype.tcbSignCert = $util.newBuffer([]), o.prototype.qeSignCert = $util.newBuffer([]), o.prototype.dcapRootCaDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcapQuote != null && Object.hasOwnProperty.call(e, "dcapQuote") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcapQuote), e.tcbInfo != null && Object.hasOwnProperty.call(e, "tcbInfo") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.tcbInfo), e.qeIdentity != null && Object.hasOwnProperty.call(e, "qeIdentity") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.qeIdentity), e.tcbSignCert != null && Object.hasOwnProperty.call(e, "tcbSignCert") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.tcbSignCert), e.qeSignCert != null && Object.hasOwnProperty.call(e, "qeSignCert") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.qeSignCert), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.dcapRootCaDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.FatquoteDcap();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcapQuote = e.bytes();
            break;
          }
          case 2: {
            r.tcbInfo = e.bytes();
            break;
          }
          case 3: {
            r.qeIdentity = e.bytes();
            break;
          }
          case 4: {
            r.tcbSignCert = e.bytes();
            break;
          }
          case 5: {
            r.qeSignCert = e.bytes();
            break;
          }
          case 6: {
            r.dcapRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && !(e.dcapQuote && typeof e.dcapQuote.length == "number" || $util.isString(e.dcapQuote)) ? "dcapQuote: buffer expected" : e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && !(e.tcbInfo && typeof e.tcbInfo.length == "number" || $util.isString(e.tcbInfo)) ? "tcbInfo: buffer expected" : e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && !(e.qeIdentity && typeof e.qeIdentity.length == "number" || $util.isString(e.qeIdentity)) ? "qeIdentity: buffer expected" : e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && !(e.tcbSignCert && typeof e.tcbSignCert.length == "number" || $util.isString(e.tcbSignCert)) ? "tcbSignCert: buffer expected" : e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && !(e.qeSignCert && typeof e.qeSignCert.length == "number" || $util.isString(e.qeSignCert)) ? "qeSignCert: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteDcap)
        return e;
      let t = new $root.attestation.FatquoteDcap();
      return e.dcapQuote != null && (typeof e.dcapQuote == "string" ? $util.base64.decode(e.dcapQuote, t.dcapQuote = $util.newBuffer($util.base64.length(e.dcapQuote)), 0) : e.dcapQuote.length >= 0 && (t.dcapQuote = e.dcapQuote)), e.tcbInfo != null && (typeof e.tcbInfo == "string" ? $util.base64.decode(e.tcbInfo, t.tcbInfo = $util.newBuffer($util.base64.length(e.tcbInfo)), 0) : e.tcbInfo.length >= 0 && (t.tcbInfo = e.tcbInfo)), e.qeIdentity != null && (typeof e.qeIdentity == "string" ? $util.base64.decode(e.qeIdentity, t.qeIdentity = $util.newBuffer($util.base64.length(e.qeIdentity)), 0) : e.qeIdentity.length >= 0 && (t.qeIdentity = e.qeIdentity)), e.tcbSignCert != null && (typeof e.tcbSignCert == "string" ? $util.base64.decode(e.tcbSignCert, t.tcbSignCert = $util.newBuffer($util.base64.length(e.tcbSignCert)), 0) : e.tcbSignCert.length >= 0 && (t.tcbSignCert = e.tcbSignCert)), e.qeSignCert != null && (typeof e.qeSignCert == "string" ? $util.base64.decode(e.qeSignCert, t.qeSignCert = $util.newBuffer($util.base64.length(e.qeSignCert)), 0) : e.qeSignCert.length >= 0 && (t.qeSignCert = e.qeSignCert)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, t.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (t.dcapRootCaDer = e.dcapRootCaDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dcapQuote = "" : (n.dcapQuote = [], t.bytes !== Array && (n.dcapQuote = $util.newBuffer(n.dcapQuote))), t.bytes === String ? n.tcbInfo = "" : (n.tcbInfo = [], t.bytes !== Array && (n.tcbInfo = $util.newBuffer(n.tcbInfo))), t.bytes === String ? n.qeIdentity = "" : (n.qeIdentity = [], t.bytes !== Array && (n.qeIdentity = $util.newBuffer(n.qeIdentity))), t.bytes === String ? n.tcbSignCert = "" : (n.tcbSignCert = [], t.bytes !== Array && (n.tcbSignCert = $util.newBuffer(n.tcbSignCert))), t.bytes === String ? n.qeSignCert = "" : (n.qeSignCert = [], t.bytes !== Array && (n.qeSignCert = $util.newBuffer(n.qeSignCert))), t.bytes === String ? n.dcapRootCaDer = "" : (n.dcapRootCaDer = [], t.bytes !== Array && (n.dcapRootCaDer = $util.newBuffer(n.dcapRootCaDer)))), e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && (n.dcapQuote = t.bytes === String ? $util.base64.encode(e.dcapQuote, 0, e.dcapQuote.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapQuote) : e.dcapQuote), e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && (n.tcbInfo = t.bytes === String ? $util.base64.encode(e.tcbInfo, 0, e.tcbInfo.length) : t.bytes === Array ? Array.prototype.slice.call(e.tcbInfo) : e.tcbInfo), e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && (n.qeIdentity = t.bytes === String ? $util.base64.encode(e.qeIdentity, 0, e.qeIdentity.length) : t.bytes === Array ? Array.prototype.slice.call(e.qeIdentity) : e.qeIdentity), e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && (n.tcbSignCert = t.bytes === String ? $util.base64.encode(e.tcbSignCert, 0, e.tcbSignCert.length) : t.bytes === Array ? Array.prototype.slice.call(e.tcbSignCert) : e.tcbSignCert), e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && (n.qeSignCert = t.bytes === String ? $util.base64.encode(e.qeSignCert, 0, e.qeSignCert.length) : t.bytes === Array ? Array.prototype.slice.call(e.qeSignCert) : e.qeSignCert), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (n.dcapRootCaDer = t.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteDcap";
    }, o;
  }(), c.FatquoteDcapMrsigner = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcapQuote = $util.newBuffer([]), o.prototype.tcbInfo = $util.newBuffer([]), o.prototype.qeIdentity = $util.newBuffer([]), o.prototype.tcbSignCert = $util.newBuffer([]), o.prototype.qeSignCert = $util.newBuffer([]), o.prototype.dcapRootCaDer = $util.newBuffer([]), o.prototype.sigstoreEvidence = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcapQuote != null && Object.hasOwnProperty.call(e, "dcapQuote") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcapQuote), e.tcbInfo != null && Object.hasOwnProperty.call(e, "tcbInfo") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.tcbInfo), e.qeIdentity != null && Object.hasOwnProperty.call(e, "qeIdentity") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.qeIdentity), e.tcbSignCert != null && Object.hasOwnProperty.call(e, "tcbSignCert") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.tcbSignCert), e.qeSignCert != null && Object.hasOwnProperty.call(e, "qeSignCert") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.qeSignCert), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.dcapRootCaDer), e.sigstoreEvidence != null && Object.hasOwnProperty.call(e, "sigstoreEvidence") && $root.attestation.SigstoreEvidence.encode(e.sigstoreEvidence, t.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.FatquoteDcapMrsigner();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcapQuote = e.bytes();
            break;
          }
          case 2: {
            r.tcbInfo = e.bytes();
            break;
          }
          case 3: {
            r.qeIdentity = e.bytes();
            break;
          }
          case 4: {
            r.tcbSignCert = e.bytes();
            break;
          }
          case 5: {
            r.qeSignCert = e.bytes();
            break;
          }
          case 6: {
            r.dcapRootCaDer = e.bytes();
            break;
          }
          case 7: {
            r.sigstoreEvidence = $root.attestation.SigstoreEvidence.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && !(e.dcapQuote && typeof e.dcapQuote.length == "number" || $util.isString(e.dcapQuote)))
        return "dcapQuote: buffer expected";
      if (e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && !(e.tcbInfo && typeof e.tcbInfo.length == "number" || $util.isString(e.tcbInfo)))
        return "tcbInfo: buffer expected";
      if (e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && !(e.qeIdentity && typeof e.qeIdentity.length == "number" || $util.isString(e.qeIdentity)))
        return "qeIdentity: buffer expected";
      if (e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && !(e.tcbSignCert && typeof e.tcbSignCert.length == "number" || $util.isString(e.tcbSignCert)))
        return "tcbSignCert: buffer expected";
      if (e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && !(e.qeSignCert && typeof e.qeSignCert.length == "number" || $util.isString(e.qeSignCert)))
        return "qeSignCert: buffer expected";
      if (e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)))
        return "dcapRootCaDer: buffer expected";
      if (e.sigstoreEvidence != null && e.hasOwnProperty("sigstoreEvidence")) {
        let t = $root.attestation.SigstoreEvidence.verify(e.sigstoreEvidence);
        if (t)
          return "sigstoreEvidence." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteDcapMrsigner)
        return e;
      let t = new $root.attestation.FatquoteDcapMrsigner();
      if (e.dcapQuote != null && (typeof e.dcapQuote == "string" ? $util.base64.decode(e.dcapQuote, t.dcapQuote = $util.newBuffer($util.base64.length(e.dcapQuote)), 0) : e.dcapQuote.length >= 0 && (t.dcapQuote = e.dcapQuote)), e.tcbInfo != null && (typeof e.tcbInfo == "string" ? $util.base64.decode(e.tcbInfo, t.tcbInfo = $util.newBuffer($util.base64.length(e.tcbInfo)), 0) : e.tcbInfo.length >= 0 && (t.tcbInfo = e.tcbInfo)), e.qeIdentity != null && (typeof e.qeIdentity == "string" ? $util.base64.decode(e.qeIdentity, t.qeIdentity = $util.newBuffer($util.base64.length(e.qeIdentity)), 0) : e.qeIdentity.length >= 0 && (t.qeIdentity = e.qeIdentity)), e.tcbSignCert != null && (typeof e.tcbSignCert == "string" ? $util.base64.decode(e.tcbSignCert, t.tcbSignCert = $util.newBuffer($util.base64.length(e.tcbSignCert)), 0) : e.tcbSignCert.length >= 0 && (t.tcbSignCert = e.tcbSignCert)), e.qeSignCert != null && (typeof e.qeSignCert == "string" ? $util.base64.decode(e.qeSignCert, t.qeSignCert = $util.newBuffer($util.base64.length(e.qeSignCert)), 0) : e.qeSignCert.length >= 0 && (t.qeSignCert = e.qeSignCert)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, t.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (t.dcapRootCaDer = e.dcapRootCaDer)), e.sigstoreEvidence != null) {
        if (typeof e.sigstoreEvidence != "object")
          throw TypeError(".attestation.FatquoteDcapMrsigner.sigstoreEvidence: object expected");
        t.sigstoreEvidence = $root.attestation.SigstoreEvidence.fromObject(e.sigstoreEvidence);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dcapQuote = "" : (n.dcapQuote = [], t.bytes !== Array && (n.dcapQuote = $util.newBuffer(n.dcapQuote))), t.bytes === String ? n.tcbInfo = "" : (n.tcbInfo = [], t.bytes !== Array && (n.tcbInfo = $util.newBuffer(n.tcbInfo))), t.bytes === String ? n.qeIdentity = "" : (n.qeIdentity = [], t.bytes !== Array && (n.qeIdentity = $util.newBuffer(n.qeIdentity))), t.bytes === String ? n.tcbSignCert = "" : (n.tcbSignCert = [], t.bytes !== Array && (n.tcbSignCert = $util.newBuffer(n.tcbSignCert))), t.bytes === String ? n.qeSignCert = "" : (n.qeSignCert = [], t.bytes !== Array && (n.qeSignCert = $util.newBuffer(n.qeSignCert))), t.bytes === String ? n.dcapRootCaDer = "" : (n.dcapRootCaDer = [], t.bytes !== Array && (n.dcapRootCaDer = $util.newBuffer(n.dcapRootCaDer))), n.sigstoreEvidence = null), e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && (n.dcapQuote = t.bytes === String ? $util.base64.encode(e.dcapQuote, 0, e.dcapQuote.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapQuote) : e.dcapQuote), e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && (n.tcbInfo = t.bytes === String ? $util.base64.encode(e.tcbInfo, 0, e.tcbInfo.length) : t.bytes === Array ? Array.prototype.slice.call(e.tcbInfo) : e.tcbInfo), e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && (n.qeIdentity = t.bytes === String ? $util.base64.encode(e.qeIdentity, 0, e.qeIdentity.length) : t.bytes === Array ? Array.prototype.slice.call(e.qeIdentity) : e.qeIdentity), e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && (n.tcbSignCert = t.bytes === String ? $util.base64.encode(e.tcbSignCert, 0, e.tcbSignCert.length) : t.bytes === Array ? Array.prototype.slice.call(e.tcbSignCert) : e.tcbSignCert), e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && (n.qeSignCert = t.bytes === String ? $util.base64.encode(e.qeSignCert, 0, e.qeSignCert.length) : t.bytes === Array ? Array.prototype.slice.call(e.qeSignCert) : e.qeSignCert), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (n.dcapRootCaDer = t.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.sigstoreEvidence != null && e.hasOwnProperty("sigstoreEvidence") && (n.sigstoreEvidence = $root.attestation.SigstoreEvidence.toObject(e.sigstoreEvidence, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteDcapMrsigner";
    }, o;
  }(), c.SigstoreFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.prototype.contents = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.contents != null && Object.hasOwnProperty.call(e, "contents") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.contents), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.SigstoreFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          case 2: {
            r.contents = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.contents != null && e.hasOwnProperty("contents") && !(e.contents && typeof e.contents.length == "number" || $util.isString(e.contents)) ? "contents: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.SigstoreFile)
        return e;
      let t = new $root.attestation.SigstoreFile();
      return e.name != null && (t.name = String(e.name)), e.contents != null && (typeof e.contents == "string" ? $util.base64.decode(e.contents, t.contents = $util.newBuffer($util.base64.length(e.contents)), 0) : e.contents.length >= 0 && (t.contents = e.contents)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = "", t.bytes === String ? n.contents = "" : (n.contents = [], t.bytes !== Array && (n.contents = $util.newBuffer(n.contents)))), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.contents != null && e.hasOwnProperty("contents") && (n.contents = t.bytes === String ? $util.base64.encode(e.contents, 0, e.contents.length) : t.bytes === Array ? Array.prototype.slice.call(e.contents) : e.contents), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.SigstoreFile";
    }, o;
  }(), c.SigstoreEvidence = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.v1 = null;
    let i;
    return Object.defineProperty(o.prototype, "sigstoreEvidence", {
      get: $util.oneOfGetter(i = ["v1"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.v1 != null && Object.hasOwnProperty.call(t, "v1") && $root.attestation.SigstoreEvidenceV1.encode(t.v1, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.attestation.SigstoreEvidence();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.v1 = $root.attestation.SigstoreEvidenceV1.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.v1 != null && t.hasOwnProperty("v1")) {
        let n = $root.attestation.SigstoreEvidenceV1.verify(t.v1);
        if (n)
          return "v1." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.attestation.SigstoreEvidence)
        return t;
      let n = new $root.attestation.SigstoreEvidence();
      if (t.v1 != null) {
        if (typeof t.v1 != "object")
          throw TypeError(".attestation.SigstoreEvidence.v1: object expected");
        n.v1 = $root.attestation.SigstoreEvidenceV1.fromObject(t.v1);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.v1 != null && t.hasOwnProperty("v1") && (r.v1 = $root.attestation.SigstoreEvidenceV1.toObject(t.v1, n), n.oneofs && (r.sigstoreEvidence = "v1")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/attestation.SigstoreEvidence";
    }, o;
  }(), c.SigstoreEvidenceV1 = function() {
    function o(i) {
      if (this.files = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.files = $util.emptyArray, o.prototype.rekorLogEntryJson = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.files != null && e.files.length)
        for (let n = 0; n < e.files.length; ++n)
          $root.attestation.SigstoreFile.encode(e.files[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e.rekorLogEntryJson != null && Object.hasOwnProperty.call(e, "rekorLogEntryJson") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.rekorLogEntryJson), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.SigstoreEvidenceV1();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.files && r.files.length || (r.files = []), r.files.push($root.attestation.SigstoreFile.decode(e, e.uint32()));
            break;
          }
          case 2: {
            r.rekorLogEntryJson = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.files != null && e.hasOwnProperty("files")) {
        if (!Array.isArray(e.files))
          return "files: array expected";
        for (let t = 0; t < e.files.length; ++t) {
          let n = $root.attestation.SigstoreFile.verify(e.files[t]);
          if (n)
            return "files." + n;
        }
      }
      return e.rekorLogEntryJson != null && e.hasOwnProperty("rekorLogEntryJson") && !(e.rekorLogEntryJson && typeof e.rekorLogEntryJson.length == "number" || $util.isString(e.rekorLogEntryJson)) ? "rekorLogEntryJson: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.SigstoreEvidenceV1)
        return e;
      let t = new $root.attestation.SigstoreEvidenceV1();
      if (e.files) {
        if (!Array.isArray(e.files))
          throw TypeError(".attestation.SigstoreEvidenceV1.files: array expected");
        t.files = [];
        for (let n = 0; n < e.files.length; ++n) {
          if (typeof e.files[n] != "object")
            throw TypeError(".attestation.SigstoreEvidenceV1.files: object expected");
          t.files[n] = $root.attestation.SigstoreFile.fromObject(e.files[n]);
        }
      }
      return e.rekorLogEntryJson != null && (typeof e.rekorLogEntryJson == "string" ? $util.base64.decode(e.rekorLogEntryJson, t.rekorLogEntryJson = $util.newBuffer($util.base64.length(e.rekorLogEntryJson)), 0) : e.rekorLogEntryJson.length >= 0 && (t.rekorLogEntryJson = e.rekorLogEntryJson)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.files = []), t.defaults && (t.bytes === String ? n.rekorLogEntryJson = "" : (n.rekorLogEntryJson = [], t.bytes !== Array && (n.rekorLogEntryJson = $util.newBuffer(n.rekorLogEntryJson)))), e.files && e.files.length) {
        n.files = [];
        for (let r = 0; r < e.files.length; ++r)
          n.files[r] = $root.attestation.SigstoreFile.toObject(e.files[r], t);
      }
      return e.rekorLogEntryJson != null && e.hasOwnProperty("rekorLogEntryJson") && (n.rekorLogEntryJson = t.bytes === String ? $util.base64.encode(e.rekorLogEntryJson, 0, e.rekorLogEntryJson.length) : t.bytes === Array ? Array.prototype.slice.call(e.rekorLogEntryJson) : e.rekorLogEntryJson), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.SigstoreEvidenceV1";
    }, o;
  }(), c.FatquoteNitro = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.cose = $util.newBuffer([]), o.prototype.nitroRootCaDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.cose != null && Object.hasOwnProperty.call(e, "cose") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.cose), e.nitroRootCaDer != null && Object.hasOwnProperty.call(e, "nitroRootCaDer") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nitroRootCaDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.FatquoteNitro();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.cose = e.bytes();
            break;
          }
          case 2: {
            r.nitroRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.cose != null && e.hasOwnProperty("cose") && !(e.cose && typeof e.cose.length == "number" || $util.isString(e.cose)) ? "cose: buffer expected" : e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && !(e.nitroRootCaDer && typeof e.nitroRootCaDer.length == "number" || $util.isString(e.nitroRootCaDer)) ? "nitroRootCaDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteNitro)
        return e;
      let t = new $root.attestation.FatquoteNitro();
      return e.cose != null && (typeof e.cose == "string" ? $util.base64.decode(e.cose, t.cose = $util.newBuffer($util.base64.length(e.cose)), 0) : e.cose.length >= 0 && (t.cose = e.cose)), e.nitroRootCaDer != null && (typeof e.nitroRootCaDer == "string" ? $util.base64.decode(e.nitroRootCaDer, t.nitroRootCaDer = $util.newBuffer($util.base64.length(e.nitroRootCaDer)), 0) : e.nitroRootCaDer.length >= 0 && (t.nitroRootCaDer = e.nitroRootCaDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.cose = "" : (n.cose = [], t.bytes !== Array && (n.cose = $util.newBuffer(n.cose))), t.bytes === String ? n.nitroRootCaDer = "" : (n.nitroRootCaDer = [], t.bytes !== Array && (n.nitroRootCaDer = $util.newBuffer(n.nitroRootCaDer)))), e.cose != null && e.hasOwnProperty("cose") && (n.cose = t.bytes === String ? $util.base64.encode(e.cose, 0, e.cose.length) : t.bytes === Array ? Array.prototype.slice.call(e.cose) : e.cose), e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && (n.nitroRootCaDer = t.bytes === String ? $util.base64.encode(e.nitroRootCaDer, 0, e.nitroRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.nitroRootCaDer) : e.nitroRootCaDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteNitro";
    }, o;
  }(), c.FatquoteSnp = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.reportBin = $util.newBuffer([]), o.prototype.amdArkDer = $util.newBuffer([]), o.prototype.amdSevDer = $util.newBuffer([]), o.prototype.vcekCrtDer = $util.newBuffer([]), o.prototype.reportData = $util.newBuffer([]), o.prototype.roughtimePubKey = $util.newBuffer([]), o.prototype.roughtimeNonce = $util.newBuffer([]), o.prototype.signedTimestamp = $util.newBuffer([]), o.prototype.decentriqDer = $util.newBuffer([]), o.prototype.chipDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.reportBin != null && Object.hasOwnProperty.call(e, "reportBin") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.reportBin), e.amdArkDer != null && Object.hasOwnProperty.call(e, "amdArkDer") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.amdArkDer), e.amdSevDer != null && Object.hasOwnProperty.call(e, "amdSevDer") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.amdSevDer), e.vcekCrtDer != null && Object.hasOwnProperty.call(e, "vcekCrtDer") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.vcekCrtDer), e.reportData != null && Object.hasOwnProperty.call(e, "reportData") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.reportData), e.roughtimePubKey != null && Object.hasOwnProperty.call(e, "roughtimePubKey") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.roughtimePubKey), e.roughtimeNonce != null && Object.hasOwnProperty.call(e, "roughtimeNonce") && t.uint32(
        /* id 7, wireType 2 =*/
        58
      ).bytes(e.roughtimeNonce), e.signedTimestamp != null && Object.hasOwnProperty.call(e, "signedTimestamp") && t.uint32(
        /* id 8, wireType 2 =*/
        66
      ).bytes(e.signedTimestamp), e.decentriqDer != null && Object.hasOwnProperty.call(e, "decentriqDer") && t.uint32(
        /* id 9, wireType 2 =*/
        74
      ).bytes(e.decentriqDer), e.chipDer != null && Object.hasOwnProperty.call(e, "chipDer") && t.uint32(
        /* id 10, wireType 2 =*/
        82
      ).bytes(e.chipDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.FatquoteSnp();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.reportBin = e.bytes();
            break;
          }
          case 2: {
            r.amdArkDer = e.bytes();
            break;
          }
          case 3: {
            r.amdSevDer = e.bytes();
            break;
          }
          case 4: {
            r.vcekCrtDer = e.bytes();
            break;
          }
          case 5: {
            r.reportData = e.bytes();
            break;
          }
          case 6: {
            r.roughtimePubKey = e.bytes();
            break;
          }
          case 7: {
            r.roughtimeNonce = e.bytes();
            break;
          }
          case 8: {
            r.signedTimestamp = e.bytes();
            break;
          }
          case 9: {
            r.decentriqDer = e.bytes();
            break;
          }
          case 10: {
            r.chipDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.reportBin != null && e.hasOwnProperty("reportBin") && !(e.reportBin && typeof e.reportBin.length == "number" || $util.isString(e.reportBin)) ? "reportBin: buffer expected" : e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && !(e.amdArkDer && typeof e.amdArkDer.length == "number" || $util.isString(e.amdArkDer)) ? "amdArkDer: buffer expected" : e.amdSevDer != null && e.hasOwnProperty("amdSevDer") && !(e.amdSevDer && typeof e.amdSevDer.length == "number" || $util.isString(e.amdSevDer)) ? "amdSevDer: buffer expected" : e.vcekCrtDer != null && e.hasOwnProperty("vcekCrtDer") && !(e.vcekCrtDer && typeof e.vcekCrtDer.length == "number" || $util.isString(e.vcekCrtDer)) ? "vcekCrtDer: buffer expected" : e.reportData != null && e.hasOwnProperty("reportData") && !(e.reportData && typeof e.reportData.length == "number" || $util.isString(e.reportData)) ? "reportData: buffer expected" : e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && !(e.roughtimePubKey && typeof e.roughtimePubKey.length == "number" || $util.isString(e.roughtimePubKey)) ? "roughtimePubKey: buffer expected" : e.roughtimeNonce != null && e.hasOwnProperty("roughtimeNonce") && !(e.roughtimeNonce && typeof e.roughtimeNonce.length == "number" || $util.isString(e.roughtimeNonce)) ? "roughtimeNonce: buffer expected" : e.signedTimestamp != null && e.hasOwnProperty("signedTimestamp") && !(e.signedTimestamp && typeof e.signedTimestamp.length == "number" || $util.isString(e.signedTimestamp)) ? "signedTimestamp: buffer expected" : e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && !(e.decentriqDer && typeof e.decentriqDer.length == "number" || $util.isString(e.decentriqDer)) ? "decentriqDer: buffer expected" : e.chipDer != null && e.hasOwnProperty("chipDer") && !(e.chipDer && typeof e.chipDer.length == "number" || $util.isString(e.chipDer)) ? "chipDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteSnp)
        return e;
      let t = new $root.attestation.FatquoteSnp();
      return e.reportBin != null && (typeof e.reportBin == "string" ? $util.base64.decode(e.reportBin, t.reportBin = $util.newBuffer($util.base64.length(e.reportBin)), 0) : e.reportBin.length >= 0 && (t.reportBin = e.reportBin)), e.amdArkDer != null && (typeof e.amdArkDer == "string" ? $util.base64.decode(e.amdArkDer, t.amdArkDer = $util.newBuffer($util.base64.length(e.amdArkDer)), 0) : e.amdArkDer.length >= 0 && (t.amdArkDer = e.amdArkDer)), e.amdSevDer != null && (typeof e.amdSevDer == "string" ? $util.base64.decode(e.amdSevDer, t.amdSevDer = $util.newBuffer($util.base64.length(e.amdSevDer)), 0) : e.amdSevDer.length >= 0 && (t.amdSevDer = e.amdSevDer)), e.vcekCrtDer != null && (typeof e.vcekCrtDer == "string" ? $util.base64.decode(e.vcekCrtDer, t.vcekCrtDer = $util.newBuffer($util.base64.length(e.vcekCrtDer)), 0) : e.vcekCrtDer.length >= 0 && (t.vcekCrtDer = e.vcekCrtDer)), e.reportData != null && (typeof e.reportData == "string" ? $util.base64.decode(e.reportData, t.reportData = $util.newBuffer($util.base64.length(e.reportData)), 0) : e.reportData.length >= 0 && (t.reportData = e.reportData)), e.roughtimePubKey != null && (typeof e.roughtimePubKey == "string" ? $util.base64.decode(e.roughtimePubKey, t.roughtimePubKey = $util.newBuffer($util.base64.length(e.roughtimePubKey)), 0) : e.roughtimePubKey.length >= 0 && (t.roughtimePubKey = e.roughtimePubKey)), e.roughtimeNonce != null && (typeof e.roughtimeNonce == "string" ? $util.base64.decode(e.roughtimeNonce, t.roughtimeNonce = $util.newBuffer($util.base64.length(e.roughtimeNonce)), 0) : e.roughtimeNonce.length >= 0 && (t.roughtimeNonce = e.roughtimeNonce)), e.signedTimestamp != null && (typeof e.signedTimestamp == "string" ? $util.base64.decode(e.signedTimestamp, t.signedTimestamp = $util.newBuffer($util.base64.length(e.signedTimestamp)), 0) : e.signedTimestamp.length >= 0 && (t.signedTimestamp = e.signedTimestamp)), e.decentriqDer != null && (typeof e.decentriqDer == "string" ? $util.base64.decode(e.decentriqDer, t.decentriqDer = $util.newBuffer($util.base64.length(e.decentriqDer)), 0) : e.decentriqDer.length >= 0 && (t.decentriqDer = e.decentriqDer)), e.chipDer != null && (typeof e.chipDer == "string" ? $util.base64.decode(e.chipDer, t.chipDer = $util.newBuffer($util.base64.length(e.chipDer)), 0) : e.chipDer.length >= 0 && (t.chipDer = e.chipDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.reportBin = "" : (n.reportBin = [], t.bytes !== Array && (n.reportBin = $util.newBuffer(n.reportBin))), t.bytes === String ? n.amdArkDer = "" : (n.amdArkDer = [], t.bytes !== Array && (n.amdArkDer = $util.newBuffer(n.amdArkDer))), t.bytes === String ? n.amdSevDer = "" : (n.amdSevDer = [], t.bytes !== Array && (n.amdSevDer = $util.newBuffer(n.amdSevDer))), t.bytes === String ? n.vcekCrtDer = "" : (n.vcekCrtDer = [], t.bytes !== Array && (n.vcekCrtDer = $util.newBuffer(n.vcekCrtDer))), t.bytes === String ? n.reportData = "" : (n.reportData = [], t.bytes !== Array && (n.reportData = $util.newBuffer(n.reportData))), t.bytes === String ? n.roughtimePubKey = "" : (n.roughtimePubKey = [], t.bytes !== Array && (n.roughtimePubKey = $util.newBuffer(n.roughtimePubKey))), t.bytes === String ? n.roughtimeNonce = "" : (n.roughtimeNonce = [], t.bytes !== Array && (n.roughtimeNonce = $util.newBuffer(n.roughtimeNonce))), t.bytes === String ? n.signedTimestamp = "" : (n.signedTimestamp = [], t.bytes !== Array && (n.signedTimestamp = $util.newBuffer(n.signedTimestamp))), t.bytes === String ? n.decentriqDer = "" : (n.decentriqDer = [], t.bytes !== Array && (n.decentriqDer = $util.newBuffer(n.decentriqDer))), t.bytes === String ? n.chipDer = "" : (n.chipDer = [], t.bytes !== Array && (n.chipDer = $util.newBuffer(n.chipDer)))), e.reportBin != null && e.hasOwnProperty("reportBin") && (n.reportBin = t.bytes === String ? $util.base64.encode(e.reportBin, 0, e.reportBin.length) : t.bytes === Array ? Array.prototype.slice.call(e.reportBin) : e.reportBin), e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && (n.amdArkDer = t.bytes === String ? $util.base64.encode(e.amdArkDer, 0, e.amdArkDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.amdArkDer) : e.amdArkDer), e.amdSevDer != null && e.hasOwnProperty("amdSevDer") && (n.amdSevDer = t.bytes === String ? $util.base64.encode(e.amdSevDer, 0, e.amdSevDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.amdSevDer) : e.amdSevDer), e.vcekCrtDer != null && e.hasOwnProperty("vcekCrtDer") && (n.vcekCrtDer = t.bytes === String ? $util.base64.encode(e.vcekCrtDer, 0, e.vcekCrtDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.vcekCrtDer) : e.vcekCrtDer), e.reportData != null && e.hasOwnProperty("reportData") && (n.reportData = t.bytes === String ? $util.base64.encode(e.reportData, 0, e.reportData.length) : t.bytes === Array ? Array.prototype.slice.call(e.reportData) : e.reportData), e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && (n.roughtimePubKey = t.bytes === String ? $util.base64.encode(e.roughtimePubKey, 0, e.roughtimePubKey.length) : t.bytes === Array ? Array.prototype.slice.call(e.roughtimePubKey) : e.roughtimePubKey), e.roughtimeNonce != null && e.hasOwnProperty("roughtimeNonce") && (n.roughtimeNonce = t.bytes === String ? $util.base64.encode(e.roughtimeNonce, 0, e.roughtimeNonce.length) : t.bytes === Array ? Array.prototype.slice.call(e.roughtimeNonce) : e.roughtimeNonce), e.signedTimestamp != null && e.hasOwnProperty("signedTimestamp") && (n.signedTimestamp = t.bytes === String ? $util.base64.encode(e.signedTimestamp, 0, e.signedTimestamp.length) : t.bytes === Array ? Array.prototype.slice.call(e.signedTimestamp) : e.signedTimestamp), e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && (n.decentriqDer = t.bytes === String ? $util.base64.encode(e.decentriqDer, 0, e.decentriqDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.decentriqDer) : e.decentriqDer), e.chipDer != null && e.hasOwnProperty("chipDer") && (n.chipDer = t.bytes === String ? $util.base64.encode(e.chipDer, 0, e.chipDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.chipDer) : e.chipDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteSnp";
    }, o;
  }(), c.AttestationSpecification = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.intelEpid = null, o.prototype.intelDcap = null, o.prototype.awsNitro = null, o.prototype.amdSnp = null, o.prototype.intelDcapMrsigner = null;
    let i;
    return Object.defineProperty(o.prototype, "attestationSpecification", {
      get: $util.oneOfGetter(i = ["intelEpid", "intelDcap", "awsNitro", "amdSnp", "intelDcapMrsigner"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.intelEpid != null && Object.hasOwnProperty.call(t, "intelEpid") && $root.attestation.AttestationSpecificationIntelEpid.encode(t.intelEpid, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.intelDcap != null && Object.hasOwnProperty.call(t, "intelDcap") && $root.attestation.AttestationSpecificationIntelDcap.encode(t.intelDcap, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.awsNitro != null && Object.hasOwnProperty.call(t, "awsNitro") && $root.attestation.AttestationSpecificationAwsNitro.encode(t.awsNitro, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.amdSnp != null && Object.hasOwnProperty.call(t, "amdSnp") && $root.attestation.AttestationSpecificationAmdSnp.encode(t.amdSnp, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.intelDcapMrsigner != null && Object.hasOwnProperty.call(t, "intelDcapMrsigner") && $root.attestation.AttestationSpecificationIntelDcapMrsigner.encode(t.intelDcapMrsigner, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.attestation.AttestationSpecification();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.intelEpid != null && t.hasOwnProperty("intelEpid")) {
        n.attestationSpecification = 1;
        {
          let r = $root.attestation.AttestationSpecificationIntelEpid.verify(t.intelEpid);
          if (r)
            return "intelEpid." + r;
        }
      }
      if (t.intelDcap != null && t.hasOwnProperty("intelDcap")) {
        if (n.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        n.attestationSpecification = 1;
        {
          let r = $root.attestation.AttestationSpecificationIntelDcap.verify(t.intelDcap);
          if (r)
            return "intelDcap." + r;
        }
      }
      if (t.awsNitro != null && t.hasOwnProperty("awsNitro")) {
        if (n.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        n.attestationSpecification = 1;
        {
          let r = $root.attestation.AttestationSpecificationAwsNitro.verify(t.awsNitro);
          if (r)
            return "awsNitro." + r;
        }
      }
      if (t.amdSnp != null && t.hasOwnProperty("amdSnp")) {
        if (n.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        n.attestationSpecification = 1;
        {
          let r = $root.attestation.AttestationSpecificationAmdSnp.verify(t.amdSnp);
          if (r)
            return "amdSnp." + r;
        }
      }
      if (t.intelDcapMrsigner != null && t.hasOwnProperty("intelDcapMrsigner")) {
        if (n.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        n.attestationSpecification = 1;
        {
          let r = $root.attestation.AttestationSpecificationIntelDcapMrsigner.verify(t.intelDcapMrsigner);
          if (r)
            return "intelDcapMrsigner." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.attestation.AttestationSpecification)
        return t;
      let n = new $root.attestation.AttestationSpecification();
      if (t.intelEpid != null) {
        if (typeof t.intelEpid != "object")
          throw TypeError(".attestation.AttestationSpecification.intelEpid: object expected");
        n.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.fromObject(t.intelEpid);
      }
      if (t.intelDcap != null) {
        if (typeof t.intelDcap != "object")
          throw TypeError(".attestation.AttestationSpecification.intelDcap: object expected");
        n.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.fromObject(t.intelDcap);
      }
      if (t.awsNitro != null) {
        if (typeof t.awsNitro != "object")
          throw TypeError(".attestation.AttestationSpecification.awsNitro: object expected");
        n.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.fromObject(t.awsNitro);
      }
      if (t.amdSnp != null) {
        if (typeof t.amdSnp != "object")
          throw TypeError(".attestation.AttestationSpecification.amdSnp: object expected");
        n.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.fromObject(t.amdSnp);
      }
      if (t.intelDcapMrsigner != null) {
        if (typeof t.intelDcapMrsigner != "object")
          throw TypeError(".attestation.AttestationSpecification.intelDcapMrsigner: object expected");
        n.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.fromObject(t.intelDcapMrsigner);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.intelEpid != null && t.hasOwnProperty("intelEpid") && (r.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.toObject(t.intelEpid, n), n.oneofs && (r.attestationSpecification = "intelEpid")), t.intelDcap != null && t.hasOwnProperty("intelDcap") && (r.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.toObject(t.intelDcap, n), n.oneofs && (r.attestationSpecification = "intelDcap")), t.awsNitro != null && t.hasOwnProperty("awsNitro") && (r.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.toObject(t.awsNitro, n), n.oneofs && (r.attestationSpecification = "awsNitro")), t.amdSnp != null && t.hasOwnProperty("amdSnp") && (r.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.toObject(t.amdSnp, n), n.oneofs && (r.attestationSpecification = "amdSnp")), t.intelDcapMrsigner != null && t.hasOwnProperty("intelDcapMrsigner") && (r.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.toObject(t.intelDcapMrsigner, n), n.oneofs && (r.attestationSpecification = "intelDcapMrsigner")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/attestation.AttestationSpecification";
    }, o;
  }(), c.AttestationSpecificationIntelEpid = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.mrenclave = $util.newBuffer([]), o.prototype.iasRootCaDer = $util.newBuffer([]), o.prototype.acceptDebug = !1, o.prototype.acceptGroupOutOfDate = !1, o.prototype.acceptConfigurationNeeded = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.mrenclave != null && Object.hasOwnProperty.call(e, "mrenclave") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrenclave), e.iasRootCaDer != null && Object.hasOwnProperty.call(e, "iasRootCaDer") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.iasRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptGroupOutOfDate != null && Object.hasOwnProperty.call(e, "acceptGroupOutOfDate") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.AttestationSpecificationIntelEpid();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.mrenclave = e.bytes();
            break;
          }
          case 2: {
            r.iasRootCaDer = e.bytes();
            break;
          }
          case 3: {
            r.acceptDebug = e.bool();
            break;
          }
          case 4: {
            r.acceptGroupOutOfDate = e.bool();
            break;
          }
          case 5: {
            r.acceptConfigurationNeeded = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrenclave != null && e.hasOwnProperty("mrenclave") && !(e.mrenclave && typeof e.mrenclave.length == "number" || $util.isString(e.mrenclave)) ? "mrenclave: buffer expected" : e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && !(e.iasRootCaDer && typeof e.iasRootCaDer.length == "number" || $util.isString(e.iasRootCaDer)) ? "iasRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptGroupOutOfDate != null && e.hasOwnProperty("acceptGroupOutOfDate") && typeof e.acceptGroupOutOfDate != "boolean" ? "acceptGroupOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelEpid)
        return e;
      let t = new $root.attestation.AttestationSpecificationIntelEpid();
      return e.mrenclave != null && (typeof e.mrenclave == "string" ? $util.base64.decode(e.mrenclave, t.mrenclave = $util.newBuffer($util.base64.length(e.mrenclave)), 0) : e.mrenclave.length >= 0 && (t.mrenclave = e.mrenclave)), e.iasRootCaDer != null && (typeof e.iasRootCaDer == "string" ? $util.base64.decode(e.iasRootCaDer, t.iasRootCaDer = $util.newBuffer($util.base64.length(e.iasRootCaDer)), 0) : e.iasRootCaDer.length >= 0 && (t.iasRootCaDer = e.iasRootCaDer)), e.acceptDebug != null && (t.acceptDebug = !!e.acceptDebug), e.acceptGroupOutOfDate != null && (t.acceptGroupOutOfDate = !!e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && (t.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.mrenclave = "" : (n.mrenclave = [], t.bytes !== Array && (n.mrenclave = $util.newBuffer(n.mrenclave))), t.bytes === String ? n.iasRootCaDer = "" : (n.iasRootCaDer = [], t.bytes !== Array && (n.iasRootCaDer = $util.newBuffer(n.iasRootCaDer))), n.acceptDebug = !1, n.acceptGroupOutOfDate = !1, n.acceptConfigurationNeeded = !1), e.mrenclave != null && e.hasOwnProperty("mrenclave") && (n.mrenclave = t.bytes === String ? $util.base64.encode(e.mrenclave, 0, e.mrenclave.length) : t.bytes === Array ? Array.prototype.slice.call(e.mrenclave) : e.mrenclave), e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && (n.iasRootCaDer = t.bytes === String ? $util.base64.encode(e.iasRootCaDer, 0, e.iasRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.iasRootCaDer) : e.iasRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (n.acceptDebug = e.acceptDebug), e.acceptGroupOutOfDate != null && e.hasOwnProperty("acceptGroupOutOfDate") && (n.acceptGroupOutOfDate = e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (n.acceptConfigurationNeeded = e.acceptConfigurationNeeded), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelEpid";
    }, o;
  }(), c.AttestationSpecificationIntelDcap = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.mrenclave = $util.newBuffer([]), o.prototype.dcapRootCaDer = $util.newBuffer([]), o.prototype.acceptDebug = !1, o.prototype.acceptOutOfDate = !1, o.prototype.acceptConfigurationNeeded = !1, o.prototype.acceptRevoked = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.mrenclave != null && Object.hasOwnProperty.call(e, "mrenclave") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrenclave), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcapRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptOutOfDate != null && Object.hasOwnProperty.call(e, "acceptOutOfDate") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), e.acceptRevoked != null && Object.hasOwnProperty.call(e, "acceptRevoked") && t.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(e.acceptRevoked), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.AttestationSpecificationIntelDcap();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.mrenclave = e.bytes();
            break;
          }
          case 2: {
            r.dcapRootCaDer = e.bytes();
            break;
          }
          case 3: {
            r.acceptDebug = e.bool();
            break;
          }
          case 4: {
            r.acceptOutOfDate = e.bool();
            break;
          }
          case 5: {
            r.acceptConfigurationNeeded = e.bool();
            break;
          }
          case 6: {
            r.acceptRevoked = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrenclave != null && e.hasOwnProperty("mrenclave") && !(e.mrenclave && typeof e.mrenclave.length == "number" || $util.isString(e.mrenclave)) ? "mrenclave: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && typeof e.acceptOutOfDate != "boolean" ? "acceptOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && typeof e.acceptRevoked != "boolean" ? "acceptRevoked: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelDcap)
        return e;
      let t = new $root.attestation.AttestationSpecificationIntelDcap();
      return e.mrenclave != null && (typeof e.mrenclave == "string" ? $util.base64.decode(e.mrenclave, t.mrenclave = $util.newBuffer($util.base64.length(e.mrenclave)), 0) : e.mrenclave.length >= 0 && (t.mrenclave = e.mrenclave)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, t.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (t.dcapRootCaDer = e.dcapRootCaDer)), e.acceptDebug != null && (t.acceptDebug = !!e.acceptDebug), e.acceptOutOfDate != null && (t.acceptOutOfDate = !!e.acceptOutOfDate), e.acceptConfigurationNeeded != null && (t.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), e.acceptRevoked != null && (t.acceptRevoked = !!e.acceptRevoked), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.mrenclave = "" : (n.mrenclave = [], t.bytes !== Array && (n.mrenclave = $util.newBuffer(n.mrenclave))), t.bytes === String ? n.dcapRootCaDer = "" : (n.dcapRootCaDer = [], t.bytes !== Array && (n.dcapRootCaDer = $util.newBuffer(n.dcapRootCaDer))), n.acceptDebug = !1, n.acceptOutOfDate = !1, n.acceptConfigurationNeeded = !1, n.acceptRevoked = !1), e.mrenclave != null && e.hasOwnProperty("mrenclave") && (n.mrenclave = t.bytes === String ? $util.base64.encode(e.mrenclave, 0, e.mrenclave.length) : t.bytes === Array ? Array.prototype.slice.call(e.mrenclave) : e.mrenclave), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (n.dcapRootCaDer = t.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (n.acceptDebug = e.acceptDebug), e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && (n.acceptOutOfDate = e.acceptOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (n.acceptConfigurationNeeded = e.acceptConfigurationNeeded), e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && (n.acceptRevoked = e.acceptRevoked), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelDcap";
    }, o;
  }(), c.AttestationSpecificationAwsNitro = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.nitroRootCaDer = $util.newBuffer([]), o.prototype.pcr0 = $util.newBuffer([]), o.prototype.pcr1 = $util.newBuffer([]), o.prototype.pcr2 = $util.newBuffer([]), o.prototype.pcr8 = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.nitroRootCaDer != null && Object.hasOwnProperty.call(e, "nitroRootCaDer") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.nitroRootCaDer), e.pcr0 != null && Object.hasOwnProperty.call(e, "pcr0") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.pcr0), e.pcr1 != null && Object.hasOwnProperty.call(e, "pcr1") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.pcr1), e.pcr2 != null && Object.hasOwnProperty.call(e, "pcr2") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.pcr2), e.pcr8 != null && Object.hasOwnProperty.call(e, "pcr8") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.pcr8), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.AttestationSpecificationAwsNitro();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.nitroRootCaDer = e.bytes();
            break;
          }
          case 2: {
            r.pcr0 = e.bytes();
            break;
          }
          case 3: {
            r.pcr1 = e.bytes();
            break;
          }
          case 4: {
            r.pcr2 = e.bytes();
            break;
          }
          case 5: {
            r.pcr8 = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && !(e.nitroRootCaDer && typeof e.nitroRootCaDer.length == "number" || $util.isString(e.nitroRootCaDer)) ? "nitroRootCaDer: buffer expected" : e.pcr0 != null && e.hasOwnProperty("pcr0") && !(e.pcr0 && typeof e.pcr0.length == "number" || $util.isString(e.pcr0)) ? "pcr0: buffer expected" : e.pcr1 != null && e.hasOwnProperty("pcr1") && !(e.pcr1 && typeof e.pcr1.length == "number" || $util.isString(e.pcr1)) ? "pcr1: buffer expected" : e.pcr2 != null && e.hasOwnProperty("pcr2") && !(e.pcr2 && typeof e.pcr2.length == "number" || $util.isString(e.pcr2)) ? "pcr2: buffer expected" : e.pcr8 != null && e.hasOwnProperty("pcr8") && !(e.pcr8 && typeof e.pcr8.length == "number" || $util.isString(e.pcr8)) ? "pcr8: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationAwsNitro)
        return e;
      let t = new $root.attestation.AttestationSpecificationAwsNitro();
      return e.nitroRootCaDer != null && (typeof e.nitroRootCaDer == "string" ? $util.base64.decode(e.nitroRootCaDer, t.nitroRootCaDer = $util.newBuffer($util.base64.length(e.nitroRootCaDer)), 0) : e.nitroRootCaDer.length >= 0 && (t.nitroRootCaDer = e.nitroRootCaDer)), e.pcr0 != null && (typeof e.pcr0 == "string" ? $util.base64.decode(e.pcr0, t.pcr0 = $util.newBuffer($util.base64.length(e.pcr0)), 0) : e.pcr0.length >= 0 && (t.pcr0 = e.pcr0)), e.pcr1 != null && (typeof e.pcr1 == "string" ? $util.base64.decode(e.pcr1, t.pcr1 = $util.newBuffer($util.base64.length(e.pcr1)), 0) : e.pcr1.length >= 0 && (t.pcr1 = e.pcr1)), e.pcr2 != null && (typeof e.pcr2 == "string" ? $util.base64.decode(e.pcr2, t.pcr2 = $util.newBuffer($util.base64.length(e.pcr2)), 0) : e.pcr2.length >= 0 && (t.pcr2 = e.pcr2)), e.pcr8 != null && (typeof e.pcr8 == "string" ? $util.base64.decode(e.pcr8, t.pcr8 = $util.newBuffer($util.base64.length(e.pcr8)), 0) : e.pcr8.length >= 0 && (t.pcr8 = e.pcr8)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.nitroRootCaDer = "" : (n.nitroRootCaDer = [], t.bytes !== Array && (n.nitroRootCaDer = $util.newBuffer(n.nitroRootCaDer))), t.bytes === String ? n.pcr0 = "" : (n.pcr0 = [], t.bytes !== Array && (n.pcr0 = $util.newBuffer(n.pcr0))), t.bytes === String ? n.pcr1 = "" : (n.pcr1 = [], t.bytes !== Array && (n.pcr1 = $util.newBuffer(n.pcr1))), t.bytes === String ? n.pcr2 = "" : (n.pcr2 = [], t.bytes !== Array && (n.pcr2 = $util.newBuffer(n.pcr2))), t.bytes === String ? n.pcr8 = "" : (n.pcr8 = [], t.bytes !== Array && (n.pcr8 = $util.newBuffer(n.pcr8)))), e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && (n.nitroRootCaDer = t.bytes === String ? $util.base64.encode(e.nitroRootCaDer, 0, e.nitroRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.nitroRootCaDer) : e.nitroRootCaDer), e.pcr0 != null && e.hasOwnProperty("pcr0") && (n.pcr0 = t.bytes === String ? $util.base64.encode(e.pcr0, 0, e.pcr0.length) : t.bytes === Array ? Array.prototype.slice.call(e.pcr0) : e.pcr0), e.pcr1 != null && e.hasOwnProperty("pcr1") && (n.pcr1 = t.bytes === String ? $util.base64.encode(e.pcr1, 0, e.pcr1.length) : t.bytes === Array ? Array.prototype.slice.call(e.pcr1) : e.pcr1), e.pcr2 != null && e.hasOwnProperty("pcr2") && (n.pcr2 = t.bytes === String ? $util.base64.encode(e.pcr2, 0, e.pcr2.length) : t.bytes === Array ? Array.prototype.slice.call(e.pcr2) : e.pcr2), e.pcr8 != null && e.hasOwnProperty("pcr8") && (n.pcr8 = t.bytes === String ? $util.base64.encode(e.pcr8, 0, e.pcr8.length) : t.bytes === Array ? Array.prototype.slice.call(e.pcr8) : e.pcr8), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationAwsNitro";
    }, o;
  }(), c.AttestationSpecificationAmdSnp = function() {
    function o(i) {
      if (this.authorizedChipIds = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.amdArkDer = $util.newBuffer([]), o.prototype.measurement = $util.newBuffer([]), o.prototype.roughtimePubKey = $util.newBuffer([]), o.prototype.authorizedChipIds = $util.emptyArray, o.prototype.decentriqDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.amdArkDer != null && Object.hasOwnProperty.call(e, "amdArkDer") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.amdArkDer), e.measurement != null && Object.hasOwnProperty.call(e, "measurement") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.measurement), e.roughtimePubKey != null && Object.hasOwnProperty.call(e, "roughtimePubKey") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.roughtimePubKey), e.authorizedChipIds != null && e.authorizedChipIds.length)
        for (let n = 0; n < e.authorizedChipIds.length; ++n)
          t.uint32(
            /* id 4, wireType 2 =*/
            34
          ).bytes(e.authorizedChipIds[n]);
      return e.decentriqDer != null && Object.hasOwnProperty.call(e, "decentriqDer") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.decentriqDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.AttestationSpecificationAmdSnp();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.amdArkDer = e.bytes();
            break;
          }
          case 2: {
            r.measurement = e.bytes();
            break;
          }
          case 3: {
            r.roughtimePubKey = e.bytes();
            break;
          }
          case 4: {
            r.authorizedChipIds && r.authorizedChipIds.length || (r.authorizedChipIds = []), r.authorizedChipIds.push(e.bytes());
            break;
          }
          case 5: {
            r.decentriqDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && !(e.amdArkDer && typeof e.amdArkDer.length == "number" || $util.isString(e.amdArkDer)))
        return "amdArkDer: buffer expected";
      if (e.measurement != null && e.hasOwnProperty("measurement") && !(e.measurement && typeof e.measurement.length == "number" || $util.isString(e.measurement)))
        return "measurement: buffer expected";
      if (e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && !(e.roughtimePubKey && typeof e.roughtimePubKey.length == "number" || $util.isString(e.roughtimePubKey)))
        return "roughtimePubKey: buffer expected";
      if (e.authorizedChipIds != null && e.hasOwnProperty("authorizedChipIds")) {
        if (!Array.isArray(e.authorizedChipIds))
          return "authorizedChipIds: array expected";
        for (let t = 0; t < e.authorizedChipIds.length; ++t)
          if (!(e.authorizedChipIds[t] && typeof e.authorizedChipIds[t].length == "number" || $util.isString(e.authorizedChipIds[t])))
            return "authorizedChipIds: buffer[] expected";
      }
      return e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && !(e.decentriqDer && typeof e.decentriqDer.length == "number" || $util.isString(e.decentriqDer)) ? "decentriqDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationAmdSnp)
        return e;
      let t = new $root.attestation.AttestationSpecificationAmdSnp();
      if (e.amdArkDer != null && (typeof e.amdArkDer == "string" ? $util.base64.decode(e.amdArkDer, t.amdArkDer = $util.newBuffer($util.base64.length(e.amdArkDer)), 0) : e.amdArkDer.length >= 0 && (t.amdArkDer = e.amdArkDer)), e.measurement != null && (typeof e.measurement == "string" ? $util.base64.decode(e.measurement, t.measurement = $util.newBuffer($util.base64.length(e.measurement)), 0) : e.measurement.length >= 0 && (t.measurement = e.measurement)), e.roughtimePubKey != null && (typeof e.roughtimePubKey == "string" ? $util.base64.decode(e.roughtimePubKey, t.roughtimePubKey = $util.newBuffer($util.base64.length(e.roughtimePubKey)), 0) : e.roughtimePubKey.length >= 0 && (t.roughtimePubKey = e.roughtimePubKey)), e.authorizedChipIds) {
        if (!Array.isArray(e.authorizedChipIds))
          throw TypeError(".attestation.AttestationSpecificationAmdSnp.authorizedChipIds: array expected");
        t.authorizedChipIds = [];
        for (let n = 0; n < e.authorizedChipIds.length; ++n)
          typeof e.authorizedChipIds[n] == "string" ? $util.base64.decode(e.authorizedChipIds[n], t.authorizedChipIds[n] = $util.newBuffer($util.base64.length(e.authorizedChipIds[n])), 0) : e.authorizedChipIds[n].length >= 0 && (t.authorizedChipIds[n] = e.authorizedChipIds[n]);
      }
      return e.decentriqDer != null && (typeof e.decentriqDer == "string" ? $util.base64.decode(e.decentriqDer, t.decentriqDer = $util.newBuffer($util.base64.length(e.decentriqDer)), 0) : e.decentriqDer.length >= 0 && (t.decentriqDer = e.decentriqDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.authorizedChipIds = []), t.defaults && (t.bytes === String ? n.amdArkDer = "" : (n.amdArkDer = [], t.bytes !== Array && (n.amdArkDer = $util.newBuffer(n.amdArkDer))), t.bytes === String ? n.measurement = "" : (n.measurement = [], t.bytes !== Array && (n.measurement = $util.newBuffer(n.measurement))), t.bytes === String ? n.roughtimePubKey = "" : (n.roughtimePubKey = [], t.bytes !== Array && (n.roughtimePubKey = $util.newBuffer(n.roughtimePubKey))), t.bytes === String ? n.decentriqDer = "" : (n.decentriqDer = [], t.bytes !== Array && (n.decentriqDer = $util.newBuffer(n.decentriqDer)))), e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && (n.amdArkDer = t.bytes === String ? $util.base64.encode(e.amdArkDer, 0, e.amdArkDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.amdArkDer) : e.amdArkDer), e.measurement != null && e.hasOwnProperty("measurement") && (n.measurement = t.bytes === String ? $util.base64.encode(e.measurement, 0, e.measurement.length) : t.bytes === Array ? Array.prototype.slice.call(e.measurement) : e.measurement), e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && (n.roughtimePubKey = t.bytes === String ? $util.base64.encode(e.roughtimePubKey, 0, e.roughtimePubKey.length) : t.bytes === Array ? Array.prototype.slice.call(e.roughtimePubKey) : e.roughtimePubKey), e.authorizedChipIds && e.authorizedChipIds.length) {
        n.authorizedChipIds = [];
        for (let r = 0; r < e.authorizedChipIds.length; ++r)
          n.authorizedChipIds[r] = t.bytes === String ? $util.base64.encode(e.authorizedChipIds[r], 0, e.authorizedChipIds[r].length) : t.bytes === Array ? Array.prototype.slice.call(e.authorizedChipIds[r]) : e.authorizedChipIds[r];
      }
      return e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && (n.decentriqDer = t.bytes === String ? $util.base64.encode(e.decentriqDer, 0, e.decentriqDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.decentriqDer) : e.decentriqDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationAmdSnp";
    }, o;
  }(), c.AttestationSpecificationIntelDcapMrsigner = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.mrsigner = $util.newBuffer([]), o.prototype.dcapRootCaDer = $util.newBuffer([]), o.prototype.acceptDebug = !1, o.prototype.acceptOutOfDate = !1, o.prototype.acceptConfigurationNeeded = !1, o.prototype.acceptRevoked = !1, o.prototype.isvprodid = 0, o.prototype.sigstoreRootOlpcJson = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.mrsigner != null && Object.hasOwnProperty.call(e, "mrsigner") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrsigner), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcapRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptOutOfDate != null && Object.hasOwnProperty.call(e, "acceptOutOfDate") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), e.acceptRevoked != null && Object.hasOwnProperty.call(e, "acceptRevoked") && t.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(e.acceptRevoked), e.isvprodid != null && Object.hasOwnProperty.call(e, "isvprodid") && t.uint32(
        /* id 7, wireType 0 =*/
        56
      ).uint32(e.isvprodid), e.sigstoreRootOlpcJson != null && Object.hasOwnProperty.call(e, "sigstoreRootOlpcJson") && t.uint32(
        /* id 8, wireType 2 =*/
        66
      ).bytes(e.sigstoreRootOlpcJson), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.attestation.AttestationSpecificationIntelDcapMrsigner();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.mrsigner = e.bytes();
            break;
          }
          case 2: {
            r.dcapRootCaDer = e.bytes();
            break;
          }
          case 3: {
            r.acceptDebug = e.bool();
            break;
          }
          case 4: {
            r.acceptOutOfDate = e.bool();
            break;
          }
          case 5: {
            r.acceptConfigurationNeeded = e.bool();
            break;
          }
          case 6: {
            r.acceptRevoked = e.bool();
            break;
          }
          case 7: {
            r.isvprodid = e.uint32();
            break;
          }
          case 8: {
            r.sigstoreRootOlpcJson = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrsigner != null && e.hasOwnProperty("mrsigner") && !(e.mrsigner && typeof e.mrsigner.length == "number" || $util.isString(e.mrsigner)) ? "mrsigner: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && typeof e.acceptOutOfDate != "boolean" ? "acceptOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && typeof e.acceptRevoked != "boolean" ? "acceptRevoked: boolean expected" : e.isvprodid != null && e.hasOwnProperty("isvprodid") && !$util.isInteger(e.isvprodid) ? "isvprodid: integer expected" : e.sigstoreRootOlpcJson != null && e.hasOwnProperty("sigstoreRootOlpcJson") && !(e.sigstoreRootOlpcJson && typeof e.sigstoreRootOlpcJson.length == "number" || $util.isString(e.sigstoreRootOlpcJson)) ? "sigstoreRootOlpcJson: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelDcapMrsigner)
        return e;
      let t = new $root.attestation.AttestationSpecificationIntelDcapMrsigner();
      return e.mrsigner != null && (typeof e.mrsigner == "string" ? $util.base64.decode(e.mrsigner, t.mrsigner = $util.newBuffer($util.base64.length(e.mrsigner)), 0) : e.mrsigner.length >= 0 && (t.mrsigner = e.mrsigner)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, t.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (t.dcapRootCaDer = e.dcapRootCaDer)), e.acceptDebug != null && (t.acceptDebug = !!e.acceptDebug), e.acceptOutOfDate != null && (t.acceptOutOfDate = !!e.acceptOutOfDate), e.acceptConfigurationNeeded != null && (t.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), e.acceptRevoked != null && (t.acceptRevoked = !!e.acceptRevoked), e.isvprodid != null && (t.isvprodid = e.isvprodid >>> 0), e.sigstoreRootOlpcJson != null && (typeof e.sigstoreRootOlpcJson == "string" ? $util.base64.decode(e.sigstoreRootOlpcJson, t.sigstoreRootOlpcJson = $util.newBuffer($util.base64.length(e.sigstoreRootOlpcJson)), 0) : e.sigstoreRootOlpcJson.length >= 0 && (t.sigstoreRootOlpcJson = e.sigstoreRootOlpcJson)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.mrsigner = "" : (n.mrsigner = [], t.bytes !== Array && (n.mrsigner = $util.newBuffer(n.mrsigner))), t.bytes === String ? n.dcapRootCaDer = "" : (n.dcapRootCaDer = [], t.bytes !== Array && (n.dcapRootCaDer = $util.newBuffer(n.dcapRootCaDer))), n.acceptDebug = !1, n.acceptOutOfDate = !1, n.acceptConfigurationNeeded = !1, n.acceptRevoked = !1, n.isvprodid = 0, t.bytes === String ? n.sigstoreRootOlpcJson = "" : (n.sigstoreRootOlpcJson = [], t.bytes !== Array && (n.sigstoreRootOlpcJson = $util.newBuffer(n.sigstoreRootOlpcJson)))), e.mrsigner != null && e.hasOwnProperty("mrsigner") && (n.mrsigner = t.bytes === String ? $util.base64.encode(e.mrsigner, 0, e.mrsigner.length) : t.bytes === Array ? Array.prototype.slice.call(e.mrsigner) : e.mrsigner), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (n.dcapRootCaDer = t.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (n.acceptDebug = e.acceptDebug), e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && (n.acceptOutOfDate = e.acceptOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (n.acceptConfigurationNeeded = e.acceptConfigurationNeeded), e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && (n.acceptRevoked = e.acceptRevoked), e.isvprodid != null && e.hasOwnProperty("isvprodid") && (n.isvprodid = e.isvprodid), e.sigstoreRootOlpcJson != null && e.hasOwnProperty("sigstoreRootOlpcJson") && (n.sigstoreRootOlpcJson = t.bytes === String ? $util.base64.encode(e.sigstoreRootOlpcJson, 0, e.sigstoreRootOlpcJson.length) : t.bytes === Array ? Array.prototype.slice.call(e.sigstoreRootOlpcJson) : e.sigstoreRootOlpcJson), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelDcapMrsigner";
    }, o;
  }(), c;
})(), azure_blob_storage = $root.azure_blob_storage = (() => {
  const c = {};
  return c.ImportRole = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.azure_blob_storage.ImportRole();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.azure_blob_storage.ImportRole ? e : new $root.azure_blob_storage.ImportRole();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.ImportRole";
    }, o;
  }(), c.ExportRole = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.azure_blob_storage.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.azure_blob_storage.ExportRole();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.azure_blob_storage.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.azure_blob_storage.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.azure_blob_storage.ExportRole)
        return e;
      let t = new $root.azure_blob_storage.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".azure_blob_storage.ExportRole.input: object expected");
        t.input = $root.azure_blob_storage.SinkInput.fromObject(e.input);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null), e.input != null && e.hasOwnProperty("input") && (n.input = $root.azure_blob_storage.SinkInput.toObject(e.input, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.ExportRole";
    }, o;
  }(), c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.azure_blob_storage.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.azure_blob_storage.SingleFile)
        return e;
      let t = new $root.azure_blob_storage.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.azure_blob_storage.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.azure_blob_storage.RawFile ? e : new $root.azure_blob_storage.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.azure_blob_storage.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.azure_blob_storage.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.azure_blob_storage.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.azure_blob_storage.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.azure_blob_storage.ZipFile)
        return t;
      let n = new $root.azure_blob_storage.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".azure_blob_storage.ZipFile.singleFile: object expected");
        n.singleFile = $root.azure_blob_storage.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.azure_blob_storage.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/azure_blob_storage.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.azure_blob_storage.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.azure_blob_storage.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.azure_blob_storage.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.azure_blob_storage.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.azure_blob_storage.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.azure_blob_storage.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.azure_blob_storage.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.azure_blob_storage.SinkInput)
        return t;
      let n = new $root.azure_blob_storage.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".azure_blob_storage.SinkInput.raw: object expected");
        n.raw = $root.azure_blob_storage.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".azure_blob_storage.SinkInput.zip: object expected");
        n.zip = $root.azure_blob_storage.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.azure_blob_storage.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.azure_blob_storage.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/azure_blob_storage.SinkInput";
    }, o;
  }(), c.AzureBlobStorageWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.credentialsDependency = "", o.prototype.importRole = null, o.prototype.exportRole = null;
    let i;
    return Object.defineProperty(o.prototype, "role", {
      get: $util.oneOfGetter(i = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.credentialsDependency != null && Object.hasOwnProperty.call(t, "credentialsDependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.credentialsDependency), t.importRole != null && Object.hasOwnProperty.call(t, "importRole") && $root.azure_blob_storage.ImportRole.encode(t.importRole, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.exportRole != null && Object.hasOwnProperty.call(t, "exportRole") && $root.azure_blob_storage.ExportRole.encode(t.exportRole, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.credentialsDependency = t.string();
            break;
          }
          case 2: {
            u.importRole = $root.azure_blob_storage.ImportRole.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.exportRole = $root.azure_blob_storage.ExportRole.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && !$util.isString(t.credentialsDependency))
        return "credentialsDependency: string expected";
      if (t.importRole != null && t.hasOwnProperty("importRole")) {
        n.role = 1;
        {
          let r = $root.azure_blob_storage.ImportRole.verify(t.importRole);
          if (r)
            return "importRole." + r;
        }
      }
      if (t.exportRole != null && t.hasOwnProperty("exportRole")) {
        if (n.role === 1)
          return "role: multiple values";
        n.role = 1;
        {
          let r = $root.azure_blob_storage.ExportRole.verify(t.exportRole);
          if (r)
            return "exportRole." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration)
        return t;
      let n = new $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration();
      if (t.credentialsDependency != null && (n.credentialsDependency = String(t.credentialsDependency)), t.importRole != null) {
        if (typeof t.importRole != "object")
          throw TypeError(".azure_blob_storage.AzureBlobStorageWorkerConfiguration.importRole: object expected");
        n.importRole = $root.azure_blob_storage.ImportRole.fromObject(t.importRole);
      }
      if (t.exportRole != null) {
        if (typeof t.exportRole != "object")
          throw TypeError(".azure_blob_storage.AzureBlobStorageWorkerConfiguration.exportRole: object expected");
        n.exportRole = $root.azure_blob_storage.ExportRole.fromObject(t.exportRole);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.credentialsDependency = ""), t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && (r.credentialsDependency = t.credentialsDependency), t.importRole != null && t.hasOwnProperty("importRole") && (r.importRole = $root.azure_blob_storage.ImportRole.toObject(t.importRole, n), n.oneofs && (r.role = "importRole")), t.exportRole != null && t.hasOwnProperty("exportRole") && (r.exportRole = $root.azure_blob_storage.ExportRole.toObject(t.exportRole, n), n.oneofs && (r.role = "exportRole")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/azure_blob_storage.AzureBlobStorageWorkerConfiguration";
    }, o;
  }(), c;
})(), compute_container = $root.compute_container = (() => {
  const c = {};
  return c.ContainerWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.static = null;
    let i;
    return Object.defineProperty(o.prototype, "configuration", {
      get: $util.oneOfGetter(i = ["static"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.static != null && Object.hasOwnProperty.call(t, "static") && $root.compute_container.StaticImage.encode(t.static, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_container.ContainerWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.static = $root.compute_container.StaticImage.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.static != null && t.hasOwnProperty("static")) {
        let n = $root.compute_container.StaticImage.verify(t.static);
        if (n)
          return "static." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_container.ContainerWorkerConfiguration)
        return t;
      let n = new $root.compute_container.ContainerWorkerConfiguration();
      if (t.static != null) {
        if (typeof t.static != "object")
          throw TypeError(".compute_container.ContainerWorkerConfiguration.static: object expected");
        n.static = $root.compute_container.StaticImage.fromObject(t.static);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.static != null && t.hasOwnProperty("static") && (r.static = $root.compute_container.StaticImage.toObject(t.static, n), n.oneofs && (r.configuration = "static")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_container.ContainerWorkerConfiguration";
    }, o;
  }(), c.StaticImage = function() {
    function o(e) {
      if (this.command = [], this.mountPoints = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.command = $util.emptyArray, o.prototype.mountPoints = $util.emptyArray, o.prototype.outputPath = "", o.prototype.includeContainerLogsOnError = !1, o.prototype.includeContainerLogsOnSuccess = !1, o.prototype.minimumContainerMemorySize = null, o.prototype.extraChunkCacheSizeToAvailableMemoryRatio = null, o.prototype.proxyConfiguration = null;
    let i;
    return Object.defineProperty(o.prototype, "_minimumContainerMemorySize", {
      get: $util.oneOfGetter(i = ["minimumContainerMemorySize"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_extraChunkCacheSizeToAvailableMemoryRatio", {
      get: $util.oneOfGetter(i = ["extraChunkCacheSizeToAvailableMemoryRatio"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_proxyConfiguration", {
      get: $util.oneOfGetter(i = ["proxyConfiguration"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.command != null && t.command.length)
        for (let r = 0; r < t.command.length; ++r)
          n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(t.command[r]);
      if (t.mountPoints != null && t.mountPoints.length)
        for (let r = 0; r < t.mountPoints.length; ++r)
          $root.compute_container.MountPoint.encode(t.mountPoints[r], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return t.outputPath != null && Object.hasOwnProperty.call(t, "outputPath") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.outputPath), t.includeContainerLogsOnError != null && Object.hasOwnProperty.call(t, "includeContainerLogsOnError") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.includeContainerLogsOnError), t.includeContainerLogsOnSuccess != null && Object.hasOwnProperty.call(t, "includeContainerLogsOnSuccess") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(t.includeContainerLogsOnSuccess), t.minimumContainerMemorySize != null && Object.hasOwnProperty.call(t, "minimumContainerMemorySize") && n.uint32(
        /* id 6, wireType 0 =*/
        48
      ).uint64(t.minimumContainerMemorySize), t.extraChunkCacheSizeToAvailableMemoryRatio != null && Object.hasOwnProperty.call(t, "extraChunkCacheSizeToAvailableMemoryRatio") && n.uint32(
        /* id 7, wireType 5 =*/
        61
      ).float(t.extraChunkCacheSizeToAvailableMemoryRatio), t.proxyConfiguration != null && Object.hasOwnProperty.call(t, "proxyConfiguration") && $root.compute_container.ProxyConfiguration.encode(t.proxyConfiguration, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_container.StaticImage();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.command && u.command.length || (u.command = []), u.command.push(t.string());
            break;
          }
          case 2: {
            u.mountPoints && u.mountPoints.length || (u.mountPoints = []), u.mountPoints.push($root.compute_container.MountPoint.decode(t, t.uint32()));
            break;
          }
          case 3: {
            u.outputPath = t.string();
            break;
          }
          case 4: {
            u.includeContainerLogsOnError = t.bool();
            break;
          }
          case 5: {
            u.includeContainerLogsOnSuccess = t.bool();
            break;
          }
          case 6: {
            u.minimumContainerMemorySize = t.uint64();
            break;
          }
          case 7: {
            u.extraChunkCacheSizeToAvailableMemoryRatio = t.float();
            break;
          }
          case 8: {
            u.proxyConfiguration = $root.compute_container.ProxyConfiguration.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.command != null && t.hasOwnProperty("command")) {
        if (!Array.isArray(t.command))
          return "command: array expected";
        for (let n = 0; n < t.command.length; ++n)
          if (!$util.isString(t.command[n]))
            return "command: string[] expected";
      }
      if (t.mountPoints != null && t.hasOwnProperty("mountPoints")) {
        if (!Array.isArray(t.mountPoints))
          return "mountPoints: array expected";
        for (let n = 0; n < t.mountPoints.length; ++n) {
          let r = $root.compute_container.MountPoint.verify(t.mountPoints[n]);
          if (r)
            return "mountPoints." + r;
        }
      }
      if (t.outputPath != null && t.hasOwnProperty("outputPath") && !$util.isString(t.outputPath))
        return "outputPath: string expected";
      if (t.includeContainerLogsOnError != null && t.hasOwnProperty("includeContainerLogsOnError") && typeof t.includeContainerLogsOnError != "boolean")
        return "includeContainerLogsOnError: boolean expected";
      if (t.includeContainerLogsOnSuccess != null && t.hasOwnProperty("includeContainerLogsOnSuccess") && typeof t.includeContainerLogsOnSuccess != "boolean")
        return "includeContainerLogsOnSuccess: boolean expected";
      if (t.minimumContainerMemorySize != null && t.hasOwnProperty("minimumContainerMemorySize") && !$util.isInteger(t.minimumContainerMemorySize) && !(t.minimumContainerMemorySize && $util.isInteger(t.minimumContainerMemorySize.low) && $util.isInteger(t.minimumContainerMemorySize.high)))
        return "minimumContainerMemorySize: integer|Long expected";
      if (t.extraChunkCacheSizeToAvailableMemoryRatio != null && t.hasOwnProperty("extraChunkCacheSizeToAvailableMemoryRatio") && typeof t.extraChunkCacheSizeToAvailableMemoryRatio != "number")
        return "extraChunkCacheSizeToAvailableMemoryRatio: number expected";
      if (t.proxyConfiguration != null && t.hasOwnProperty("proxyConfiguration")) {
        let n = $root.compute_container.ProxyConfiguration.verify(t.proxyConfiguration);
        if (n)
          return "proxyConfiguration." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_container.StaticImage)
        return t;
      let n = new $root.compute_container.StaticImage();
      if (t.command) {
        if (!Array.isArray(t.command))
          throw TypeError(".compute_container.StaticImage.command: array expected");
        n.command = [];
        for (let r = 0; r < t.command.length; ++r)
          n.command[r] = String(t.command[r]);
      }
      if (t.mountPoints) {
        if (!Array.isArray(t.mountPoints))
          throw TypeError(".compute_container.StaticImage.mountPoints: array expected");
        n.mountPoints = [];
        for (let r = 0; r < t.mountPoints.length; ++r) {
          if (typeof t.mountPoints[r] != "object")
            throw TypeError(".compute_container.StaticImage.mountPoints: object expected");
          n.mountPoints[r] = $root.compute_container.MountPoint.fromObject(t.mountPoints[r]);
        }
      }
      if (t.outputPath != null && (n.outputPath = String(t.outputPath)), t.includeContainerLogsOnError != null && (n.includeContainerLogsOnError = !!t.includeContainerLogsOnError), t.includeContainerLogsOnSuccess != null && (n.includeContainerLogsOnSuccess = !!t.includeContainerLogsOnSuccess), t.minimumContainerMemorySize != null && ($util.Long ? (n.minimumContainerMemorySize = $util.Long.fromValue(t.minimumContainerMemorySize)).unsigned = !0 : typeof t.minimumContainerMemorySize == "string" ? n.minimumContainerMemorySize = parseInt(t.minimumContainerMemorySize, 10) : typeof t.minimumContainerMemorySize == "number" ? n.minimumContainerMemorySize = t.minimumContainerMemorySize : typeof t.minimumContainerMemorySize == "object" && (n.minimumContainerMemorySize = new $util.LongBits(t.minimumContainerMemorySize.low >>> 0, t.minimumContainerMemorySize.high >>> 0).toNumber(!0))), t.extraChunkCacheSizeToAvailableMemoryRatio != null && (n.extraChunkCacheSizeToAvailableMemoryRatio = Number(t.extraChunkCacheSizeToAvailableMemoryRatio)), t.proxyConfiguration != null) {
        if (typeof t.proxyConfiguration != "object")
          throw TypeError(".compute_container.StaticImage.proxyConfiguration: object expected");
        n.proxyConfiguration = $root.compute_container.ProxyConfiguration.fromObject(t.proxyConfiguration);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.command = [], r.mountPoints = []), n.defaults && (r.outputPath = "", r.includeContainerLogsOnError = !1, r.includeContainerLogsOnSuccess = !1), t.command && t.command.length) {
        r.command = [];
        for (let u = 0; u < t.command.length; ++u)
          r.command[u] = t.command[u];
      }
      if (t.mountPoints && t.mountPoints.length) {
        r.mountPoints = [];
        for (let u = 0; u < t.mountPoints.length; ++u)
          r.mountPoints[u] = $root.compute_container.MountPoint.toObject(t.mountPoints[u], n);
      }
      return t.outputPath != null && t.hasOwnProperty("outputPath") && (r.outputPath = t.outputPath), t.includeContainerLogsOnError != null && t.hasOwnProperty("includeContainerLogsOnError") && (r.includeContainerLogsOnError = t.includeContainerLogsOnError), t.includeContainerLogsOnSuccess != null && t.hasOwnProperty("includeContainerLogsOnSuccess") && (r.includeContainerLogsOnSuccess = t.includeContainerLogsOnSuccess), t.minimumContainerMemorySize != null && t.hasOwnProperty("minimumContainerMemorySize") && (typeof t.minimumContainerMemorySize == "number" ? r.minimumContainerMemorySize = n.longs === String ? String(t.minimumContainerMemorySize) : t.minimumContainerMemorySize : r.minimumContainerMemorySize = n.longs === String ? $util.Long.prototype.toString.call(t.minimumContainerMemorySize) : n.longs === Number ? new $util.LongBits(t.minimumContainerMemorySize.low >>> 0, t.minimumContainerMemorySize.high >>> 0).toNumber(!0) : t.minimumContainerMemorySize, n.oneofs && (r._minimumContainerMemorySize = "minimumContainerMemorySize")), t.extraChunkCacheSizeToAvailableMemoryRatio != null && t.hasOwnProperty("extraChunkCacheSizeToAvailableMemoryRatio") && (r.extraChunkCacheSizeToAvailableMemoryRatio = n.json && !isFinite(t.extraChunkCacheSizeToAvailableMemoryRatio) ? String(t.extraChunkCacheSizeToAvailableMemoryRatio) : t.extraChunkCacheSizeToAvailableMemoryRatio, n.oneofs && (r._extraChunkCacheSizeToAvailableMemoryRatio = "extraChunkCacheSizeToAvailableMemoryRatio")), t.proxyConfiguration != null && t.hasOwnProperty("proxyConfiguration") && (r.proxyConfiguration = $root.compute_container.ProxyConfiguration.toObject(t.proxyConfiguration, n), n.oneofs && (r._proxyConfiguration = "proxyConfiguration")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_container.StaticImage";
    }, o;
  }(), c.ProxyConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.liberal = null, o.prototype.domainAllowlist = null;
    let i;
    return Object.defineProperty(o.prototype, "configuration", {
      get: $util.oneOfGetter(i = ["liberal", "domainAllowlist"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.liberal != null && Object.hasOwnProperty.call(t, "liberal") && $root.compute_container.ProxyConfigurationLiberal.encode(t.liberal, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.domainAllowlist != null && Object.hasOwnProperty.call(t, "domainAllowlist") && $root.compute_container.ProxyConfigurationDomainAllowlist.encode(t.domainAllowlist, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_container.ProxyConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.liberal = $root.compute_container.ProxyConfigurationLiberal.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.liberal != null && t.hasOwnProperty("liberal")) {
        n.configuration = 1;
        {
          let r = $root.compute_container.ProxyConfigurationLiberal.verify(t.liberal);
          if (r)
            return "liberal." + r;
        }
      }
      if (t.domainAllowlist != null && t.hasOwnProperty("domainAllowlist")) {
        if (n.configuration === 1)
          return "configuration: multiple values";
        n.configuration = 1;
        {
          let r = $root.compute_container.ProxyConfigurationDomainAllowlist.verify(t.domainAllowlist);
          if (r)
            return "domainAllowlist." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_container.ProxyConfiguration)
        return t;
      let n = new $root.compute_container.ProxyConfiguration();
      if (t.liberal != null) {
        if (typeof t.liberal != "object")
          throw TypeError(".compute_container.ProxyConfiguration.liberal: object expected");
        n.liberal = $root.compute_container.ProxyConfigurationLiberal.fromObject(t.liberal);
      }
      if (t.domainAllowlist != null) {
        if (typeof t.domainAllowlist != "object")
          throw TypeError(".compute_container.ProxyConfiguration.domainAllowlist: object expected");
        n.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.fromObject(t.domainAllowlist);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.liberal != null && t.hasOwnProperty("liberal") && (r.liberal = $root.compute_container.ProxyConfigurationLiberal.toObject(t.liberal, n), n.oneofs && (r.configuration = "liberal")), t.domainAllowlist != null && t.hasOwnProperty("domainAllowlist") && (r.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.toObject(t.domainAllowlist, n), n.oneofs && (r.configuration = "domainAllowlist")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_container.ProxyConfiguration";
    }, o;
  }(), c.ProxyConfigurationLiberal = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_container.ProxyConfigurationLiberal();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.compute_container.ProxyConfigurationLiberal ? e : new $root.compute_container.ProxyConfigurationLiberal();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.ProxyConfigurationLiberal";
    }, o;
  }(), c.ProxyConfigurationDomainAllowlist = function() {
    function o(i) {
      if (this.domain = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.domain = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.domain != null && e.domain.length)
        for (let n = 0; n < e.domain.length; ++n)
          t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.domain[n]);
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_container.ProxyConfigurationDomainAllowlist();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.domain && r.domain.length || (r.domain = []), r.domain.push(e.string());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.domain != null && e.hasOwnProperty("domain")) {
        if (!Array.isArray(e.domain))
          return "domain: array expected";
        for (let t = 0; t < e.domain.length; ++t)
          if (!$util.isString(e.domain[t]))
            return "domain: string[] expected";
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_container.ProxyConfigurationDomainAllowlist)
        return e;
      let t = new $root.compute_container.ProxyConfigurationDomainAllowlist();
      if (e.domain) {
        if (!Array.isArray(e.domain))
          throw TypeError(".compute_container.ProxyConfigurationDomainAllowlist.domain: array expected");
        t.domain = [];
        for (let n = 0; n < e.domain.length; ++n)
          t.domain[n] = String(e.domain[n]);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.domain = []), e.domain && e.domain.length) {
        n.domain = [];
        for (let r = 0; r < e.domain.length; ++r)
          n.domain[r] = e.domain[r];
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.ProxyConfigurationDomainAllowlist";
    }, o;
  }(), c.MountPoint = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.path = "", o.prototype.dependency = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.path != null && Object.hasOwnProperty.call(e, "path") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.path), e.dependency != null && Object.hasOwnProperty.call(e, "dependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dependency), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_container.MountPoint();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.path = e.string();
            break;
          }
          case 2: {
            r.dependency = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.path != null && e.hasOwnProperty("path") && !$util.isString(e.path) ? "path: string expected" : e.dependency != null && e.hasOwnProperty("dependency") && !$util.isString(e.dependency) ? "dependency: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_container.MountPoint)
        return e;
      let t = new $root.compute_container.MountPoint();
      return e.path != null && (t.path = String(e.path)), e.dependency != null && (t.dependency = String(e.dependency)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.path = "", n.dependency = ""), e.path != null && e.hasOwnProperty("path") && (n.path = e.path), e.dependency != null && e.hasOwnProperty("dependency") && (n.dependency = e.dependency), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.MountPoint";
    }, o;
  }(), c;
})(), compute_post = $root.compute_post = (() => {
  const c = {};
  return c.PostWorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.useMockBackend = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.useMockBackend != null && Object.hasOwnProperty.call(e, "useMockBackend") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useMockBackend), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_post.PostWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.useMockBackend = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.useMockBackend != null && e.hasOwnProperty("useMockBackend") && typeof e.useMockBackend != "boolean" ? "useMockBackend: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_post.PostWorkerConfiguration)
        return e;
      let t = new $root.compute_post.PostWorkerConfiguration();
      return e.useMockBackend != null && (t.useMockBackend = !!e.useMockBackend), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.useMockBackend = !1), e.useMockBackend != null && e.hasOwnProperty("useMockBackend") && (n.useMockBackend = e.useMockBackend), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_post.PostWorkerConfiguration";
    }, o;
  }(), c;
})(), compute_s3_sink = $root.compute_s3_sink = (() => {
  const c = {};
  return c.S3Provider = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "AWS"] = 0, i[o[1] = "GCS"] = 1, i;
  }(), c.S3SinkWorkerConfiguration = function() {
    function o(e) {
      if (this.objects = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.endpoint = "", o.prototype.region = "", o.prototype.objects = $util.emptyArray, o.prototype.s3Provider = 0, o.prototype.userDefinedCredentials = null, o.prototype.dqDspCredentials = null, o.prototype.contentType = null;
    let i;
    return Object.defineProperty(o.prototype, "credentials", {
      get: $util.oneOfGetter(i = ["userDefinedCredentials", "dqDspCredentials"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_contentType", {
      get: $util.oneOfGetter(i = ["contentType"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.endpoint != null && Object.hasOwnProperty.call(t, "endpoint") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.endpoint), t.region != null && Object.hasOwnProperty.call(t, "region") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.region), t.objects != null && t.objects.length)
        for (let r = 0; r < t.objects.length; ++r)
          $root.compute_s3_sink.S3Object.encode(t.objects[r], n.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return t.s3Provider != null && Object.hasOwnProperty.call(t, "s3Provider") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).int32(t.s3Provider), t.userDefinedCredentials != null && Object.hasOwnProperty.call(t, "userDefinedCredentials") && $root.compute_s3_sink.UserDefinedCredentials.encode(t.userDefinedCredentials, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.dqDspCredentials != null && Object.hasOwnProperty.call(t, "dqDspCredentials") && $root.compute_s3_sink.DqDspCredentials.encode(t.dqDspCredentials, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.contentType != null && Object.hasOwnProperty.call(t, "contentType") && n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).string(t.contentType), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_s3_sink.S3SinkWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.endpoint = t.string();
            break;
          }
          case 2: {
            u.region = t.string();
            break;
          }
          case 4: {
            u.objects && u.objects.length || (u.objects = []), u.objects.push($root.compute_s3_sink.S3Object.decode(t, t.uint32()));
            break;
          }
          case 5: {
            u.s3Provider = t.int32();
            break;
          }
          case 6: {
            u.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.contentType = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.endpoint != null && t.hasOwnProperty("endpoint") && !$util.isString(t.endpoint))
        return "endpoint: string expected";
      if (t.region != null && t.hasOwnProperty("region") && !$util.isString(t.region))
        return "region: string expected";
      if (t.objects != null && t.hasOwnProperty("objects")) {
        if (!Array.isArray(t.objects))
          return "objects: array expected";
        for (let r = 0; r < t.objects.length; ++r) {
          let u = $root.compute_s3_sink.S3Object.verify(t.objects[r]);
          if (u)
            return "objects." + u;
        }
      }
      if (t.s3Provider != null && t.hasOwnProperty("s3Provider"))
        switch (t.s3Provider) {
          default:
            return "s3Provider: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (t.userDefinedCredentials != null && t.hasOwnProperty("userDefinedCredentials")) {
        n.credentials = 1;
        {
          let r = $root.compute_s3_sink.UserDefinedCredentials.verify(t.userDefinedCredentials);
          if (r)
            return "userDefinedCredentials." + r;
        }
      }
      if (t.dqDspCredentials != null && t.hasOwnProperty("dqDspCredentials")) {
        if (n.credentials === 1)
          return "credentials: multiple values";
        n.credentials = 1;
        {
          let r = $root.compute_s3_sink.DqDspCredentials.verify(t.dqDspCredentials);
          if (r)
            return "dqDspCredentials." + r;
        }
      }
      return t.contentType != null && t.hasOwnProperty("contentType") && (n._contentType = 1, !$util.isString(t.contentType)) ? "contentType: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_s3_sink.S3SinkWorkerConfiguration)
        return t;
      let n = new $root.compute_s3_sink.S3SinkWorkerConfiguration();
      if (t.endpoint != null && (n.endpoint = String(t.endpoint)), t.region != null && (n.region = String(t.region)), t.objects) {
        if (!Array.isArray(t.objects))
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.objects: array expected");
        n.objects = [];
        for (let r = 0; r < t.objects.length; ++r) {
          if (typeof t.objects[r] != "object")
            throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.objects: object expected");
          n.objects[r] = $root.compute_s3_sink.S3Object.fromObject(t.objects[r]);
        }
      }
      switch (t.s3Provider) {
        default:
          if (typeof t.s3Provider == "number") {
            n.s3Provider = t.s3Provider;
            break;
          }
          break;
        case "AWS":
        case 0:
          n.s3Provider = 0;
          break;
        case "GCS":
        case 1:
          n.s3Provider = 1;
          break;
      }
      if (t.userDefinedCredentials != null) {
        if (typeof t.userDefinedCredentials != "object")
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.userDefinedCredentials: object expected");
        n.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.fromObject(t.userDefinedCredentials);
      }
      if (t.dqDspCredentials != null) {
        if (typeof t.dqDspCredentials != "object")
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.dqDspCredentials: object expected");
        n.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.fromObject(t.dqDspCredentials);
      }
      return t.contentType != null && (n.contentType = String(t.contentType)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.objects = []), n.defaults && (r.endpoint = "", r.region = "", r.s3Provider = n.enums === String ? "AWS" : 0), t.endpoint != null && t.hasOwnProperty("endpoint") && (r.endpoint = t.endpoint), t.region != null && t.hasOwnProperty("region") && (r.region = t.region), t.objects && t.objects.length) {
        r.objects = [];
        for (let u = 0; u < t.objects.length; ++u)
          r.objects[u] = $root.compute_s3_sink.S3Object.toObject(t.objects[u], n);
      }
      return t.s3Provider != null && t.hasOwnProperty("s3Provider") && (r.s3Provider = n.enums === String ? $root.compute_s3_sink.S3Provider[t.s3Provider] === void 0 ? t.s3Provider : $root.compute_s3_sink.S3Provider[t.s3Provider] : t.s3Provider), t.userDefinedCredentials != null && t.hasOwnProperty("userDefinedCredentials") && (r.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.toObject(t.userDefinedCredentials, n), n.oneofs && (r.credentials = "userDefinedCredentials")), t.dqDspCredentials != null && t.hasOwnProperty("dqDspCredentials") && (r.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.toObject(t.dqDspCredentials, n), n.oneofs && (r.credentials = "dqDspCredentials")), t.contentType != null && t.hasOwnProperty("contentType") && (r.contentType = t.contentType, n.oneofs && (r._contentType = "contentType")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_s3_sink.S3SinkWorkerConfiguration";
    }, o;
  }(), c.UserDefinedCredentials = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.userDefinedCredentials = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.userDefinedCredentials != null && Object.hasOwnProperty.call(e, "userDefinedCredentials") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.userDefinedCredentials), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.UserDefinedCredentials();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.userDefinedCredentials = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.userDefinedCredentials != null && e.hasOwnProperty("userDefinedCredentials") && !$util.isString(e.userDefinedCredentials) ? "userDefinedCredentials: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.UserDefinedCredentials)
        return e;
      let t = new $root.compute_s3_sink.UserDefinedCredentials();
      return e.userDefinedCredentials != null && (t.userDefinedCredentials = String(e.userDefinedCredentials)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.userDefinedCredentials = ""), e.userDefinedCredentials != null && e.hasOwnProperty("userDefinedCredentials") && (n.userDefinedCredentials = e.userDefinedCredentials), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.UserDefinedCredentials";
    }, o;
  }(), c.DqDspCredentials = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dspType = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dspType != null && Object.hasOwnProperty.call(e, "dspType") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.dspType), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.DqDspCredentials();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dspType = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dspType != null && e.hasOwnProperty("dspType"))
        switch (e.dspType) {
          default:
            return "dspType: enum value expected";
          case 0:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.DqDspCredentials)
        return e;
      let t = new $root.compute_s3_sink.DqDspCredentials();
      switch (e.dspType) {
        default:
          if (typeof e.dspType == "number") {
            t.dspType = e.dspType;
            break;
          }
          break;
        case "SPLICKY":
        case 0:
          t.dspType = 0;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dspType = t.enums === String ? "SPLICKY" : 0), e.dspType != null && e.hasOwnProperty("dspType") && (n.dspType = t.enums === String ? $root.compute_s3_sink.DspCredentialsType[e.dspType] === void 0 ? e.dspType : $root.compute_s3_sink.DspCredentialsType[e.dspType] : e.dspType), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.DqDspCredentials";
    }, o;
  }(), c.DspCredentialsType = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "SPLICKY"] = 0, i;
  }(), c.S3Object = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.zip = null, o.prototype.raw = null;
    let i;
    return Object.defineProperty(o.prototype, "format", {
      get: $util.oneOfGetter(i = ["zip", "raw"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.compute_s3_sink.ZipObject.encode(t.zip, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.compute_s3_sink.RawObject.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_s3_sink.S3Object();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.zip = $root.compute_s3_sink.ZipObject.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.raw = $root.compute_s3_sink.RawObject.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.zip != null && t.hasOwnProperty("zip")) {
        n.format = 1;
        {
          let r = $root.compute_s3_sink.ZipObject.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      if (t.raw != null && t.hasOwnProperty("raw")) {
        if (n.format === 1)
          return "format: multiple values";
        n.format = 1;
        {
          let r = $root.compute_s3_sink.RawObject.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_s3_sink.S3Object)
        return t;
      let n = new $root.compute_s3_sink.S3Object();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".compute_s3_sink.S3Object.zip: object expected");
        n.zip = $root.compute_s3_sink.ZipObject.fromObject(t.zip);
      }
      if (t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".compute_s3_sink.S3Object.raw: object expected");
        n.raw = $root.compute_s3_sink.RawObject.fromObject(t.raw);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.compute_s3_sink.ZipObject.toObject(t.zip, n), n.oneofs && (r.format = "zip")), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.compute_s3_sink.RawObject.toObject(t.raw, n), n.oneofs && (r.format = "raw")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_s3_sink.S3Object";
    }, o;
  }(), c.RawObject = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.key = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.key != null && Object.hasOwnProperty.call(e, "key") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.key), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.RawObject();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.key = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.key != null && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.RawObject)
        return e;
      let t = new $root.compute_s3_sink.RawObject();
      return e.key != null && (t.key = String(e.key)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.key = ""), e.key != null && e.hasOwnProperty("key") && (n.key = e.key), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.RawObject";
    }, o;
  }(), c.ZipObject = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null, o.prototype.fullContent = null;
    let i;
    return Object.defineProperty(o.prototype, "kind", {
      get: $util.oneOfGetter(i = ["singleFile", "fullContent"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.compute_s3_sink.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.fullContent != null && Object.hasOwnProperty.call(t, "fullContent") && $root.compute_s3_sink.FullContent.encode(t.fullContent, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_s3_sink.ZipObject();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.compute_s3_sink.SingleFile.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.fullContent = $root.compute_s3_sink.FullContent.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        n.kind = 1;
        {
          let r = $root.compute_s3_sink.SingleFile.verify(t.singleFile);
          if (r)
            return "singleFile." + r;
        }
      }
      if (t.fullContent != null && t.hasOwnProperty("fullContent")) {
        if (n.kind === 1)
          return "kind: multiple values";
        n.kind = 1;
        {
          let r = $root.compute_s3_sink.FullContent.verify(t.fullContent);
          if (r)
            return "fullContent." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_s3_sink.ZipObject)
        return t;
      let n = new $root.compute_s3_sink.ZipObject();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".compute_s3_sink.ZipObject.singleFile: object expected");
        n.singleFile = $root.compute_s3_sink.SingleFile.fromObject(t.singleFile);
      }
      if (t.fullContent != null) {
        if (typeof t.fullContent != "object")
          throw TypeError(".compute_s3_sink.ZipObject.fullContent: object expected");
        n.fullContent = $root.compute_s3_sink.FullContent.fromObject(t.fullContent);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.compute_s3_sink.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.kind = "singleFile")), t.fullContent != null && t.hasOwnProperty("fullContent") && (r.fullContent = $root.compute_s3_sink.FullContent.toObject(t.fullContent, n), n.oneofs && (r.kind = "fullContent")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_s3_sink.ZipObject";
    }, o;
  }(), c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.key = "", o.prototype.path = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.key != null && Object.hasOwnProperty.call(e, "key") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.key), e.path != null && Object.hasOwnProperty.call(e, "path") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.path), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.key = e.string();
            break;
          }
          case 2: {
            r.path = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.key != null && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : e.path != null && e.hasOwnProperty("path") && !$util.isString(e.path) ? "path: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.SingleFile)
        return e;
      let t = new $root.compute_s3_sink.SingleFile();
      return e.key != null && (t.key = String(e.key)), e.path != null && (t.path = String(e.path)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.key = "", n.path = ""), e.key != null && e.hasOwnProperty("key") && (n.key = e.key), e.path != null && e.hasOwnProperty("path") && (n.path = e.path), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.SingleFile";
    }, o;
  }(), c.FullContent = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.FullContent();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.compute_s3_sink.FullContent ? e : new $root.compute_s3_sink.FullContent();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.FullContent";
    }, o;
  }(), c.S3Credentials = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.accessKey = "", o.prototype.secretKey = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.accessKey != null && Object.hasOwnProperty.call(e, "accessKey") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.accessKey), e.secretKey != null && Object.hasOwnProperty.call(e, "secretKey") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.secretKey), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_s3_sink.S3Credentials();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.accessKey = e.string();
            break;
          }
          case 2: {
            r.secretKey = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.accessKey != null && e.hasOwnProperty("accessKey") && !$util.isString(e.accessKey) ? "accessKey: string expected" : e.secretKey != null && e.hasOwnProperty("secretKey") && !$util.isString(e.secretKey) ? "secretKey: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.S3Credentials)
        return e;
      let t = new $root.compute_s3_sink.S3Credentials();
      return e.accessKey != null && (t.accessKey = String(e.accessKey)), e.secretKey != null && (t.secretKey = String(e.secretKey)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.accessKey = "", n.secretKey = ""), e.accessKey != null && e.hasOwnProperty("accessKey") && (n.accessKey = e.accessKey), e.secretKey != null && e.hasOwnProperty("secretKey") && (n.secretKey = e.secretKey), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.S3Credentials";
    }, o;
  }(), c;
})(), compute_sql = $root.compute_sql = (() => {
  const c = {};
  return c.SqlWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.validation = null, o.prototype.computation = null;
    let i;
    return Object.defineProperty(o.prototype, "configuration", {
      get: $util.oneOfGetter(i = ["validation", "computation"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.validation != null && Object.hasOwnProperty.call(t, "validation") && $root.compute_sql.ValidationConfiguration.encode(t.validation, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.computation != null && Object.hasOwnProperty.call(t, "computation") && $root.compute_sql.ComputationConfiguration.encode(t.computation, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_sql.SqlWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.validation = $root.compute_sql.ValidationConfiguration.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.computation = $root.compute_sql.ComputationConfiguration.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.validation != null && t.hasOwnProperty("validation")) {
        n.configuration = 1;
        {
          let r = $root.compute_sql.ValidationConfiguration.verify(t.validation);
          if (r)
            return "validation." + r;
        }
      }
      if (t.computation != null && t.hasOwnProperty("computation")) {
        if (n.configuration === 1)
          return "configuration: multiple values";
        n.configuration = 1;
        {
          let r = $root.compute_sql.ComputationConfiguration.verify(t.computation);
          if (r)
            return "computation." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_sql.SqlWorkerConfiguration)
        return t;
      let n = new $root.compute_sql.SqlWorkerConfiguration();
      if (t.validation != null) {
        if (typeof t.validation != "object")
          throw TypeError(".compute_sql.SqlWorkerConfiguration.validation: object expected");
        n.validation = $root.compute_sql.ValidationConfiguration.fromObject(t.validation);
      }
      if (t.computation != null) {
        if (typeof t.computation != "object")
          throw TypeError(".compute_sql.SqlWorkerConfiguration.computation: object expected");
        n.computation = $root.compute_sql.ComputationConfiguration.fromObject(t.computation);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.validation != null && t.hasOwnProperty("validation") && (r.validation = $root.compute_sql.ValidationConfiguration.toObject(t.validation, n), n.oneofs && (r.configuration = "validation")), t.computation != null && t.hasOwnProperty("computation") && (r.computation = $root.compute_sql.ComputationConfiguration.toObject(t.computation, n), n.oneofs && (r.configuration = "computation")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_sql.SqlWorkerConfiguration";
    }, o;
  }(), c.ValidationConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.tableSchema = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.tableSchema != null && Object.hasOwnProperty.call(e, "tableSchema") && $root.compute_sql.TableSchema.encode(e.tableSchema, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.ValidationConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.tableSchema = $root.compute_sql.TableSchema.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.tableSchema != null && e.hasOwnProperty("tableSchema")) {
        let t = $root.compute_sql.TableSchema.verify(e.tableSchema);
        if (t)
          return "tableSchema." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ValidationConfiguration)
        return e;
      let t = new $root.compute_sql.ValidationConfiguration();
      if (e.tableSchema != null) {
        if (typeof e.tableSchema != "object")
          throw TypeError(".compute_sql.ValidationConfiguration.tableSchema: object expected");
        t.tableSchema = $root.compute_sql.TableSchema.fromObject(e.tableSchema);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.tableSchema = null), e.tableSchema != null && e.hasOwnProperty("tableSchema") && (n.tableSchema = $root.compute_sql.TableSchema.toObject(e.tableSchema, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ValidationConfiguration";
    }, o;
  }(), c.TableSchema = function() {
    function o(i) {
      if (this.namedColumns = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.namedColumns = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.namedColumns != null && e.namedColumns.length)
        for (let n = 0; n < e.namedColumns.length; ++n)
          $root.compute_sql.NamedColumn.encode(e.namedColumns[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.TableSchema();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.namedColumns && r.namedColumns.length || (r.namedColumns = []), r.namedColumns.push($root.compute_sql.NamedColumn.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.namedColumns != null && e.hasOwnProperty("namedColumns")) {
        if (!Array.isArray(e.namedColumns))
          return "namedColumns: array expected";
        for (let t = 0; t < e.namedColumns.length; ++t) {
          let n = $root.compute_sql.NamedColumn.verify(e.namedColumns[t]);
          if (n)
            return "namedColumns." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.TableSchema)
        return e;
      let t = new $root.compute_sql.TableSchema();
      if (e.namedColumns) {
        if (!Array.isArray(e.namedColumns))
          throw TypeError(".compute_sql.TableSchema.namedColumns: array expected");
        t.namedColumns = [];
        for (let n = 0; n < e.namedColumns.length; ++n) {
          if (typeof e.namedColumns[n] != "object")
            throw TypeError(".compute_sql.TableSchema.namedColumns: object expected");
          t.namedColumns[n] = $root.compute_sql.NamedColumn.fromObject(e.namedColumns[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.namedColumns = []), e.namedColumns && e.namedColumns.length) {
        n.namedColumns = [];
        for (let r = 0; r < e.namedColumns.length; ++r)
          n.namedColumns[r] = $root.compute_sql.NamedColumn.toObject(e.namedColumns[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.TableSchema";
    }, o;
  }(), c.NamedColumn = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.name = null, o.prototype.columnType = null;
    let i;
    return Object.defineProperty(o.prototype, "_name", {
      get: $util.oneOfGetter(i = ["name"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.name), t.columnType != null && Object.hasOwnProperty.call(t, "columnType") && $root.compute_sql.ColumnType.encode(t.columnType, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.compute_sql.NamedColumn();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.name = t.string();
            break;
          }
          case 2: {
            u.columnType = $root.compute_sql.ColumnType.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.columnType != null && t.hasOwnProperty("columnType")) {
        let n = $root.compute_sql.ColumnType.verify(t.columnType);
        if (n)
          return "columnType." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.compute_sql.NamedColumn)
        return t;
      let n = new $root.compute_sql.NamedColumn();
      if (t.name != null && (n.name = String(t.name)), t.columnType != null) {
        if (typeof t.columnType != "object")
          throw TypeError(".compute_sql.NamedColumn.columnType: object expected");
        n.columnType = $root.compute_sql.ColumnType.fromObject(t.columnType);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.columnType = null), t.name != null && t.hasOwnProperty("name") && (r.name = t.name, n.oneofs && (r._name = "name")), t.columnType != null && t.hasOwnProperty("columnType") && (r.columnType = $root.compute_sql.ColumnType.toObject(t.columnType, n)), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/compute_sql.NamedColumn";
    }, o;
  }(), c.ColumnType = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.primitiveType = 0, o.prototype.nullable = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.primitiveType != null && Object.hasOwnProperty.call(e, "primitiveType") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.primitiveType), e.nullable != null && Object.hasOwnProperty.call(e, "nullable") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.nullable), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.ColumnType();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.primitiveType = e.int32();
            break;
          }
          case 2: {
            r.nullable = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.primitiveType != null && e.hasOwnProperty("primitiveType"))
        switch (e.primitiveType) {
          default:
            return "primitiveType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return e.nullable != null && e.hasOwnProperty("nullable") && typeof e.nullable != "boolean" ? "nullable: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ColumnType)
        return e;
      let t = new $root.compute_sql.ColumnType();
      switch (e.primitiveType) {
        default:
          if (typeof e.primitiveType == "number") {
            t.primitiveType = e.primitiveType;
            break;
          }
          break;
        case "INT64":
        case 0:
          t.primitiveType = 0;
          break;
        case "STRING":
        case 1:
          t.primitiveType = 1;
          break;
        case "FLOAT64":
        case 2:
          t.primitiveType = 2;
          break;
      }
      return e.nullable != null && (t.nullable = !!e.nullable), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.primitiveType = t.enums === String ? "INT64" : 0, n.nullable = !1), e.primitiveType != null && e.hasOwnProperty("primitiveType") && (n.primitiveType = t.enums === String ? $root.compute_sql.PrimitiveType[e.primitiveType] === void 0 ? e.primitiveType : $root.compute_sql.PrimitiveType[e.primitiveType] : e.primitiveType), e.nullable != null && e.hasOwnProperty("nullable") && (n.nullable = e.nullable), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ColumnType";
    }, o;
  }(), c.PrimitiveType = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "INT64"] = 0, i[o[1] = "STRING"] = 1, i[o[2] = "FLOAT64"] = 2, i;
  }(), c.TableDependencyMapping = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.table = "", o.prototype.dependency = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.table != null && Object.hasOwnProperty.call(e, "table") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.table), e.dependency != null && Object.hasOwnProperty.call(e, "dependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dependency), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.TableDependencyMapping();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.table = e.string();
            break;
          }
          case 2: {
            r.dependency = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.table != null && e.hasOwnProperty("table") && !$util.isString(e.table) ? "table: string expected" : e.dependency != null && e.hasOwnProperty("dependency") && !$util.isString(e.dependency) ? "dependency: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.TableDependencyMapping)
        return e;
      let t = new $root.compute_sql.TableDependencyMapping();
      return e.table != null && (t.table = String(e.table)), e.dependency != null && (t.dependency = String(e.dependency)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.table = "", n.dependency = ""), e.table != null && e.hasOwnProperty("table") && (n.table = e.table), e.dependency != null && e.hasOwnProperty("dependency") && (n.dependency = e.dependency), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.TableDependencyMapping";
    }, o;
  }(), c.ComputationConfiguration = function() {
    function o(i) {
      if (this.constraints = [], this.tableDependencyMappings = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.sqlStatement = "", o.prototype.privacySettings = null, o.prototype.constraints = $util.emptyArray, o.prototype.tableDependencyMappings = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.sqlStatement != null && Object.hasOwnProperty.call(e, "sqlStatement") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.sqlStatement), e.privacySettings != null && Object.hasOwnProperty.call(e, "privacySettings") && $root.compute_sql.PrivacySettings.encode(e.privacySettings, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.constraints != null && e.constraints.length)
        for (let n = 0; n < e.constraints.length; ++n)
          $root.compute_sql.Constraint.encode(e.constraints[n], t.uint32(
            /* id 3, wireType 2 =*/
            26
          ).fork()).ldelim();
      if (e.tableDependencyMappings != null && e.tableDependencyMappings.length)
        for (let n = 0; n < e.tableDependencyMappings.length; ++n)
          $root.compute_sql.TableDependencyMapping.encode(e.tableDependencyMappings[n], t.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.ComputationConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.sqlStatement = e.string();
            break;
          }
          case 2: {
            r.privacySettings = $root.compute_sql.PrivacySettings.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.constraints && r.constraints.length || (r.constraints = []), r.constraints.push($root.compute_sql.Constraint.decode(e, e.uint32()));
            break;
          }
          case 4: {
            r.tableDependencyMappings && r.tableDependencyMappings.length || (r.tableDependencyMappings = []), r.tableDependencyMappings.push($root.compute_sql.TableDependencyMapping.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.sqlStatement != null && e.hasOwnProperty("sqlStatement") && !$util.isString(e.sqlStatement))
        return "sqlStatement: string expected";
      if (e.privacySettings != null && e.hasOwnProperty("privacySettings")) {
        let t = $root.compute_sql.PrivacySettings.verify(e.privacySettings);
        if (t)
          return "privacySettings." + t;
      }
      if (e.constraints != null && e.hasOwnProperty("constraints")) {
        if (!Array.isArray(e.constraints))
          return "constraints: array expected";
        for (let t = 0; t < e.constraints.length; ++t) {
          let n = $root.compute_sql.Constraint.verify(e.constraints[t]);
          if (n)
            return "constraints." + n;
        }
      }
      if (e.tableDependencyMappings != null && e.hasOwnProperty("tableDependencyMappings")) {
        if (!Array.isArray(e.tableDependencyMappings))
          return "tableDependencyMappings: array expected";
        for (let t = 0; t < e.tableDependencyMappings.length; ++t) {
          let n = $root.compute_sql.TableDependencyMapping.verify(e.tableDependencyMappings[t]);
          if (n)
            return "tableDependencyMappings." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ComputationConfiguration)
        return e;
      let t = new $root.compute_sql.ComputationConfiguration();
      if (e.sqlStatement != null && (t.sqlStatement = String(e.sqlStatement)), e.privacySettings != null) {
        if (typeof e.privacySettings != "object")
          throw TypeError(".compute_sql.ComputationConfiguration.privacySettings: object expected");
        t.privacySettings = $root.compute_sql.PrivacySettings.fromObject(e.privacySettings);
      }
      if (e.constraints) {
        if (!Array.isArray(e.constraints))
          throw TypeError(".compute_sql.ComputationConfiguration.constraints: array expected");
        t.constraints = [];
        for (let n = 0; n < e.constraints.length; ++n) {
          if (typeof e.constraints[n] != "object")
            throw TypeError(".compute_sql.ComputationConfiguration.constraints: object expected");
          t.constraints[n] = $root.compute_sql.Constraint.fromObject(e.constraints[n]);
        }
      }
      if (e.tableDependencyMappings) {
        if (!Array.isArray(e.tableDependencyMappings))
          throw TypeError(".compute_sql.ComputationConfiguration.tableDependencyMappings: array expected");
        t.tableDependencyMappings = [];
        for (let n = 0; n < e.tableDependencyMappings.length; ++n) {
          if (typeof e.tableDependencyMappings[n] != "object")
            throw TypeError(".compute_sql.ComputationConfiguration.tableDependencyMappings: object expected");
          t.tableDependencyMappings[n] = $root.compute_sql.TableDependencyMapping.fromObject(e.tableDependencyMappings[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.constraints = [], n.tableDependencyMappings = []), t.defaults && (n.sqlStatement = "", n.privacySettings = null), e.sqlStatement != null && e.hasOwnProperty("sqlStatement") && (n.sqlStatement = e.sqlStatement), e.privacySettings != null && e.hasOwnProperty("privacySettings") && (n.privacySettings = $root.compute_sql.PrivacySettings.toObject(e.privacySettings, t)), e.constraints && e.constraints.length) {
        n.constraints = [];
        for (let r = 0; r < e.constraints.length; ++r)
          n.constraints[r] = $root.compute_sql.Constraint.toObject(e.constraints[r], t);
      }
      if (e.tableDependencyMappings && e.tableDependencyMappings.length) {
        n.tableDependencyMappings = [];
        for (let r = 0; r < e.tableDependencyMappings.length; ++r)
          n.tableDependencyMappings[r] = $root.compute_sql.TableDependencyMapping.toObject(e.tableDependencyMappings[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ComputationConfiguration";
    }, o;
  }(), c.PrivacySettings = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.minAggregationGroupSize = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.minAggregationGroupSize != null && Object.hasOwnProperty.call(e, "minAggregationGroupSize") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int64(e.minAggregationGroupSize), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.PrivacySettings();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.minAggregationGroupSize = e.int64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.minAggregationGroupSize != null && e.hasOwnProperty("minAggregationGroupSize") && !$util.isInteger(e.minAggregationGroupSize) && !(e.minAggregationGroupSize && $util.isInteger(e.minAggregationGroupSize.low) && $util.isInteger(e.minAggregationGroupSize.high)) ? "minAggregationGroupSize: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.PrivacySettings)
        return e;
      let t = new $root.compute_sql.PrivacySettings();
      return e.minAggregationGroupSize != null && ($util.Long ? (t.minAggregationGroupSize = $util.Long.fromValue(e.minAggregationGroupSize)).unsigned = !1 : typeof e.minAggregationGroupSize == "string" ? t.minAggregationGroupSize = parseInt(e.minAggregationGroupSize, 10) : typeof e.minAggregationGroupSize == "number" ? t.minAggregationGroupSize = e.minAggregationGroupSize : typeof e.minAggregationGroupSize == "object" && (t.minAggregationGroupSize = new $util.LongBits(e.minAggregationGroupSize.low >>> 0, e.minAggregationGroupSize.high >>> 0).toNumber())), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if ($util.Long) {
          let r = new $util.Long(0, 0, !1);
          n.minAggregationGroupSize = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.minAggregationGroupSize = t.longs === String ? "0" : 0;
      return e.minAggregationGroupSize != null && e.hasOwnProperty("minAggregationGroupSize") && (typeof e.minAggregationGroupSize == "number" ? n.minAggregationGroupSize = t.longs === String ? String(e.minAggregationGroupSize) : e.minAggregationGroupSize : n.minAggregationGroupSize = t.longs === String ? $util.Long.prototype.toString.call(e.minAggregationGroupSize) : t.longs === Number ? new $util.LongBits(e.minAggregationGroupSize.low >>> 0, e.minAggregationGroupSize.high >>> 0).toNumber() : e.minAggregationGroupSize), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.PrivacySettings";
    }, o;
  }(), c.Constraint = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.description = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.description != null && Object.hasOwnProperty.call(e, "description") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.description), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.compute_sql.Constraint();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.description = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description) ? "description: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.compute_sql.Constraint)
        return e;
      let t = new $root.compute_sql.Constraint();
      return e.description != null && (t.description = String(e.description)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.description = ""), e.description != null && e.hasOwnProperty("description") && (n.description = e.description), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.Constraint";
    }, o;
  }(), c;
})(), data_room = $root.data_room = (() => {
  const c = {};
  return c.DataRoom = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.name = "", o.prototype.description = "", o.prototype.governanceProtocol = null, o.prototype.initialConfiguration = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), e.description != null && Object.hasOwnProperty.call(e, "description") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.description), e.governanceProtocol != null && Object.hasOwnProperty.call(e, "governanceProtocol") && $root.data_room.GovernanceProtocol.encode(e.governanceProtocol, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.initialConfiguration != null && Object.hasOwnProperty.call(e, "initialConfiguration") && $root.data_room.DataRoomConfiguration.encode(e.initialConfiguration, t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.DataRoom();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.name = e.string();
            break;
          }
          case 3: {
            r.description = e.string();
            break;
          }
          case 4: {
            r.governanceProtocol = $root.data_room.GovernanceProtocol.decode(e, e.uint32());
            break;
          }
          case 5: {
            r.initialConfiguration = $root.data_room.DataRoomConfiguration.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name))
        return "name: string expected";
      if (e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description))
        return "description: string expected";
      if (e.governanceProtocol != null && e.hasOwnProperty("governanceProtocol")) {
        let t = $root.data_room.GovernanceProtocol.verify(e.governanceProtocol);
        if (t)
          return "governanceProtocol." + t;
      }
      if (e.initialConfiguration != null && e.hasOwnProperty("initialConfiguration")) {
        let t = $root.data_room.DataRoomConfiguration.verify(e.initialConfiguration);
        if (t)
          return "initialConfiguration." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.DataRoom)
        return e;
      let t = new $root.data_room.DataRoom();
      if (e.id != null && (t.id = String(e.id)), e.name != null && (t.name = String(e.name)), e.description != null && (t.description = String(e.description)), e.governanceProtocol != null) {
        if (typeof e.governanceProtocol != "object")
          throw TypeError(".data_room.DataRoom.governanceProtocol: object expected");
        t.governanceProtocol = $root.data_room.GovernanceProtocol.fromObject(e.governanceProtocol);
      }
      if (e.initialConfiguration != null) {
        if (typeof e.initialConfiguration != "object")
          throw TypeError(".data_room.DataRoom.initialConfiguration: object expected");
        t.initialConfiguration = $root.data_room.DataRoomConfiguration.fromObject(e.initialConfiguration);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = "", n.name = "", n.description = "", n.governanceProtocol = null, n.initialConfiguration = null), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.description != null && e.hasOwnProperty("description") && (n.description = e.description), e.governanceProtocol != null && e.hasOwnProperty("governanceProtocol") && (n.governanceProtocol = $root.data_room.GovernanceProtocol.toObject(e.governanceProtocol, t)), e.initialConfiguration != null && e.hasOwnProperty("initialConfiguration") && (n.initialConfiguration = $root.data_room.DataRoomConfiguration.toObject(e.initialConfiguration, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DataRoom";
    }, o;
  }(), c.GovernanceProtocol = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.staticDataRoomPolicy = null, o.prototype.affectedDataOwnersApprovePolicy = null;
    let i;
    return Object.defineProperty(o.prototype, "policy", {
      get: $util.oneOfGetter(i = ["staticDataRoomPolicy", "affectedDataOwnersApprovePolicy"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.staticDataRoomPolicy != null && Object.hasOwnProperty.call(t, "staticDataRoomPolicy") && $root.data_room.StaticDataRoomPolicy.encode(t.staticDataRoomPolicy, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.affectedDataOwnersApprovePolicy != null && Object.hasOwnProperty.call(t, "affectedDataOwnersApprovePolicy") && $root.data_room.AffectedDataOwnersApprovePolicy.encode(t.affectedDataOwnersApprovePolicy, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.GovernanceProtocol();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.staticDataRoomPolicy != null && t.hasOwnProperty("staticDataRoomPolicy")) {
        n.policy = 1;
        {
          let r = $root.data_room.StaticDataRoomPolicy.verify(t.staticDataRoomPolicy);
          if (r)
            return "staticDataRoomPolicy." + r;
        }
      }
      if (t.affectedDataOwnersApprovePolicy != null && t.hasOwnProperty("affectedDataOwnersApprovePolicy")) {
        if (n.policy === 1)
          return "policy: multiple values";
        n.policy = 1;
        {
          let r = $root.data_room.AffectedDataOwnersApprovePolicy.verify(t.affectedDataOwnersApprovePolicy);
          if (r)
            return "affectedDataOwnersApprovePolicy." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.GovernanceProtocol)
        return t;
      let n = new $root.data_room.GovernanceProtocol();
      if (t.staticDataRoomPolicy != null) {
        if (typeof t.staticDataRoomPolicy != "object")
          throw TypeError(".data_room.GovernanceProtocol.staticDataRoomPolicy: object expected");
        n.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.fromObject(t.staticDataRoomPolicy);
      }
      if (t.affectedDataOwnersApprovePolicy != null) {
        if (typeof t.affectedDataOwnersApprovePolicy != "object")
          throw TypeError(".data_room.GovernanceProtocol.affectedDataOwnersApprovePolicy: object expected");
        n.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.fromObject(t.affectedDataOwnersApprovePolicy);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.staticDataRoomPolicy != null && t.hasOwnProperty("staticDataRoomPolicy") && (r.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.toObject(t.staticDataRoomPolicy, n), n.oneofs && (r.policy = "staticDataRoomPolicy")), t.affectedDataOwnersApprovePolicy != null && t.hasOwnProperty("affectedDataOwnersApprovePolicy") && (r.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.toObject(t.affectedDataOwnersApprovePolicy, n), n.oneofs && (r.policy = "affectedDataOwnersApprovePolicy")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.GovernanceProtocol";
    }, o;
  }(), c.StaticDataRoomPolicy = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.StaticDataRoomPolicy();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.StaticDataRoomPolicy ? e : new $root.data_room.StaticDataRoomPolicy();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.StaticDataRoomPolicy";
    }, o;
  }(), c.AffectedDataOwnersApprovePolicy = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.AffectedDataOwnersApprovePolicy();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.AffectedDataOwnersApprovePolicy ? e : new $root.data_room.AffectedDataOwnersApprovePolicy();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AffectedDataOwnersApprovePolicy";
    }, o;
  }(), c.DataRoomConfiguration = function() {
    function o(i) {
      if (this.elements = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.elements = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.elements != null && e.elements.length)
        for (let n = 0; n < e.elements.length; ++n)
          $root.data_room.ConfigurationElement.encode(e.elements[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.DataRoomConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.elements && r.elements.length || (r.elements = []), r.elements.push($root.data_room.ConfigurationElement.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.elements != null && e.hasOwnProperty("elements")) {
        if (!Array.isArray(e.elements))
          return "elements: array expected";
        for (let t = 0; t < e.elements.length; ++t) {
          let n = $root.data_room.ConfigurationElement.verify(e.elements[t]);
          if (n)
            return "elements." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.DataRoomConfiguration)
        return e;
      let t = new $root.data_room.DataRoomConfiguration();
      if (e.elements) {
        if (!Array.isArray(e.elements))
          throw TypeError(".data_room.DataRoomConfiguration.elements: array expected");
        t.elements = [];
        for (let n = 0; n < e.elements.length; ++n) {
          if (typeof e.elements[n] != "object")
            throw TypeError(".data_room.DataRoomConfiguration.elements: object expected");
          t.elements[n] = $root.data_room.ConfigurationElement.fromObject(e.elements[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.elements = []), e.elements && e.elements.length) {
        n.elements = [];
        for (let r = 0; r < e.elements.length; ++r)
          n.elements[r] = $root.data_room.ConfigurationElement.toObject(e.elements[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DataRoomConfiguration";
    }, o;
  }(), c.ConfigurationElement = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.id = "", o.prototype.computeNode = null, o.prototype.attestationSpecification = null, o.prototype.userPermission = null, o.prototype.authenticationMethod = null;
    let i;
    return Object.defineProperty(o.prototype, "element", {
      get: $util.oneOfGetter(i = ["computeNode", "attestationSpecification", "userPermission", "authenticationMethod"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.id), t.computeNode != null && Object.hasOwnProperty.call(t, "computeNode") && $root.data_room.ComputeNode.encode(t.computeNode, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.attestationSpecification != null && Object.hasOwnProperty.call(t, "attestationSpecification") && $root.attestation.AttestationSpecification.encode(t.attestationSpecification, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.userPermission != null && Object.hasOwnProperty.call(t, "userPermission") && $root.data_room.UserPermission.encode(t.userPermission, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.authenticationMethod != null && Object.hasOwnProperty.call(t, "authenticationMethod") && $root.data_room.AuthenticationMethod.encode(t.authenticationMethod, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.ConfigurationElement();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.id = t.string();
            break;
          }
          case 2: {
            u.computeNode = $root.data_room.ComputeNode.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.attestationSpecification = $root.attestation.AttestationSpecification.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.userPermission = $root.data_room.UserPermission.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.authenticationMethod = $root.data_room.AuthenticationMethod.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
        return "id: string expected";
      if (t.computeNode != null && t.hasOwnProperty("computeNode")) {
        n.element = 1;
        {
          let r = $root.data_room.ComputeNode.verify(t.computeNode);
          if (r)
            return "computeNode." + r;
        }
      }
      if (t.attestationSpecification != null && t.hasOwnProperty("attestationSpecification")) {
        if (n.element === 1)
          return "element: multiple values";
        n.element = 1;
        {
          let r = $root.attestation.AttestationSpecification.verify(t.attestationSpecification);
          if (r)
            return "attestationSpecification." + r;
        }
      }
      if (t.userPermission != null && t.hasOwnProperty("userPermission")) {
        if (n.element === 1)
          return "element: multiple values";
        n.element = 1;
        {
          let r = $root.data_room.UserPermission.verify(t.userPermission);
          if (r)
            return "userPermission." + r;
        }
      }
      if (t.authenticationMethod != null && t.hasOwnProperty("authenticationMethod")) {
        if (n.element === 1)
          return "element: multiple values";
        n.element = 1;
        {
          let r = $root.data_room.AuthenticationMethod.verify(t.authenticationMethod);
          if (r)
            return "authenticationMethod." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.ConfigurationElement)
        return t;
      let n = new $root.data_room.ConfigurationElement();
      if (t.id != null && (n.id = String(t.id)), t.computeNode != null) {
        if (typeof t.computeNode != "object")
          throw TypeError(".data_room.ConfigurationElement.computeNode: object expected");
        n.computeNode = $root.data_room.ComputeNode.fromObject(t.computeNode);
      }
      if (t.attestationSpecification != null) {
        if (typeof t.attestationSpecification != "object")
          throw TypeError(".data_room.ConfigurationElement.attestationSpecification: object expected");
        n.attestationSpecification = $root.attestation.AttestationSpecification.fromObject(t.attestationSpecification);
      }
      if (t.userPermission != null) {
        if (typeof t.userPermission != "object")
          throw TypeError(".data_room.ConfigurationElement.userPermission: object expected");
        n.userPermission = $root.data_room.UserPermission.fromObject(t.userPermission);
      }
      if (t.authenticationMethod != null) {
        if (typeof t.authenticationMethod != "object")
          throw TypeError(".data_room.ConfigurationElement.authenticationMethod: object expected");
        n.authenticationMethod = $root.data_room.AuthenticationMethod.fromObject(t.authenticationMethod);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.id = ""), t.id != null && t.hasOwnProperty("id") && (r.id = t.id), t.computeNode != null && t.hasOwnProperty("computeNode") && (r.computeNode = $root.data_room.ComputeNode.toObject(t.computeNode, n), n.oneofs && (r.element = "computeNode")), t.attestationSpecification != null && t.hasOwnProperty("attestationSpecification") && (r.attestationSpecification = $root.attestation.AttestationSpecification.toObject(t.attestationSpecification, n), n.oneofs && (r.element = "attestationSpecification")), t.userPermission != null && t.hasOwnProperty("userPermission") && (r.userPermission = $root.data_room.UserPermission.toObject(t.userPermission, n), n.oneofs && (r.element = "userPermission")), t.authenticationMethod != null && t.hasOwnProperty("authenticationMethod") && (r.authenticationMethod = $root.data_room.AuthenticationMethod.toObject(t.authenticationMethod, n), n.oneofs && (r.element = "authenticationMethod")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.ConfigurationElement";
    }, o;
  }(), c.ConfigurationModification = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.add = null, o.prototype.change = null, o.prototype.delete = null;
    let i;
    return Object.defineProperty(o.prototype, "modification", {
      get: $util.oneOfGetter(i = ["add", "change", "delete"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.add != null && Object.hasOwnProperty.call(t, "add") && $root.data_room.AddModification.encode(t.add, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.change != null && Object.hasOwnProperty.call(t, "change") && $root.data_room.ChangeModification.encode(t.change, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.delete != null && Object.hasOwnProperty.call(t, "delete") && $root.data_room.DeleteModification.encode(t.delete, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.ConfigurationModification();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.add = $root.data_room.AddModification.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.change = $root.data_room.ChangeModification.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.delete = $root.data_room.DeleteModification.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.add != null && t.hasOwnProperty("add")) {
        n.modification = 1;
        {
          let r = $root.data_room.AddModification.verify(t.add);
          if (r)
            return "add." + r;
        }
      }
      if (t.change != null && t.hasOwnProperty("change")) {
        if (n.modification === 1)
          return "modification: multiple values";
        n.modification = 1;
        {
          let r = $root.data_room.ChangeModification.verify(t.change);
          if (r)
            return "change." + r;
        }
      }
      if (t.delete != null && t.hasOwnProperty("delete")) {
        if (n.modification === 1)
          return "modification: multiple values";
        n.modification = 1;
        {
          let r = $root.data_room.DeleteModification.verify(t.delete);
          if (r)
            return "delete." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.ConfigurationModification)
        return t;
      let n = new $root.data_room.ConfigurationModification();
      if (t.add != null) {
        if (typeof t.add != "object")
          throw TypeError(".data_room.ConfigurationModification.add: object expected");
        n.add = $root.data_room.AddModification.fromObject(t.add);
      }
      if (t.change != null) {
        if (typeof t.change != "object")
          throw TypeError(".data_room.ConfigurationModification.change: object expected");
        n.change = $root.data_room.ChangeModification.fromObject(t.change);
      }
      if (t.delete != null) {
        if (typeof t.delete != "object")
          throw TypeError(".data_room.ConfigurationModification.delete: object expected");
        n.delete = $root.data_room.DeleteModification.fromObject(t.delete);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.add != null && t.hasOwnProperty("add") && (r.add = $root.data_room.AddModification.toObject(t.add, n), n.oneofs && (r.modification = "add")), t.change != null && t.hasOwnProperty("change") && (r.change = $root.data_room.ChangeModification.toObject(t.change, n), n.oneofs && (r.modification = "change")), t.delete != null && t.hasOwnProperty("delete") && (r.delete = $root.data_room.DeleteModification.toObject(t.delete, n), n.oneofs && (r.modification = "delete")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.ConfigurationModification";
    }, o;
  }(), c.AddModification = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.element = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.element != null && Object.hasOwnProperty.call(e, "element") && $root.data_room.ConfigurationElement.encode(e.element, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.AddModification();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.element = $root.data_room.ConfigurationElement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.element != null && e.hasOwnProperty("element")) {
        let t = $root.data_room.ConfigurationElement.verify(e.element);
        if (t)
          return "element." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.AddModification)
        return e;
      let t = new $root.data_room.AddModification();
      if (e.element != null) {
        if (typeof e.element != "object")
          throw TypeError(".data_room.AddModification.element: object expected");
        t.element = $root.data_room.ConfigurationElement.fromObject(e.element);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.element = null), e.element != null && e.hasOwnProperty("element") && (n.element = $root.data_room.ConfigurationElement.toObject(e.element, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AddModification";
    }, o;
  }(), c.ChangeModification = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.element = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.element != null && Object.hasOwnProperty.call(e, "element") && $root.data_room.ConfigurationElement.encode(e.element, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ChangeModification();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.element = $root.data_room.ConfigurationElement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.element != null && e.hasOwnProperty("element")) {
        let t = $root.data_room.ConfigurationElement.verify(e.element);
        if (t)
          return "element." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ChangeModification)
        return e;
      let t = new $root.data_room.ChangeModification();
      if (e.element != null) {
        if (typeof e.element != "object")
          throw TypeError(".data_room.ChangeModification.element: object expected");
        t.element = $root.data_room.ConfigurationElement.fromObject(e.element);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.element = null), e.element != null && e.hasOwnProperty("element") && (n.element = $root.data_room.ConfigurationElement.toObject(e.element, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ChangeModification";
    }, o;
  }(), c.DeleteModification = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.DeleteModification();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.DeleteModification)
        return e;
      let t = new $root.data_room.DeleteModification();
      return e.id != null && (t.id = String(e.id)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DeleteModification";
    }, o;
  }(), c.ConfigurationCommit = function() {
    function o(i) {
      if (this.modifications = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.name = "", o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.dataRoomHistoryPin = $util.newBuffer([]), o.prototype.modifications = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.dataRoomId), e.dataRoomHistoryPin != null && Object.hasOwnProperty.call(e, "dataRoomHistoryPin") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.dataRoomHistoryPin), e.modifications != null && e.modifications.length)
        for (let n = 0; n < e.modifications.length; ++n)
          $root.data_room.ConfigurationModification.encode(e.modifications[n], t.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ConfigurationCommit();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.name = e.string();
            break;
          }
          case 3: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 4: {
            r.dataRoomHistoryPin = e.bytes();
            break;
          }
          case 5: {
            r.modifications && r.modifications.length || (r.modifications = []), r.modifications.push($root.data_room.ConfigurationModification.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name))
        return "name: string expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.dataRoomHistoryPin != null && e.hasOwnProperty("dataRoomHistoryPin") && !(e.dataRoomHistoryPin && typeof e.dataRoomHistoryPin.length == "number" || $util.isString(e.dataRoomHistoryPin)))
        return "dataRoomHistoryPin: buffer expected";
      if (e.modifications != null && e.hasOwnProperty("modifications")) {
        if (!Array.isArray(e.modifications))
          return "modifications: array expected";
        for (let t = 0; t < e.modifications.length; ++t) {
          let n = $root.data_room.ConfigurationModification.verify(e.modifications[t]);
          if (n)
            return "modifications." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ConfigurationCommit)
        return e;
      let t = new $root.data_room.ConfigurationCommit();
      if (e.id != null && (t.id = String(e.id)), e.name != null && (t.name = String(e.name)), e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.dataRoomHistoryPin != null && (typeof e.dataRoomHistoryPin == "string" ? $util.base64.decode(e.dataRoomHistoryPin, t.dataRoomHistoryPin = $util.newBuffer($util.base64.length(e.dataRoomHistoryPin)), 0) : e.dataRoomHistoryPin.length >= 0 && (t.dataRoomHistoryPin = e.dataRoomHistoryPin)), e.modifications) {
        if (!Array.isArray(e.modifications))
          throw TypeError(".data_room.ConfigurationCommit.modifications: array expected");
        t.modifications = [];
        for (let n = 0; n < e.modifications.length; ++n) {
          if (typeof e.modifications[n] != "object")
            throw TypeError(".data_room.ConfigurationCommit.modifications: object expected");
          t.modifications[n] = $root.data_room.ConfigurationModification.fromObject(e.modifications[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.modifications = []), t.defaults && (n.id = "", n.name = "", t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), t.bytes === String ? n.dataRoomHistoryPin = "" : (n.dataRoomHistoryPin = [], t.bytes !== Array && (n.dataRoomHistoryPin = $util.newBuffer(n.dataRoomHistoryPin)))), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.dataRoomHistoryPin != null && e.hasOwnProperty("dataRoomHistoryPin") && (n.dataRoomHistoryPin = t.bytes === String ? $util.base64.encode(e.dataRoomHistoryPin, 0, e.dataRoomHistoryPin.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomHistoryPin) : e.dataRoomHistoryPin), e.modifications && e.modifications.length) {
        n.modifications = [];
        for (let r = 0; r < e.modifications.length; ++r)
          n.modifications[r] = $root.data_room.ConfigurationModification.toObject(e.modifications[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ConfigurationCommit";
    }, o;
  }(), c.WindowRateLimitingConfig = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.timeWindowSeconds = 0, o.prototype.numMaxExecutions = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.timeWindowSeconds != null && Object.hasOwnProperty.call(e, "timeWindowSeconds") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.timeWindowSeconds), e.numMaxExecutions != null && Object.hasOwnProperty.call(e, "numMaxExecutions") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.numMaxExecutions), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.WindowRateLimitingConfig();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.timeWindowSeconds = e.uint32();
            break;
          }
          case 2: {
            r.numMaxExecutions = e.uint32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.timeWindowSeconds != null && e.hasOwnProperty("timeWindowSeconds") && !$util.isInteger(e.timeWindowSeconds) ? "timeWindowSeconds: integer expected" : e.numMaxExecutions != null && e.hasOwnProperty("numMaxExecutions") && !$util.isInteger(e.numMaxExecutions) ? "numMaxExecutions: integer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.WindowRateLimitingConfig)
        return e;
      let t = new $root.data_room.WindowRateLimitingConfig();
      return e.timeWindowSeconds != null && (t.timeWindowSeconds = e.timeWindowSeconds >>> 0), e.numMaxExecutions != null && (t.numMaxExecutions = e.numMaxExecutions >>> 0), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.timeWindowSeconds = 0, n.numMaxExecutions = 0), e.timeWindowSeconds != null && e.hasOwnProperty("timeWindowSeconds") && (n.timeWindowSeconds = e.timeWindowSeconds), e.numMaxExecutions != null && e.hasOwnProperty("numMaxExecutions") && (n.numMaxExecutions = e.numMaxExecutions), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.WindowRateLimitingConfig";
    }, o;
  }(), c.RateLimitingConfig = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.window = null;
    let i;
    return Object.defineProperty(o.prototype, "method", {
      get: $util.oneOfGetter(i = ["window"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.window != null && Object.hasOwnProperty.call(t, "window") && $root.data_room.WindowRateLimitingConfig.encode(t.window, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.RateLimitingConfig();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.window = $root.data_room.WindowRateLimitingConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.window != null && t.hasOwnProperty("window")) {
        let n = $root.data_room.WindowRateLimitingConfig.verify(t.window);
        if (n)
          return "window." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.RateLimitingConfig)
        return t;
      let n = new $root.data_room.RateLimitingConfig();
      if (t.window != null) {
        if (typeof t.window != "object")
          throw TypeError(".data_room.RateLimitingConfig.window: object expected");
        n.window = $root.data_room.WindowRateLimitingConfig.fromObject(t.window);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.window != null && t.hasOwnProperty("window") && (r.window = $root.data_room.WindowRateLimitingConfig.toObject(t.window, n), n.oneofs && (r.method = "window")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.RateLimitingConfig";
    }, o;
  }(), c.ComputeNode = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.nodeName = "", o.prototype.leaf = null, o.prototype.parameter = null, o.prototype.branch = null, o.prototype.airlock = null, o.prototype.rateLimiting = null;
    let i;
    return Object.defineProperty(o.prototype, "node", {
      get: $util.oneOfGetter(i = ["leaf", "parameter", "branch", "airlock"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(i = ["rateLimiting"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.nodeName != null && Object.hasOwnProperty.call(t, "nodeName") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.nodeName), t.leaf != null && Object.hasOwnProperty.call(t, "leaf") && $root.data_room.ComputeNodeLeaf.encode(t.leaf, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.branch != null && Object.hasOwnProperty.call(t, "branch") && $root.data_room.ComputeNodeBranch.encode(t.branch, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.parameter != null && Object.hasOwnProperty.call(t, "parameter") && $root.data_room.ComputeNodeParameter.encode(t.parameter, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.rateLimiting != null && Object.hasOwnProperty.call(t, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(t.rateLimiting, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.airlock != null && Object.hasOwnProperty.call(t, "airlock") && $root.data_room.ComputeNodeAirlock.encode(t.airlock, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.ComputeNode();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.nodeName = t.string();
            break;
          }
          case 2: {
            u.leaf = $root.data_room.ComputeNodeLeaf.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.parameter = $root.data_room.ComputeNodeParameter.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.branch = $root.data_room.ComputeNodeBranch.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.airlock = $root.data_room.ComputeNodeAirlock.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.rateLimiting = $root.data_room.RateLimitingConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.nodeName != null && t.hasOwnProperty("nodeName") && !$util.isString(t.nodeName))
        return "nodeName: string expected";
      if (t.leaf != null && t.hasOwnProperty("leaf")) {
        n.node = 1;
        {
          let r = $root.data_room.ComputeNodeLeaf.verify(t.leaf);
          if (r)
            return "leaf." + r;
        }
      }
      if (t.parameter != null && t.hasOwnProperty("parameter")) {
        if (n.node === 1)
          return "node: multiple values";
        n.node = 1;
        {
          let r = $root.data_room.ComputeNodeParameter.verify(t.parameter);
          if (r)
            return "parameter." + r;
        }
      }
      if (t.branch != null && t.hasOwnProperty("branch")) {
        if (n.node === 1)
          return "node: multiple values";
        n.node = 1;
        {
          let r = $root.data_room.ComputeNodeBranch.verify(t.branch);
          if (r)
            return "branch." + r;
        }
      }
      if (t.airlock != null && t.hasOwnProperty("airlock")) {
        if (n.node === 1)
          return "node: multiple values";
        n.node = 1;
        {
          let r = $root.data_room.ComputeNodeAirlock.verify(t.airlock);
          if (r)
            return "airlock." + r;
        }
      }
      if (t.rateLimiting != null && t.hasOwnProperty("rateLimiting")) {
        n._rateLimiting = 1;
        {
          let r = $root.data_room.RateLimitingConfig.verify(t.rateLimiting);
          if (r)
            return "rateLimiting." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.ComputeNode)
        return t;
      let n = new $root.data_room.ComputeNode();
      if (t.nodeName != null && (n.nodeName = String(t.nodeName)), t.leaf != null) {
        if (typeof t.leaf != "object")
          throw TypeError(".data_room.ComputeNode.leaf: object expected");
        n.leaf = $root.data_room.ComputeNodeLeaf.fromObject(t.leaf);
      }
      if (t.parameter != null) {
        if (typeof t.parameter != "object")
          throw TypeError(".data_room.ComputeNode.parameter: object expected");
        n.parameter = $root.data_room.ComputeNodeParameter.fromObject(t.parameter);
      }
      if (t.branch != null) {
        if (typeof t.branch != "object")
          throw TypeError(".data_room.ComputeNode.branch: object expected");
        n.branch = $root.data_room.ComputeNodeBranch.fromObject(t.branch);
      }
      if (t.airlock != null) {
        if (typeof t.airlock != "object")
          throw TypeError(".data_room.ComputeNode.airlock: object expected");
        n.airlock = $root.data_room.ComputeNodeAirlock.fromObject(t.airlock);
      }
      if (t.rateLimiting != null) {
        if (typeof t.rateLimiting != "object")
          throw TypeError(".data_room.ComputeNode.rateLimiting: object expected");
        n.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(t.rateLimiting);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.nodeName = ""), t.nodeName != null && t.hasOwnProperty("nodeName") && (r.nodeName = t.nodeName), t.leaf != null && t.hasOwnProperty("leaf") && (r.leaf = $root.data_room.ComputeNodeLeaf.toObject(t.leaf, n), n.oneofs && (r.node = "leaf")), t.branch != null && t.hasOwnProperty("branch") && (r.branch = $root.data_room.ComputeNodeBranch.toObject(t.branch, n), n.oneofs && (r.node = "branch")), t.parameter != null && t.hasOwnProperty("parameter") && (r.parameter = $root.data_room.ComputeNodeParameter.toObject(t.parameter, n), n.oneofs && (r.node = "parameter")), t.rateLimiting != null && t.hasOwnProperty("rateLimiting") && (r.rateLimiting = $root.data_room.RateLimitingConfig.toObject(t.rateLimiting, n), n.oneofs && (r._rateLimiting = "rateLimiting")), t.airlock != null && t.hasOwnProperty("airlock") && (r.airlock = $root.data_room.ComputeNodeAirlock.toObject(t.airlock, n), n.oneofs && (r.node = "airlock")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.ComputeNode";
    }, o;
  }(), c.ComputeNodeLeaf = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.isRequired = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.isRequired != null && Object.hasOwnProperty.call(e, "isRequired") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.isRequired), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ComputeNodeLeaf();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.isRequired = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.isRequired != null && e.hasOwnProperty("isRequired") && typeof e.isRequired != "boolean" ? "isRequired: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeLeaf)
        return e;
      let t = new $root.data_room.ComputeNodeLeaf();
      return e.isRequired != null && (t.isRequired = !!e.isRequired), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.isRequired = !1), e.isRequired != null && e.hasOwnProperty("isRequired") && (n.isRequired = e.isRequired), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeLeaf";
    }, o;
  }(), c.ComputeNodeParameter = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.isRequired = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.isRequired != null && Object.hasOwnProperty.call(e, "isRequired") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.isRequired), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ComputeNodeParameter();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.isRequired = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.isRequired != null && e.hasOwnProperty("isRequired") && typeof e.isRequired != "boolean" ? "isRequired: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeParameter)
        return e;
      let t = new $root.data_room.ComputeNodeParameter();
      return e.isRequired != null && (t.isRequired = !!e.isRequired), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.isRequired = !1), e.isRequired != null && e.hasOwnProperty("isRequired") && (n.isRequired = e.isRequired), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeParameter";
    }, o;
  }(), c.ComputeNodeAirlock = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.quotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.airlockedDependency = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.quotaBytes != null && Object.hasOwnProperty.call(e, "quotaBytes") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.quotaBytes), e.airlockedDependency != null && Object.hasOwnProperty.call(e, "airlockedDependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.airlockedDependency), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ComputeNodeAirlock();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.quotaBytes = e.uint64();
            break;
          }
          case 2: {
            r.airlockedDependency = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && !$util.isInteger(e.quotaBytes) && !(e.quotaBytes && $util.isInteger(e.quotaBytes.low) && $util.isInteger(e.quotaBytes.high)) ? "quotaBytes: integer|Long expected" : e.airlockedDependency != null && e.hasOwnProperty("airlockedDependency") && !$util.isString(e.airlockedDependency) ? "airlockedDependency: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeAirlock)
        return e;
      let t = new $root.data_room.ComputeNodeAirlock();
      return e.quotaBytes != null && ($util.Long ? (t.quotaBytes = $util.Long.fromValue(e.quotaBytes)).unsigned = !0 : typeof e.quotaBytes == "string" ? t.quotaBytes = parseInt(e.quotaBytes, 10) : typeof e.quotaBytes == "number" ? t.quotaBytes = e.quotaBytes : typeof e.quotaBytes == "object" && (t.quotaBytes = new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0))), e.airlockedDependency != null && (t.airlockedDependency = String(e.airlockedDependency)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults) {
        if ($util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.quotaBytes = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.quotaBytes = t.longs === String ? "0" : 0;
        n.airlockedDependency = "";
      }
      return e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && (typeof e.quotaBytes == "number" ? n.quotaBytes = t.longs === String ? String(e.quotaBytes) : e.quotaBytes : n.quotaBytes = t.longs === String ? $util.Long.prototype.toString.call(e.quotaBytes) : t.longs === Number ? new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0) : e.quotaBytes), e.airlockedDependency != null && e.hasOwnProperty("airlockedDependency") && (n.airlockedDependency = e.airlockedDependency), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeAirlock";
    }, o;
  }(), c.ComputeNodeFormat = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "RAW"] = 0, i[o[1] = "ZIP"] = 1, i;
  }(), c.ComputeNodeProtocol = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.version = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.version != null && Object.hasOwnProperty.call(e, "version") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.version), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ComputeNodeProtocol();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.version = e.uint32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeProtocol)
        return e;
      let t = new $root.data_room.ComputeNodeProtocol();
      return e.version != null && (t.version = e.version >>> 0), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.version = 0), e.version != null && e.hasOwnProperty("version") && (n.version = e.version), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeProtocol";
    }, o;
  }(), c.ComputeNodeBranch = function() {
    function o(i) {
      if (this.dependencies = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.config = $util.newBuffer([]), o.prototype.dependencies = $util.emptyArray, o.prototype.outputFormat = 0, o.prototype.protocol = null, o.prototype.attestationSpecificationId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.config != null && Object.hasOwnProperty.call(e, "config") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.config), e.dependencies != null && e.dependencies.length)
        for (let n = 0; n < e.dependencies.length; ++n)
          t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.dependencies[n]);
      return e.outputFormat != null && Object.hasOwnProperty.call(e, "outputFormat") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.outputFormat), e.protocol != null && Object.hasOwnProperty.call(e, "protocol") && $root.data_room.ComputeNodeProtocol.encode(e.protocol, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.attestationSpecificationId != null && Object.hasOwnProperty.call(e, "attestationSpecificationId") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.attestationSpecificationId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ComputeNodeBranch();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.config = e.bytes();
            break;
          }
          case 2: {
            r.dependencies && r.dependencies.length || (r.dependencies = []), r.dependencies.push(e.string());
            break;
          }
          case 3: {
            r.outputFormat = e.int32();
            break;
          }
          case 4: {
            r.protocol = $root.data_room.ComputeNodeProtocol.decode(e, e.uint32());
            break;
          }
          case 5: {
            r.attestationSpecificationId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.config != null && e.hasOwnProperty("config") && !(e.config && typeof e.config.length == "number" || $util.isString(e.config)))
        return "config: buffer expected";
      if (e.dependencies != null && e.hasOwnProperty("dependencies")) {
        if (!Array.isArray(e.dependencies))
          return "dependencies: array expected";
        for (let t = 0; t < e.dependencies.length; ++t)
          if (!$util.isString(e.dependencies[t]))
            return "dependencies: string[] expected";
      }
      if (e.outputFormat != null && e.hasOwnProperty("outputFormat"))
        switch (e.outputFormat) {
          default:
            return "outputFormat: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (e.protocol != null && e.hasOwnProperty("protocol")) {
        let t = $root.data_room.ComputeNodeProtocol.verify(e.protocol);
        if (t)
          return "protocol." + t;
      }
      return e.attestationSpecificationId != null && e.hasOwnProperty("attestationSpecificationId") && !$util.isString(e.attestationSpecificationId) ? "attestationSpecificationId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeBranch)
        return e;
      let t = new $root.data_room.ComputeNodeBranch();
      if (e.config != null && (typeof e.config == "string" ? $util.base64.decode(e.config, t.config = $util.newBuffer($util.base64.length(e.config)), 0) : e.config.length >= 0 && (t.config = e.config)), e.dependencies) {
        if (!Array.isArray(e.dependencies))
          throw TypeError(".data_room.ComputeNodeBranch.dependencies: array expected");
        t.dependencies = [];
        for (let n = 0; n < e.dependencies.length; ++n)
          t.dependencies[n] = String(e.dependencies[n]);
      }
      switch (e.outputFormat) {
        default:
          if (typeof e.outputFormat == "number") {
            t.outputFormat = e.outputFormat;
            break;
          }
          break;
        case "RAW":
        case 0:
          t.outputFormat = 0;
          break;
        case "ZIP":
        case 1:
          t.outputFormat = 1;
          break;
      }
      if (e.protocol != null) {
        if (typeof e.protocol != "object")
          throw TypeError(".data_room.ComputeNodeBranch.protocol: object expected");
        t.protocol = $root.data_room.ComputeNodeProtocol.fromObject(e.protocol);
      }
      return e.attestationSpecificationId != null && (t.attestationSpecificationId = String(e.attestationSpecificationId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.dependencies = []), t.defaults && (t.bytes === String ? n.config = "" : (n.config = [], t.bytes !== Array && (n.config = $util.newBuffer(n.config))), n.outputFormat = t.enums === String ? "RAW" : 0, n.protocol = null, n.attestationSpecificationId = ""), e.config != null && e.hasOwnProperty("config") && (n.config = t.bytes === String ? $util.base64.encode(e.config, 0, e.config.length) : t.bytes === Array ? Array.prototype.slice.call(e.config) : e.config), e.dependencies && e.dependencies.length) {
        n.dependencies = [];
        for (let r = 0; r < e.dependencies.length; ++r)
          n.dependencies[r] = e.dependencies[r];
      }
      return e.outputFormat != null && e.hasOwnProperty("outputFormat") && (n.outputFormat = t.enums === String ? $root.data_room.ComputeNodeFormat[e.outputFormat] === void 0 ? e.outputFormat : $root.data_room.ComputeNodeFormat[e.outputFormat] : e.outputFormat), e.protocol != null && e.hasOwnProperty("protocol") && (n.protocol = $root.data_room.ComputeNodeProtocol.toObject(e.protocol, t)), e.attestationSpecificationId != null && e.hasOwnProperty("attestationSpecificationId") && (n.attestationSpecificationId = e.attestationSpecificationId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeBranch";
    }, o;
  }(), c.UserPermission = function() {
    function o(i) {
      if (this.permissions = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.email = "", o.prototype.permissions = $util.emptyArray, o.prototype.authenticationMethodId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), e.permissions != null && e.permissions.length)
        for (let n = 0; n < e.permissions.length; ++n)
          $root.data_room.Permission.encode(e.permissions[n], t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return e.authenticationMethodId != null && Object.hasOwnProperty.call(e, "authenticationMethodId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.authenticationMethodId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.UserPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.email = e.string();
            break;
          }
          case 2: {
            r.permissions && r.permissions.length || (r.permissions = []), r.permissions.push($root.data_room.Permission.decode(e, e.uint32()));
            break;
          }
          case 3: {
            r.authenticationMethodId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email))
        return "email: string expected";
      if (e.permissions != null && e.hasOwnProperty("permissions")) {
        if (!Array.isArray(e.permissions))
          return "permissions: array expected";
        for (let t = 0; t < e.permissions.length; ++t) {
          let n = $root.data_room.Permission.verify(e.permissions[t]);
          if (n)
            return "permissions." + n;
        }
      }
      return e.authenticationMethodId != null && e.hasOwnProperty("authenticationMethodId") && !$util.isString(e.authenticationMethodId) ? "authenticationMethodId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.UserPermission)
        return e;
      let t = new $root.data_room.UserPermission();
      if (e.email != null && (t.email = String(e.email)), e.permissions) {
        if (!Array.isArray(e.permissions))
          throw TypeError(".data_room.UserPermission.permissions: array expected");
        t.permissions = [];
        for (let n = 0; n < e.permissions.length; ++n) {
          if (typeof e.permissions[n] != "object")
            throw TypeError(".data_room.UserPermission.permissions: object expected");
          t.permissions[n] = $root.data_room.Permission.fromObject(e.permissions[n]);
        }
      }
      return e.authenticationMethodId != null && (t.authenticationMethodId = String(e.authenticationMethodId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.permissions = []), t.defaults && (n.email = "", n.authenticationMethodId = ""), e.email != null && e.hasOwnProperty("email") && (n.email = e.email), e.permissions && e.permissions.length) {
        n.permissions = [];
        for (let r = 0; r < e.permissions.length; ++r)
          n.permissions[r] = $root.data_room.Permission.toObject(e.permissions[r], t);
      }
      return e.authenticationMethodId != null && e.hasOwnProperty("authenticationMethodId") && (n.authenticationMethodId = e.authenticationMethodId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.UserPermission";
    }, o;
  }(), c.AuthenticationMethod = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.personalPki = null, o.prototype.dqPki = null, o.prototype.dcrSecret = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.personalPki != null && Object.hasOwnProperty.call(e, "personalPki") && $root.data_room.PkiPolicy.encode(e.personalPki, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dqPki != null && Object.hasOwnProperty.call(e, "dqPki") && $root.data_room.PkiPolicy.encode(e.dqPki, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && $root.data_room.DcrSecretPolicy.encode(e.dcrSecret, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.AuthenticationMethod();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.personalPki = $root.data_room.PkiPolicy.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.dqPki = $root.data_room.PkiPolicy.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.dcrSecret = $root.data_room.DcrSecretPolicy.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.personalPki != null && e.hasOwnProperty("personalPki")) {
        let t = $root.data_room.PkiPolicy.verify(e.personalPki);
        if (t)
          return "personalPki." + t;
      }
      if (e.dqPki != null && e.hasOwnProperty("dqPki")) {
        let t = $root.data_room.PkiPolicy.verify(e.dqPki);
        if (t)
          return "dqPki." + t;
      }
      if (e.dcrSecret != null && e.hasOwnProperty("dcrSecret")) {
        let t = $root.data_room.DcrSecretPolicy.verify(e.dcrSecret);
        if (t)
          return "dcrSecret." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.AuthenticationMethod)
        return e;
      let t = new $root.data_room.AuthenticationMethod();
      if (e.personalPki != null) {
        if (typeof e.personalPki != "object")
          throw TypeError(".data_room.AuthenticationMethod.personalPki: object expected");
        t.personalPki = $root.data_room.PkiPolicy.fromObject(e.personalPki);
      }
      if (e.dqPki != null) {
        if (typeof e.dqPki != "object")
          throw TypeError(".data_room.AuthenticationMethod.dqPki: object expected");
        t.dqPki = $root.data_room.PkiPolicy.fromObject(e.dqPki);
      }
      if (e.dcrSecret != null) {
        if (typeof e.dcrSecret != "object")
          throw TypeError(".data_room.AuthenticationMethod.dcrSecret: object expected");
        t.dcrSecret = $root.data_room.DcrSecretPolicy.fromObject(e.dcrSecret);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.personalPki = null, n.dqPki = null, n.dcrSecret = null), e.personalPki != null && e.hasOwnProperty("personalPki") && (n.personalPki = $root.data_room.PkiPolicy.toObject(e.personalPki, t)), e.dqPki != null && e.hasOwnProperty("dqPki") && (n.dqPki = $root.data_room.PkiPolicy.toObject(e.dqPki, t)), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (n.dcrSecret = $root.data_room.DcrSecretPolicy.toObject(e.dcrSecret, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AuthenticationMethod";
    }, o;
  }(), c.PkiPolicy = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.rootCertificatePem = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.rootCertificatePem != null && Object.hasOwnProperty.call(e, "rootCertificatePem") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.rootCertificatePem), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.PkiPolicy();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.rootCertificatePem = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.rootCertificatePem != null && e.hasOwnProperty("rootCertificatePem") && !(e.rootCertificatePem && typeof e.rootCertificatePem.length == "number" || $util.isString(e.rootCertificatePem)) ? "rootCertificatePem: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.PkiPolicy)
        return e;
      let t = new $root.data_room.PkiPolicy();
      return e.rootCertificatePem != null && (typeof e.rootCertificatePem == "string" ? $util.base64.decode(e.rootCertificatePem, t.rootCertificatePem = $util.newBuffer($util.base64.length(e.rootCertificatePem)), 0) : e.rootCertificatePem.length >= 0 && (t.rootCertificatePem = e.rootCertificatePem)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.rootCertificatePem = "" : (n.rootCertificatePem = [], t.bytes !== Array && (n.rootCertificatePem = $util.newBuffer(n.rootCertificatePem)))), e.rootCertificatePem != null && e.hasOwnProperty("rootCertificatePem") && (n.rootCertificatePem = t.bytes === String ? $util.base64.encode(e.rootCertificatePem, 0, e.rootCertificatePem.length) : t.bytes === Array ? Array.prototype.slice.call(e.rootCertificatePem) : e.rootCertificatePem), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.PkiPolicy";
    }, o;
  }(), c.DcrSecretPolicy = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcrSecretId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcrSecretId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.DcrSecretPolicy();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.DcrSecretPolicy)
        return e;
      let t = new $root.data_room.DcrSecretPolicy();
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, t.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (t.dcrSecretId = e.dcrSecretId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dcrSecretId = "" : (n.dcrSecretId = [], t.bytes !== Array && (n.dcrSecretId = $util.newBuffer(n.dcrSecretId)))), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (n.dcrSecretId = t.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DcrSecretPolicy";
    }, o;
  }(), c.Permission = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.executeComputePermission = null, o.prototype.leafCrudPermission = null, o.prototype.retrieveDataRoomPermission = null, o.prototype.retrieveAuditLogPermission = null, o.prototype.retrieveDataRoomStatusPermission = null, o.prototype.updateDataRoomStatusPermission = null, o.prototype.retrievePublishedDatasetsPermission = null, o.prototype.dryRunPermission = null, o.prototype.generateMergeSignaturePermission = null, o.prototype.executeDevelopmentComputePermission = null, o.prototype.mergeConfigurationCommitPermission = null, o.prototype.retrieveComputeResultPermission = null, o.prototype.casAuxiliaryStatePermission = null, o.prototype.readAuxiliaryStatePermission = null;
    let i;
    return Object.defineProperty(o.prototype, "permission", {
      get: $util.oneOfGetter(i = ["executeComputePermission", "leafCrudPermission", "retrieveDataRoomPermission", "retrieveAuditLogPermission", "retrieveDataRoomStatusPermission", "updateDataRoomStatusPermission", "retrievePublishedDatasetsPermission", "dryRunPermission", "generateMergeSignaturePermission", "executeDevelopmentComputePermission", "mergeConfigurationCommitPermission", "retrieveComputeResultPermission", "casAuxiliaryStatePermission", "readAuxiliaryStatePermission"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.executeComputePermission != null && Object.hasOwnProperty.call(t, "executeComputePermission") && $root.data_room.ExecuteComputePermission.encode(t.executeComputePermission, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.leafCrudPermission != null && Object.hasOwnProperty.call(t, "leafCrudPermission") && $root.data_room.LeafCrudPermission.encode(t.leafCrudPermission, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.retrieveDataRoomPermission != null && Object.hasOwnProperty.call(t, "retrieveDataRoomPermission") && $root.data_room.RetrieveDataRoomPermission.encode(t.retrieveDataRoomPermission, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.retrieveAuditLogPermission != null && Object.hasOwnProperty.call(t, "retrieveAuditLogPermission") && $root.data_room.RetrieveAuditLogPermission.encode(t.retrieveAuditLogPermission, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.retrieveDataRoomStatusPermission != null && Object.hasOwnProperty.call(t, "retrieveDataRoomStatusPermission") && $root.data_room.RetrieveDataRoomStatusPermission.encode(t.retrieveDataRoomStatusPermission, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.updateDataRoomStatusPermission != null && Object.hasOwnProperty.call(t, "updateDataRoomStatusPermission") && $root.data_room.UpdateDataRoomStatusPermission.encode(t.updateDataRoomStatusPermission, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.retrievePublishedDatasetsPermission != null && Object.hasOwnProperty.call(t, "retrievePublishedDatasetsPermission") && $root.data_room.RetrievePublishedDatasetsPermission.encode(t.retrievePublishedDatasetsPermission, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.dryRunPermission != null && Object.hasOwnProperty.call(t, "dryRunPermission") && $root.data_room.DryRunPermission.encode(t.dryRunPermission, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.generateMergeSignaturePermission != null && Object.hasOwnProperty.call(t, "generateMergeSignaturePermission") && $root.data_room.GenerateMergeSignaturePermission.encode(t.generateMergeSignaturePermission, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.executeDevelopmentComputePermission != null && Object.hasOwnProperty.call(t, "executeDevelopmentComputePermission") && $root.data_room.ExecuteDevelopmentComputePermission.encode(t.executeDevelopmentComputePermission, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), t.mergeConfigurationCommitPermission != null && Object.hasOwnProperty.call(t, "mergeConfigurationCommitPermission") && $root.data_room.MergeConfigurationCommitPermission.encode(t.mergeConfigurationCommitPermission, n.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), t.retrieveComputeResultPermission != null && Object.hasOwnProperty.call(t, "retrieveComputeResultPermission") && $root.data_room.RetrieveComputeResultPermission.encode(t.retrieveComputeResultPermission, n.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), t.casAuxiliaryStatePermission != null && Object.hasOwnProperty.call(t, "casAuxiliaryStatePermission") && $root.data_room.CasAuxiliaryStatePermission.encode(t.casAuxiliaryStatePermission, n.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), t.readAuxiliaryStatePermission != null && Object.hasOwnProperty.call(t, "readAuxiliaryStatePermission") && $root.data_room.ReadAuxiliaryStatePermission.encode(t.readAuxiliaryStatePermission, n.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.data_room.Permission();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.executeComputePermission = $root.data_room.ExecuteComputePermission.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.leafCrudPermission = $root.data_room.LeafCrudPermission.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.dryRunPermission = $root.data_room.DryRunPermission.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.decode(t, t.uint32());
            break;
          }
          case 11: {
            u.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.decode(t, t.uint32());
            break;
          }
          case 12: {
            u.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.decode(t, t.uint32());
            break;
          }
          case 13: {
            u.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.decode(t, t.uint32());
            break;
          }
          case 14: {
            u.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.executeComputePermission != null && t.hasOwnProperty("executeComputePermission")) {
        n.permission = 1;
        {
          let r = $root.data_room.ExecuteComputePermission.verify(t.executeComputePermission);
          if (r)
            return "executeComputePermission." + r;
        }
      }
      if (t.leafCrudPermission != null && t.hasOwnProperty("leafCrudPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.LeafCrudPermission.verify(t.leafCrudPermission);
          if (r)
            return "leafCrudPermission." + r;
        }
      }
      if (t.retrieveDataRoomPermission != null && t.hasOwnProperty("retrieveDataRoomPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.RetrieveDataRoomPermission.verify(t.retrieveDataRoomPermission);
          if (r)
            return "retrieveDataRoomPermission." + r;
        }
      }
      if (t.retrieveAuditLogPermission != null && t.hasOwnProperty("retrieveAuditLogPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.RetrieveAuditLogPermission.verify(t.retrieveAuditLogPermission);
          if (r)
            return "retrieveAuditLogPermission." + r;
        }
      }
      if (t.retrieveDataRoomStatusPermission != null && t.hasOwnProperty("retrieveDataRoomStatusPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.RetrieveDataRoomStatusPermission.verify(t.retrieveDataRoomStatusPermission);
          if (r)
            return "retrieveDataRoomStatusPermission." + r;
        }
      }
      if (t.updateDataRoomStatusPermission != null && t.hasOwnProperty("updateDataRoomStatusPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.UpdateDataRoomStatusPermission.verify(t.updateDataRoomStatusPermission);
          if (r)
            return "updateDataRoomStatusPermission." + r;
        }
      }
      if (t.retrievePublishedDatasetsPermission != null && t.hasOwnProperty("retrievePublishedDatasetsPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.RetrievePublishedDatasetsPermission.verify(t.retrievePublishedDatasetsPermission);
          if (r)
            return "retrievePublishedDatasetsPermission." + r;
        }
      }
      if (t.dryRunPermission != null && t.hasOwnProperty("dryRunPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.DryRunPermission.verify(t.dryRunPermission);
          if (r)
            return "dryRunPermission." + r;
        }
      }
      if (t.generateMergeSignaturePermission != null && t.hasOwnProperty("generateMergeSignaturePermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.GenerateMergeSignaturePermission.verify(t.generateMergeSignaturePermission);
          if (r)
            return "generateMergeSignaturePermission." + r;
        }
      }
      if (t.executeDevelopmentComputePermission != null && t.hasOwnProperty("executeDevelopmentComputePermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.ExecuteDevelopmentComputePermission.verify(t.executeDevelopmentComputePermission);
          if (r)
            return "executeDevelopmentComputePermission." + r;
        }
      }
      if (t.mergeConfigurationCommitPermission != null && t.hasOwnProperty("mergeConfigurationCommitPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.MergeConfigurationCommitPermission.verify(t.mergeConfigurationCommitPermission);
          if (r)
            return "mergeConfigurationCommitPermission." + r;
        }
      }
      if (t.retrieveComputeResultPermission != null && t.hasOwnProperty("retrieveComputeResultPermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.RetrieveComputeResultPermission.verify(t.retrieveComputeResultPermission);
          if (r)
            return "retrieveComputeResultPermission." + r;
        }
      }
      if (t.casAuxiliaryStatePermission != null && t.hasOwnProperty("casAuxiliaryStatePermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.CasAuxiliaryStatePermission.verify(t.casAuxiliaryStatePermission);
          if (r)
            return "casAuxiliaryStatePermission." + r;
        }
      }
      if (t.readAuxiliaryStatePermission != null && t.hasOwnProperty("readAuxiliaryStatePermission")) {
        if (n.permission === 1)
          return "permission: multiple values";
        n.permission = 1;
        {
          let r = $root.data_room.ReadAuxiliaryStatePermission.verify(t.readAuxiliaryStatePermission);
          if (r)
            return "readAuxiliaryStatePermission." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.data_room.Permission)
        return t;
      let n = new $root.data_room.Permission();
      if (t.executeComputePermission != null) {
        if (typeof t.executeComputePermission != "object")
          throw TypeError(".data_room.Permission.executeComputePermission: object expected");
        n.executeComputePermission = $root.data_room.ExecuteComputePermission.fromObject(t.executeComputePermission);
      }
      if (t.leafCrudPermission != null) {
        if (typeof t.leafCrudPermission != "object")
          throw TypeError(".data_room.Permission.leafCrudPermission: object expected");
        n.leafCrudPermission = $root.data_room.LeafCrudPermission.fromObject(t.leafCrudPermission);
      }
      if (t.retrieveDataRoomPermission != null) {
        if (typeof t.retrieveDataRoomPermission != "object")
          throw TypeError(".data_room.Permission.retrieveDataRoomPermission: object expected");
        n.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.fromObject(t.retrieveDataRoomPermission);
      }
      if (t.retrieveAuditLogPermission != null) {
        if (typeof t.retrieveAuditLogPermission != "object")
          throw TypeError(".data_room.Permission.retrieveAuditLogPermission: object expected");
        n.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.fromObject(t.retrieveAuditLogPermission);
      }
      if (t.retrieveDataRoomStatusPermission != null) {
        if (typeof t.retrieveDataRoomStatusPermission != "object")
          throw TypeError(".data_room.Permission.retrieveDataRoomStatusPermission: object expected");
        n.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.fromObject(t.retrieveDataRoomStatusPermission);
      }
      if (t.updateDataRoomStatusPermission != null) {
        if (typeof t.updateDataRoomStatusPermission != "object")
          throw TypeError(".data_room.Permission.updateDataRoomStatusPermission: object expected");
        n.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.fromObject(t.updateDataRoomStatusPermission);
      }
      if (t.retrievePublishedDatasetsPermission != null) {
        if (typeof t.retrievePublishedDatasetsPermission != "object")
          throw TypeError(".data_room.Permission.retrievePublishedDatasetsPermission: object expected");
        n.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.fromObject(t.retrievePublishedDatasetsPermission);
      }
      if (t.dryRunPermission != null) {
        if (typeof t.dryRunPermission != "object")
          throw TypeError(".data_room.Permission.dryRunPermission: object expected");
        n.dryRunPermission = $root.data_room.DryRunPermission.fromObject(t.dryRunPermission);
      }
      if (t.generateMergeSignaturePermission != null) {
        if (typeof t.generateMergeSignaturePermission != "object")
          throw TypeError(".data_room.Permission.generateMergeSignaturePermission: object expected");
        n.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.fromObject(t.generateMergeSignaturePermission);
      }
      if (t.executeDevelopmentComputePermission != null) {
        if (typeof t.executeDevelopmentComputePermission != "object")
          throw TypeError(".data_room.Permission.executeDevelopmentComputePermission: object expected");
        n.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.fromObject(t.executeDevelopmentComputePermission);
      }
      if (t.mergeConfigurationCommitPermission != null) {
        if (typeof t.mergeConfigurationCommitPermission != "object")
          throw TypeError(".data_room.Permission.mergeConfigurationCommitPermission: object expected");
        n.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.fromObject(t.mergeConfigurationCommitPermission);
      }
      if (t.retrieveComputeResultPermission != null) {
        if (typeof t.retrieveComputeResultPermission != "object")
          throw TypeError(".data_room.Permission.retrieveComputeResultPermission: object expected");
        n.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.fromObject(t.retrieveComputeResultPermission);
      }
      if (t.casAuxiliaryStatePermission != null) {
        if (typeof t.casAuxiliaryStatePermission != "object")
          throw TypeError(".data_room.Permission.casAuxiliaryStatePermission: object expected");
        n.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.fromObject(t.casAuxiliaryStatePermission);
      }
      if (t.readAuxiliaryStatePermission != null) {
        if (typeof t.readAuxiliaryStatePermission != "object")
          throw TypeError(".data_room.Permission.readAuxiliaryStatePermission: object expected");
        n.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.fromObject(t.readAuxiliaryStatePermission);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.executeComputePermission != null && t.hasOwnProperty("executeComputePermission") && (r.executeComputePermission = $root.data_room.ExecuteComputePermission.toObject(t.executeComputePermission, n), n.oneofs && (r.permission = "executeComputePermission")), t.leafCrudPermission != null && t.hasOwnProperty("leafCrudPermission") && (r.leafCrudPermission = $root.data_room.LeafCrudPermission.toObject(t.leafCrudPermission, n), n.oneofs && (r.permission = "leafCrudPermission")), t.retrieveDataRoomPermission != null && t.hasOwnProperty("retrieveDataRoomPermission") && (r.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.toObject(t.retrieveDataRoomPermission, n), n.oneofs && (r.permission = "retrieveDataRoomPermission")), t.retrieveAuditLogPermission != null && t.hasOwnProperty("retrieveAuditLogPermission") && (r.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.toObject(t.retrieveAuditLogPermission, n), n.oneofs && (r.permission = "retrieveAuditLogPermission")), t.retrieveDataRoomStatusPermission != null && t.hasOwnProperty("retrieveDataRoomStatusPermission") && (r.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.toObject(t.retrieveDataRoomStatusPermission, n), n.oneofs && (r.permission = "retrieveDataRoomStatusPermission")), t.updateDataRoomStatusPermission != null && t.hasOwnProperty("updateDataRoomStatusPermission") && (r.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.toObject(t.updateDataRoomStatusPermission, n), n.oneofs && (r.permission = "updateDataRoomStatusPermission")), t.retrievePublishedDatasetsPermission != null && t.hasOwnProperty("retrievePublishedDatasetsPermission") && (r.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.toObject(t.retrievePublishedDatasetsPermission, n), n.oneofs && (r.permission = "retrievePublishedDatasetsPermission")), t.dryRunPermission != null && t.hasOwnProperty("dryRunPermission") && (r.dryRunPermission = $root.data_room.DryRunPermission.toObject(t.dryRunPermission, n), n.oneofs && (r.permission = "dryRunPermission")), t.generateMergeSignaturePermission != null && t.hasOwnProperty("generateMergeSignaturePermission") && (r.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.toObject(t.generateMergeSignaturePermission, n), n.oneofs && (r.permission = "generateMergeSignaturePermission")), t.executeDevelopmentComputePermission != null && t.hasOwnProperty("executeDevelopmentComputePermission") && (r.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.toObject(t.executeDevelopmentComputePermission, n), n.oneofs && (r.permission = "executeDevelopmentComputePermission")), t.mergeConfigurationCommitPermission != null && t.hasOwnProperty("mergeConfigurationCommitPermission") && (r.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.toObject(t.mergeConfigurationCommitPermission, n), n.oneofs && (r.permission = "mergeConfigurationCommitPermission")), t.retrieveComputeResultPermission != null && t.hasOwnProperty("retrieveComputeResultPermission") && (r.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.toObject(t.retrieveComputeResultPermission, n), n.oneofs && (r.permission = "retrieveComputeResultPermission")), t.casAuxiliaryStatePermission != null && t.hasOwnProperty("casAuxiliaryStatePermission") && (r.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.toObject(t.casAuxiliaryStatePermission, n), n.oneofs && (r.permission = "casAuxiliaryStatePermission")), t.readAuxiliaryStatePermission != null && t.hasOwnProperty("readAuxiliaryStatePermission") && (r.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.toObject(t.readAuxiliaryStatePermission, n), n.oneofs && (r.permission = "readAuxiliaryStatePermission")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/data_room.Permission";
    }, o;
  }(), c.ExecuteComputePermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.computeNodeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ExecuteComputePermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.ExecuteComputePermission)
        return e;
      let t = new $root.data_room.ExecuteComputePermission();
      return e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.computeNodeId = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ExecuteComputePermission";
    }, o;
  }(), c.LeafCrudPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.leafNodeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.leafNodeId != null && Object.hasOwnProperty.call(e, "leafNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.leafNodeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.LeafCrudPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.leafNodeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.leafNodeId != null && e.hasOwnProperty("leafNodeId") && !$util.isString(e.leafNodeId) ? "leafNodeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.LeafCrudPermission)
        return e;
      let t = new $root.data_room.LeafCrudPermission();
      return e.leafNodeId != null && (t.leafNodeId = String(e.leafNodeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.leafNodeId = ""), e.leafNodeId != null && e.hasOwnProperty("leafNodeId") && (n.leafNodeId = e.leafNodeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.LeafCrudPermission";
    }, o;
  }(), c.RetrieveDataRoomPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.RetrieveDataRoomPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveDataRoomPermission ? e : new $root.data_room.RetrieveDataRoomPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveDataRoomPermission";
    }, o;
  }(), c.RetrieveAuditLogPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.RetrieveAuditLogPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveAuditLogPermission ? e : new $root.data_room.RetrieveAuditLogPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveAuditLogPermission";
    }, o;
  }(), c.RetrieveDataRoomStatusPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.RetrieveDataRoomStatusPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveDataRoomStatusPermission ? e : new $root.data_room.RetrieveDataRoomStatusPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveDataRoomStatusPermission";
    }, o;
  }(), c.UpdateDataRoomStatusPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.UpdateDataRoomStatusPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.UpdateDataRoomStatusPermission ? e : new $root.data_room.UpdateDataRoomStatusPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.UpdateDataRoomStatusPermission";
    }, o;
  }(), c.RetrievePublishedDatasetsPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.RetrievePublishedDatasetsPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.RetrievePublishedDatasetsPermission ? e : new $root.data_room.RetrievePublishedDatasetsPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrievePublishedDatasetsPermission";
    }, o;
  }(), c.DryRunPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.DryRunPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.DryRunPermission ? e : new $root.data_room.DryRunPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DryRunPermission";
    }, o;
  }(), c.GenerateMergeSignaturePermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.GenerateMergeSignaturePermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.GenerateMergeSignaturePermission ? e : new $root.data_room.GenerateMergeSignaturePermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.GenerateMergeSignaturePermission";
    }, o;
  }(), c.ExecuteDevelopmentComputePermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ExecuteDevelopmentComputePermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.ExecuteDevelopmentComputePermission ? e : new $root.data_room.ExecuteDevelopmentComputePermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ExecuteDevelopmentComputePermission";
    }, o;
  }(), c.MergeConfigurationCommitPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.MergeConfigurationCommitPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.MergeConfigurationCommitPermission ? e : new $root.data_room.MergeConfigurationCommitPermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.MergeConfigurationCommitPermission";
    }, o;
  }(), c.RetrieveComputeResultPermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.computeNodeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.RetrieveComputeResultPermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_room.RetrieveComputeResultPermission)
        return e;
      let t = new $root.data_room.RetrieveComputeResultPermission();
      return e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.computeNodeId = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveComputeResultPermission";
    }, o;
  }(), c.CasAuxiliaryStatePermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.CasAuxiliaryStatePermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.CasAuxiliaryStatePermission ? e : new $root.data_room.CasAuxiliaryStatePermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.CasAuxiliaryStatePermission";
    }, o;
  }(), c.ReadAuxiliaryStatePermission = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_room.ReadAuxiliaryStatePermission();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.data_room.ReadAuxiliaryStatePermission ? e : new $root.data_room.ReadAuxiliaryStatePermission();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ReadAuxiliaryStatePermission";
    }, o;
  }(), c;
})(), data_source_s3 = $root.data_source_s3 = (() => {
  const c = {};
  return c.S3Source = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.bucket = "", o.prototype.region = "", o.prototype.objectKey = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.bucket != null && Object.hasOwnProperty.call(e, "bucket") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.bucket), e.region != null && Object.hasOwnProperty.call(e, "region") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.region), e.objectKey != null && Object.hasOwnProperty.call(e, "objectKey") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.objectKey), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_source_s3.S3Source();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.bucket = e.string();
            break;
          }
          case 2: {
            r.region = e.string();
            break;
          }
          case 3: {
            r.objectKey = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.bucket != null && e.hasOwnProperty("bucket") && !$util.isString(e.bucket) ? "bucket: string expected" : e.region != null && e.hasOwnProperty("region") && !$util.isString(e.region) ? "region: string expected" : e.objectKey != null && e.hasOwnProperty("objectKey") && !$util.isString(e.objectKey) ? "objectKey: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_source_s3.S3Source)
        return e;
      let t = new $root.data_source_s3.S3Source();
      return e.bucket != null && (t.bucket = String(e.bucket)), e.region != null && (t.region = String(e.region)), e.objectKey != null && (t.objectKey = String(e.objectKey)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.bucket = "", n.region = "", n.objectKey = ""), e.bucket != null && e.hasOwnProperty("bucket") && (n.bucket = e.bucket), e.region != null && e.hasOwnProperty("region") && (n.region = e.region), e.objectKey != null && e.hasOwnProperty("objectKey") && (n.objectKey = e.objectKey), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_s3.S3Source";
    }, o;
  }(), c.S3Provider = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "AWS"] = 0, i[o[1] = "GCS"] = 1, i;
  }(), c.DataSourceS3WorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.source = null, o.prototype.credentialsDependency = "", o.prototype.s3Provider = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.source != null && Object.hasOwnProperty.call(e, "source") && $root.data_source_s3.S3Source.encode(e.source, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.s3Provider != null && Object.hasOwnProperty.call(e, "s3Provider") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.s3Provider), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_source_s3.DataSourceS3WorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.source = $root.data_source_s3.S3Source.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.credentialsDependency = e.string();
            break;
          }
          case 3: {
            r.s3Provider = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.source != null && e.hasOwnProperty("source")) {
        let t = $root.data_source_s3.S3Source.verify(e.source);
        if (t)
          return "source." + t;
      }
      if (e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency))
        return "credentialsDependency: string expected";
      if (e.s3Provider != null && e.hasOwnProperty("s3Provider"))
        switch (e.s3Provider) {
          default:
            return "s3Provider: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_source_s3.DataSourceS3WorkerConfiguration)
        return e;
      let t = new $root.data_source_s3.DataSourceS3WorkerConfiguration();
      if (e.source != null) {
        if (typeof e.source != "object")
          throw TypeError(".data_source_s3.DataSourceS3WorkerConfiguration.source: object expected");
        t.source = $root.data_source_s3.S3Source.fromObject(e.source);
      }
      switch (e.credentialsDependency != null && (t.credentialsDependency = String(e.credentialsDependency)), e.s3Provider) {
        default:
          if (typeof e.s3Provider == "number") {
            t.s3Provider = e.s3Provider;
            break;
          }
          break;
        case "AWS":
        case 0:
          t.s3Provider = 0;
          break;
        case "GCS":
        case 1:
          t.s3Provider = 1;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.source = null, n.credentialsDependency = "", n.s3Provider = t.enums === String ? "AWS" : 0), e.source != null && e.hasOwnProperty("source") && (n.source = $root.data_source_s3.S3Source.toObject(e.source, t)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (n.credentialsDependency = e.credentialsDependency), e.s3Provider != null && e.hasOwnProperty("s3Provider") && (n.s3Provider = t.enums === String ? $root.data_source_s3.S3Provider[e.s3Provider] === void 0 ? e.s3Provider : $root.data_source_s3.S3Provider[e.s3Provider] : e.s3Provider), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_s3.DataSourceS3WorkerConfiguration";
    }, o;
  }(), c;
})(), data_source_snowflake = $root.data_source_snowflake = (() => {
  const c = {};
  return c.SnowflakeSource = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.warehouseName = "", o.prototype.databaseName = "", o.prototype.schemaName = "", o.prototype.tableName = "", o.prototype.stageName = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.warehouseName != null && Object.hasOwnProperty.call(e, "warehouseName") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.warehouseName), e.databaseName != null && Object.hasOwnProperty.call(e, "databaseName") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.databaseName), e.schemaName != null && Object.hasOwnProperty.call(e, "schemaName") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.schemaName), e.tableName != null && Object.hasOwnProperty.call(e, "tableName") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.tableName), e.stageName != null && Object.hasOwnProperty.call(e, "stageName") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.stageName), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_source_snowflake.SnowflakeSource();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.warehouseName = e.string();
            break;
          }
          case 2: {
            r.databaseName = e.string();
            break;
          }
          case 3: {
            r.schemaName = e.string();
            break;
          }
          case 4: {
            r.tableName = e.string();
            break;
          }
          case 5: {
            r.stageName = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.warehouseName != null && e.hasOwnProperty("warehouseName") && !$util.isString(e.warehouseName) ? "warehouseName: string expected" : e.databaseName != null && e.hasOwnProperty("databaseName") && !$util.isString(e.databaseName) ? "databaseName: string expected" : e.schemaName != null && e.hasOwnProperty("schemaName") && !$util.isString(e.schemaName) ? "schemaName: string expected" : e.tableName != null && e.hasOwnProperty("tableName") && !$util.isString(e.tableName) ? "tableName: string expected" : e.stageName != null && e.hasOwnProperty("stageName") && !$util.isString(e.stageName) ? "stageName: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_source_snowflake.SnowflakeSource)
        return e;
      let t = new $root.data_source_snowflake.SnowflakeSource();
      return e.warehouseName != null && (t.warehouseName = String(e.warehouseName)), e.databaseName != null && (t.databaseName = String(e.databaseName)), e.schemaName != null && (t.schemaName = String(e.schemaName)), e.tableName != null && (t.tableName = String(e.tableName)), e.stageName != null && (t.stageName = String(e.stageName)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.warehouseName = "", n.databaseName = "", n.schemaName = "", n.tableName = "", n.stageName = ""), e.warehouseName != null && e.hasOwnProperty("warehouseName") && (n.warehouseName = e.warehouseName), e.databaseName != null && e.hasOwnProperty("databaseName") && (n.databaseName = e.databaseName), e.schemaName != null && e.hasOwnProperty("schemaName") && (n.schemaName = e.schemaName), e.tableName != null && e.hasOwnProperty("tableName") && (n.tableName = e.tableName), e.stageName != null && e.hasOwnProperty("stageName") && (n.stageName = e.stageName), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_snowflake.SnowflakeSource";
    }, o;
  }(), c.DataSourceSnowflakeWorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.source = null, o.prototype.credentialsDependency = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.source != null && Object.hasOwnProperty.call(e, "source") && $root.data_source_snowflake.SnowflakeSource.encode(e.source, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.source = $root.data_source_snowflake.SnowflakeSource.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.credentialsDependency = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.source != null && e.hasOwnProperty("source")) {
        let t = $root.data_source_snowflake.SnowflakeSource.verify(e.source);
        if (t)
          return "source." + t;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration)
        return e;
      let t = new $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration();
      if (e.source != null) {
        if (typeof e.source != "object")
          throw TypeError(".data_source_snowflake.DataSourceSnowflakeWorkerConfiguration.source: object expected");
        t.source = $root.data_source_snowflake.SnowflakeSource.fromObject(e.source);
      }
      return e.credentialsDependency != null && (t.credentialsDependency = String(e.credentialsDependency)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.source = null, n.credentialsDependency = ""), e.source != null && e.hasOwnProperty("source") && (n.source = $root.data_source_snowflake.SnowflakeSource.toObject(e.source, t)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (n.credentialsDependency = e.credentialsDependency), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_snowflake.DataSourceSnowflakeWorkerConfiguration";
    }, o;
  }(), c;
})(), dataset_sink = $root.dataset_sink = (() => {
  const c = {};
  return c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.dataset_sink.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.dataset_sink.RawFile ? e : new $root.dataset_sink.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.RawFile";
    }, o;
  }(), c.AllFiles = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.dataset_sink.AllFiles();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.dataset_sink.AllFiles ? e : new $root.dataset_sink.AllFiles();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.AllFiles";
    }, o;
  }(), c.SingleFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.name = "", o.prototype.renameAs = null;
    let i;
    return Object.defineProperty(o.prototype, "_renameAs", {
      get: $util.oneOfGetter(i = ["renameAs"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.name), t.renameAs != null && Object.hasOwnProperty.call(t, "renameAs") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.renameAs), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.dataset_sink.SingleFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.name = t.string();
            break;
          }
          case 2: {
            u.renameAs = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name) ? "name: string expected" : t.renameAs != null && t.hasOwnProperty("renameAs") && !$util.isString(t.renameAs) ? "renameAs: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.dataset_sink.SingleFile)
        return t;
      let n = new $root.dataset_sink.SingleFile();
      return t.name != null && (n.name = String(t.name)), t.renameAs != null && (n.renameAs = String(t.renameAs)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.name = ""), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.renameAs != null && t.hasOwnProperty("renameAs") && (r.renameAs = t.renameAs, n.oneofs && (r._renameAs = "renameAs")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/dataset_sink.SingleFile";
    }, o;
  }(), c.FileSelection = function() {
    function o(i) {
      if (this.names = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.names = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.names != null && e.names.length)
        for (let n = 0; n < e.names.length; ++n)
          $root.dataset_sink.SingleFile.encode(e.names[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.dataset_sink.FileSelection();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.names && r.names.length || (r.names = []), r.names.push($root.dataset_sink.SingleFile.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.names != null && e.hasOwnProperty("names")) {
        if (!Array.isArray(e.names))
          return "names: array expected";
        for (let t = 0; t < e.names.length; ++t) {
          let n = $root.dataset_sink.SingleFile.verify(e.names[t]);
          if (n)
            return "names." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.dataset_sink.FileSelection)
        return e;
      let t = new $root.dataset_sink.FileSelection();
      if (e.names) {
        if (!Array.isArray(e.names))
          throw TypeError(".dataset_sink.FileSelection.names: array expected");
        t.names = [];
        for (let n = 0; n < e.names.length; ++n) {
          if (typeof e.names[n] != "object")
            throw TypeError(".dataset_sink.FileSelection.names: object expected");
          t.names[n] = $root.dataset_sink.SingleFile.fromObject(e.names[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.names = []), e.names && e.names.length) {
        n.names = [];
        for (let r = 0; r < e.names.length; ++r)
          n.names[r] = $root.dataset_sink.SingleFile.toObject(e.names[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.FileSelection";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.all = null, o.prototype.files = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["all", "files"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.all != null && Object.hasOwnProperty.call(t, "all") && $root.dataset_sink.AllFiles.encode(t.all, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.files != null && Object.hasOwnProperty.call(t, "files") && $root.dataset_sink.FileSelection.encode(t.files, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.dataset_sink.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.all = $root.dataset_sink.AllFiles.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.files = $root.dataset_sink.FileSelection.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.all != null && t.hasOwnProperty("all")) {
        n.selection = 1;
        {
          let r = $root.dataset_sink.AllFiles.verify(t.all);
          if (r)
            return "all." + r;
        }
      }
      if (t.files != null && t.hasOwnProperty("files")) {
        if (n.selection === 1)
          return "selection: multiple values";
        n.selection = 1;
        {
          let r = $root.dataset_sink.FileSelection.verify(t.files);
          if (r)
            return "files." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.dataset_sink.ZipFile)
        return t;
      let n = new $root.dataset_sink.ZipFile();
      if (t.all != null) {
        if (typeof t.all != "object")
          throw TypeError(".dataset_sink.ZipFile.all: object expected");
        n.all = $root.dataset_sink.AllFiles.fromObject(t.all);
      }
      if (t.files != null) {
        if (typeof t.files != "object")
          throw TypeError(".dataset_sink.ZipFile.files: object expected");
        n.files = $root.dataset_sink.FileSelection.fromObject(t.files);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.all != null && t.hasOwnProperty("all") && (r.all = $root.dataset_sink.AllFiles.toObject(t.all, n), n.oneofs && (r.selection = "all")), t.files != null && t.hasOwnProperty("files") && (r.files = $root.dataset_sink.FileSelection.toObject(t.files, n), n.oneofs && (r.selection = "files")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/dataset_sink.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.dataset_sink.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.dataset_sink.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.dataset_sink.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.dataset_sink.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.dataset_sink.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.dataset_sink.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.dataset_sink.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.dataset_sink.SinkInput)
        return t;
      let n = new $root.dataset_sink.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".dataset_sink.SinkInput.raw: object expected");
        n.raw = $root.dataset_sink.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".dataset_sink.SinkInput.zip: object expected");
        n.zip = $root.dataset_sink.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.dataset_sink.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.dataset_sink.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/dataset_sink.SinkInput";
    }, o;
  }(), c.DatasetSinkWorkerConfiguration = function() {
    function o(e) {
      if (this.inputs = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.inputs = $util.emptyArray, o.prototype.encryptionKeyDependency = "", o.prototype.datasetImportId = null, o.prototype.isKeyHexEncoded = !1;
    let i;
    return Object.defineProperty(o.prototype, "_datasetImportId", {
      get: $util.oneOfGetter(i = ["datasetImportId"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.inputs != null && t.inputs.length)
        for (let r = 0; r < t.inputs.length; ++r)
          $root.dataset_sink.SinkInput.encode(t.inputs[r], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t.encryptionKeyDependency != null && Object.hasOwnProperty.call(t, "encryptionKeyDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.encryptionKeyDependency), t.datasetImportId != null && Object.hasOwnProperty.call(t, "datasetImportId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.datasetImportId), t.isKeyHexEncoded != null && Object.hasOwnProperty.call(t, "isKeyHexEncoded") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.isKeyHexEncoded), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.dataset_sink.DatasetSinkWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.inputs && u.inputs.length || (u.inputs = []), u.inputs.push($root.dataset_sink.SinkInput.decode(t, t.uint32()));
            break;
          }
          case 2: {
            u.encryptionKeyDependency = t.string();
            break;
          }
          case 3: {
            u.datasetImportId = t.string();
            break;
          }
          case 4: {
            u.isKeyHexEncoded = t.bool();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.inputs != null && t.hasOwnProperty("inputs")) {
        if (!Array.isArray(t.inputs))
          return "inputs: array expected";
        for (let n = 0; n < t.inputs.length; ++n) {
          let r = $root.dataset_sink.SinkInput.verify(t.inputs[n]);
          if (r)
            return "inputs." + r;
        }
      }
      return t.encryptionKeyDependency != null && t.hasOwnProperty("encryptionKeyDependency") && !$util.isString(t.encryptionKeyDependency) ? "encryptionKeyDependency: string expected" : t.datasetImportId != null && t.hasOwnProperty("datasetImportId") && !$util.isString(t.datasetImportId) ? "datasetImportId: string expected" : t.isKeyHexEncoded != null && t.hasOwnProperty("isKeyHexEncoded") && typeof t.isKeyHexEncoded != "boolean" ? "isKeyHexEncoded: boolean expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.dataset_sink.DatasetSinkWorkerConfiguration)
        return t;
      let n = new $root.dataset_sink.DatasetSinkWorkerConfiguration();
      if (t.inputs) {
        if (!Array.isArray(t.inputs))
          throw TypeError(".dataset_sink.DatasetSinkWorkerConfiguration.inputs: array expected");
        n.inputs = [];
        for (let r = 0; r < t.inputs.length; ++r) {
          if (typeof t.inputs[r] != "object")
            throw TypeError(".dataset_sink.DatasetSinkWorkerConfiguration.inputs: object expected");
          n.inputs[r] = $root.dataset_sink.SinkInput.fromObject(t.inputs[r]);
        }
      }
      return t.encryptionKeyDependency != null && (n.encryptionKeyDependency = String(t.encryptionKeyDependency)), t.datasetImportId != null && (n.datasetImportId = String(t.datasetImportId)), t.isKeyHexEncoded != null && (n.isKeyHexEncoded = !!t.isKeyHexEncoded), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.inputs = []), n.defaults && (r.encryptionKeyDependency = "", r.isKeyHexEncoded = !1), t.inputs && t.inputs.length) {
        r.inputs = [];
        for (let u = 0; u < t.inputs.length; ++u)
          r.inputs[u] = $root.dataset_sink.SinkInput.toObject(t.inputs[u], n);
      }
      return t.encryptionKeyDependency != null && t.hasOwnProperty("encryptionKeyDependency") && (r.encryptionKeyDependency = t.encryptionKeyDependency), t.datasetImportId != null && t.hasOwnProperty("datasetImportId") && (r.datasetImportId = t.datasetImportId, n.oneofs && (r._datasetImportId = "datasetImportId")), t.isKeyHexEncoded != null && t.hasOwnProperty("isKeyHexEncoded") && (r.isKeyHexEncoded = t.isKeyHexEncoded), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/dataset_sink.DatasetSinkWorkerConfiguration";
    }, o;
  }(), c;
})(), delta_enclave_api = $root.delta_enclave_api = (() => {
  const c = {};
  return c.Request = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.deltaRequest = null, o.prototype.extensionMessage = null, o.prototype.deltaRequestV2 = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["deltaRequest", "extensionMessage", "deltaRequestV2"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.deltaRequest != null && Object.hasOwnProperty.call(t, "deltaRequest") && $root.delta_enclave_api.DataNoncePubkey.encode(t.deltaRequest, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.extensionMessage != null && Object.hasOwnProperty.call(t, "extensionMessage") && $root.delta_enclave_api.ExtensionMessage.encode(t.extensionMessage, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.deltaRequestV2 != null && Object.hasOwnProperty.call(t, "deltaRequestV2") && $root.delta_enclave_api.DataNoncePubkey.encode(t.deltaRequestV2, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.delta_enclave_api.Request();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.extensionMessage = $root.delta_enclave_api.ExtensionMessage.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.deltaRequest != null && t.hasOwnProperty("deltaRequest")) {
        n.request = 1;
        {
          let r = $root.delta_enclave_api.DataNoncePubkey.verify(t.deltaRequest);
          if (r)
            return "deltaRequest." + r;
        }
      }
      if (t.extensionMessage != null && t.hasOwnProperty("extensionMessage")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.delta_enclave_api.ExtensionMessage.verify(t.extensionMessage);
          if (r)
            return "extensionMessage." + r;
        }
      }
      if (t.deltaRequestV2 != null && t.hasOwnProperty("deltaRequestV2")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.delta_enclave_api.DataNoncePubkey.verify(t.deltaRequestV2);
          if (r)
            return "deltaRequestV2." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.delta_enclave_api.Request)
        return t;
      let n = new $root.delta_enclave_api.Request();
      if (t.deltaRequest != null) {
        if (typeof t.deltaRequest != "object")
          throw TypeError(".delta_enclave_api.Request.deltaRequest: object expected");
        n.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.fromObject(t.deltaRequest);
      }
      if (t.extensionMessage != null) {
        if (typeof t.extensionMessage != "object")
          throw TypeError(".delta_enclave_api.Request.extensionMessage: object expected");
        n.extensionMessage = $root.delta_enclave_api.ExtensionMessage.fromObject(t.extensionMessage);
      }
      if (t.deltaRequestV2 != null) {
        if (typeof t.deltaRequestV2 != "object")
          throw TypeError(".delta_enclave_api.Request.deltaRequestV2: object expected");
        n.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.fromObject(t.deltaRequestV2);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.deltaRequest != null && t.hasOwnProperty("deltaRequest") && (r.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.toObject(t.deltaRequest, n), n.oneofs && (r.request = "deltaRequest")), t.extensionMessage != null && t.hasOwnProperty("extensionMessage") && (r.extensionMessage = $root.delta_enclave_api.ExtensionMessage.toObject(t.extensionMessage, n), n.oneofs && (r.request = "extensionMessage")), t.deltaRequestV2 != null && t.hasOwnProperty("deltaRequestV2") && (r.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.toObject(t.deltaRequestV2, n), n.oneofs && (r.request = "deltaRequestV2")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/delta_enclave_api.Request";
    }, o;
  }(), c.ExtensionMessage = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.prototype.payload = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.payload != null && Object.hasOwnProperty.call(e, "payload") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.payload), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.ExtensionMessage();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          case 2: {
            r.payload = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.payload != null && e.hasOwnProperty("payload") && !(e.payload && typeof e.payload.length == "number" || $util.isString(e.payload)) ? "payload: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.ExtensionMessage)
        return e;
      let t = new $root.delta_enclave_api.ExtensionMessage();
      return e.name != null && (t.name = String(e.name)), e.payload != null && (typeof e.payload == "string" ? $util.base64.decode(e.payload, t.payload = $util.newBuffer($util.base64.length(e.payload)), 0) : e.payload.length >= 0 && (t.payload = e.payload)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = "", t.bytes === String ? n.payload = "" : (n.payload = [], t.bytes !== Array && (n.payload = $util.newBuffer(n.payload)))), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.payload != null && e.hasOwnProperty("payload") && (n.payload = t.bytes === String ? $util.base64.encode(e.payload, 0, e.payload.length) : t.bytes === Array ? Array.prototype.slice.call(e.payload) : e.payload), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.ExtensionMessage";
    }, o;
  }(), c.Response = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.successfulResponse = null, o.prototype.unsuccessfulResponse = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["successfulResponse", "unsuccessfulResponse"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.successfulResponse != null && Object.hasOwnProperty.call(t, "successfulResponse") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(t.successfulResponse), t.unsuccessfulResponse != null && Object.hasOwnProperty.call(t, "unsuccessfulResponse") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.unsuccessfulResponse), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.delta_enclave_api.Response();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.successfulResponse = t.bytes();
            break;
          }
          case 2: {
            u.unsuccessfulResponse = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.successfulResponse != null && t.hasOwnProperty("successfulResponse") && (n.response = 1, !(t.successfulResponse && typeof t.successfulResponse.length == "number" || $util.isString(t.successfulResponse))))
        return "successfulResponse: buffer expected";
      if (t.unsuccessfulResponse != null && t.hasOwnProperty("unsuccessfulResponse")) {
        if (n.response === 1)
          return "response: multiple values";
        if (n.response = 1, !$util.isString(t.unsuccessfulResponse))
          return "unsuccessfulResponse: string expected";
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.delta_enclave_api.Response)
        return t;
      let n = new $root.delta_enclave_api.Response();
      return t.successfulResponse != null && (typeof t.successfulResponse == "string" ? $util.base64.decode(t.successfulResponse, n.successfulResponse = $util.newBuffer($util.base64.length(t.successfulResponse)), 0) : t.successfulResponse.length >= 0 && (n.successfulResponse = t.successfulResponse)), t.unsuccessfulResponse != null && (n.unsuccessfulResponse = String(t.unsuccessfulResponse)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.successfulResponse != null && t.hasOwnProperty("successfulResponse") && (r.successfulResponse = n.bytes === String ? $util.base64.encode(t.successfulResponse, 0, t.successfulResponse.length) : n.bytes === Array ? Array.prototype.slice.call(t.successfulResponse) : t.successfulResponse, n.oneofs && (r.response = "successfulResponse")), t.unsuccessfulResponse != null && t.hasOwnProperty("unsuccessfulResponse") && (r.unsuccessfulResponse = t.unsuccessfulResponse, n.oneofs && (r.response = "unsuccessfulResponse")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/delta_enclave_api.Response";
    }, o;
  }(), c.DataNoncePubkey = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.data = $util.newBuffer([]), o.prototype.nonce = $util.newBuffer([]), o.prototype.pubkey = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), e.nonce != null && Object.hasOwnProperty.call(e, "nonce") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nonce), e.pubkey != null && Object.hasOwnProperty.call(e, "pubkey") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.pubkey), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.DataNoncePubkey();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.data = e.bytes();
            break;
          }
          case 2: {
            r.nonce = e.bytes();
            break;
          }
          case 3: {
            r.pubkey = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : e.nonce != null && e.hasOwnProperty("nonce") && !(e.nonce && typeof e.nonce.length == "number" || $util.isString(e.nonce)) ? "nonce: buffer expected" : e.pubkey != null && e.hasOwnProperty("pubkey") && !(e.pubkey && typeof e.pubkey.length == "number" || $util.isString(e.pubkey)) ? "pubkey: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.DataNoncePubkey)
        return e;
      let t = new $root.delta_enclave_api.DataNoncePubkey();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, t.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (t.data = e.data)), e.nonce != null && (typeof e.nonce == "string" ? $util.base64.decode(e.nonce, t.nonce = $util.newBuffer($util.base64.length(e.nonce)), 0) : e.nonce.length >= 0 && (t.nonce = e.nonce)), e.pubkey != null && (typeof e.pubkey == "string" ? $util.base64.decode(e.pubkey, t.pubkey = $util.newBuffer($util.base64.length(e.pubkey)), 0) : e.pubkey.length >= 0 && (t.pubkey = e.pubkey)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.data = "" : (n.data = [], t.bytes !== Array && (n.data = $util.newBuffer(n.data))), t.bytes === String ? n.nonce = "" : (n.nonce = [], t.bytes !== Array && (n.nonce = $util.newBuffer(n.nonce))), t.bytes === String ? n.pubkey = "" : (n.pubkey = [], t.bytes !== Array && (n.pubkey = $util.newBuffer(n.pubkey)))), e.data != null && e.hasOwnProperty("data") && (n.data = t.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.nonce != null && e.hasOwnProperty("nonce") && (n.nonce = t.bytes === String ? $util.base64.encode(e.nonce, 0, e.nonce.length) : t.bytes === Array ? Array.prototype.slice.call(e.nonce) : e.nonce), e.pubkey != null && e.hasOwnProperty("pubkey") && (n.pubkey = t.bytes === String ? $util.base64.encode(e.pubkey, 0, e.pubkey.length) : t.bytes === Array ? Array.prototype.slice.call(e.pubkey) : e.pubkey), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.DataNoncePubkey";
    }, o;
  }(), c.DataNonce = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.data = $util.newBuffer([]), o.prototype.nonce = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), e.nonce != null && Object.hasOwnProperty.call(e, "nonce") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nonce), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.DataNonce();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.data = e.bytes();
            break;
          }
          case 2: {
            r.nonce = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : e.nonce != null && e.hasOwnProperty("nonce") && !(e.nonce && typeof e.nonce.length == "number" || $util.isString(e.nonce)) ? "nonce: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.DataNonce)
        return e;
      let t = new $root.delta_enclave_api.DataNonce();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, t.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (t.data = e.data)), e.nonce != null && (typeof e.nonce == "string" ? $util.base64.decode(e.nonce, t.nonce = $util.newBuffer($util.base64.length(e.nonce)), 0) : e.nonce.length >= 0 && (t.nonce = e.nonce)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.data = "" : (n.data = [], t.bytes !== Array && (n.data = $util.newBuffer(n.data))), t.bytes === String ? n.nonce = "" : (n.nonce = [], t.bytes !== Array && (n.nonce = $util.newBuffer(n.nonce)))), e.data != null && e.hasOwnProperty("data") && (n.data = t.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.nonce != null && e.hasOwnProperty("nonce") && (n.nonce = t.bytes === String ? $util.base64.encode(e.nonce, 0, e.nonce.length) : t.bytes === Array ? Array.prototype.slice.call(e.nonce) : e.nonce), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.DataNonce";
    }, o;
  }(), c.SealedEncryptedMessage = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.encryptedMessage = null, o.prototype.sealingKeyParams = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.encryptedMessage != null && Object.hasOwnProperty.call(e, "encryptedMessage") && $root.delta_enclave_api.DataNonce.encode(e.encryptedMessage, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.sealingKeyParams != null && Object.hasOwnProperty.call(e, "sealingKeyParams") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.sealingKeyParams), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.SealedEncryptedMessage();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.encryptedMessage = $root.delta_enclave_api.DataNonce.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.sealingKeyParams = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.encryptedMessage != null && e.hasOwnProperty("encryptedMessage")) {
        let t = $root.delta_enclave_api.DataNonce.verify(e.encryptedMessage);
        if (t)
          return "encryptedMessage." + t;
      }
      return e.sealingKeyParams != null && e.hasOwnProperty("sealingKeyParams") && !(e.sealingKeyParams && typeof e.sealingKeyParams.length == "number" || $util.isString(e.sealingKeyParams)) ? "sealingKeyParams: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.SealedEncryptedMessage)
        return e;
      let t = new $root.delta_enclave_api.SealedEncryptedMessage();
      if (e.encryptedMessage != null) {
        if (typeof e.encryptedMessage != "object")
          throw TypeError(".delta_enclave_api.SealedEncryptedMessage.encryptedMessage: object expected");
        t.encryptedMessage = $root.delta_enclave_api.DataNonce.fromObject(e.encryptedMessage);
      }
      return e.sealingKeyParams != null && (typeof e.sealingKeyParams == "string" ? $util.base64.decode(e.sealingKeyParams, t.sealingKeyParams = $util.newBuffer($util.base64.length(e.sealingKeyParams)), 0) : e.sealingKeyParams.length >= 0 && (t.sealingKeyParams = e.sealingKeyParams)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.encryptedMessage = null, t.bytes === String ? n.sealingKeyParams = "" : (n.sealingKeyParams = [], t.bytes !== Array && (n.sealingKeyParams = $util.newBuffer(n.sealingKeyParams)))), e.encryptedMessage != null && e.hasOwnProperty("encryptedMessage") && (n.encryptedMessage = $root.delta_enclave_api.DataNonce.toObject(e.encryptedMessage, t)), e.sealingKeyParams != null && e.hasOwnProperty("sealingKeyParams") && (n.sealingKeyParams = t.bytes === String ? $util.base64.encode(e.sealingKeyParams, 0, e.sealingKeyParams.length) : t.bytes === Array ? Array.prototype.slice.call(e.sealingKeyParams) : e.sealingKeyParams), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.SealedEncryptedMessage";
    }, o;
  }(), c.EncryptionHeader = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.chilyKey = null;
    let i;
    return Object.defineProperty(o.prototype, "encryptionHeader", {
      get: $util.oneOfGetter(i = ["chilyKey"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.chilyKey != null && Object.hasOwnProperty.call(t, "chilyKey") && $root.delta_enclave_api.ChilyKey.encode(t.chilyKey, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.delta_enclave_api.EncryptionHeader();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.chilyKey = $root.delta_enclave_api.ChilyKey.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.chilyKey != null && t.hasOwnProperty("chilyKey")) {
        let n = $root.delta_enclave_api.ChilyKey.verify(t.chilyKey);
        if (n)
          return "chilyKey." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.delta_enclave_api.EncryptionHeader)
        return t;
      let n = new $root.delta_enclave_api.EncryptionHeader();
      if (t.chilyKey != null) {
        if (typeof t.chilyKey != "object")
          throw TypeError(".delta_enclave_api.EncryptionHeader.chilyKey: object expected");
        n.chilyKey = $root.delta_enclave_api.ChilyKey.fromObject(t.chilyKey);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.chilyKey != null && t.hasOwnProperty("chilyKey") && (r.chilyKey = $root.delta_enclave_api.ChilyKey.toObject(t.chilyKey, n), n.oneofs && (r.encryptionHeader = "chilyKey")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/delta_enclave_api.EncryptionHeader";
    }, o;
  }(), c.ChilyKey = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.encryptionNonce = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.encryptionNonce != null && Object.hasOwnProperty.call(e, "encryptionNonce") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.encryptionNonce), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.ChilyKey();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 2: {
            r.encryptionNonce = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.encryptionNonce != null && e.hasOwnProperty("encryptionNonce") && !(e.encryptionNonce && typeof e.encryptionNonce.length == "number" || $util.isString(e.encryptionNonce)) ? "encryptionNonce: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.ChilyKey)
        return e;
      let t = new $root.delta_enclave_api.ChilyKey();
      return e.encryptionNonce != null && (typeof e.encryptionNonce == "string" ? $util.base64.decode(e.encryptionNonce, t.encryptionNonce = $util.newBuffer($util.base64.length(e.encryptionNonce)), 0) : e.encryptionNonce.length >= 0 && (t.encryptionNonce = e.encryptionNonce)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.encryptionNonce = "" : (n.encryptionNonce = [], t.bytes !== Array && (n.encryptionNonce = $util.newBuffer(n.encryptionNonce)))), e.encryptionNonce != null && e.hasOwnProperty("encryptionNonce") && (n.encryptionNonce = t.bytes === String ? $util.base64.encode(e.encryptionNonce, 0, e.encryptionNonce.length) : t.bytes === Array ? Array.prototype.slice.call(e.encryptionNonce) : e.encryptionNonce), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.ChilyKey";
    }, o;
  }(), c.VersionHeader = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.version != null && Object.hasOwnProperty.call(e, "version") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int64(e.version), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.delta_enclave_api.VersionHeader();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.version = e.int64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) && !(e.version && $util.isInteger(e.version.low) && $util.isInteger(e.version.high)) ? "version: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.VersionHeader)
        return e;
      let t = new $root.delta_enclave_api.VersionHeader();
      return e.version != null && ($util.Long ? (t.version = $util.Long.fromValue(e.version)).unsigned = !1 : typeof e.version == "string" ? t.version = parseInt(e.version, 10) : typeof e.version == "number" ? t.version = e.version : typeof e.version == "object" && (t.version = new $util.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber())), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if ($util.Long) {
          let r = new $util.Long(0, 0, !1);
          n.version = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.version = t.longs === String ? "0" : 0;
      return e.version != null && e.hasOwnProperty("version") && (typeof e.version == "number" ? n.version = t.longs === String ? String(e.version) : e.version : n.version = t.longs === String ? $util.Long.prototype.toString.call(e.version) : t.longs === Number ? new $util.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber() : e.version), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.VersionHeader";
    }, o;
  }(), c.ChunkHeader = function() {
    function o(e) {
      if (this.untrustedChunkContentSizes = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.extraEntropy = $util.newBuffer([]), o.prototype.untrustedContentSize = null, o.prototype.untrustedChunkContentSizes = $util.emptyArray;
    let i;
    return Object.defineProperty(o.prototype, "_untrustedContentSize", {
      get: $util.oneOfGetter(i = ["untrustedContentSize"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.extraEntropy != null && Object.hasOwnProperty.call(t, "extraEntropy") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(t.extraEntropy), t.untrustedContentSize != null && Object.hasOwnProperty.call(t, "untrustedContentSize") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(t.untrustedContentSize), t.untrustedChunkContentSizes != null && t.untrustedChunkContentSizes.length) {
        n.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork();
        for (let r = 0; r < t.untrustedChunkContentSizes.length; ++r)
          n.uint64(t.untrustedChunkContentSizes[r]);
        n.ldelim();
      }
      return n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.delta_enclave_api.ChunkHeader();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.extraEntropy = t.bytes();
            break;
          }
          case 2: {
            u.untrustedContentSize = t.uint64();
            break;
          }
          case 3: {
            if (u.untrustedChunkContentSizes && u.untrustedChunkContentSizes.length || (u.untrustedChunkContentSizes = []), (l & 7) === 2) {
              let f = t.uint32() + t.pos;
              for (; t.pos < f; )
                u.untrustedChunkContentSizes.push(t.uint64());
            } else
              u.untrustedChunkContentSizes.push(t.uint64());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.extraEntropy != null && t.hasOwnProperty("extraEntropy") && !(t.extraEntropy && typeof t.extraEntropy.length == "number" || $util.isString(t.extraEntropy)))
        return "extraEntropy: buffer expected";
      if (t.untrustedContentSize != null && t.hasOwnProperty("untrustedContentSize") && !$util.isInteger(t.untrustedContentSize) && !(t.untrustedContentSize && $util.isInteger(t.untrustedContentSize.low) && $util.isInteger(t.untrustedContentSize.high)))
        return "untrustedContentSize: integer|Long expected";
      if (t.untrustedChunkContentSizes != null && t.hasOwnProperty("untrustedChunkContentSizes")) {
        if (!Array.isArray(t.untrustedChunkContentSizes))
          return "untrustedChunkContentSizes: array expected";
        for (let n = 0; n < t.untrustedChunkContentSizes.length; ++n)
          if (!$util.isInteger(t.untrustedChunkContentSizes[n]) && !(t.untrustedChunkContentSizes[n] && $util.isInteger(t.untrustedChunkContentSizes[n].low) && $util.isInteger(t.untrustedChunkContentSizes[n].high)))
            return "untrustedChunkContentSizes: integer|Long[] expected";
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.delta_enclave_api.ChunkHeader)
        return t;
      let n = new $root.delta_enclave_api.ChunkHeader();
      if (t.extraEntropy != null && (typeof t.extraEntropy == "string" ? $util.base64.decode(t.extraEntropy, n.extraEntropy = $util.newBuffer($util.base64.length(t.extraEntropy)), 0) : t.extraEntropy.length >= 0 && (n.extraEntropy = t.extraEntropy)), t.untrustedContentSize != null && ($util.Long ? (n.untrustedContentSize = $util.Long.fromValue(t.untrustedContentSize)).unsigned = !0 : typeof t.untrustedContentSize == "string" ? n.untrustedContentSize = parseInt(t.untrustedContentSize, 10) : typeof t.untrustedContentSize == "number" ? n.untrustedContentSize = t.untrustedContentSize : typeof t.untrustedContentSize == "object" && (n.untrustedContentSize = new $util.LongBits(t.untrustedContentSize.low >>> 0, t.untrustedContentSize.high >>> 0).toNumber(!0))), t.untrustedChunkContentSizes) {
        if (!Array.isArray(t.untrustedChunkContentSizes))
          throw TypeError(".delta_enclave_api.ChunkHeader.untrustedChunkContentSizes: array expected");
        n.untrustedChunkContentSizes = [];
        for (let r = 0; r < t.untrustedChunkContentSizes.length; ++r)
          $util.Long ? (n.untrustedChunkContentSizes[r] = $util.Long.fromValue(t.untrustedChunkContentSizes[r])).unsigned = !0 : typeof t.untrustedChunkContentSizes[r] == "string" ? n.untrustedChunkContentSizes[r] = parseInt(t.untrustedChunkContentSizes[r], 10) : typeof t.untrustedChunkContentSizes[r] == "number" ? n.untrustedChunkContentSizes[r] = t.untrustedChunkContentSizes[r] : typeof t.untrustedChunkContentSizes[r] == "object" && (n.untrustedChunkContentSizes[r] = new $util.LongBits(t.untrustedChunkContentSizes[r].low >>> 0, t.untrustedChunkContentSizes[r].high >>> 0).toNumber(!0));
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.untrustedChunkContentSizes = []), n.defaults && (n.bytes === String ? r.extraEntropy = "" : (r.extraEntropy = [], n.bytes !== Array && (r.extraEntropy = $util.newBuffer(r.extraEntropy)))), t.extraEntropy != null && t.hasOwnProperty("extraEntropy") && (r.extraEntropy = n.bytes === String ? $util.base64.encode(t.extraEntropy, 0, t.extraEntropy.length) : n.bytes === Array ? Array.prototype.slice.call(t.extraEntropy) : t.extraEntropy), t.untrustedContentSize != null && t.hasOwnProperty("untrustedContentSize") && (typeof t.untrustedContentSize == "number" ? r.untrustedContentSize = n.longs === String ? String(t.untrustedContentSize) : t.untrustedContentSize : r.untrustedContentSize = n.longs === String ? $util.Long.prototype.toString.call(t.untrustedContentSize) : n.longs === Number ? new $util.LongBits(t.untrustedContentSize.low >>> 0, t.untrustedContentSize.high >>> 0).toNumber(!0) : t.untrustedContentSize, n.oneofs && (r._untrustedContentSize = "untrustedContentSize")), t.untrustedChunkContentSizes && t.untrustedChunkContentSizes.length) {
        r.untrustedChunkContentSizes = [];
        for (let u = 0; u < t.untrustedChunkContentSizes.length; ++u)
          typeof t.untrustedChunkContentSizes[u] == "number" ? r.untrustedChunkContentSizes[u] = n.longs === String ? String(t.untrustedChunkContentSizes[u]) : t.untrustedChunkContentSizes[u] : r.untrustedChunkContentSizes[u] = n.longs === String ? $util.Long.prototype.toString.call(t.untrustedChunkContentSizes[u]) : n.longs === Number ? new $util.LongBits(t.untrustedChunkContentSizes[u].low >>> 0, t.untrustedChunkContentSizes[u].high >>> 0).toNumber(!0) : t.untrustedChunkContentSizes[u];
      }
      return r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/delta_enclave_api.ChunkHeader";
    }, o;
  }(), c;
})(), gcg = $root.gcg = (() => {
  const c = {};
  return c.GcgRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.userAuth = null, o.prototype.createDataRoomRequest = null, o.prototype.retrieveDataRoomRequest = null, o.prototype.retrieveCurrentDataRoomConfigurationRequest = null, o.prototype.retrieveDataRoomStatusRequest = null, o.prototype.updateDataRoomStatusRequest = null, o.prototype.retrieveAuditLogRequest = null, o.prototype.publishDatasetToDataRoomRequest = null, o.prototype.retrievePublishedDatasetsRequest = null, o.prototype.removePublishedDatasetRequest = null, o.prototype.executeComputeRequest = null, o.prototype.jobStatusRequest = null, o.prototype.getResultsRequest = null, o.prototype.createConfigurationCommitRequest = null, o.prototype.retrieveConfigurationCommitRequest = null, o.prototype.executeDevelopmentComputeRequest = null, o.prototype.generateMergeApprovalSignatureRequest = null, o.prototype.mergeConfigurationCommitRequest = null, o.prototype.retrieveConfigurationCommitApproversRequest = null, o.prototype.casAuxiliaryStateRequest = null, o.prototype.readAuxiliaryStateRequest = null, o.prototype.retrieveUsedAirlockQuotaRequest = null, o.prototype.getResultsSizeRequest = null, o.prototype.endorsementRequest = null;
    let i;
    return Object.defineProperty(o.prototype, "gcgRequest", {
      get: $util.oneOfGetter(i = ["createDataRoomRequest", "retrieveDataRoomRequest", "retrieveCurrentDataRoomConfigurationRequest", "retrieveDataRoomStatusRequest", "updateDataRoomStatusRequest", "retrieveAuditLogRequest", "publishDatasetToDataRoomRequest", "retrievePublishedDatasetsRequest", "removePublishedDatasetRequest", "executeComputeRequest", "jobStatusRequest", "getResultsRequest", "createConfigurationCommitRequest", "retrieveConfigurationCommitRequest", "executeDevelopmentComputeRequest", "generateMergeApprovalSignatureRequest", "mergeConfigurationCommitRequest", "retrieveConfigurationCommitApproversRequest", "casAuxiliaryStateRequest", "readAuxiliaryStateRequest", "retrieveUsedAirlockQuotaRequest", "getResultsSizeRequest", "endorsementRequest"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.userAuth != null && Object.hasOwnProperty.call(t, "userAuth") && $root.gcg.UserAuth.encode(t.userAuth, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.createDataRoomRequest != null && Object.hasOwnProperty.call(t, "createDataRoomRequest") && $root.gcg.CreateDataRoomRequest.encode(t.createDataRoomRequest, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.retrieveDataRoomRequest != null && Object.hasOwnProperty.call(t, "retrieveDataRoomRequest") && $root.gcg.RetrieveDataRoomRequest.encode(t.retrieveDataRoomRequest, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.retrieveCurrentDataRoomConfigurationRequest != null && Object.hasOwnProperty.call(t, "retrieveCurrentDataRoomConfigurationRequest") && $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.encode(t.retrieveCurrentDataRoomConfigurationRequest, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.retrieveDataRoomStatusRequest != null && Object.hasOwnProperty.call(t, "retrieveDataRoomStatusRequest") && $root.gcg.RetrieveDataRoomStatusRequest.encode(t.retrieveDataRoomStatusRequest, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.updateDataRoomStatusRequest != null && Object.hasOwnProperty.call(t, "updateDataRoomStatusRequest") && $root.gcg.UpdateDataRoomStatusRequest.encode(t.updateDataRoomStatusRequest, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.retrieveAuditLogRequest != null && Object.hasOwnProperty.call(t, "retrieveAuditLogRequest") && $root.gcg.RetrieveAuditLogRequest.encode(t.retrieveAuditLogRequest, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.publishDatasetToDataRoomRequest != null && Object.hasOwnProperty.call(t, "publishDatasetToDataRoomRequest") && $root.gcg.PublishDatasetToDataRoomRequest.encode(t.publishDatasetToDataRoomRequest, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.retrievePublishedDatasetsRequest != null && Object.hasOwnProperty.call(t, "retrievePublishedDatasetsRequest") && $root.gcg.RetrievePublishedDatasetsRequest.encode(t.retrievePublishedDatasetsRequest, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.removePublishedDatasetRequest != null && Object.hasOwnProperty.call(t, "removePublishedDatasetRequest") && $root.gcg.RemovePublishedDatasetRequest.encode(t.removePublishedDatasetRequest, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), t.executeComputeRequest != null && Object.hasOwnProperty.call(t, "executeComputeRequest") && $root.gcg.ExecuteComputeRequest.encode(t.executeComputeRequest, n.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), t.jobStatusRequest != null && Object.hasOwnProperty.call(t, "jobStatusRequest") && $root.gcg.JobStatusRequest.encode(t.jobStatusRequest, n.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), t.getResultsRequest != null && Object.hasOwnProperty.call(t, "getResultsRequest") && $root.gcg.GetResultsRequest.encode(t.getResultsRequest, n.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), t.createConfigurationCommitRequest != null && Object.hasOwnProperty.call(t, "createConfigurationCommitRequest") && $root.gcg.CreateConfigurationCommitRequest.encode(t.createConfigurationCommitRequest, n.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), t.retrieveConfigurationCommitRequest != null && Object.hasOwnProperty.call(t, "retrieveConfigurationCommitRequest") && $root.gcg.RetrieveConfigurationCommitRequest.encode(t.retrieveConfigurationCommitRequest, n.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), t.executeDevelopmentComputeRequest != null && Object.hasOwnProperty.call(t, "executeDevelopmentComputeRequest") && $root.gcg.ExecuteDevelopmentComputeRequest.encode(t.executeDevelopmentComputeRequest, n.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), t.generateMergeApprovalSignatureRequest != null && Object.hasOwnProperty.call(t, "generateMergeApprovalSignatureRequest") && $root.gcg.GenerateMergeApprovalSignatureRequest.encode(t.generateMergeApprovalSignatureRequest, n.uint32(
        /* id 17, wireType 2 =*/
        138
      ).fork()).ldelim(), t.mergeConfigurationCommitRequest != null && Object.hasOwnProperty.call(t, "mergeConfigurationCommitRequest") && $root.gcg.MergeConfigurationCommitRequest.encode(t.mergeConfigurationCommitRequest, n.uint32(
        /* id 18, wireType 2 =*/
        146
      ).fork()).ldelim(), t.retrieveConfigurationCommitApproversRequest != null && Object.hasOwnProperty.call(t, "retrieveConfigurationCommitApproversRequest") && $root.gcg.RetrieveConfigurationCommitApproversRequest.encode(t.retrieveConfigurationCommitApproversRequest, n.uint32(
        /* id 19, wireType 2 =*/
        154
      ).fork()).ldelim(), t.casAuxiliaryStateRequest != null && Object.hasOwnProperty.call(t, "casAuxiliaryStateRequest") && $root.gcg.CasAuxiliaryStateRequest.encode(t.casAuxiliaryStateRequest, n.uint32(
        /* id 20, wireType 2 =*/
        162
      ).fork()).ldelim(), t.readAuxiliaryStateRequest != null && Object.hasOwnProperty.call(t, "readAuxiliaryStateRequest") && $root.gcg.ReadAuxiliaryStateRequest.encode(t.readAuxiliaryStateRequest, n.uint32(
        /* id 21, wireType 2 =*/
        170
      ).fork()).ldelim(), t.retrieveUsedAirlockQuotaRequest != null && Object.hasOwnProperty.call(t, "retrieveUsedAirlockQuotaRequest") && $root.gcg.RetrieveUsedAirlockQuotaRequest.encode(t.retrieveUsedAirlockQuotaRequest, n.uint32(
        /* id 22, wireType 2 =*/
        178
      ).fork()).ldelim(), t.getResultsSizeRequest != null && Object.hasOwnProperty.call(t, "getResultsSizeRequest") && $root.gcg.GetResultsSizeRequest.encode(t.getResultsSizeRequest, n.uint32(
        /* id 23, wireType 2 =*/
        186
      ).fork()).ldelim(), t.endorsementRequest != null && Object.hasOwnProperty.call(t, "endorsementRequest") && $root.identity_endorsement.EndorsementRequest.encode(t.endorsementRequest, n.uint32(
        /* id 101, wireType 2 =*/
        810
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.GcgRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.userAuth = $root.gcg.UserAuth.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.decode(t, t.uint32());
            break;
          }
          case 11: {
            u.executeComputeRequest = $root.gcg.ExecuteComputeRequest.decode(t, t.uint32());
            break;
          }
          case 12: {
            u.jobStatusRequest = $root.gcg.JobStatusRequest.decode(t, t.uint32());
            break;
          }
          case 13: {
            u.getResultsRequest = $root.gcg.GetResultsRequest.decode(t, t.uint32());
            break;
          }
          case 14: {
            u.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.decode(t, t.uint32());
            break;
          }
          case 15: {
            u.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.decode(t, t.uint32());
            break;
          }
          case 16: {
            u.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.decode(t, t.uint32());
            break;
          }
          case 17: {
            u.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.decode(t, t.uint32());
            break;
          }
          case 18: {
            u.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.decode(t, t.uint32());
            break;
          }
          case 19: {
            u.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.decode(t, t.uint32());
            break;
          }
          case 20: {
            u.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.decode(t, t.uint32());
            break;
          }
          case 21: {
            u.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.decode(t, t.uint32());
            break;
          }
          case 22: {
            u.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.decode(t, t.uint32());
            break;
          }
          case 23: {
            u.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.decode(t, t.uint32());
            break;
          }
          case 101: {
            u.endorsementRequest = $root.identity_endorsement.EndorsementRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.userAuth != null && t.hasOwnProperty("userAuth")) {
        let r = $root.gcg.UserAuth.verify(t.userAuth);
        if (r)
          return "userAuth." + r;
      }
      if (t.createDataRoomRequest != null && t.hasOwnProperty("createDataRoomRequest")) {
        n.gcgRequest = 1;
        {
          let r = $root.gcg.CreateDataRoomRequest.verify(t.createDataRoomRequest);
          if (r)
            return "createDataRoomRequest." + r;
        }
      }
      if (t.retrieveDataRoomRequest != null && t.hasOwnProperty("retrieveDataRoomRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveDataRoomRequest.verify(t.retrieveDataRoomRequest);
          if (r)
            return "retrieveDataRoomRequest." + r;
        }
      }
      if (t.retrieveCurrentDataRoomConfigurationRequest != null && t.hasOwnProperty("retrieveCurrentDataRoomConfigurationRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.verify(t.retrieveCurrentDataRoomConfigurationRequest);
          if (r)
            return "retrieveCurrentDataRoomConfigurationRequest." + r;
        }
      }
      if (t.retrieveDataRoomStatusRequest != null && t.hasOwnProperty("retrieveDataRoomStatusRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveDataRoomStatusRequest.verify(t.retrieveDataRoomStatusRequest);
          if (r)
            return "retrieveDataRoomStatusRequest." + r;
        }
      }
      if (t.updateDataRoomStatusRequest != null && t.hasOwnProperty("updateDataRoomStatusRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.UpdateDataRoomStatusRequest.verify(t.updateDataRoomStatusRequest);
          if (r)
            return "updateDataRoomStatusRequest." + r;
        }
      }
      if (t.retrieveAuditLogRequest != null && t.hasOwnProperty("retrieveAuditLogRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveAuditLogRequest.verify(t.retrieveAuditLogRequest);
          if (r)
            return "retrieveAuditLogRequest." + r;
        }
      }
      if (t.publishDatasetToDataRoomRequest != null && t.hasOwnProperty("publishDatasetToDataRoomRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.PublishDatasetToDataRoomRequest.verify(t.publishDatasetToDataRoomRequest);
          if (r)
            return "publishDatasetToDataRoomRequest." + r;
        }
      }
      if (t.retrievePublishedDatasetsRequest != null && t.hasOwnProperty("retrievePublishedDatasetsRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrievePublishedDatasetsRequest.verify(t.retrievePublishedDatasetsRequest);
          if (r)
            return "retrievePublishedDatasetsRequest." + r;
        }
      }
      if (t.removePublishedDatasetRequest != null && t.hasOwnProperty("removePublishedDatasetRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RemovePublishedDatasetRequest.verify(t.removePublishedDatasetRequest);
          if (r)
            return "removePublishedDatasetRequest." + r;
        }
      }
      if (t.executeComputeRequest != null && t.hasOwnProperty("executeComputeRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.ExecuteComputeRequest.verify(t.executeComputeRequest);
          if (r)
            return "executeComputeRequest." + r;
        }
      }
      if (t.jobStatusRequest != null && t.hasOwnProperty("jobStatusRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.JobStatusRequest.verify(t.jobStatusRequest);
          if (r)
            return "jobStatusRequest." + r;
        }
      }
      if (t.getResultsRequest != null && t.hasOwnProperty("getResultsRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.GetResultsRequest.verify(t.getResultsRequest);
          if (r)
            return "getResultsRequest." + r;
        }
      }
      if (t.createConfigurationCommitRequest != null && t.hasOwnProperty("createConfigurationCommitRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.CreateConfigurationCommitRequest.verify(t.createConfigurationCommitRequest);
          if (r)
            return "createConfigurationCommitRequest." + r;
        }
      }
      if (t.retrieveConfigurationCommitRequest != null && t.hasOwnProperty("retrieveConfigurationCommitRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveConfigurationCommitRequest.verify(t.retrieveConfigurationCommitRequest);
          if (r)
            return "retrieveConfigurationCommitRequest." + r;
        }
      }
      if (t.executeDevelopmentComputeRequest != null && t.hasOwnProperty("executeDevelopmentComputeRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.ExecuteDevelopmentComputeRequest.verify(t.executeDevelopmentComputeRequest);
          if (r)
            return "executeDevelopmentComputeRequest." + r;
        }
      }
      if (t.generateMergeApprovalSignatureRequest != null && t.hasOwnProperty("generateMergeApprovalSignatureRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.GenerateMergeApprovalSignatureRequest.verify(t.generateMergeApprovalSignatureRequest);
          if (r)
            return "generateMergeApprovalSignatureRequest." + r;
        }
      }
      if (t.mergeConfigurationCommitRequest != null && t.hasOwnProperty("mergeConfigurationCommitRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.MergeConfigurationCommitRequest.verify(t.mergeConfigurationCommitRequest);
          if (r)
            return "mergeConfigurationCommitRequest." + r;
        }
      }
      if (t.retrieveConfigurationCommitApproversRequest != null && t.hasOwnProperty("retrieveConfigurationCommitApproversRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveConfigurationCommitApproversRequest.verify(t.retrieveConfigurationCommitApproversRequest);
          if (r)
            return "retrieveConfigurationCommitApproversRequest." + r;
        }
      }
      if (t.casAuxiliaryStateRequest != null && t.hasOwnProperty("casAuxiliaryStateRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.CasAuxiliaryStateRequest.verify(t.casAuxiliaryStateRequest);
          if (r)
            return "casAuxiliaryStateRequest." + r;
        }
      }
      if (t.readAuxiliaryStateRequest != null && t.hasOwnProperty("readAuxiliaryStateRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.ReadAuxiliaryStateRequest.verify(t.readAuxiliaryStateRequest);
          if (r)
            return "readAuxiliaryStateRequest." + r;
        }
      }
      if (t.retrieveUsedAirlockQuotaRequest != null && t.hasOwnProperty("retrieveUsedAirlockQuotaRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.RetrieveUsedAirlockQuotaRequest.verify(t.retrieveUsedAirlockQuotaRequest);
          if (r)
            return "retrieveUsedAirlockQuotaRequest." + r;
        }
      }
      if (t.getResultsSizeRequest != null && t.hasOwnProperty("getResultsSizeRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.gcg.GetResultsSizeRequest.verify(t.getResultsSizeRequest);
          if (r)
            return "getResultsSizeRequest." + r;
        }
      }
      if (t.endorsementRequest != null && t.hasOwnProperty("endorsementRequest")) {
        if (n.gcgRequest === 1)
          return "gcgRequest: multiple values";
        n.gcgRequest = 1;
        {
          let r = $root.identity_endorsement.EndorsementRequest.verify(t.endorsementRequest);
          if (r)
            return "endorsementRequest." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.GcgRequest)
        return t;
      let n = new $root.gcg.GcgRequest();
      if (t.userAuth != null) {
        if (typeof t.userAuth != "object")
          throw TypeError(".gcg.GcgRequest.userAuth: object expected");
        n.userAuth = $root.gcg.UserAuth.fromObject(t.userAuth);
      }
      if (t.createDataRoomRequest != null) {
        if (typeof t.createDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.createDataRoomRequest: object expected");
        n.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.fromObject(t.createDataRoomRequest);
      }
      if (t.retrieveDataRoomRequest != null) {
        if (typeof t.retrieveDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveDataRoomRequest: object expected");
        n.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.fromObject(t.retrieveDataRoomRequest);
      }
      if (t.retrieveCurrentDataRoomConfigurationRequest != null) {
        if (typeof t.retrieveCurrentDataRoomConfigurationRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveCurrentDataRoomConfigurationRequest: object expected");
        n.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.fromObject(t.retrieveCurrentDataRoomConfigurationRequest);
      }
      if (t.retrieveDataRoomStatusRequest != null) {
        if (typeof t.retrieveDataRoomStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveDataRoomStatusRequest: object expected");
        n.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.fromObject(t.retrieveDataRoomStatusRequest);
      }
      if (t.updateDataRoomStatusRequest != null) {
        if (typeof t.updateDataRoomStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.updateDataRoomStatusRequest: object expected");
        n.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.fromObject(t.updateDataRoomStatusRequest);
      }
      if (t.retrieveAuditLogRequest != null) {
        if (typeof t.retrieveAuditLogRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveAuditLogRequest: object expected");
        n.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.fromObject(t.retrieveAuditLogRequest);
      }
      if (t.publishDatasetToDataRoomRequest != null) {
        if (typeof t.publishDatasetToDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.publishDatasetToDataRoomRequest: object expected");
        n.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.fromObject(t.publishDatasetToDataRoomRequest);
      }
      if (t.retrievePublishedDatasetsRequest != null) {
        if (typeof t.retrievePublishedDatasetsRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrievePublishedDatasetsRequest: object expected");
        n.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.fromObject(t.retrievePublishedDatasetsRequest);
      }
      if (t.removePublishedDatasetRequest != null) {
        if (typeof t.removePublishedDatasetRequest != "object")
          throw TypeError(".gcg.GcgRequest.removePublishedDatasetRequest: object expected");
        n.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.fromObject(t.removePublishedDatasetRequest);
      }
      if (t.executeComputeRequest != null) {
        if (typeof t.executeComputeRequest != "object")
          throw TypeError(".gcg.GcgRequest.executeComputeRequest: object expected");
        n.executeComputeRequest = $root.gcg.ExecuteComputeRequest.fromObject(t.executeComputeRequest);
      }
      if (t.jobStatusRequest != null) {
        if (typeof t.jobStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.jobStatusRequest: object expected");
        n.jobStatusRequest = $root.gcg.JobStatusRequest.fromObject(t.jobStatusRequest);
      }
      if (t.getResultsRequest != null) {
        if (typeof t.getResultsRequest != "object")
          throw TypeError(".gcg.GcgRequest.getResultsRequest: object expected");
        n.getResultsRequest = $root.gcg.GetResultsRequest.fromObject(t.getResultsRequest);
      }
      if (t.createConfigurationCommitRequest != null) {
        if (typeof t.createConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.createConfigurationCommitRequest: object expected");
        n.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.fromObject(t.createConfigurationCommitRequest);
      }
      if (t.retrieveConfigurationCommitRequest != null) {
        if (typeof t.retrieveConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveConfigurationCommitRequest: object expected");
        n.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.fromObject(t.retrieveConfigurationCommitRequest);
      }
      if (t.executeDevelopmentComputeRequest != null) {
        if (typeof t.executeDevelopmentComputeRequest != "object")
          throw TypeError(".gcg.GcgRequest.executeDevelopmentComputeRequest: object expected");
        n.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.fromObject(t.executeDevelopmentComputeRequest);
      }
      if (t.generateMergeApprovalSignatureRequest != null) {
        if (typeof t.generateMergeApprovalSignatureRequest != "object")
          throw TypeError(".gcg.GcgRequest.generateMergeApprovalSignatureRequest: object expected");
        n.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.fromObject(t.generateMergeApprovalSignatureRequest);
      }
      if (t.mergeConfigurationCommitRequest != null) {
        if (typeof t.mergeConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.mergeConfigurationCommitRequest: object expected");
        n.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.fromObject(t.mergeConfigurationCommitRequest);
      }
      if (t.retrieveConfigurationCommitApproversRequest != null) {
        if (typeof t.retrieveConfigurationCommitApproversRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveConfigurationCommitApproversRequest: object expected");
        n.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.fromObject(t.retrieveConfigurationCommitApproversRequest);
      }
      if (t.casAuxiliaryStateRequest != null) {
        if (typeof t.casAuxiliaryStateRequest != "object")
          throw TypeError(".gcg.GcgRequest.casAuxiliaryStateRequest: object expected");
        n.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.fromObject(t.casAuxiliaryStateRequest);
      }
      if (t.readAuxiliaryStateRequest != null) {
        if (typeof t.readAuxiliaryStateRequest != "object")
          throw TypeError(".gcg.GcgRequest.readAuxiliaryStateRequest: object expected");
        n.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.fromObject(t.readAuxiliaryStateRequest);
      }
      if (t.retrieveUsedAirlockQuotaRequest != null) {
        if (typeof t.retrieveUsedAirlockQuotaRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveUsedAirlockQuotaRequest: object expected");
        n.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.fromObject(t.retrieveUsedAirlockQuotaRequest);
      }
      if (t.getResultsSizeRequest != null) {
        if (typeof t.getResultsSizeRequest != "object")
          throw TypeError(".gcg.GcgRequest.getResultsSizeRequest: object expected");
        n.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.fromObject(t.getResultsSizeRequest);
      }
      if (t.endorsementRequest != null) {
        if (typeof t.endorsementRequest != "object")
          throw TypeError(".gcg.GcgRequest.endorsementRequest: object expected");
        n.endorsementRequest = $root.identity_endorsement.EndorsementRequest.fromObject(t.endorsementRequest);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.userAuth = null), t.userAuth != null && t.hasOwnProperty("userAuth") && (r.userAuth = $root.gcg.UserAuth.toObject(t.userAuth, n)), t.createDataRoomRequest != null && t.hasOwnProperty("createDataRoomRequest") && (r.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.toObject(t.createDataRoomRequest, n), n.oneofs && (r.gcgRequest = "createDataRoomRequest")), t.retrieveDataRoomRequest != null && t.hasOwnProperty("retrieveDataRoomRequest") && (r.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.toObject(t.retrieveDataRoomRequest, n), n.oneofs && (r.gcgRequest = "retrieveDataRoomRequest")), t.retrieveCurrentDataRoomConfigurationRequest != null && t.hasOwnProperty("retrieveCurrentDataRoomConfigurationRequest") && (r.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.toObject(t.retrieveCurrentDataRoomConfigurationRequest, n), n.oneofs && (r.gcgRequest = "retrieveCurrentDataRoomConfigurationRequest")), t.retrieveDataRoomStatusRequest != null && t.hasOwnProperty("retrieveDataRoomStatusRequest") && (r.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.toObject(t.retrieveDataRoomStatusRequest, n), n.oneofs && (r.gcgRequest = "retrieveDataRoomStatusRequest")), t.updateDataRoomStatusRequest != null && t.hasOwnProperty("updateDataRoomStatusRequest") && (r.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.toObject(t.updateDataRoomStatusRequest, n), n.oneofs && (r.gcgRequest = "updateDataRoomStatusRequest")), t.retrieveAuditLogRequest != null && t.hasOwnProperty("retrieveAuditLogRequest") && (r.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.toObject(t.retrieveAuditLogRequest, n), n.oneofs && (r.gcgRequest = "retrieveAuditLogRequest")), t.publishDatasetToDataRoomRequest != null && t.hasOwnProperty("publishDatasetToDataRoomRequest") && (r.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.toObject(t.publishDatasetToDataRoomRequest, n), n.oneofs && (r.gcgRequest = "publishDatasetToDataRoomRequest")), t.retrievePublishedDatasetsRequest != null && t.hasOwnProperty("retrievePublishedDatasetsRequest") && (r.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.toObject(t.retrievePublishedDatasetsRequest, n), n.oneofs && (r.gcgRequest = "retrievePublishedDatasetsRequest")), t.removePublishedDatasetRequest != null && t.hasOwnProperty("removePublishedDatasetRequest") && (r.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.toObject(t.removePublishedDatasetRequest, n), n.oneofs && (r.gcgRequest = "removePublishedDatasetRequest")), t.executeComputeRequest != null && t.hasOwnProperty("executeComputeRequest") && (r.executeComputeRequest = $root.gcg.ExecuteComputeRequest.toObject(t.executeComputeRequest, n), n.oneofs && (r.gcgRequest = "executeComputeRequest")), t.jobStatusRequest != null && t.hasOwnProperty("jobStatusRequest") && (r.jobStatusRequest = $root.gcg.JobStatusRequest.toObject(t.jobStatusRequest, n), n.oneofs && (r.gcgRequest = "jobStatusRequest")), t.getResultsRequest != null && t.hasOwnProperty("getResultsRequest") && (r.getResultsRequest = $root.gcg.GetResultsRequest.toObject(t.getResultsRequest, n), n.oneofs && (r.gcgRequest = "getResultsRequest")), t.createConfigurationCommitRequest != null && t.hasOwnProperty("createConfigurationCommitRequest") && (r.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.toObject(t.createConfigurationCommitRequest, n), n.oneofs && (r.gcgRequest = "createConfigurationCommitRequest")), t.retrieveConfigurationCommitRequest != null && t.hasOwnProperty("retrieveConfigurationCommitRequest") && (r.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.toObject(t.retrieveConfigurationCommitRequest, n), n.oneofs && (r.gcgRequest = "retrieveConfigurationCommitRequest")), t.executeDevelopmentComputeRequest != null && t.hasOwnProperty("executeDevelopmentComputeRequest") && (r.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.toObject(t.executeDevelopmentComputeRequest, n), n.oneofs && (r.gcgRequest = "executeDevelopmentComputeRequest")), t.generateMergeApprovalSignatureRequest != null && t.hasOwnProperty("generateMergeApprovalSignatureRequest") && (r.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.toObject(t.generateMergeApprovalSignatureRequest, n), n.oneofs && (r.gcgRequest = "generateMergeApprovalSignatureRequest")), t.mergeConfigurationCommitRequest != null && t.hasOwnProperty("mergeConfigurationCommitRequest") && (r.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.toObject(t.mergeConfigurationCommitRequest, n), n.oneofs && (r.gcgRequest = "mergeConfigurationCommitRequest")), t.retrieveConfigurationCommitApproversRequest != null && t.hasOwnProperty("retrieveConfigurationCommitApproversRequest") && (r.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.toObject(t.retrieveConfigurationCommitApproversRequest, n), n.oneofs && (r.gcgRequest = "retrieveConfigurationCommitApproversRequest")), t.casAuxiliaryStateRequest != null && t.hasOwnProperty("casAuxiliaryStateRequest") && (r.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.toObject(t.casAuxiliaryStateRequest, n), n.oneofs && (r.gcgRequest = "casAuxiliaryStateRequest")), t.readAuxiliaryStateRequest != null && t.hasOwnProperty("readAuxiliaryStateRequest") && (r.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.toObject(t.readAuxiliaryStateRequest, n), n.oneofs && (r.gcgRequest = "readAuxiliaryStateRequest")), t.retrieveUsedAirlockQuotaRequest != null && t.hasOwnProperty("retrieveUsedAirlockQuotaRequest") && (r.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.toObject(t.retrieveUsedAirlockQuotaRequest, n), n.oneofs && (r.gcgRequest = "retrieveUsedAirlockQuotaRequest")), t.getResultsSizeRequest != null && t.hasOwnProperty("getResultsSizeRequest") && (r.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.toObject(t.getResultsSizeRequest, n), n.oneofs && (r.gcgRequest = "getResultsSizeRequest")), t.endorsementRequest != null && t.hasOwnProperty("endorsementRequest") && (r.endorsementRequest = $root.identity_endorsement.EndorsementRequest.toObject(t.endorsementRequest, n), n.oneofs && (r.gcgRequest = "endorsementRequest")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.GcgRequest";
    }, o;
  }(), c.GcgResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.failure = null, o.prototype.createDataRoomResponse = null, o.prototype.retrieveDataRoomResponse = null, o.prototype.retrieveCurrentDataRoomConfigurationResponse = null, o.prototype.retrieveDataRoomStatusResponse = null, o.prototype.updateDataRoomStatusResponse = null, o.prototype.retrieveAuditLogResponse = null, o.prototype.publishDatasetToDataRoomResponse = null, o.prototype.retrievePublishedDatasetsResponse = null, o.prototype.removePublishedDatasetResponse = null, o.prototype.executeComputeResponse = null, o.prototype.jobStatusResponse = null, o.prototype.getResultsResponseChunk = null, o.prototype.getResultsResponseFooter = null, o.prototype.createConfigurationCommitResponse = null, o.prototype.retrieveConfigurationCommitResponse = null, o.prototype.generateMergeApprovalSignatureResponse = null, o.prototype.mergeConfigurationCommitResponse = null, o.prototype.retrieveConfigurationCommitApproversResponse = null, o.prototype.casAuxiliaryStateResponse = null, o.prototype.readAuxiliaryStateResponse = null, o.prototype.retrieveUsedAirlockQuotaResponse = null, o.prototype.getResultsSizeResponse = null, o.prototype.endorsementResponse = null;
    let i;
    return Object.defineProperty(o.prototype, "gcgResponse", {
      get: $util.oneOfGetter(i = ["failure", "createDataRoomResponse", "retrieveDataRoomResponse", "retrieveCurrentDataRoomConfigurationResponse", "retrieveDataRoomStatusResponse", "updateDataRoomStatusResponse", "retrieveAuditLogResponse", "publishDatasetToDataRoomResponse", "retrievePublishedDatasetsResponse", "removePublishedDatasetResponse", "executeComputeResponse", "jobStatusResponse", "getResultsResponseChunk", "getResultsResponseFooter", "createConfigurationCommitResponse", "retrieveConfigurationCommitResponse", "generateMergeApprovalSignatureResponse", "mergeConfigurationCommitResponse", "retrieveConfigurationCommitApproversResponse", "casAuxiliaryStateResponse", "readAuxiliaryStateResponse", "retrieveUsedAirlockQuotaResponse", "getResultsSizeResponse", "endorsementResponse"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.failure != null && Object.hasOwnProperty.call(t, "failure") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.failure), t.createDataRoomResponse != null && Object.hasOwnProperty.call(t, "createDataRoomResponse") && $root.gcg.CreateDataRoomResponse.encode(t.createDataRoomResponse, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.retrieveDataRoomResponse != null && Object.hasOwnProperty.call(t, "retrieveDataRoomResponse") && $root.gcg.RetrieveDataRoomResponse.encode(t.retrieveDataRoomResponse, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.retrieveCurrentDataRoomConfigurationResponse != null && Object.hasOwnProperty.call(t, "retrieveCurrentDataRoomConfigurationResponse") && $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.encode(t.retrieveCurrentDataRoomConfigurationResponse, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.retrieveDataRoomStatusResponse != null && Object.hasOwnProperty.call(t, "retrieveDataRoomStatusResponse") && $root.gcg.RetrieveDataRoomStatusResponse.encode(t.retrieveDataRoomStatusResponse, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.updateDataRoomStatusResponse != null && Object.hasOwnProperty.call(t, "updateDataRoomStatusResponse") && $root.gcg.UpdateDataRoomStatusResponse.encode(t.updateDataRoomStatusResponse, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.retrieveAuditLogResponse != null && Object.hasOwnProperty.call(t, "retrieveAuditLogResponse") && $root.gcg.RetrieveAuditLogResponse.encode(t.retrieveAuditLogResponse, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.publishDatasetToDataRoomResponse != null && Object.hasOwnProperty.call(t, "publishDatasetToDataRoomResponse") && $root.gcg.PublishDatasetToDataRoomResponse.encode(t.publishDatasetToDataRoomResponse, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.retrievePublishedDatasetsResponse != null && Object.hasOwnProperty.call(t, "retrievePublishedDatasetsResponse") && $root.gcg.RetrievePublishedDatasetsResponse.encode(t.retrievePublishedDatasetsResponse, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.removePublishedDatasetResponse != null && Object.hasOwnProperty.call(t, "removePublishedDatasetResponse") && $root.gcg.RemovePublishedDatasetResponse.encode(t.removePublishedDatasetResponse, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), t.executeComputeResponse != null && Object.hasOwnProperty.call(t, "executeComputeResponse") && $root.gcg.ExecuteComputeResponse.encode(t.executeComputeResponse, n.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), t.jobStatusResponse != null && Object.hasOwnProperty.call(t, "jobStatusResponse") && $root.gcg.JobStatusResponse.encode(t.jobStatusResponse, n.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), t.getResultsResponseChunk != null && Object.hasOwnProperty.call(t, "getResultsResponseChunk") && $root.gcg.GetResultsResponseChunk.encode(t.getResultsResponseChunk, n.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), t.getResultsResponseFooter != null && Object.hasOwnProperty.call(t, "getResultsResponseFooter") && $root.gcg.GetResultsResponseFooter.encode(t.getResultsResponseFooter, n.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), t.createConfigurationCommitResponse != null && Object.hasOwnProperty.call(t, "createConfigurationCommitResponse") && $root.gcg.CreateConfigurationCommitResponse.encode(t.createConfigurationCommitResponse, n.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), t.retrieveConfigurationCommitResponse != null && Object.hasOwnProperty.call(t, "retrieveConfigurationCommitResponse") && $root.gcg.RetrieveConfigurationCommitResponse.encode(t.retrieveConfigurationCommitResponse, n.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), t.generateMergeApprovalSignatureResponse != null && Object.hasOwnProperty.call(t, "generateMergeApprovalSignatureResponse") && $root.gcg.GenerateMergeApprovalSignatureResponse.encode(t.generateMergeApprovalSignatureResponse, n.uint32(
        /* id 17, wireType 2 =*/
        138
      ).fork()).ldelim(), t.mergeConfigurationCommitResponse != null && Object.hasOwnProperty.call(t, "mergeConfigurationCommitResponse") && $root.gcg.MergeConfigurationCommitResponse.encode(t.mergeConfigurationCommitResponse, n.uint32(
        /* id 18, wireType 2 =*/
        146
      ).fork()).ldelim(), t.retrieveConfigurationCommitApproversResponse != null && Object.hasOwnProperty.call(t, "retrieveConfigurationCommitApproversResponse") && $root.gcg.RetrieveConfigurationCommitApproversResponse.encode(t.retrieveConfigurationCommitApproversResponse, n.uint32(
        /* id 19, wireType 2 =*/
        154
      ).fork()).ldelim(), t.casAuxiliaryStateResponse != null && Object.hasOwnProperty.call(t, "casAuxiliaryStateResponse") && $root.gcg.CasAuxiliaryStateResponse.encode(t.casAuxiliaryStateResponse, n.uint32(
        /* id 20, wireType 2 =*/
        162
      ).fork()).ldelim(), t.readAuxiliaryStateResponse != null && Object.hasOwnProperty.call(t, "readAuxiliaryStateResponse") && $root.gcg.ReadAuxiliaryStateResponse.encode(t.readAuxiliaryStateResponse, n.uint32(
        /* id 21, wireType 2 =*/
        170
      ).fork()).ldelim(), t.retrieveUsedAirlockQuotaResponse != null && Object.hasOwnProperty.call(t, "retrieveUsedAirlockQuotaResponse") && $root.gcg.RetrieveUsedAirlockQuotaResponse.encode(t.retrieveUsedAirlockQuotaResponse, n.uint32(
        /* id 22, wireType 2 =*/
        178
      ).fork()).ldelim(), t.getResultsSizeResponse != null && Object.hasOwnProperty.call(t, "getResultsSizeResponse") && $root.gcg.GetResultsSizeResponse.encode(t.getResultsSizeResponse, n.uint32(
        /* id 23, wireType 2 =*/
        186
      ).fork()).ldelim(), t.endorsementResponse != null && Object.hasOwnProperty.call(t, "endorsementResponse") && $root.identity_endorsement.EndorsementResponse.encode(t.endorsementResponse, n.uint32(
        /* id 101, wireType 2 =*/
        810
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.GcgResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.failure = t.string();
            break;
          }
          case 2: {
            u.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.decode(t, t.uint32());
            break;
          }
          case 11: {
            u.executeComputeResponse = $root.gcg.ExecuteComputeResponse.decode(t, t.uint32());
            break;
          }
          case 12: {
            u.jobStatusResponse = $root.gcg.JobStatusResponse.decode(t, t.uint32());
            break;
          }
          case 13: {
            u.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.decode(t, t.uint32());
            break;
          }
          case 14: {
            u.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.decode(t, t.uint32());
            break;
          }
          case 15: {
            u.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.decode(t, t.uint32());
            break;
          }
          case 16: {
            u.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.decode(t, t.uint32());
            break;
          }
          case 17: {
            u.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.decode(t, t.uint32());
            break;
          }
          case 18: {
            u.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.decode(t, t.uint32());
            break;
          }
          case 19: {
            u.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.decode(t, t.uint32());
            break;
          }
          case 20: {
            u.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.decode(t, t.uint32());
            break;
          }
          case 21: {
            u.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.decode(t, t.uint32());
            break;
          }
          case 22: {
            u.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.decode(t, t.uint32());
            break;
          }
          case 23: {
            u.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.decode(t, t.uint32());
            break;
          }
          case 101: {
            u.endorsementResponse = $root.identity_endorsement.EndorsementResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.failure != null && t.hasOwnProperty("failure") && (n.gcgResponse = 1, !$util.isString(t.failure)))
        return "failure: string expected";
      if (t.createDataRoomResponse != null && t.hasOwnProperty("createDataRoomResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.CreateDataRoomResponse.verify(t.createDataRoomResponse);
          if (r)
            return "createDataRoomResponse." + r;
        }
      }
      if (t.retrieveDataRoomResponse != null && t.hasOwnProperty("retrieveDataRoomResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveDataRoomResponse.verify(t.retrieveDataRoomResponse);
          if (r)
            return "retrieveDataRoomResponse." + r;
        }
      }
      if (t.retrieveCurrentDataRoomConfigurationResponse != null && t.hasOwnProperty("retrieveCurrentDataRoomConfigurationResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.verify(t.retrieveCurrentDataRoomConfigurationResponse);
          if (r)
            return "retrieveCurrentDataRoomConfigurationResponse." + r;
        }
      }
      if (t.retrieveDataRoomStatusResponse != null && t.hasOwnProperty("retrieveDataRoomStatusResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveDataRoomStatusResponse.verify(t.retrieveDataRoomStatusResponse);
          if (r)
            return "retrieveDataRoomStatusResponse." + r;
        }
      }
      if (t.updateDataRoomStatusResponse != null && t.hasOwnProperty("updateDataRoomStatusResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.UpdateDataRoomStatusResponse.verify(t.updateDataRoomStatusResponse);
          if (r)
            return "updateDataRoomStatusResponse." + r;
        }
      }
      if (t.retrieveAuditLogResponse != null && t.hasOwnProperty("retrieveAuditLogResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveAuditLogResponse.verify(t.retrieveAuditLogResponse);
          if (r)
            return "retrieveAuditLogResponse." + r;
        }
      }
      if (t.publishDatasetToDataRoomResponse != null && t.hasOwnProperty("publishDatasetToDataRoomResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.PublishDatasetToDataRoomResponse.verify(t.publishDatasetToDataRoomResponse);
          if (r)
            return "publishDatasetToDataRoomResponse." + r;
        }
      }
      if (t.retrievePublishedDatasetsResponse != null && t.hasOwnProperty("retrievePublishedDatasetsResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrievePublishedDatasetsResponse.verify(t.retrievePublishedDatasetsResponse);
          if (r)
            return "retrievePublishedDatasetsResponse." + r;
        }
      }
      if (t.removePublishedDatasetResponse != null && t.hasOwnProperty("removePublishedDatasetResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RemovePublishedDatasetResponse.verify(t.removePublishedDatasetResponse);
          if (r)
            return "removePublishedDatasetResponse." + r;
        }
      }
      if (t.executeComputeResponse != null && t.hasOwnProperty("executeComputeResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.ExecuteComputeResponse.verify(t.executeComputeResponse);
          if (r)
            return "executeComputeResponse." + r;
        }
      }
      if (t.jobStatusResponse != null && t.hasOwnProperty("jobStatusResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.JobStatusResponse.verify(t.jobStatusResponse);
          if (r)
            return "jobStatusResponse." + r;
        }
      }
      if (t.getResultsResponseChunk != null && t.hasOwnProperty("getResultsResponseChunk")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.GetResultsResponseChunk.verify(t.getResultsResponseChunk);
          if (r)
            return "getResultsResponseChunk." + r;
        }
      }
      if (t.getResultsResponseFooter != null && t.hasOwnProperty("getResultsResponseFooter")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.GetResultsResponseFooter.verify(t.getResultsResponseFooter);
          if (r)
            return "getResultsResponseFooter." + r;
        }
      }
      if (t.createConfigurationCommitResponse != null && t.hasOwnProperty("createConfigurationCommitResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.CreateConfigurationCommitResponse.verify(t.createConfigurationCommitResponse);
          if (r)
            return "createConfigurationCommitResponse." + r;
        }
      }
      if (t.retrieveConfigurationCommitResponse != null && t.hasOwnProperty("retrieveConfigurationCommitResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveConfigurationCommitResponse.verify(t.retrieveConfigurationCommitResponse);
          if (r)
            return "retrieveConfigurationCommitResponse." + r;
        }
      }
      if (t.generateMergeApprovalSignatureResponse != null && t.hasOwnProperty("generateMergeApprovalSignatureResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.GenerateMergeApprovalSignatureResponse.verify(t.generateMergeApprovalSignatureResponse);
          if (r)
            return "generateMergeApprovalSignatureResponse." + r;
        }
      }
      if (t.mergeConfigurationCommitResponse != null && t.hasOwnProperty("mergeConfigurationCommitResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.MergeConfigurationCommitResponse.verify(t.mergeConfigurationCommitResponse);
          if (r)
            return "mergeConfigurationCommitResponse." + r;
        }
      }
      if (t.retrieveConfigurationCommitApproversResponse != null && t.hasOwnProperty("retrieveConfigurationCommitApproversResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveConfigurationCommitApproversResponse.verify(t.retrieveConfigurationCommitApproversResponse);
          if (r)
            return "retrieveConfigurationCommitApproversResponse." + r;
        }
      }
      if (t.casAuxiliaryStateResponse != null && t.hasOwnProperty("casAuxiliaryStateResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.CasAuxiliaryStateResponse.verify(t.casAuxiliaryStateResponse);
          if (r)
            return "casAuxiliaryStateResponse." + r;
        }
      }
      if (t.readAuxiliaryStateResponse != null && t.hasOwnProperty("readAuxiliaryStateResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.ReadAuxiliaryStateResponse.verify(t.readAuxiliaryStateResponse);
          if (r)
            return "readAuxiliaryStateResponse." + r;
        }
      }
      if (t.retrieveUsedAirlockQuotaResponse != null && t.hasOwnProperty("retrieveUsedAirlockQuotaResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.RetrieveUsedAirlockQuotaResponse.verify(t.retrieveUsedAirlockQuotaResponse);
          if (r)
            return "retrieveUsedAirlockQuotaResponse." + r;
        }
      }
      if (t.getResultsSizeResponse != null && t.hasOwnProperty("getResultsSizeResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.gcg.GetResultsSizeResponse.verify(t.getResultsSizeResponse);
          if (r)
            return "getResultsSizeResponse." + r;
        }
      }
      if (t.endorsementResponse != null && t.hasOwnProperty("endorsementResponse")) {
        if (n.gcgResponse === 1)
          return "gcgResponse: multiple values";
        n.gcgResponse = 1;
        {
          let r = $root.identity_endorsement.EndorsementResponse.verify(t.endorsementResponse);
          if (r)
            return "endorsementResponse." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.GcgResponse)
        return t;
      let n = new $root.gcg.GcgResponse();
      if (t.failure != null && (n.failure = String(t.failure)), t.createDataRoomResponse != null) {
        if (typeof t.createDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.createDataRoomResponse: object expected");
        n.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.fromObject(t.createDataRoomResponse);
      }
      if (t.retrieveDataRoomResponse != null) {
        if (typeof t.retrieveDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveDataRoomResponse: object expected");
        n.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.fromObject(t.retrieveDataRoomResponse);
      }
      if (t.retrieveCurrentDataRoomConfigurationResponse != null) {
        if (typeof t.retrieveCurrentDataRoomConfigurationResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveCurrentDataRoomConfigurationResponse: object expected");
        n.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.fromObject(t.retrieveCurrentDataRoomConfigurationResponse);
      }
      if (t.retrieveDataRoomStatusResponse != null) {
        if (typeof t.retrieveDataRoomStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveDataRoomStatusResponse: object expected");
        n.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.fromObject(t.retrieveDataRoomStatusResponse);
      }
      if (t.updateDataRoomStatusResponse != null) {
        if (typeof t.updateDataRoomStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.updateDataRoomStatusResponse: object expected");
        n.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.fromObject(t.updateDataRoomStatusResponse);
      }
      if (t.retrieveAuditLogResponse != null) {
        if (typeof t.retrieveAuditLogResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveAuditLogResponse: object expected");
        n.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.fromObject(t.retrieveAuditLogResponse);
      }
      if (t.publishDatasetToDataRoomResponse != null) {
        if (typeof t.publishDatasetToDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.publishDatasetToDataRoomResponse: object expected");
        n.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.fromObject(t.publishDatasetToDataRoomResponse);
      }
      if (t.retrievePublishedDatasetsResponse != null) {
        if (typeof t.retrievePublishedDatasetsResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrievePublishedDatasetsResponse: object expected");
        n.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.fromObject(t.retrievePublishedDatasetsResponse);
      }
      if (t.removePublishedDatasetResponse != null) {
        if (typeof t.removePublishedDatasetResponse != "object")
          throw TypeError(".gcg.GcgResponse.removePublishedDatasetResponse: object expected");
        n.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.fromObject(t.removePublishedDatasetResponse);
      }
      if (t.executeComputeResponse != null) {
        if (typeof t.executeComputeResponse != "object")
          throw TypeError(".gcg.GcgResponse.executeComputeResponse: object expected");
        n.executeComputeResponse = $root.gcg.ExecuteComputeResponse.fromObject(t.executeComputeResponse);
      }
      if (t.jobStatusResponse != null) {
        if (typeof t.jobStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.jobStatusResponse: object expected");
        n.jobStatusResponse = $root.gcg.JobStatusResponse.fromObject(t.jobStatusResponse);
      }
      if (t.getResultsResponseChunk != null) {
        if (typeof t.getResultsResponseChunk != "object")
          throw TypeError(".gcg.GcgResponse.getResultsResponseChunk: object expected");
        n.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.fromObject(t.getResultsResponseChunk);
      }
      if (t.getResultsResponseFooter != null) {
        if (typeof t.getResultsResponseFooter != "object")
          throw TypeError(".gcg.GcgResponse.getResultsResponseFooter: object expected");
        n.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.fromObject(t.getResultsResponseFooter);
      }
      if (t.createConfigurationCommitResponse != null) {
        if (typeof t.createConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.createConfigurationCommitResponse: object expected");
        n.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.fromObject(t.createConfigurationCommitResponse);
      }
      if (t.retrieveConfigurationCommitResponse != null) {
        if (typeof t.retrieveConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveConfigurationCommitResponse: object expected");
        n.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.fromObject(t.retrieveConfigurationCommitResponse);
      }
      if (t.generateMergeApprovalSignatureResponse != null) {
        if (typeof t.generateMergeApprovalSignatureResponse != "object")
          throw TypeError(".gcg.GcgResponse.generateMergeApprovalSignatureResponse: object expected");
        n.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.fromObject(t.generateMergeApprovalSignatureResponse);
      }
      if (t.mergeConfigurationCommitResponse != null) {
        if (typeof t.mergeConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.mergeConfigurationCommitResponse: object expected");
        n.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.fromObject(t.mergeConfigurationCommitResponse);
      }
      if (t.retrieveConfigurationCommitApproversResponse != null) {
        if (typeof t.retrieveConfigurationCommitApproversResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveConfigurationCommitApproversResponse: object expected");
        n.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.fromObject(t.retrieveConfigurationCommitApproversResponse);
      }
      if (t.casAuxiliaryStateResponse != null) {
        if (typeof t.casAuxiliaryStateResponse != "object")
          throw TypeError(".gcg.GcgResponse.casAuxiliaryStateResponse: object expected");
        n.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.fromObject(t.casAuxiliaryStateResponse);
      }
      if (t.readAuxiliaryStateResponse != null) {
        if (typeof t.readAuxiliaryStateResponse != "object")
          throw TypeError(".gcg.GcgResponse.readAuxiliaryStateResponse: object expected");
        n.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.fromObject(t.readAuxiliaryStateResponse);
      }
      if (t.retrieveUsedAirlockQuotaResponse != null) {
        if (typeof t.retrieveUsedAirlockQuotaResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveUsedAirlockQuotaResponse: object expected");
        n.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.fromObject(t.retrieveUsedAirlockQuotaResponse);
      }
      if (t.getResultsSizeResponse != null) {
        if (typeof t.getResultsSizeResponse != "object")
          throw TypeError(".gcg.GcgResponse.getResultsSizeResponse: object expected");
        n.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.fromObject(t.getResultsSizeResponse);
      }
      if (t.endorsementResponse != null) {
        if (typeof t.endorsementResponse != "object")
          throw TypeError(".gcg.GcgResponse.endorsementResponse: object expected");
        n.endorsementResponse = $root.identity_endorsement.EndorsementResponse.fromObject(t.endorsementResponse);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.failure != null && t.hasOwnProperty("failure") && (r.failure = t.failure, n.oneofs && (r.gcgResponse = "failure")), t.createDataRoomResponse != null && t.hasOwnProperty("createDataRoomResponse") && (r.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.toObject(t.createDataRoomResponse, n), n.oneofs && (r.gcgResponse = "createDataRoomResponse")), t.retrieveDataRoomResponse != null && t.hasOwnProperty("retrieveDataRoomResponse") && (r.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.toObject(t.retrieveDataRoomResponse, n), n.oneofs && (r.gcgResponse = "retrieveDataRoomResponse")), t.retrieveCurrentDataRoomConfigurationResponse != null && t.hasOwnProperty("retrieveCurrentDataRoomConfigurationResponse") && (r.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.toObject(t.retrieveCurrentDataRoomConfigurationResponse, n), n.oneofs && (r.gcgResponse = "retrieveCurrentDataRoomConfigurationResponse")), t.retrieveDataRoomStatusResponse != null && t.hasOwnProperty("retrieveDataRoomStatusResponse") && (r.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.toObject(t.retrieveDataRoomStatusResponse, n), n.oneofs && (r.gcgResponse = "retrieveDataRoomStatusResponse")), t.updateDataRoomStatusResponse != null && t.hasOwnProperty("updateDataRoomStatusResponse") && (r.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.toObject(t.updateDataRoomStatusResponse, n), n.oneofs && (r.gcgResponse = "updateDataRoomStatusResponse")), t.retrieveAuditLogResponse != null && t.hasOwnProperty("retrieveAuditLogResponse") && (r.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.toObject(t.retrieveAuditLogResponse, n), n.oneofs && (r.gcgResponse = "retrieveAuditLogResponse")), t.publishDatasetToDataRoomResponse != null && t.hasOwnProperty("publishDatasetToDataRoomResponse") && (r.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.toObject(t.publishDatasetToDataRoomResponse, n), n.oneofs && (r.gcgResponse = "publishDatasetToDataRoomResponse")), t.retrievePublishedDatasetsResponse != null && t.hasOwnProperty("retrievePublishedDatasetsResponse") && (r.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.toObject(t.retrievePublishedDatasetsResponse, n), n.oneofs && (r.gcgResponse = "retrievePublishedDatasetsResponse")), t.removePublishedDatasetResponse != null && t.hasOwnProperty("removePublishedDatasetResponse") && (r.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.toObject(t.removePublishedDatasetResponse, n), n.oneofs && (r.gcgResponse = "removePublishedDatasetResponse")), t.executeComputeResponse != null && t.hasOwnProperty("executeComputeResponse") && (r.executeComputeResponse = $root.gcg.ExecuteComputeResponse.toObject(t.executeComputeResponse, n), n.oneofs && (r.gcgResponse = "executeComputeResponse")), t.jobStatusResponse != null && t.hasOwnProperty("jobStatusResponse") && (r.jobStatusResponse = $root.gcg.JobStatusResponse.toObject(t.jobStatusResponse, n), n.oneofs && (r.gcgResponse = "jobStatusResponse")), t.getResultsResponseChunk != null && t.hasOwnProperty("getResultsResponseChunk") && (r.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.toObject(t.getResultsResponseChunk, n), n.oneofs && (r.gcgResponse = "getResultsResponseChunk")), t.getResultsResponseFooter != null && t.hasOwnProperty("getResultsResponseFooter") && (r.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.toObject(t.getResultsResponseFooter, n), n.oneofs && (r.gcgResponse = "getResultsResponseFooter")), t.createConfigurationCommitResponse != null && t.hasOwnProperty("createConfigurationCommitResponse") && (r.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.toObject(t.createConfigurationCommitResponse, n), n.oneofs && (r.gcgResponse = "createConfigurationCommitResponse")), t.retrieveConfigurationCommitResponse != null && t.hasOwnProperty("retrieveConfigurationCommitResponse") && (r.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.toObject(t.retrieveConfigurationCommitResponse, n), n.oneofs && (r.gcgResponse = "retrieveConfigurationCommitResponse")), t.generateMergeApprovalSignatureResponse != null && t.hasOwnProperty("generateMergeApprovalSignatureResponse") && (r.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.toObject(t.generateMergeApprovalSignatureResponse, n), n.oneofs && (r.gcgResponse = "generateMergeApprovalSignatureResponse")), t.mergeConfigurationCommitResponse != null && t.hasOwnProperty("mergeConfigurationCommitResponse") && (r.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.toObject(t.mergeConfigurationCommitResponse, n), n.oneofs && (r.gcgResponse = "mergeConfigurationCommitResponse")), t.retrieveConfigurationCommitApproversResponse != null && t.hasOwnProperty("retrieveConfigurationCommitApproversResponse") && (r.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.toObject(t.retrieveConfigurationCommitApproversResponse, n), n.oneofs && (r.gcgResponse = "retrieveConfigurationCommitApproversResponse")), t.casAuxiliaryStateResponse != null && t.hasOwnProperty("casAuxiliaryStateResponse") && (r.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.toObject(t.casAuxiliaryStateResponse, n), n.oneofs && (r.gcgResponse = "casAuxiliaryStateResponse")), t.readAuxiliaryStateResponse != null && t.hasOwnProperty("readAuxiliaryStateResponse") && (r.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.toObject(t.readAuxiliaryStateResponse, n), n.oneofs && (r.gcgResponse = "readAuxiliaryStateResponse")), t.retrieveUsedAirlockQuotaResponse != null && t.hasOwnProperty("retrieveUsedAirlockQuotaResponse") && (r.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.toObject(t.retrieveUsedAirlockQuotaResponse, n), n.oneofs && (r.gcgResponse = "retrieveUsedAirlockQuotaResponse")), t.getResultsSizeResponse != null && t.hasOwnProperty("getResultsSizeResponse") && (r.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.toObject(t.getResultsSizeResponse, n), n.oneofs && (r.gcgResponse = "getResultsSizeResponse")), t.endorsementResponse != null && t.hasOwnProperty("endorsementResponse") && (r.endorsementResponse = $root.identity_endorsement.EndorsementResponse.toObject(t.endorsementResponse, n), n.oneofs && (r.gcgResponse = "endorsementResponse")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.GcgResponse";
    }, o;
  }(), c.UserAuth = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.pki = null, o.prototype.enclaveEndorsements = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.pki != null && Object.hasOwnProperty.call(e, "pki") && $root.gcg.Pki.encode(e.pki, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.enclaveEndorsements != null && Object.hasOwnProperty.call(e, "enclaveEndorsements") && $root.identity_endorsement.EnclaveEndorsements.encode(e.enclaveEndorsements, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.UserAuth();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.pki = $root.gcg.Pki.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.pki != null && e.hasOwnProperty("pki")) {
        let t = $root.gcg.Pki.verify(e.pki);
        if (t)
          return "pki." + t;
      }
      if (e.enclaveEndorsements != null && e.hasOwnProperty("enclaveEndorsements")) {
        let t = $root.identity_endorsement.EnclaveEndorsements.verify(e.enclaveEndorsements);
        if (t)
          return "enclaveEndorsements." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.UserAuth)
        return e;
      let t = new $root.gcg.UserAuth();
      if (e.pki != null) {
        if (typeof e.pki != "object")
          throw TypeError(".gcg.UserAuth.pki: object expected");
        t.pki = $root.gcg.Pki.fromObject(e.pki);
      }
      if (e.enclaveEndorsements != null) {
        if (typeof e.enclaveEndorsements != "object")
          throw TypeError(".gcg.UserAuth.enclaveEndorsements: object expected");
        t.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.fromObject(e.enclaveEndorsements);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.pki = null, n.enclaveEndorsements = null), e.pki != null && e.hasOwnProperty("pki") && (n.pki = $root.gcg.Pki.toObject(e.pki, t)), e.enclaveEndorsements != null && e.hasOwnProperty("enclaveEndorsements") && (n.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.toObject(e.enclaveEndorsements, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UserAuth";
    }, o;
  }(), c.Pki = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.certChainPem = $util.newBuffer([]), o.prototype.signature = $util.newBuffer([]), o.prototype.idMac = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.certChainPem != null && Object.hasOwnProperty.call(e, "certChainPem") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.certChainPem), e.signature != null && Object.hasOwnProperty.call(e, "signature") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.signature), e.idMac != null && Object.hasOwnProperty.call(e, "idMac") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.idMac), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.Pki();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.certChainPem = e.bytes();
            break;
          }
          case 2: {
            r.signature = e.bytes();
            break;
          }
          case 3: {
            r.idMac = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.certChainPem != null && e.hasOwnProperty("certChainPem") && !(e.certChainPem && typeof e.certChainPem.length == "number" || $util.isString(e.certChainPem)) ? "certChainPem: buffer expected" : e.signature != null && e.hasOwnProperty("signature") && !(e.signature && typeof e.signature.length == "number" || $util.isString(e.signature)) ? "signature: buffer expected" : e.idMac != null && e.hasOwnProperty("idMac") && !(e.idMac && typeof e.idMac.length == "number" || $util.isString(e.idMac)) ? "idMac: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.Pki)
        return e;
      let t = new $root.gcg.Pki();
      return e.certChainPem != null && (typeof e.certChainPem == "string" ? $util.base64.decode(e.certChainPem, t.certChainPem = $util.newBuffer($util.base64.length(e.certChainPem)), 0) : e.certChainPem.length >= 0 && (t.certChainPem = e.certChainPem)), e.signature != null && (typeof e.signature == "string" ? $util.base64.decode(e.signature, t.signature = $util.newBuffer($util.base64.length(e.signature)), 0) : e.signature.length >= 0 && (t.signature = e.signature)), e.idMac != null && (typeof e.idMac == "string" ? $util.base64.decode(e.idMac, t.idMac = $util.newBuffer($util.base64.length(e.idMac)), 0) : e.idMac.length >= 0 && (t.idMac = e.idMac)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.certChainPem = "" : (n.certChainPem = [], t.bytes !== Array && (n.certChainPem = $util.newBuffer(n.certChainPem))), t.bytes === String ? n.signature = "" : (n.signature = [], t.bytes !== Array && (n.signature = $util.newBuffer(n.signature))), t.bytes === String ? n.idMac = "" : (n.idMac = [], t.bytes !== Array && (n.idMac = $util.newBuffer(n.idMac)))), e.certChainPem != null && e.hasOwnProperty("certChainPem") && (n.certChainPem = t.bytes === String ? $util.base64.encode(e.certChainPem, 0, e.certChainPem.length) : t.bytes === Array ? Array.prototype.slice.call(e.certChainPem) : e.certChainPem), e.signature != null && e.hasOwnProperty("signature") && (n.signature = t.bytes === String ? $util.base64.encode(e.signature, 0, e.signature.length) : t.bytes === Array ? Array.prototype.slice.call(e.signature) : e.signature), e.idMac != null && e.hasOwnProperty("idMac") && (n.idMac = t.bytes === String ? $util.base64.encode(e.idMac, 0, e.idMac.length) : t.bytes === Array ? Array.prototype.slice.call(e.idMac) : e.idMac), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.Pki";
    }, o;
  }(), c.CreateDataRoomRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dataRoom = null, o.prototype.highLevelRepresentation = null, o.prototype.dataRoomMetadata = null;
    let i;
    return Object.defineProperty(o.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(i = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_dataRoomMetadata", {
      get: $util.oneOfGetter(i = ["dataRoomMetadata"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dataRoom != null && Object.hasOwnProperty.call(t, "dataRoom") && $root.data_room.DataRoom.encode(t.dataRoom, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.highLevelRepresentation != null && Object.hasOwnProperty.call(t, "highLevelRepresentation") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(t.highLevelRepresentation), t.dataRoomMetadata != null && Object.hasOwnProperty.call(t, "dataRoomMetadata") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.dataRoomMetadata), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CreateDataRoomRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dataRoom = $root.data_room.DataRoom.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.highLevelRepresentation = t.bytes();
            break;
          }
          case 3: {
            u.dataRoomMetadata = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.dataRoom != null && t.hasOwnProperty("dataRoom")) {
        let n = $root.data_room.DataRoom.verify(t.dataRoom);
        if (n)
          return "dataRoom." + n;
      }
      return t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && !(t.highLevelRepresentation && typeof t.highLevelRepresentation.length == "number" || $util.isString(t.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : t.dataRoomMetadata != null && t.hasOwnProperty("dataRoomMetadata") && !(t.dataRoomMetadata && typeof t.dataRoomMetadata.length == "number" || $util.isString(t.dataRoomMetadata)) ? "dataRoomMetadata: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CreateDataRoomRequest)
        return t;
      let n = new $root.gcg.CreateDataRoomRequest();
      if (t.dataRoom != null) {
        if (typeof t.dataRoom != "object")
          throw TypeError(".gcg.CreateDataRoomRequest.dataRoom: object expected");
        n.dataRoom = $root.data_room.DataRoom.fromObject(t.dataRoom);
      }
      return t.highLevelRepresentation != null && (typeof t.highLevelRepresentation == "string" ? $util.base64.decode(t.highLevelRepresentation, n.highLevelRepresentation = $util.newBuffer($util.base64.length(t.highLevelRepresentation)), 0) : t.highLevelRepresentation.length >= 0 && (n.highLevelRepresentation = t.highLevelRepresentation)), t.dataRoomMetadata != null && (typeof t.dataRoomMetadata == "string" ? $util.base64.decode(t.dataRoomMetadata, n.dataRoomMetadata = $util.newBuffer($util.base64.length(t.dataRoomMetadata)), 0) : t.dataRoomMetadata.length >= 0 && (n.dataRoomMetadata = t.dataRoomMetadata)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dataRoom = null), t.dataRoom != null && t.hasOwnProperty("dataRoom") && (r.dataRoom = $root.data_room.DataRoom.toObject(t.dataRoom, n)), t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && (r.highLevelRepresentation = n.bytes === String ? $util.base64.encode(t.highLevelRepresentation, 0, t.highLevelRepresentation.length) : n.bytes === Array ? Array.prototype.slice.call(t.highLevelRepresentation) : t.highLevelRepresentation, n.oneofs && (r._highLevelRepresentation = "highLevelRepresentation")), t.dataRoomMetadata != null && t.hasOwnProperty("dataRoomMetadata") && (r.dataRoomMetadata = n.bytes === String ? $util.base64.encode(t.dataRoomMetadata, 0, t.dataRoomMetadata.length) : n.bytes === Array ? Array.prototype.slice.call(t.dataRoomMetadata) : t.dataRoomMetadata, n.oneofs && (r._dataRoomMetadata = "dataRoomMetadata")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CreateDataRoomRequest";
    }, o;
  }(), c.CreateDataRoomResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dataRoomId = null, o.prototype.dataRoomValidationError = null;
    let i;
    return Object.defineProperty(o.prototype, "createDataRoomResponse", {
      get: $util.oneOfGetter(i = ["dataRoomId", "dataRoomValidationError"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dataRoomId != null && Object.hasOwnProperty.call(t, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(t.dataRoomId), t.dataRoomValidationError != null && Object.hasOwnProperty.call(t, "dataRoomValidationError") && $root.gcg.DataRoomValidationError.encode(t.dataRoomValidationError, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CreateDataRoomResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dataRoomId = t.bytes();
            break;
          }
          case 2: {
            u.dataRoomValidationError = $root.gcg.DataRoomValidationError.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dataRoomId != null && t.hasOwnProperty("dataRoomId") && (n.createDataRoomResponse = 1, !(t.dataRoomId && typeof t.dataRoomId.length == "number" || $util.isString(t.dataRoomId))))
        return "dataRoomId: buffer expected";
      if (t.dataRoomValidationError != null && t.hasOwnProperty("dataRoomValidationError")) {
        if (n.createDataRoomResponse === 1)
          return "createDataRoomResponse: multiple values";
        n.createDataRoomResponse = 1;
        {
          let r = $root.gcg.DataRoomValidationError.verify(t.dataRoomValidationError);
          if (r)
            return "dataRoomValidationError." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CreateDataRoomResponse)
        return t;
      let n = new $root.gcg.CreateDataRoomResponse();
      if (t.dataRoomId != null && (typeof t.dataRoomId == "string" ? $util.base64.decode(t.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(t.dataRoomId)), 0) : t.dataRoomId.length >= 0 && (n.dataRoomId = t.dataRoomId)), t.dataRoomValidationError != null) {
        if (typeof t.dataRoomValidationError != "object")
          throw TypeError(".gcg.CreateDataRoomResponse.dataRoomValidationError: object expected");
        n.dataRoomValidationError = $root.gcg.DataRoomValidationError.fromObject(t.dataRoomValidationError);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.dataRoomId != null && t.hasOwnProperty("dataRoomId") && (r.dataRoomId = n.bytes === String ? $util.base64.encode(t.dataRoomId, 0, t.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(t.dataRoomId) : t.dataRoomId, n.oneofs && (r.createDataRoomResponse = "dataRoomId")), t.dataRoomValidationError != null && t.hasOwnProperty("dataRoomValidationError") && (r.dataRoomValidationError = $root.gcg.DataRoomValidationError.toObject(t.dataRoomValidationError, n), n.oneofs && (r.createDataRoomResponse = "dataRoomValidationError")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CreateDataRoomResponse";
    }, o;
  }(), c.DataRoomValidationError = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.message = "", o.prototype.permissionIndex = null, o.prototype.computeNodeId = null, o.prototype.userPermissionId = null, o.prototype.attestationSpecificationId = null, o.prototype.authenticationMethodId = null;
    let i;
    return Object.defineProperty(o.prototype, "_permissionIndex", {
      get: $util.oneOfGetter(i = ["permissionIndex"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_computeNodeId", {
      get: $util.oneOfGetter(i = ["computeNodeId"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_userPermissionId", {
      get: $util.oneOfGetter(i = ["userPermissionId"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_attestationSpecificationId", {
      get: $util.oneOfGetter(i = ["attestationSpecificationId"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_authenticationMethodId", {
      get: $util.oneOfGetter(i = ["authenticationMethodId"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.message != null && Object.hasOwnProperty.call(t, "message") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.message), t.permissionIndex != null && Object.hasOwnProperty.call(t, "permissionIndex") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(t.permissionIndex), t.computeNodeId != null && Object.hasOwnProperty.call(t, "computeNodeId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.computeNodeId), t.userPermissionId != null && Object.hasOwnProperty.call(t, "userPermissionId") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.userPermissionId), t.attestationSpecificationId != null && Object.hasOwnProperty.call(t, "attestationSpecificationId") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.attestationSpecificationId), t.authenticationMethodId != null && Object.hasOwnProperty.call(t, "authenticationMethodId") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(t.authenticationMethodId), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.DataRoomValidationError();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.message = t.string();
            break;
          }
          case 2: {
            u.permissionIndex = t.uint64();
            break;
          }
          case 3: {
            u.computeNodeId = t.string();
            break;
          }
          case 4: {
            u.userPermissionId = t.string();
            break;
          }
          case 5: {
            u.attestationSpecificationId = t.string();
            break;
          }
          case 6: {
            u.authenticationMethodId = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.message != null && t.hasOwnProperty("message") && !$util.isString(t.message) ? "message: string expected" : t.permissionIndex != null && t.hasOwnProperty("permissionIndex") && !$util.isInteger(t.permissionIndex) && !(t.permissionIndex && $util.isInteger(t.permissionIndex.low) && $util.isInteger(t.permissionIndex.high)) ? "permissionIndex: integer|Long expected" : t.computeNodeId != null && t.hasOwnProperty("computeNodeId") && !$util.isString(t.computeNodeId) ? "computeNodeId: string expected" : t.userPermissionId != null && t.hasOwnProperty("userPermissionId") && !$util.isString(t.userPermissionId) ? "userPermissionId: string expected" : t.attestationSpecificationId != null && t.hasOwnProperty("attestationSpecificationId") && !$util.isString(t.attestationSpecificationId) ? "attestationSpecificationId: string expected" : t.authenticationMethodId != null && t.hasOwnProperty("authenticationMethodId") && !$util.isString(t.authenticationMethodId) ? "authenticationMethodId: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.DataRoomValidationError)
        return t;
      let n = new $root.gcg.DataRoomValidationError();
      return t.message != null && (n.message = String(t.message)), t.permissionIndex != null && ($util.Long ? (n.permissionIndex = $util.Long.fromValue(t.permissionIndex)).unsigned = !0 : typeof t.permissionIndex == "string" ? n.permissionIndex = parseInt(t.permissionIndex, 10) : typeof t.permissionIndex == "number" ? n.permissionIndex = t.permissionIndex : typeof t.permissionIndex == "object" && (n.permissionIndex = new $util.LongBits(t.permissionIndex.low >>> 0, t.permissionIndex.high >>> 0).toNumber(!0))), t.computeNodeId != null && (n.computeNodeId = String(t.computeNodeId)), t.userPermissionId != null && (n.userPermissionId = String(t.userPermissionId)), t.attestationSpecificationId != null && (n.attestationSpecificationId = String(t.attestationSpecificationId)), t.authenticationMethodId != null && (n.authenticationMethodId = String(t.authenticationMethodId)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.message = ""), t.message != null && t.hasOwnProperty("message") && (r.message = t.message), t.permissionIndex != null && t.hasOwnProperty("permissionIndex") && (typeof t.permissionIndex == "number" ? r.permissionIndex = n.longs === String ? String(t.permissionIndex) : t.permissionIndex : r.permissionIndex = n.longs === String ? $util.Long.prototype.toString.call(t.permissionIndex) : n.longs === Number ? new $util.LongBits(t.permissionIndex.low >>> 0, t.permissionIndex.high >>> 0).toNumber(!0) : t.permissionIndex, n.oneofs && (r._permissionIndex = "permissionIndex")), t.computeNodeId != null && t.hasOwnProperty("computeNodeId") && (r.computeNodeId = t.computeNodeId, n.oneofs && (r._computeNodeId = "computeNodeId")), t.userPermissionId != null && t.hasOwnProperty("userPermissionId") && (r.userPermissionId = t.userPermissionId, n.oneofs && (r._userPermissionId = "userPermissionId")), t.attestationSpecificationId != null && t.hasOwnProperty("attestationSpecificationId") && (r.attestationSpecificationId = t.attestationSpecificationId, n.oneofs && (r._attestationSpecificationId = "attestationSpecificationId")), t.authenticationMethodId != null && t.hasOwnProperty("authenticationMethodId") && (r.authenticationMethodId = t.authenticationMethodId, n.oneofs && (r._authenticationMethodId = "authenticationMethodId")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.DataRoomValidationError";
    }, o;
  }(), c.PublishDatasetToDataRoomRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.datasetHash = $util.newBuffer([]), o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.leafId = "", o.prototype.encryptionKey = $util.newBuffer([]), o.prototype.scope = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.datasetHash != null && Object.hasOwnProperty.call(e, "datasetHash") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.datasetHash), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dataRoomId), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.leafId), e.encryptionKey != null && Object.hasOwnProperty.call(e, "encryptionKey") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.encryptionKey), e.scope != null && Object.hasOwnProperty.call(e, "scope") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.scope), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.PublishDatasetToDataRoomRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.datasetHash = e.bytes();
            break;
          }
          case 2: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 3: {
            r.leafId = e.string();
            break;
          }
          case 4: {
            r.encryptionKey = e.bytes();
            break;
          }
          case 5: {
            r.scope = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.datasetHash != null && e.hasOwnProperty("datasetHash") && !(e.datasetHash && typeof e.datasetHash.length == "number" || $util.isString(e.datasetHash)) ? "datasetHash: buffer expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && !(e.encryptionKey && typeof e.encryptionKey.length == "number" || $util.isString(e.encryptionKey)) ? "encryptionKey: buffer expected" : e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)) ? "scope: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.PublishDatasetToDataRoomRequest)
        return e;
      let t = new $root.gcg.PublishDatasetToDataRoomRequest();
      return e.datasetHash != null && (typeof e.datasetHash == "string" ? $util.base64.decode(e.datasetHash, t.datasetHash = $util.newBuffer($util.base64.length(e.datasetHash)), 0) : e.datasetHash.length >= 0 && (t.datasetHash = e.datasetHash)), e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.leafId != null && (t.leafId = String(e.leafId)), e.encryptionKey != null && (typeof e.encryptionKey == "string" ? $util.base64.decode(e.encryptionKey, t.encryptionKey = $util.newBuffer($util.base64.length(e.encryptionKey)), 0) : e.encryptionKey.length >= 0 && (t.encryptionKey = e.encryptionKey)), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, t.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (t.scope = e.scope)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.datasetHash = "" : (n.datasetHash = [], t.bytes !== Array && (n.datasetHash = $util.newBuffer(n.datasetHash))), t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), n.leafId = "", t.bytes === String ? n.encryptionKey = "" : (n.encryptionKey = [], t.bytes !== Array && (n.encryptionKey = $util.newBuffer(n.encryptionKey))), t.bytes === String ? n.scope = "" : (n.scope = [], t.bytes !== Array && (n.scope = $util.newBuffer(n.scope)))), e.datasetHash != null && e.hasOwnProperty("datasetHash") && (n.datasetHash = t.bytes === String ? $util.base64.encode(e.datasetHash, 0, e.datasetHash.length) : t.bytes === Array ? Array.prototype.slice.call(e.datasetHash) : e.datasetHash), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.leafId != null && e.hasOwnProperty("leafId") && (n.leafId = e.leafId), e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && (n.encryptionKey = t.bytes === String ? $util.base64.encode(e.encryptionKey, 0, e.encryptionKey.length) : t.bytes === Array ? Array.prototype.slice.call(e.encryptionKey) : e.encryptionKey), e.scope != null && e.hasOwnProperty("scope") && (n.scope = t.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : t.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishDatasetToDataRoomRequest";
    }, o;
  }(), c.PublishDatasetToDataRoomResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.PublishDatasetToDataRoomResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.PublishDatasetToDataRoomResponse ? e : new $root.gcg.PublishDatasetToDataRoomResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishDatasetToDataRoomResponse";
    }, o;
  }(), c.ExecuteComputeRequest = function() {
    function o(i) {
      if (this.computeNodeIds = [], this.parameters = {}, this.testDatasets = {}, i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.computeNodeIds = $util.emptyArray, o.prototype.isDryRun = !1, o.prototype.scope = $util.newBuffer([]), o.prototype.parameters = $util.emptyObject, o.prototype.testDatasets = $util.emptyObject, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.computeNodeIds != null && e.computeNodeIds.length)
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.computeNodeIds[n]);
      if (e.isDryRun != null && Object.hasOwnProperty.call(e, "isDryRun") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.isDryRun), e.scope != null && Object.hasOwnProperty.call(e, "scope") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.scope), e.parameters != null && Object.hasOwnProperty.call(e, "parameters"))
        for (let n = Object.keys(e.parameters), r = 0; r < n.length; ++r)
          t.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(n[r]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.parameters[n[r]]).ldelim();
      if (e.testDatasets != null && Object.hasOwnProperty.call(e, "testDatasets"))
        for (let n = Object.keys(e.testDatasets), r = 0; r < n.length; ++r)
          t.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(n[r]), $root.gcg.TestDataset.encode(e.testDatasets[n[r]], t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim().ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.ExecuteComputeRequest(), u, l;
      for (; e.pos < n; ) {
        let f = e.uint32();
        switch (f >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            r.computeNodeIds && r.computeNodeIds.length || (r.computeNodeIds = []), r.computeNodeIds.push(e.string());
            break;
          }
          case 3: {
            r.isDryRun = e.bool();
            break;
          }
          case 4: {
            r.scope = e.bytes();
            break;
          }
          case 5: {
            r.parameters === $util.emptyObject && (r.parameters = {});
            let a = e.uint32() + e.pos;
            for (u = "", l = ""; e.pos < a; ) {
              let d = e.uint32();
              switch (d >>> 3) {
                case 1:
                  u = e.string();
                  break;
                case 2:
                  l = e.string();
                  break;
                default:
                  e.skipType(d & 7);
                  break;
              }
            }
            r.parameters[u] = l;
            break;
          }
          case 6: {
            r.testDatasets === $util.emptyObject && (r.testDatasets = {});
            let a = e.uint32() + e.pos;
            for (u = "", l = null; e.pos < a; ) {
              let d = e.uint32();
              switch (d >>> 3) {
                case 1:
                  u = e.string();
                  break;
                case 2:
                  l = $root.gcg.TestDataset.decode(e, e.uint32());
                  break;
                default:
                  e.skipType(d & 7);
                  break;
              }
            }
            r.testDatasets[u] = l;
            break;
          }
          default:
            e.skipType(f & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.computeNodeIds != null && e.hasOwnProperty("computeNodeIds")) {
        if (!Array.isArray(e.computeNodeIds))
          return "computeNodeIds: array expected";
        for (let t = 0; t < e.computeNodeIds.length; ++t)
          if (!$util.isString(e.computeNodeIds[t]))
            return "computeNodeIds: string[] expected";
      }
      if (e.isDryRun != null && e.hasOwnProperty("isDryRun") && typeof e.isDryRun != "boolean")
        return "isDryRun: boolean expected";
      if (e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)))
        return "scope: buffer expected";
      if (e.parameters != null && e.hasOwnProperty("parameters")) {
        if (!$util.isObject(e.parameters))
          return "parameters: object expected";
        let t = Object.keys(e.parameters);
        for (let n = 0; n < t.length; ++n)
          if (!$util.isString(e.parameters[t[n]]))
            return "parameters: string{k:string} expected";
      }
      if (e.testDatasets != null && e.hasOwnProperty("testDatasets")) {
        if (!$util.isObject(e.testDatasets))
          return "testDatasets: object expected";
        let t = Object.keys(e.testDatasets);
        for (let n = 0; n < t.length; ++n) {
          let r = $root.gcg.TestDataset.verify(e.testDatasets[t[n]]);
          if (r)
            return "testDatasets." + r;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteComputeRequest)
        return e;
      let t = new $root.gcg.ExecuteComputeRequest();
      if (e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.computeNodeIds) {
        if (!Array.isArray(e.computeNodeIds))
          throw TypeError(".gcg.ExecuteComputeRequest.computeNodeIds: array expected");
        t.computeNodeIds = [];
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          t.computeNodeIds[n] = String(e.computeNodeIds[n]);
      }
      if (e.isDryRun != null && (t.isDryRun = !!e.isDryRun), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, t.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (t.scope = e.scope)), e.parameters) {
        if (typeof e.parameters != "object")
          throw TypeError(".gcg.ExecuteComputeRequest.parameters: object expected");
        t.parameters = {};
        for (let n = Object.keys(e.parameters), r = 0; r < n.length; ++r)
          t.parameters[n[r]] = String(e.parameters[n[r]]);
      }
      if (e.testDatasets) {
        if (typeof e.testDatasets != "object")
          throw TypeError(".gcg.ExecuteComputeRequest.testDatasets: object expected");
        t.testDatasets = {};
        for (let n = Object.keys(e.testDatasets), r = 0; r < n.length; ++r) {
          if (typeof e.testDatasets[n[r]] != "object")
            throw TypeError(".gcg.ExecuteComputeRequest.testDatasets: object expected");
          t.testDatasets[n[r]] = $root.gcg.TestDataset.fromObject(e.testDatasets[n[r]]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.computeNodeIds = []), (t.objects || t.defaults) && (n.parameters = {}, n.testDatasets = {}), t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), n.isDryRun = !1, t.bytes === String ? n.scope = "" : (n.scope = [], t.bytes !== Array && (n.scope = $util.newBuffer(n.scope)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.computeNodeIds && e.computeNodeIds.length) {
        n.computeNodeIds = [];
        for (let u = 0; u < e.computeNodeIds.length; ++u)
          n.computeNodeIds[u] = e.computeNodeIds[u];
      }
      e.isDryRun != null && e.hasOwnProperty("isDryRun") && (n.isDryRun = e.isDryRun), e.scope != null && e.hasOwnProperty("scope") && (n.scope = t.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : t.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope);
      let r;
      if (e.parameters && (r = Object.keys(e.parameters)).length) {
        n.parameters = {};
        for (let u = 0; u < r.length; ++u)
          n.parameters[r[u]] = e.parameters[r[u]];
      }
      if (e.testDatasets && (r = Object.keys(e.testDatasets)).length) {
        n.testDatasets = {};
        for (let u = 0; u < r.length; ++u)
          n.testDatasets[r[u]] = $root.gcg.TestDataset.toObject(e.testDatasets[r[u]], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteComputeRequest";
    }, o;
  }(), c.ExecuteDevelopmentComputeRequest = function() {
    function o(i) {
      if (this.computeNodeIds = [], this.parameters = {}, this.testDatasets = {}, i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.configurationCommitId = $util.newBuffer([]), o.prototype.computeNodeIds = $util.emptyArray, o.prototype.isDryRun = !1, o.prototype.scope = $util.newBuffer([]), o.prototype.parameters = $util.emptyObject, o.prototype.testDatasets = $util.emptyObject, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.configurationCommitId != null && Object.hasOwnProperty.call(e, "configurationCommitId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.configurationCommitId), e.computeNodeIds != null && e.computeNodeIds.length)
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.computeNodeIds[n]);
      if (e.isDryRun != null && Object.hasOwnProperty.call(e, "isDryRun") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.isDryRun), e.scope != null && Object.hasOwnProperty.call(e, "scope") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.scope), e.parameters != null && Object.hasOwnProperty.call(e, "parameters"))
        for (let n = Object.keys(e.parameters), r = 0; r < n.length; ++r)
          t.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(n[r]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.parameters[n[r]]).ldelim();
      if (e.testDatasets != null && Object.hasOwnProperty.call(e, "testDatasets"))
        for (let n = Object.keys(e.testDatasets), r = 0; r < n.length; ++r)
          t.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(n[r]), $root.gcg.TestDataset.encode(e.testDatasets[n[r]], t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim().ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.ExecuteDevelopmentComputeRequest(), u, l;
      for (; e.pos < n; ) {
        let f = e.uint32();
        switch (f >>> 3) {
          case 1: {
            r.configurationCommitId = e.bytes();
            break;
          }
          case 2: {
            r.computeNodeIds && r.computeNodeIds.length || (r.computeNodeIds = []), r.computeNodeIds.push(e.string());
            break;
          }
          case 3: {
            r.isDryRun = e.bool();
            break;
          }
          case 4: {
            r.scope = e.bytes();
            break;
          }
          case 5: {
            r.parameters === $util.emptyObject && (r.parameters = {});
            let a = e.uint32() + e.pos;
            for (u = "", l = ""; e.pos < a; ) {
              let d = e.uint32();
              switch (d >>> 3) {
                case 1:
                  u = e.string();
                  break;
                case 2:
                  l = e.string();
                  break;
                default:
                  e.skipType(d & 7);
                  break;
              }
            }
            r.parameters[u] = l;
            break;
          }
          case 6: {
            r.testDatasets === $util.emptyObject && (r.testDatasets = {});
            let a = e.uint32() + e.pos;
            for (u = "", l = null; e.pos < a; ) {
              let d = e.uint32();
              switch (d >>> 3) {
                case 1:
                  u = e.string();
                  break;
                case 2:
                  l = $root.gcg.TestDataset.decode(e, e.uint32());
                  break;
                default:
                  e.skipType(d & 7);
                  break;
              }
            }
            r.testDatasets[u] = l;
            break;
          }
          default:
            e.skipType(f & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.configurationCommitId != null && e.hasOwnProperty("configurationCommitId") && !(e.configurationCommitId && typeof e.configurationCommitId.length == "number" || $util.isString(e.configurationCommitId)))
        return "configurationCommitId: buffer expected";
      if (e.computeNodeIds != null && e.hasOwnProperty("computeNodeIds")) {
        if (!Array.isArray(e.computeNodeIds))
          return "computeNodeIds: array expected";
        for (let t = 0; t < e.computeNodeIds.length; ++t)
          if (!$util.isString(e.computeNodeIds[t]))
            return "computeNodeIds: string[] expected";
      }
      if (e.isDryRun != null && e.hasOwnProperty("isDryRun") && typeof e.isDryRun != "boolean")
        return "isDryRun: boolean expected";
      if (e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)))
        return "scope: buffer expected";
      if (e.parameters != null && e.hasOwnProperty("parameters")) {
        if (!$util.isObject(e.parameters))
          return "parameters: object expected";
        let t = Object.keys(e.parameters);
        for (let n = 0; n < t.length; ++n)
          if (!$util.isString(e.parameters[t[n]]))
            return "parameters: string{k:string} expected";
      }
      if (e.testDatasets != null && e.hasOwnProperty("testDatasets")) {
        if (!$util.isObject(e.testDatasets))
          return "testDatasets: object expected";
        let t = Object.keys(e.testDatasets);
        for (let n = 0; n < t.length; ++n) {
          let r = $root.gcg.TestDataset.verify(e.testDatasets[t[n]]);
          if (r)
            return "testDatasets." + r;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteDevelopmentComputeRequest)
        return e;
      let t = new $root.gcg.ExecuteDevelopmentComputeRequest();
      if (e.configurationCommitId != null && (typeof e.configurationCommitId == "string" ? $util.base64.decode(e.configurationCommitId, t.configurationCommitId = $util.newBuffer($util.base64.length(e.configurationCommitId)), 0) : e.configurationCommitId.length >= 0 && (t.configurationCommitId = e.configurationCommitId)), e.computeNodeIds) {
        if (!Array.isArray(e.computeNodeIds))
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.computeNodeIds: array expected");
        t.computeNodeIds = [];
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          t.computeNodeIds[n] = String(e.computeNodeIds[n]);
      }
      if (e.isDryRun != null && (t.isDryRun = !!e.isDryRun), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, t.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (t.scope = e.scope)), e.parameters) {
        if (typeof e.parameters != "object")
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.parameters: object expected");
        t.parameters = {};
        for (let n = Object.keys(e.parameters), r = 0; r < n.length; ++r)
          t.parameters[n[r]] = String(e.parameters[n[r]]);
      }
      if (e.testDatasets) {
        if (typeof e.testDatasets != "object")
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.testDatasets: object expected");
        t.testDatasets = {};
        for (let n = Object.keys(e.testDatasets), r = 0; r < n.length; ++r) {
          if (typeof e.testDatasets[n[r]] != "object")
            throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.testDatasets: object expected");
          t.testDatasets[n[r]] = $root.gcg.TestDataset.fromObject(e.testDatasets[n[r]]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.computeNodeIds = []), (t.objects || t.defaults) && (n.parameters = {}, n.testDatasets = {}), t.defaults && (t.bytes === String ? n.configurationCommitId = "" : (n.configurationCommitId = [], t.bytes !== Array && (n.configurationCommitId = $util.newBuffer(n.configurationCommitId))), n.isDryRun = !1, t.bytes === String ? n.scope = "" : (n.scope = [], t.bytes !== Array && (n.scope = $util.newBuffer(n.scope)))), e.configurationCommitId != null && e.hasOwnProperty("configurationCommitId") && (n.configurationCommitId = t.bytes === String ? $util.base64.encode(e.configurationCommitId, 0, e.configurationCommitId.length) : t.bytes === Array ? Array.prototype.slice.call(e.configurationCommitId) : e.configurationCommitId), e.computeNodeIds && e.computeNodeIds.length) {
        n.computeNodeIds = [];
        for (let u = 0; u < e.computeNodeIds.length; ++u)
          n.computeNodeIds[u] = e.computeNodeIds[u];
      }
      e.isDryRun != null && e.hasOwnProperty("isDryRun") && (n.isDryRun = e.isDryRun), e.scope != null && e.hasOwnProperty("scope") && (n.scope = t.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : t.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope);
      let r;
      if (e.parameters && (r = Object.keys(e.parameters)).length) {
        n.parameters = {};
        for (let u = 0; u < r.length; ++u)
          n.parameters[r[u]] = e.parameters[r[u]];
      }
      if (e.testDatasets && (r = Object.keys(e.testDatasets)).length) {
        n.testDatasets = {};
        for (let u = 0; u < r.length; ++u)
          n.testDatasets[r[u]] = $root.gcg.TestDataset.toObject(e.testDatasets[r[u]], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteDevelopmentComputeRequest";
    }, o;
  }(), c.TestDataset = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.encryptionKey = $util.newBuffer([]), o.prototype.manifestHash = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.encryptionKey != null && Object.hasOwnProperty.call(e, "encryptionKey") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.encryptionKey), e.manifestHash != null && Object.hasOwnProperty.call(e, "manifestHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.manifestHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.TestDataset();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.encryptionKey = e.bytes();
            break;
          }
          case 2: {
            r.manifestHash = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && !(e.encryptionKey && typeof e.encryptionKey.length == "number" || $util.isString(e.encryptionKey)) ? "encryptionKey: buffer expected" : e.manifestHash != null && e.hasOwnProperty("manifestHash") && !(e.manifestHash && typeof e.manifestHash.length == "number" || $util.isString(e.manifestHash)) ? "manifestHash: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.TestDataset)
        return e;
      let t = new $root.gcg.TestDataset();
      return e.encryptionKey != null && (typeof e.encryptionKey == "string" ? $util.base64.decode(e.encryptionKey, t.encryptionKey = $util.newBuffer($util.base64.length(e.encryptionKey)), 0) : e.encryptionKey.length >= 0 && (t.encryptionKey = e.encryptionKey)), e.manifestHash != null && (typeof e.manifestHash == "string" ? $util.base64.decode(e.manifestHash, t.manifestHash = $util.newBuffer($util.base64.length(e.manifestHash)), 0) : e.manifestHash.length >= 0 && (t.manifestHash = e.manifestHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.encryptionKey = "" : (n.encryptionKey = [], t.bytes !== Array && (n.encryptionKey = $util.newBuffer(n.encryptionKey))), t.bytes === String ? n.manifestHash = "" : (n.manifestHash = [], t.bytes !== Array && (n.manifestHash = $util.newBuffer(n.manifestHash)))), e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && (n.encryptionKey = t.bytes === String ? $util.base64.encode(e.encryptionKey, 0, e.encryptionKey.length) : t.bytes === Array ? Array.prototype.slice.call(e.encryptionKey) : e.encryptionKey), e.manifestHash != null && e.hasOwnProperty("manifestHash") && (n.manifestHash = t.bytes === String ? $util.base64.encode(e.manifestHash, 0, e.manifestHash.length) : t.bytes === Array ? Array.prototype.slice.call(e.manifestHash) : e.manifestHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.TestDataset";
    }, o;
  }(), c.ExecuteComputeResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.jobId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.ExecuteComputeResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.jobId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteComputeResponse)
        return e;
      let t = new $root.gcg.ExecuteComputeResponse();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, t.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (t.jobId = e.jobId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.jobId = "" : (n.jobId = [], t.bytes !== Array && (n.jobId = $util.newBuffer(n.jobId)))), e.jobId != null && e.hasOwnProperty("jobId") && (n.jobId = t.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : t.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteComputeResponse";
    }, o;
  }(), c.JobStatusRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.jobId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.JobStatusRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.jobId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.JobStatusRequest)
        return e;
      let t = new $root.gcg.JobStatusRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, t.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (t.jobId = e.jobId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.jobId = "" : (n.jobId = [], t.bytes !== Array && (n.jobId = $util.newBuffer(n.jobId)))), e.jobId != null && e.hasOwnProperty("jobId") && (n.jobId = t.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : t.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.JobStatusRequest";
    }, o;
  }(), c.JobStatusResponse = function() {
    function o(i) {
      if (this.completeComputeNodeIds = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.completeComputeNodeIds = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.completeComputeNodeIds != null && e.completeComputeNodeIds.length)
        for (let n = 0; n < e.completeComputeNodeIds.length; ++n)
          t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.completeComputeNodeIds[n]);
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.JobStatusResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.completeComputeNodeIds && r.completeComputeNodeIds.length || (r.completeComputeNodeIds = []), r.completeComputeNodeIds.push(e.string());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.completeComputeNodeIds != null && e.hasOwnProperty("completeComputeNodeIds")) {
        if (!Array.isArray(e.completeComputeNodeIds))
          return "completeComputeNodeIds: array expected";
        for (let t = 0; t < e.completeComputeNodeIds.length; ++t)
          if (!$util.isString(e.completeComputeNodeIds[t]))
            return "completeComputeNodeIds: string[] expected";
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.JobStatusResponse)
        return e;
      let t = new $root.gcg.JobStatusResponse();
      if (e.completeComputeNodeIds) {
        if (!Array.isArray(e.completeComputeNodeIds))
          throw TypeError(".gcg.JobStatusResponse.completeComputeNodeIds: array expected");
        t.completeComputeNodeIds = [];
        for (let n = 0; n < e.completeComputeNodeIds.length; ++n)
          t.completeComputeNodeIds[n] = String(e.completeComputeNodeIds[n]);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.completeComputeNodeIds = []), e.completeComputeNodeIds && e.completeComputeNodeIds.length) {
        n.completeComputeNodeIds = [];
        for (let r = 0; r < e.completeComputeNodeIds.length; ++r)
          n.completeComputeNodeIds[r] = e.completeComputeNodeIds[r];
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.JobStatusResponse";
    }, o;
  }(), c.GetResultsRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.jobId = $util.newBuffer([]), o.prototype.computeNodeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.computeNodeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetResultsRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.jobId = e.bytes();
            break;
          }
          case 2: {
            r.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsRequest)
        return e;
      let t = new $root.gcg.GetResultsRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, t.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (t.jobId = e.jobId)), e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.jobId = "" : (n.jobId = [], t.bytes !== Array && (n.jobId = $util.newBuffer(n.jobId))), n.computeNodeId = ""), e.jobId != null && e.hasOwnProperty("jobId") && (n.jobId = t.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : t.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsRequest";
    }, o;
  }(), c.GetResultsSizeRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.jobId = $util.newBuffer([]), o.prototype.computeNodeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.computeNodeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetResultsSizeRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.jobId = e.bytes();
            break;
          }
          case 2: {
            r.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsSizeRequest)
        return e;
      let t = new $root.gcg.GetResultsSizeRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, t.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (t.jobId = e.jobId)), e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.jobId = "" : (n.jobId = [], t.bytes !== Array && (n.jobId = $util.newBuffer(n.jobId))), n.computeNodeId = ""), e.jobId != null && e.hasOwnProperty("jobId") && (n.jobId = t.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : t.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsSizeRequest";
    }, o;
  }(), c.GetResultsResponseChunk = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.data = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetResultsResponseChunk();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.data = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsResponseChunk)
        return e;
      let t = new $root.gcg.GetResultsResponseChunk();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, t.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (t.data = e.data)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.data = "" : (n.data = [], t.bytes !== Array && (n.data = $util.newBuffer(n.data)))), e.data != null && e.hasOwnProperty("data") && (n.data = t.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsResponseChunk";
    }, o;
  }(), c.GetResultsResponseFooter = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetResultsResponseFooter();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.GetResultsResponseFooter ? e : new $root.gcg.GetResultsResponseFooter();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsResponseFooter";
    }, o;
  }(), c.RetrieveDataRoomRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveDataRoomRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomRequest)
        return e;
      let t = new $root.gcg.RetrieveDataRoomRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomRequest";
    }, o;
  }(), c.RetrieveDataRoomResponse = function() {
    function o(e) {
      if (this.commits = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dataRoom = null, o.prototype.commits = $util.emptyArray, o.prototype.highLevelRepresentation = null;
    let i;
    return Object.defineProperty(o.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(i = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.dataRoom != null && Object.hasOwnProperty.call(t, "dataRoom") && $root.data_room.DataRoom.encode(t.dataRoom, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.commits != null && t.commits.length)
        for (let r = 0; r < t.commits.length; ++r)
          $root.data_room.ConfigurationCommit.encode(t.commits[r], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return t.highLevelRepresentation != null && Object.hasOwnProperty.call(t, "highLevelRepresentation") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.highLevelRepresentation), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.RetrieveDataRoomResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dataRoom = $root.data_room.DataRoom.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.commits && u.commits.length || (u.commits = []), u.commits.push($root.data_room.ConfigurationCommit.decode(t, t.uint32()));
            break;
          }
          case 3: {
            u.highLevelRepresentation = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.dataRoom != null && t.hasOwnProperty("dataRoom")) {
        let n = $root.data_room.DataRoom.verify(t.dataRoom);
        if (n)
          return "dataRoom." + n;
      }
      if (t.commits != null && t.hasOwnProperty("commits")) {
        if (!Array.isArray(t.commits))
          return "commits: array expected";
        for (let n = 0; n < t.commits.length; ++n) {
          let r = $root.data_room.ConfigurationCommit.verify(t.commits[n]);
          if (r)
            return "commits." + r;
        }
      }
      return t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && !(t.highLevelRepresentation && typeof t.highLevelRepresentation.length == "number" || $util.isString(t.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.RetrieveDataRoomResponse)
        return t;
      let n = new $root.gcg.RetrieveDataRoomResponse();
      if (t.dataRoom != null) {
        if (typeof t.dataRoom != "object")
          throw TypeError(".gcg.RetrieveDataRoomResponse.dataRoom: object expected");
        n.dataRoom = $root.data_room.DataRoom.fromObject(t.dataRoom);
      }
      if (t.commits) {
        if (!Array.isArray(t.commits))
          throw TypeError(".gcg.RetrieveDataRoomResponse.commits: array expected");
        n.commits = [];
        for (let r = 0; r < t.commits.length; ++r) {
          if (typeof t.commits[r] != "object")
            throw TypeError(".gcg.RetrieveDataRoomResponse.commits: object expected");
          n.commits[r] = $root.data_room.ConfigurationCommit.fromObject(t.commits[r]);
        }
      }
      return t.highLevelRepresentation != null && (typeof t.highLevelRepresentation == "string" ? $util.base64.decode(t.highLevelRepresentation, n.highLevelRepresentation = $util.newBuffer($util.base64.length(t.highLevelRepresentation)), 0) : t.highLevelRepresentation.length >= 0 && (n.highLevelRepresentation = t.highLevelRepresentation)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.commits = []), n.defaults && (r.dataRoom = null), t.dataRoom != null && t.hasOwnProperty("dataRoom") && (r.dataRoom = $root.data_room.DataRoom.toObject(t.dataRoom, n)), t.commits && t.commits.length) {
        r.commits = [];
        for (let u = 0; u < t.commits.length; ++u)
          r.commits[u] = $root.data_room.ConfigurationCommit.toObject(t.commits[u], n);
      }
      return t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && (r.highLevelRepresentation = n.bytes === String ? $util.base64.encode(t.highLevelRepresentation, 0, t.highLevelRepresentation.length) : n.bytes === Array ? Array.prototype.slice.call(t.highLevelRepresentation) : t.highLevelRepresentation, n.oneofs && (r._highLevelRepresentation = "highLevelRepresentation")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.RetrieveDataRoomResponse";
    }, o;
  }(), c.RetrieveAuditLogRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveAuditLogRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveAuditLogRequest)
        return e;
      let t = new $root.gcg.RetrieveAuditLogRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveAuditLogRequest";
    }, o;
  }(), c.RetrieveAuditLogResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.log = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.log != null && Object.hasOwnProperty.call(e, "log") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.log), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveAuditLogResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.log = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.log != null && e.hasOwnProperty("log") && !(e.log && typeof e.log.length == "number" || $util.isString(e.log)) ? "log: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveAuditLogResponse)
        return e;
      let t = new $root.gcg.RetrieveAuditLogResponse();
      return e.log != null && (typeof e.log == "string" ? $util.base64.decode(e.log, t.log = $util.newBuffer($util.base64.length(e.log)), 0) : e.log.length >= 0 && (t.log = e.log)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.log = "" : (n.log = [], t.bytes !== Array && (n.log = $util.newBuffer(n.log)))), e.log != null && e.hasOwnProperty("log") && (n.log = t.bytes === String ? $util.base64.encode(e.log, 0, e.log.length) : t.bytes === Array ? Array.prototype.slice.call(e.log) : e.log), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveAuditLogResponse";
    }, o;
  }(), c.DataRoomStatus = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "Active"] = 0, i[o[1] = "Stopped"] = 1, i;
  }(), c.RetrieveDataRoomStatusRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveDataRoomStatusRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomStatusRequest)
        return e;
      let t = new $root.gcg.RetrieveDataRoomStatusRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomStatusRequest";
    }, o;
  }(), c.RetrieveDataRoomStatusResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.status = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.status != null && Object.hasOwnProperty.call(e, "status") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.status), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveDataRoomStatusResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.status = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.status != null && e.hasOwnProperty("status"))
        switch (e.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomStatusResponse)
        return e;
      let t = new $root.gcg.RetrieveDataRoomStatusResponse();
      switch (e.status) {
        default:
          if (typeof e.status == "number") {
            t.status = e.status;
            break;
          }
          break;
        case "Active":
        case 0:
          t.status = 0;
          break;
        case "Stopped":
        case 1:
          t.status = 1;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.status = t.enums === String ? "Active" : 0), e.status != null && e.hasOwnProperty("status") && (n.status = t.enums === String ? $root.gcg.DataRoomStatus[e.status] === void 0 ? e.status : $root.gcg.DataRoomStatus[e.status] : e.status), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomStatusResponse";
    }, o;
  }(), c.UpdateDataRoomStatusRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.status = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.status != null && Object.hasOwnProperty.call(e, "status") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(e.status), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.UpdateDataRoomStatusRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            r.status = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.status != null && e.hasOwnProperty("status"))
        switch (e.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.UpdateDataRoomStatusRequest)
        return e;
      let t = new $root.gcg.UpdateDataRoomStatusRequest();
      switch (e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.status) {
        default:
          if (typeof e.status == "number") {
            t.status = e.status;
            break;
          }
          break;
        case "Active":
        case 0:
          t.status = 0;
          break;
        case "Stopped":
        case 1:
          t.status = 1;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), n.status = t.enums === String ? "Active" : 0), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.status != null && e.hasOwnProperty("status") && (n.status = t.enums === String ? $root.gcg.DataRoomStatus[e.status] === void 0 ? e.status : $root.gcg.DataRoomStatus[e.status] : e.status), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UpdateDataRoomStatusRequest";
    }, o;
  }(), c.UpdateDataRoomStatusResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.UpdateDataRoomStatusResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.UpdateDataRoomStatusResponse ? e : new $root.gcg.UpdateDataRoomStatusResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UpdateDataRoomStatusResponse";
    }, o;
  }(), c.RetrievePublishedDatasetsRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrievePublishedDatasetsRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrievePublishedDatasetsRequest)
        return e;
      let t = new $root.gcg.RetrievePublishedDatasetsRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrievePublishedDatasetsRequest";
    }, o;
  }(), c.PublishedDataset = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.leafId = "", o.prototype.user = "", o.prototype.timestamp = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.datasetHash = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.leafId), e.user != null && Object.hasOwnProperty.call(e, "user") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.user), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.timestamp), e.datasetHash != null && Object.hasOwnProperty.call(e, "datasetHash") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.datasetHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.PublishedDataset();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.leafId = e.string();
            break;
          }
          case 2: {
            r.user = e.string();
            break;
          }
          case 3: {
            r.timestamp = e.uint64();
            break;
          }
          case 4: {
            r.datasetHash = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : e.user != null && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : e.timestamp != null && e.hasOwnProperty("timestamp") && !$util.isInteger(e.timestamp) && !(e.timestamp && $util.isInteger(e.timestamp.low) && $util.isInteger(e.timestamp.high)) ? "timestamp: integer|Long expected" : e.datasetHash != null && e.hasOwnProperty("datasetHash") && !(e.datasetHash && typeof e.datasetHash.length == "number" || $util.isString(e.datasetHash)) ? "datasetHash: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.PublishedDataset)
        return e;
      let t = new $root.gcg.PublishedDataset();
      return e.leafId != null && (t.leafId = String(e.leafId)), e.user != null && (t.user = String(e.user)), e.timestamp != null && ($util.Long ? (t.timestamp = $util.Long.fromValue(e.timestamp)).unsigned = !0 : typeof e.timestamp == "string" ? t.timestamp = parseInt(e.timestamp, 10) : typeof e.timestamp == "number" ? t.timestamp = e.timestamp : typeof e.timestamp == "object" && (t.timestamp = new $util.LongBits(e.timestamp.low >>> 0, e.timestamp.high >>> 0).toNumber(!0))), e.datasetHash != null && (typeof e.datasetHash == "string" ? $util.base64.decode(e.datasetHash, t.datasetHash = $util.newBuffer($util.base64.length(e.datasetHash)), 0) : e.datasetHash.length >= 0 && (t.datasetHash = e.datasetHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults) {
        if (n.leafId = "", n.user = "", $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.timestamp = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.timestamp = t.longs === String ? "0" : 0;
        t.bytes === String ? n.datasetHash = "" : (n.datasetHash = [], t.bytes !== Array && (n.datasetHash = $util.newBuffer(n.datasetHash)));
      }
      return e.leafId != null && e.hasOwnProperty("leafId") && (n.leafId = e.leafId), e.user != null && e.hasOwnProperty("user") && (n.user = e.user), e.timestamp != null && e.hasOwnProperty("timestamp") && (typeof e.timestamp == "number" ? n.timestamp = t.longs === String ? String(e.timestamp) : e.timestamp : n.timestamp = t.longs === String ? $util.Long.prototype.toString.call(e.timestamp) : t.longs === Number ? new $util.LongBits(e.timestamp.low >>> 0, e.timestamp.high >>> 0).toNumber(!0) : e.timestamp), e.datasetHash != null && e.hasOwnProperty("datasetHash") && (n.datasetHash = t.bytes === String ? $util.base64.encode(e.datasetHash, 0, e.datasetHash.length) : t.bytes === Array ? Array.prototype.slice.call(e.datasetHash) : e.datasetHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishedDataset";
    }, o;
  }(), c.RetrievePublishedDatasetsResponse = function() {
    function o(i) {
      if (this.publishedDatasets = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.publishedDatasets = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.publishedDatasets != null && e.publishedDatasets.length)
        for (let n = 0; n < e.publishedDatasets.length; ++n)
          $root.gcg.PublishedDataset.encode(e.publishedDatasets[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrievePublishedDatasetsResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.publishedDatasets && r.publishedDatasets.length || (r.publishedDatasets = []), r.publishedDatasets.push($root.gcg.PublishedDataset.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.publishedDatasets != null && e.hasOwnProperty("publishedDatasets")) {
        if (!Array.isArray(e.publishedDatasets))
          return "publishedDatasets: array expected";
        for (let t = 0; t < e.publishedDatasets.length; ++t) {
          let n = $root.gcg.PublishedDataset.verify(e.publishedDatasets[t]);
          if (n)
            return "publishedDatasets." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrievePublishedDatasetsResponse)
        return e;
      let t = new $root.gcg.RetrievePublishedDatasetsResponse();
      if (e.publishedDatasets) {
        if (!Array.isArray(e.publishedDatasets))
          throw TypeError(".gcg.RetrievePublishedDatasetsResponse.publishedDatasets: array expected");
        t.publishedDatasets = [];
        for (let n = 0; n < e.publishedDatasets.length; ++n) {
          if (typeof e.publishedDatasets[n] != "object")
            throw TypeError(".gcg.RetrievePublishedDatasetsResponse.publishedDatasets: object expected");
          t.publishedDatasets[n] = $root.gcg.PublishedDataset.fromObject(e.publishedDatasets[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.publishedDatasets = []), e.publishedDatasets && e.publishedDatasets.length) {
        n.publishedDatasets = [];
        for (let r = 0; r < e.publishedDatasets.length; ++r)
          n.publishedDatasets[r] = $root.gcg.PublishedDataset.toObject(e.publishedDatasets[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrievePublishedDatasetsResponse";
    }, o;
  }(), c.RemovePublishedDatasetRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.leafId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.leafId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RemovePublishedDatasetRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            r.leafId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RemovePublishedDatasetRequest)
        return e;
      let t = new $root.gcg.RemovePublishedDatasetRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.leafId != null && (t.leafId = String(e.leafId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), n.leafId = ""), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.leafId != null && e.hasOwnProperty("leafId") && (n.leafId = e.leafId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RemovePublishedDatasetRequest";
    }, o;
  }(), c.RemovePublishedDatasetResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RemovePublishedDatasetResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.RemovePublishedDatasetResponse ? e : new $root.gcg.RemovePublishedDatasetResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RemovePublishedDatasetResponse";
    }, o;
  }(), c.CreateConfigurationCommitRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.commit = null, o.prototype.highLevelRepresentation = null;
    let i;
    return Object.defineProperty(o.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(i = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.commit != null && Object.hasOwnProperty.call(t, "commit") && $root.data_room.ConfigurationCommit.encode(t.commit, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.highLevelRepresentation != null && Object.hasOwnProperty.call(t, "highLevelRepresentation") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(t.highLevelRepresentation), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CreateConfigurationCommitRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.commit = $root.data_room.ConfigurationCommit.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.highLevelRepresentation = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.commit != null && t.hasOwnProperty("commit")) {
        let n = $root.data_room.ConfigurationCommit.verify(t.commit);
        if (n)
          return "commit." + n;
      }
      return t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && !(t.highLevelRepresentation && typeof t.highLevelRepresentation.length == "number" || $util.isString(t.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CreateConfigurationCommitRequest)
        return t;
      let n = new $root.gcg.CreateConfigurationCommitRequest();
      if (t.commit != null) {
        if (typeof t.commit != "object")
          throw TypeError(".gcg.CreateConfigurationCommitRequest.commit: object expected");
        n.commit = $root.data_room.ConfigurationCommit.fromObject(t.commit);
      }
      return t.highLevelRepresentation != null && (typeof t.highLevelRepresentation == "string" ? $util.base64.decode(t.highLevelRepresentation, n.highLevelRepresentation = $util.newBuffer($util.base64.length(t.highLevelRepresentation)), 0) : t.highLevelRepresentation.length >= 0 && (n.highLevelRepresentation = t.highLevelRepresentation)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.commit = null), t.commit != null && t.hasOwnProperty("commit") && (r.commit = $root.data_room.ConfigurationCommit.toObject(t.commit, n)), t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && (r.highLevelRepresentation = n.bytes === String ? $util.base64.encode(t.highLevelRepresentation, 0, t.highLevelRepresentation.length) : n.bytes === Array ? Array.prototype.slice.call(t.highLevelRepresentation) : t.highLevelRepresentation, n.oneofs && (r._highLevelRepresentation = "highLevelRepresentation")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CreateConfigurationCommitRequest";
    }, o;
  }(), c.CreateConfigurationCommitResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.commitId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.CreateConfigurationCommitResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateConfigurationCommitResponse)
        return e;
      let t = new $root.gcg.CreateConfigurationCommitResponse();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, t.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (t.commitId = e.commitId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.commitId = "" : (n.commitId = [], t.bytes !== Array && (n.commitId = $util.newBuffer(n.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (n.commitId = t.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : t.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateConfigurationCommitResponse";
    }, o;
  }(), c.GenerateMergeApprovalSignatureRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.commitId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GenerateMergeApprovalSignatureRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GenerateMergeApprovalSignatureRequest)
        return e;
      let t = new $root.gcg.GenerateMergeApprovalSignatureRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, t.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (t.commitId = e.commitId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.commitId = "" : (n.commitId = [], t.bytes !== Array && (n.commitId = $util.newBuffer(n.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (n.commitId = t.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : t.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GenerateMergeApprovalSignatureRequest";
    }, o;
  }(), c.GenerateMergeApprovalSignatureResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.signature = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.signature != null && Object.hasOwnProperty.call(e, "signature") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.signature), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GenerateMergeApprovalSignatureResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.signature = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.signature != null && e.hasOwnProperty("signature") && !(e.signature && typeof e.signature.length == "number" || $util.isString(e.signature)) ? "signature: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GenerateMergeApprovalSignatureResponse)
        return e;
      let t = new $root.gcg.GenerateMergeApprovalSignatureResponse();
      return e.signature != null && (typeof e.signature == "string" ? $util.base64.decode(e.signature, t.signature = $util.newBuffer($util.base64.length(e.signature)), 0) : e.signature.length >= 0 && (t.signature = e.signature)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.signature = "" : (n.signature = [], t.bytes !== Array && (n.signature = $util.newBuffer(n.signature)))), e.signature != null && e.hasOwnProperty("signature") && (n.signature = t.bytes === String ? $util.base64.encode(e.signature, 0, e.signature.length) : t.bytes === Array ? Array.prototype.slice.call(e.signature) : e.signature), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GenerateMergeApprovalSignatureResponse";
    }, o;
  }(), c.MergeConfigurationCommitRequest = function() {
    function o(e) {
      if (this.approvalSignatures = {}, e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.commitId = $util.newBuffer([]), o.prototype.approvalSignatures = $util.emptyObject, o.prototype.newDataRoomHighLevelRepresentation = null;
    let i;
    return Object.defineProperty(o.prototype, "_newDataRoomHighLevelRepresentation", {
      get: $util.oneOfGetter(i = ["newDataRoomHighLevelRepresentation"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.commitId != null && Object.hasOwnProperty.call(t, "commitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(t.commitId), t.approvalSignatures != null && Object.hasOwnProperty.call(t, "approvalSignatures"))
        for (let r = Object.keys(t.approvalSignatures), u = 0; u < r.length; ++u)
          n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(r[u]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).bytes(t.approvalSignatures[r[u]]).ldelim();
      return t.newDataRoomHighLevelRepresentation != null && Object.hasOwnProperty.call(t, "newDataRoomHighLevelRepresentation") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.newDataRoomHighLevelRepresentation), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.MergeConfigurationCommitRequest(), l, f;
      for (; t.pos < r; ) {
        let a = t.uint32();
        switch (a >>> 3) {
          case 1: {
            u.commitId = t.bytes();
            break;
          }
          case 2: {
            u.approvalSignatures === $util.emptyObject && (u.approvalSignatures = {});
            let d = t.uint32() + t.pos;
            for (l = "", f = []; t.pos < d; ) {
              let p = t.uint32();
              switch (p >>> 3) {
                case 1:
                  l = t.string();
                  break;
                case 2:
                  f = t.bytes();
                  break;
                default:
                  t.skipType(p & 7);
                  break;
              }
            }
            u.approvalSignatures[l] = f;
            break;
          }
          case 3: {
            u.newDataRoomHighLevelRepresentation = t.bytes();
            break;
          }
          default:
            t.skipType(a & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.commitId != null && t.hasOwnProperty("commitId") && !(t.commitId && typeof t.commitId.length == "number" || $util.isString(t.commitId)))
        return "commitId: buffer expected";
      if (t.approvalSignatures != null && t.hasOwnProperty("approvalSignatures")) {
        if (!$util.isObject(t.approvalSignatures))
          return "approvalSignatures: object expected";
        let n = Object.keys(t.approvalSignatures);
        for (let r = 0; r < n.length; ++r)
          if (!(t.approvalSignatures[n[r]] && typeof t.approvalSignatures[n[r]].length == "number" || $util.isString(t.approvalSignatures[n[r]])))
            return "approvalSignatures: buffer{k:string} expected";
      }
      return t.newDataRoomHighLevelRepresentation != null && t.hasOwnProperty("newDataRoomHighLevelRepresentation") && !(t.newDataRoomHighLevelRepresentation && typeof t.newDataRoomHighLevelRepresentation.length == "number" || $util.isString(t.newDataRoomHighLevelRepresentation)) ? "newDataRoomHighLevelRepresentation: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.MergeConfigurationCommitRequest)
        return t;
      let n = new $root.gcg.MergeConfigurationCommitRequest();
      if (t.commitId != null && (typeof t.commitId == "string" ? $util.base64.decode(t.commitId, n.commitId = $util.newBuffer($util.base64.length(t.commitId)), 0) : t.commitId.length >= 0 && (n.commitId = t.commitId)), t.approvalSignatures) {
        if (typeof t.approvalSignatures != "object")
          throw TypeError(".gcg.MergeConfigurationCommitRequest.approvalSignatures: object expected");
        n.approvalSignatures = {};
        for (let r = Object.keys(t.approvalSignatures), u = 0; u < r.length; ++u)
          typeof t.approvalSignatures[r[u]] == "string" ? $util.base64.decode(t.approvalSignatures[r[u]], n.approvalSignatures[r[u]] = $util.newBuffer($util.base64.length(t.approvalSignatures[r[u]])), 0) : t.approvalSignatures[r[u]].length >= 0 && (n.approvalSignatures[r[u]] = t.approvalSignatures[r[u]]);
      }
      return t.newDataRoomHighLevelRepresentation != null && (typeof t.newDataRoomHighLevelRepresentation == "string" ? $util.base64.decode(t.newDataRoomHighLevelRepresentation, n.newDataRoomHighLevelRepresentation = $util.newBuffer($util.base64.length(t.newDataRoomHighLevelRepresentation)), 0) : t.newDataRoomHighLevelRepresentation.length >= 0 && (n.newDataRoomHighLevelRepresentation = t.newDataRoomHighLevelRepresentation)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      (n.objects || n.defaults) && (r.approvalSignatures = {}), n.defaults && (n.bytes === String ? r.commitId = "" : (r.commitId = [], n.bytes !== Array && (r.commitId = $util.newBuffer(r.commitId)))), t.commitId != null && t.hasOwnProperty("commitId") && (r.commitId = n.bytes === String ? $util.base64.encode(t.commitId, 0, t.commitId.length) : n.bytes === Array ? Array.prototype.slice.call(t.commitId) : t.commitId);
      let u;
      if (t.approvalSignatures && (u = Object.keys(t.approvalSignatures)).length) {
        r.approvalSignatures = {};
        for (let l = 0; l < u.length; ++l)
          r.approvalSignatures[u[l]] = n.bytes === String ? $util.base64.encode(t.approvalSignatures[u[l]], 0, t.approvalSignatures[u[l]].length) : n.bytes === Array ? Array.prototype.slice.call(t.approvalSignatures[u[l]]) : t.approvalSignatures[u[l]];
      }
      return t.newDataRoomHighLevelRepresentation != null && t.hasOwnProperty("newDataRoomHighLevelRepresentation") && (r.newDataRoomHighLevelRepresentation = n.bytes === String ? $util.base64.encode(t.newDataRoomHighLevelRepresentation, 0, t.newDataRoomHighLevelRepresentation.length) : n.bytes === Array ? Array.prototype.slice.call(t.newDataRoomHighLevelRepresentation) : t.newDataRoomHighLevelRepresentation, n.oneofs && (r._newDataRoomHighLevelRepresentation = "newDataRoomHighLevelRepresentation")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.MergeConfigurationCommitRequest";
    }, o;
  }(), c.RetrieveCurrentDataRoomConfigurationRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveCurrentDataRoomConfigurationRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveCurrentDataRoomConfigurationRequest)
        return e;
      let t = new $root.gcg.RetrieveCurrentDataRoomConfigurationRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveCurrentDataRoomConfigurationRequest";
    }, o;
  }(), c.RetrieveCurrentDataRoomConfigurationResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.configuration = null, o.prototype.pin = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.configuration != null && Object.hasOwnProperty.call(e, "configuration") && $root.data_room.DataRoomConfiguration.encode(e.configuration, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.pin != null && Object.hasOwnProperty.call(e, "pin") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.pin), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveCurrentDataRoomConfigurationResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.configuration = $root.data_room.DataRoomConfiguration.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.pin = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.configuration != null && e.hasOwnProperty("configuration")) {
        let t = $root.data_room.DataRoomConfiguration.verify(e.configuration);
        if (t)
          return "configuration." + t;
      }
      return e.pin != null && e.hasOwnProperty("pin") && !(e.pin && typeof e.pin.length == "number" || $util.isString(e.pin)) ? "pin: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveCurrentDataRoomConfigurationResponse)
        return e;
      let t = new $root.gcg.RetrieveCurrentDataRoomConfigurationResponse();
      if (e.configuration != null) {
        if (typeof e.configuration != "object")
          throw TypeError(".gcg.RetrieveCurrentDataRoomConfigurationResponse.configuration: object expected");
        t.configuration = $root.data_room.DataRoomConfiguration.fromObject(e.configuration);
      }
      return e.pin != null && (typeof e.pin == "string" ? $util.base64.decode(e.pin, t.pin = $util.newBuffer($util.base64.length(e.pin)), 0) : e.pin.length >= 0 && (t.pin = e.pin)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.configuration = null, t.bytes === String ? n.pin = "" : (n.pin = [], t.bytes !== Array && (n.pin = $util.newBuffer(n.pin)))), e.configuration != null && e.hasOwnProperty("configuration") && (n.configuration = $root.data_room.DataRoomConfiguration.toObject(e.configuration, t)), e.pin != null && e.hasOwnProperty("pin") && (n.pin = t.bytes === String ? $util.base64.encode(e.pin, 0, e.pin.length) : t.bytes === Array ? Array.prototype.slice.call(e.pin) : e.pin), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveCurrentDataRoomConfigurationResponse";
    }, o;
  }(), c.RetrieveConfigurationCommitApproversRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.commitId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveConfigurationCommitApproversRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitApproversRequest)
        return e;
      let t = new $root.gcg.RetrieveConfigurationCommitApproversRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, t.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (t.commitId = e.commitId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.commitId = "" : (n.commitId = [], t.bytes !== Array && (n.commitId = $util.newBuffer(n.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (n.commitId = t.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : t.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitApproversRequest";
    }, o;
  }(), c.RetrieveConfigurationCommitApproversResponse = function() {
    function o(i) {
      if (this.approvers = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.approvers = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.approvers != null && e.approvers.length)
        for (let n = 0; n < e.approvers.length; ++n)
          t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.approvers[n]);
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveConfigurationCommitApproversResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.approvers && r.approvers.length || (r.approvers = []), r.approvers.push(e.string());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.approvers != null && e.hasOwnProperty("approvers")) {
        if (!Array.isArray(e.approvers))
          return "approvers: array expected";
        for (let t = 0; t < e.approvers.length; ++t)
          if (!$util.isString(e.approvers[t]))
            return "approvers: string[] expected";
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitApproversResponse)
        return e;
      let t = new $root.gcg.RetrieveConfigurationCommitApproversResponse();
      if (e.approvers) {
        if (!Array.isArray(e.approvers))
          throw TypeError(".gcg.RetrieveConfigurationCommitApproversResponse.approvers: array expected");
        t.approvers = [];
        for (let n = 0; n < e.approvers.length; ++n)
          t.approvers[n] = String(e.approvers[n]);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.approvers = []), e.approvers && e.approvers.length) {
        n.approvers = [];
        for (let r = 0; r < e.approvers.length; ++r)
          n.approvers[r] = e.approvers[r];
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitApproversResponse";
    }, o;
  }(), c.RetrieveConfigurationCommitRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.commitId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveConfigurationCommitRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitRequest)
        return e;
      let t = new $root.gcg.RetrieveConfigurationCommitRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, t.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (t.commitId = e.commitId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.commitId = "" : (n.commitId = [], t.bytes !== Array && (n.commitId = $util.newBuffer(n.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (n.commitId = t.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : t.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitRequest";
    }, o;
  }(), c.RetrieveConfigurationCommitResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.commit = null, o.prototype.highLevelRepresentation = null;
    let i;
    return Object.defineProperty(o.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(i = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.commit != null && Object.hasOwnProperty.call(t, "commit") && $root.data_room.ConfigurationCommit.encode(t.commit, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.highLevelRepresentation != null && Object.hasOwnProperty.call(t, "highLevelRepresentation") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(t.highLevelRepresentation), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.RetrieveConfigurationCommitResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.commit = $root.data_room.ConfigurationCommit.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.highLevelRepresentation = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.commit != null && t.hasOwnProperty("commit")) {
        let n = $root.data_room.ConfigurationCommit.verify(t.commit);
        if (n)
          return "commit." + n;
      }
      return t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && !(t.highLevelRepresentation && typeof t.highLevelRepresentation.length == "number" || $util.isString(t.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.RetrieveConfigurationCommitResponse)
        return t;
      let n = new $root.gcg.RetrieveConfigurationCommitResponse();
      if (t.commit != null) {
        if (typeof t.commit != "object")
          throw TypeError(".gcg.RetrieveConfigurationCommitResponse.commit: object expected");
        n.commit = $root.data_room.ConfigurationCommit.fromObject(t.commit);
      }
      return t.highLevelRepresentation != null && (typeof t.highLevelRepresentation == "string" ? $util.base64.decode(t.highLevelRepresentation, n.highLevelRepresentation = $util.newBuffer($util.base64.length(t.highLevelRepresentation)), 0) : t.highLevelRepresentation.length >= 0 && (n.highLevelRepresentation = t.highLevelRepresentation)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.commit = null), t.commit != null && t.hasOwnProperty("commit") && (r.commit = $root.data_room.ConfigurationCommit.toObject(t.commit, n)), t.highLevelRepresentation != null && t.hasOwnProperty("highLevelRepresentation") && (r.highLevelRepresentation = n.bytes === String ? $util.base64.encode(t.highLevelRepresentation, 0, t.highLevelRepresentation.length) : n.bytes === Array ? Array.prototype.slice.call(t.highLevelRepresentation) : t.highLevelRepresentation, n.oneofs && (r._highLevelRepresentation = "highLevelRepresentation")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.RetrieveConfigurationCommitResponse";
    }, o;
  }(), c.CasAuxiliaryStateRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.value = null;
    let i;
    return Object.defineProperty(o.prototype, "_value", {
      get: $util.oneOfGetter(i = ["value"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dataRoomId != null && Object.hasOwnProperty.call(t, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(t.dataRoomId), t.index != null && Object.hasOwnProperty.call(t, "index") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(t.index), t.value != null && Object.hasOwnProperty.call(t, "value") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.value), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CasAuxiliaryStateRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dataRoomId = t.bytes();
            break;
          }
          case 2: {
            u.index = t.uint64();
            break;
          }
          case 3: {
            u.value = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.dataRoomId != null && t.hasOwnProperty("dataRoomId") && !(t.dataRoomId && typeof t.dataRoomId.length == "number" || $util.isString(t.dataRoomId)) ? "dataRoomId: buffer expected" : t.index != null && t.hasOwnProperty("index") && !$util.isInteger(t.index) && !(t.index && $util.isInteger(t.index.low) && $util.isInteger(t.index.high)) ? "index: integer|Long expected" : t.value != null && t.hasOwnProperty("value") && !(t.value && typeof t.value.length == "number" || $util.isString(t.value)) ? "value: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CasAuxiliaryStateRequest)
        return t;
      let n = new $root.gcg.CasAuxiliaryStateRequest();
      return t.dataRoomId != null && (typeof t.dataRoomId == "string" ? $util.base64.decode(t.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(t.dataRoomId)), 0) : t.dataRoomId.length >= 0 && (n.dataRoomId = t.dataRoomId)), t.index != null && ($util.Long ? (n.index = $util.Long.fromValue(t.index)).unsigned = !0 : typeof t.index == "string" ? n.index = parseInt(t.index, 10) : typeof t.index == "number" ? n.index = t.index : typeof t.index == "object" && (n.index = new $util.LongBits(t.index.low >>> 0, t.index.high >>> 0).toNumber(!0))), t.value != null && (typeof t.value == "string" ? $util.base64.decode(t.value, n.value = $util.newBuffer($util.base64.length(t.value)), 0) : t.value.length >= 0 && (n.value = t.value)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if (n.defaults)
        if (n.bytes === String ? r.dataRoomId = "" : (r.dataRoomId = [], n.bytes !== Array && (r.dataRoomId = $util.newBuffer(r.dataRoomId))), $util.Long) {
          let u = new $util.Long(0, 0, !0);
          r.index = n.longs === String ? u.toString() : n.longs === Number ? u.toNumber() : u;
        } else
          r.index = n.longs === String ? "0" : 0;
      return t.dataRoomId != null && t.hasOwnProperty("dataRoomId") && (r.dataRoomId = n.bytes === String ? $util.base64.encode(t.dataRoomId, 0, t.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(t.dataRoomId) : t.dataRoomId), t.index != null && t.hasOwnProperty("index") && (typeof t.index == "number" ? r.index = n.longs === String ? String(t.index) : t.index : r.index = n.longs === String ? $util.Long.prototype.toString.call(t.index) : n.longs === Number ? new $util.LongBits(t.index.low >>> 0, t.index.high >>> 0).toNumber(!0) : t.index), t.value != null && t.hasOwnProperty("value") && (r.value = n.bytes === String ? $util.base64.encode(t.value, 0, t.value.length) : n.bytes === Array ? Array.prototype.slice.call(t.value) : t.value, n.oneofs && (r._value = "value")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CasAuxiliaryStateRequest";
    }, o;
  }(), c.CasAuxiliaryStateResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.success = !1, o.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.value = null;
    let i;
    return Object.defineProperty(o.prototype, "_value", {
      get: $util.oneOfGetter(i = ["value"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.success != null && Object.hasOwnProperty.call(t, "success") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(t.success), t.index != null && Object.hasOwnProperty.call(t, "index") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(t.index), t.value != null && Object.hasOwnProperty.call(t, "value") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.value), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CasAuxiliaryStateResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.success = t.bool();
            break;
          }
          case 2: {
            u.index = t.uint64();
            break;
          }
          case 3: {
            u.value = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.success != null && t.hasOwnProperty("success") && typeof t.success != "boolean" ? "success: boolean expected" : t.index != null && t.hasOwnProperty("index") && !$util.isInteger(t.index) && !(t.index && $util.isInteger(t.index.low) && $util.isInteger(t.index.high)) ? "index: integer|Long expected" : t.value != null && t.hasOwnProperty("value") && !(t.value && typeof t.value.length == "number" || $util.isString(t.value)) ? "value: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CasAuxiliaryStateResponse)
        return t;
      let n = new $root.gcg.CasAuxiliaryStateResponse();
      return t.success != null && (n.success = !!t.success), t.index != null && ($util.Long ? (n.index = $util.Long.fromValue(t.index)).unsigned = !0 : typeof t.index == "string" ? n.index = parseInt(t.index, 10) : typeof t.index == "number" ? n.index = t.index : typeof t.index == "object" && (n.index = new $util.LongBits(t.index.low >>> 0, t.index.high >>> 0).toNumber(!0))), t.value != null && (typeof t.value == "string" ? $util.base64.decode(t.value, n.value = $util.newBuffer($util.base64.length(t.value)), 0) : t.value.length >= 0 && (n.value = t.value)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if (n.defaults)
        if (r.success = !1, $util.Long) {
          let u = new $util.Long(0, 0, !0);
          r.index = n.longs === String ? u.toString() : n.longs === Number ? u.toNumber() : u;
        } else
          r.index = n.longs === String ? "0" : 0;
      return t.success != null && t.hasOwnProperty("success") && (r.success = t.success), t.index != null && t.hasOwnProperty("index") && (typeof t.index == "number" ? r.index = n.longs === String ? String(t.index) : t.index : r.index = n.longs === String ? $util.Long.prototype.toString.call(t.index) : n.longs === Number ? new $util.LongBits(t.index.low >>> 0, t.index.high >>> 0).toNumber(!0) : t.index), t.value != null && t.hasOwnProperty("value") && (r.value = n.bytes === String ? $util.base64.encode(t.value, 0, t.value.length) : n.bytes === Array ? Array.prototype.slice.call(t.value) : t.value, n.oneofs && (r._value = "value")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CasAuxiliaryStateResponse";
    }, o;
  }(), c.ReadAuxiliaryStateRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.ReadAuxiliaryStateRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.ReadAuxiliaryStateRequest)
        return e;
      let t = new $root.gcg.ReadAuxiliaryStateRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ReadAuxiliaryStateRequest";
    }, o;
  }(), c.ReadAuxiliaryStateResponse = function() {
    function o(i) {
      if (this.values = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.values = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.values != null && e.values.length)
        for (let n = 0; n < e.values.length; ++n)
          $root.gcg.AuxiliaryStateValue.encode(e.values[n], t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.ReadAuxiliaryStateResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 2: {
            r.values && r.values.length || (r.values = []), r.values.push($root.gcg.AuxiliaryStateValue.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.values != null && e.hasOwnProperty("values")) {
        if (!Array.isArray(e.values))
          return "values: array expected";
        for (let t = 0; t < e.values.length; ++t) {
          let n = $root.gcg.AuxiliaryStateValue.verify(e.values[t]);
          if (n)
            return "values." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.ReadAuxiliaryStateResponse)
        return e;
      let t = new $root.gcg.ReadAuxiliaryStateResponse();
      if (e.values) {
        if (!Array.isArray(e.values))
          throw TypeError(".gcg.ReadAuxiliaryStateResponse.values: array expected");
        t.values = [];
        for (let n = 0; n < e.values.length; ++n) {
          if (typeof e.values[n] != "object")
            throw TypeError(".gcg.ReadAuxiliaryStateResponse.values: object expected");
          t.values[n] = $root.gcg.AuxiliaryStateValue.fromObject(e.values[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.values = []), e.values && e.values.length) {
        n.values = [];
        for (let r = 0; r < e.values.length; ++r)
          n.values[r] = $root.gcg.AuxiliaryStateValue.toObject(e.values[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ReadAuxiliaryStateResponse";
    }, o;
  }(), c.AuxiliaryStateValue = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.user = "", o.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.value = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.user != null && Object.hasOwnProperty.call(e, "user") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.user), e.index != null && Object.hasOwnProperty.call(e, "index") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.index), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.value), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.AuxiliaryStateValue();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.user = e.string();
            break;
          }
          case 2: {
            r.index = e.uint64();
            break;
          }
          case 3: {
            r.value = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.user != null && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : e.index != null && e.hasOwnProperty("index") && !$util.isInteger(e.index) && !(e.index && $util.isInteger(e.index.low) && $util.isInteger(e.index.high)) ? "index: integer|Long expected" : e.value != null && e.hasOwnProperty("value") && !(e.value && typeof e.value.length == "number" || $util.isString(e.value)) ? "value: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.AuxiliaryStateValue)
        return e;
      let t = new $root.gcg.AuxiliaryStateValue();
      return e.user != null && (t.user = String(e.user)), e.index != null && ($util.Long ? (t.index = $util.Long.fromValue(e.index)).unsigned = !0 : typeof e.index == "string" ? t.index = parseInt(e.index, 10) : typeof e.index == "number" ? t.index = e.index : typeof e.index == "object" && (t.index = new $util.LongBits(e.index.low >>> 0, e.index.high >>> 0).toNumber(!0))), e.value != null && (typeof e.value == "string" ? $util.base64.decode(e.value, t.value = $util.newBuffer($util.base64.length(e.value)), 0) : e.value.length >= 0 && (t.value = e.value)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults) {
        if (n.user = "", $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.index = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.index = t.longs === String ? "0" : 0;
        t.bytes === String ? n.value = "" : (n.value = [], t.bytes !== Array && (n.value = $util.newBuffer(n.value)));
      }
      return e.user != null && e.hasOwnProperty("user") && (n.user = e.user), e.index != null && e.hasOwnProperty("index") && (typeof e.index == "number" ? n.index = t.longs === String ? String(e.index) : e.index : n.index = t.longs === String ? $util.Long.prototype.toString.call(e.index) : t.longs === Number ? new $util.LongBits(e.index.low >>> 0, e.index.high >>> 0).toNumber(!0) : e.index), e.value != null && e.hasOwnProperty("value") && (n.value = t.bytes === String ? $util.base64.encode(e.value, 0, e.value.length) : t.bytes === Array ? Array.prototype.slice.call(e.value) : e.value), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.AuxiliaryStateValue";
    }, o;
  }(), c.MergeConfigurationCommitResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.MergeConfigurationCommitResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.MergeConfigurationCommitResponse ? e : new $root.gcg.MergeConfigurationCommitResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.MergeConfigurationCommitResponse";
    }, o;
  }(), c.DriverTaskConfig = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.noop = null, o.prototype.staticContent = null;
    let i;
    return Object.defineProperty(o.prototype, "driverTaskConfig", {
      get: $util.oneOfGetter(i = ["noop", "staticContent"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.noop != null && Object.hasOwnProperty.call(t, "noop") && $root.gcg.NoopConfig.encode(t.noop, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.staticContent != null && Object.hasOwnProperty.call(t, "staticContent") && $root.gcg.StaticContentConfig.encode(t.staticContent, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.DriverTaskConfig();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.noop = $root.gcg.NoopConfig.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.staticContent = $root.gcg.StaticContentConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.noop != null && t.hasOwnProperty("noop")) {
        n.driverTaskConfig = 1;
        {
          let r = $root.gcg.NoopConfig.verify(t.noop);
          if (r)
            return "noop." + r;
        }
      }
      if (t.staticContent != null && t.hasOwnProperty("staticContent")) {
        if (n.driverTaskConfig === 1)
          return "driverTaskConfig: multiple values";
        n.driverTaskConfig = 1;
        {
          let r = $root.gcg.StaticContentConfig.verify(t.staticContent);
          if (r)
            return "staticContent." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.DriverTaskConfig)
        return t;
      let n = new $root.gcg.DriverTaskConfig();
      if (t.noop != null) {
        if (typeof t.noop != "object")
          throw TypeError(".gcg.DriverTaskConfig.noop: object expected");
        n.noop = $root.gcg.NoopConfig.fromObject(t.noop);
      }
      if (t.staticContent != null) {
        if (typeof t.staticContent != "object")
          throw TypeError(".gcg.DriverTaskConfig.staticContent: object expected");
        n.staticContent = $root.gcg.StaticContentConfig.fromObject(t.staticContent);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.noop != null && t.hasOwnProperty("noop") && (r.noop = $root.gcg.NoopConfig.toObject(t.noop, n), n.oneofs && (r.driverTaskConfig = "noop")), t.staticContent != null && t.hasOwnProperty("staticContent") && (r.staticContent = $root.gcg.StaticContentConfig.toObject(t.staticContent, n), n.oneofs && (r.driverTaskConfig = "staticContent")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.DriverTaskConfig";
    }, o;
  }(), c.NoopConfig = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.NoopConfig();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.NoopConfig ? e : new $root.gcg.NoopConfig();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.NoopConfig";
    }, o;
  }(), c.StaticContentConfig = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.content = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.content), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.StaticContentConfig();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.content = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.content != null && e.hasOwnProperty("content") && !(e.content && typeof e.content.length == "number" || $util.isString(e.content)) ? "content: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.StaticContentConfig)
        return e;
      let t = new $root.gcg.StaticContentConfig();
      return e.content != null && (typeof e.content == "string" ? $util.base64.decode(e.content, t.content = $util.newBuffer($util.base64.length(e.content)), 0) : e.content.length >= 0 && (t.content = e.content)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.content = "" : (n.content = [], t.bytes !== Array && (n.content = $util.newBuffer(n.content)))), e.content != null && e.hasOwnProperty("content") && (n.content = t.bytes === String ? $util.base64.encode(e.content, 0, e.content.length) : t.bytes === Array ? Array.prototype.slice.call(e.content) : e.content), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.StaticContentConfig";
    }, o;
  }(), c.RetrieveUsedAirlockQuotaRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveUsedAirlockQuotaRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveUsedAirlockQuotaRequest)
        return e;
      let t = new $root.gcg.RetrieveUsedAirlockQuotaRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveUsedAirlockQuotaRequest";
    }, o;
  }(), c.RetrieveUsedAirlockQuotaResponse = function() {
    function o(i) {
      if (this.airlockQuotas = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.airlockQuotas = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.airlockQuotas != null && e.airlockQuotas.length)
        for (let n = 0; n < e.airlockQuotas.length; ++n)
          $root.gcg.AirlockQuotaInfo.encode(e.airlockQuotas[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.RetrieveUsedAirlockQuotaResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.airlockQuotas && r.airlockQuotas.length || (r.airlockQuotas = []), r.airlockQuotas.push($root.gcg.AirlockQuotaInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.airlockQuotas != null && e.hasOwnProperty("airlockQuotas")) {
        if (!Array.isArray(e.airlockQuotas))
          return "airlockQuotas: array expected";
        for (let t = 0; t < e.airlockQuotas.length; ++t) {
          let n = $root.gcg.AirlockQuotaInfo.verify(e.airlockQuotas[t]);
          if (n)
            return "airlockQuotas." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveUsedAirlockQuotaResponse)
        return e;
      let t = new $root.gcg.RetrieveUsedAirlockQuotaResponse();
      if (e.airlockQuotas) {
        if (!Array.isArray(e.airlockQuotas))
          throw TypeError(".gcg.RetrieveUsedAirlockQuotaResponse.airlockQuotas: array expected");
        t.airlockQuotas = [];
        for (let n = 0; n < e.airlockQuotas.length; ++n) {
          if (typeof e.airlockQuotas[n] != "object")
            throw TypeError(".gcg.RetrieveUsedAirlockQuotaResponse.airlockQuotas: object expected");
          t.airlockQuotas[n] = $root.gcg.AirlockQuotaInfo.fromObject(e.airlockQuotas[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.airlockQuotas = []), e.airlockQuotas && e.airlockQuotas.length) {
        n.airlockQuotas = [];
        for (let r = 0; r < e.airlockQuotas.length; ++r)
          n.airlockQuotas[r] = $root.gcg.AirlockQuotaInfo.toObject(e.airlockQuotas[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveUsedAirlockQuotaResponse";
    }, o;
  }(), c.AirlockQuotaInfo = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.airlockNodeId = "", o.prototype.quotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.usedQuotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.airlockNodeId != null && Object.hasOwnProperty.call(e, "airlockNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.airlockNodeId), e.quotaBytes != null && Object.hasOwnProperty.call(e, "quotaBytes") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.quotaBytes), e.usedQuotaBytes != null && Object.hasOwnProperty.call(e, "usedQuotaBytes") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.usedQuotaBytes), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.AirlockQuotaInfo();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.airlockNodeId = e.string();
            break;
          }
          case 2: {
            r.quotaBytes = e.uint64();
            break;
          }
          case 3: {
            r.usedQuotaBytes = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.airlockNodeId != null && e.hasOwnProperty("airlockNodeId") && !$util.isString(e.airlockNodeId) ? "airlockNodeId: string expected" : e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && !$util.isInteger(e.quotaBytes) && !(e.quotaBytes && $util.isInteger(e.quotaBytes.low) && $util.isInteger(e.quotaBytes.high)) ? "quotaBytes: integer|Long expected" : e.usedQuotaBytes != null && e.hasOwnProperty("usedQuotaBytes") && !$util.isInteger(e.usedQuotaBytes) && !(e.usedQuotaBytes && $util.isInteger(e.usedQuotaBytes.low) && $util.isInteger(e.usedQuotaBytes.high)) ? "usedQuotaBytes: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.AirlockQuotaInfo)
        return e;
      let t = new $root.gcg.AirlockQuotaInfo();
      return e.airlockNodeId != null && (t.airlockNodeId = String(e.airlockNodeId)), e.quotaBytes != null && ($util.Long ? (t.quotaBytes = $util.Long.fromValue(e.quotaBytes)).unsigned = !0 : typeof e.quotaBytes == "string" ? t.quotaBytes = parseInt(e.quotaBytes, 10) : typeof e.quotaBytes == "number" ? t.quotaBytes = e.quotaBytes : typeof e.quotaBytes == "object" && (t.quotaBytes = new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0))), e.usedQuotaBytes != null && ($util.Long ? (t.usedQuotaBytes = $util.Long.fromValue(e.usedQuotaBytes)).unsigned = !0 : typeof e.usedQuotaBytes == "string" ? t.usedQuotaBytes = parseInt(e.usedQuotaBytes, 10) : typeof e.usedQuotaBytes == "number" ? t.usedQuotaBytes = e.usedQuotaBytes : typeof e.usedQuotaBytes == "object" && (t.usedQuotaBytes = new $util.LongBits(e.usedQuotaBytes.low >>> 0, e.usedQuotaBytes.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults) {
        if (n.airlockNodeId = "", $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.quotaBytes = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.quotaBytes = t.longs === String ? "0" : 0;
        if ($util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.usedQuotaBytes = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.usedQuotaBytes = t.longs === String ? "0" : 0;
      }
      return e.airlockNodeId != null && e.hasOwnProperty("airlockNodeId") && (n.airlockNodeId = e.airlockNodeId), e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && (typeof e.quotaBytes == "number" ? n.quotaBytes = t.longs === String ? String(e.quotaBytes) : e.quotaBytes : n.quotaBytes = t.longs === String ? $util.Long.prototype.toString.call(e.quotaBytes) : t.longs === Number ? new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0) : e.quotaBytes), e.usedQuotaBytes != null && e.hasOwnProperty("usedQuotaBytes") && (typeof e.usedQuotaBytes == "number" ? n.usedQuotaBytes = t.longs === String ? String(e.usedQuotaBytes) : e.usedQuotaBytes : n.usedQuotaBytes = t.longs === String ? $util.Long.prototype.toString.call(e.usedQuotaBytes) : t.longs === Number ? new $util.LongBits(e.usedQuotaBytes.low >>> 0, e.usedQuotaBytes.high >>> 0).toNumber(!0) : e.usedQuotaBytes), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.AirlockQuotaInfo";
    }, o;
  }(), c.GetResultsSizeResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.sizeBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.sizeBytes != null && Object.hasOwnProperty.call(e, "sizeBytes") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.sizeBytes), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetResultsSizeResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.sizeBytes = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.sizeBytes != null && e.hasOwnProperty("sizeBytes") && !$util.isInteger(e.sizeBytes) && !(e.sizeBytes && $util.isInteger(e.sizeBytes.low) && $util.isInteger(e.sizeBytes.high)) ? "sizeBytes: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsSizeResponse)
        return e;
      let t = new $root.gcg.GetResultsSizeResponse();
      return e.sizeBytes != null && ($util.Long ? (t.sizeBytes = $util.Long.fromValue(e.sizeBytes)).unsigned = !0 : typeof e.sizeBytes == "string" ? t.sizeBytes = parseInt(e.sizeBytes, 10) : typeof e.sizeBytes == "number" ? t.sizeBytes = e.sizeBytes : typeof e.sizeBytes == "object" && (t.sizeBytes = new $util.LongBits(e.sizeBytes.low >>> 0, e.sizeBytes.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if ($util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.sizeBytes = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.sizeBytes = t.longs === String ? "0" : 0;
      return e.sizeBytes != null && e.hasOwnProperty("sizeBytes") && (typeof e.sizeBytes == "number" ? n.sizeBytes = t.longs === String ? String(e.sizeBytes) : e.sizeBytes : n.sizeBytes = t.longs === String ? $util.Long.prototype.toString.call(e.sizeBytes) : t.longs === Number ? new $util.LongBits(e.sizeBytes.low >>> 0, e.sizeBytes.high >>> 0).toNumber(!0) : e.sizeBytes), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsSizeResponse";
    }, o;
  }(), c.GcgRequestV2 = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.unauthenticated = null, o.prototype.authenticated = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["unauthenticated", "authenticated"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.unauthenticated != null && Object.hasOwnProperty.call(t, "unauthenticated") && $root.gcg.UnauthenticatedRequest.encode(t.unauthenticated, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.authenticated != null && Object.hasOwnProperty.call(t, "authenticated") && $root.gcg.AuthenticatedRequest.encode(t.authenticated, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.GcgRequestV2();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.unauthenticated = $root.gcg.UnauthenticatedRequest.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.authenticated = $root.gcg.AuthenticatedRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.unauthenticated != null && t.hasOwnProperty("unauthenticated")) {
        n.request = 1;
        {
          let r = $root.gcg.UnauthenticatedRequest.verify(t.unauthenticated);
          if (r)
            return "unauthenticated." + r;
        }
      }
      if (t.authenticated != null && t.hasOwnProperty("authenticated")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.AuthenticatedRequest.verify(t.authenticated);
          if (r)
            return "authenticated." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.GcgRequestV2)
        return t;
      let n = new $root.gcg.GcgRequestV2();
      if (t.unauthenticated != null) {
        if (typeof t.unauthenticated != "object")
          throw TypeError(".gcg.GcgRequestV2.unauthenticated: object expected");
        n.unauthenticated = $root.gcg.UnauthenticatedRequest.fromObject(t.unauthenticated);
      }
      if (t.authenticated != null) {
        if (typeof t.authenticated != "object")
          throw TypeError(".gcg.GcgRequestV2.authenticated: object expected");
        n.authenticated = $root.gcg.AuthenticatedRequest.fromObject(t.authenticated);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.unauthenticated != null && t.hasOwnProperty("unauthenticated") && (r.unauthenticated = $root.gcg.UnauthenticatedRequest.toObject(t.unauthenticated, n), n.oneofs && (r.request = "unauthenticated")), t.authenticated != null && t.hasOwnProperty("authenticated") && (r.authenticated = $root.gcg.AuthenticatedRequest.toObject(t.authenticated, n), n.oneofs && (r.request = "authenticated")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.GcgRequestV2";
    }, o;
  }(), c.AuthenticatedRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.accessToken = null, o.prototype.apiToken = null, o.prototype.createPolicy = null, o.prototype.secretStore = null, o.prototype.updateStatus = null, o.prototype.getVerificationKey = null, o.prototype.dcrAction = null, o.prototype.createApiToken = null, o.prototype.getApiTokens = null, o.prototype.deleteApiToken = null;
    let i;
    return Object.defineProperty(o.prototype, "token", {
      get: $util.oneOfGetter(i = ["accessToken", "apiToken"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["createPolicy", "secretStore", "updateStatus", "getVerificationKey", "dcrAction", "createApiToken", "getApiTokens", "deleteApiToken"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.accessToken != null && Object.hasOwnProperty.call(t, "accessToken") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.accessToken), t.apiToken != null && Object.hasOwnProperty.call(t, "apiToken") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.apiToken), t.createPolicy != null && Object.hasOwnProperty.call(t, "createPolicy") && $root.gcg.CreatePolicyRequest.encode(t.createPolicy, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.secretStore != null && Object.hasOwnProperty.call(t, "secretStore") && $root.secret_store_api.SecretStoreRequest.encode(t.secretStore, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.updateStatus != null && Object.hasOwnProperty.call(t, "updateStatus") && $root.gcg.UpdateDataRoomStatusRequest.encode(t.updateStatus, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.getVerificationKey != null && Object.hasOwnProperty.call(t, "getVerificationKey") && $root.gcg.GetVerificationKeyRequest.encode(t.getVerificationKey, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.dcrAction != null && Object.hasOwnProperty.call(t, "dcrAction") && $root.gcg.DcrActionRequest.encode(t.dcrAction, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.createApiToken != null && Object.hasOwnProperty.call(t, "createApiToken") && $root.gcg.CreateApiTokenRequest.encode(t.createApiToken, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.getApiTokens != null && Object.hasOwnProperty.call(t, "getApiTokens") && $root.gcg.GetApiTokensRequest.encode(t.getApiTokens, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.deleteApiToken != null && Object.hasOwnProperty.call(t, "deleteApiToken") && $root.gcg.DeleteApiTokenRequest.encode(t.deleteApiToken, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.AuthenticatedRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.accessToken = t.string();
            break;
          }
          case 2: {
            u.apiToken = t.string();
            break;
          }
          case 3: {
            u.createPolicy = $root.gcg.CreatePolicyRequest.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.secretStore = $root.secret_store_api.SecretStoreRequest.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.updateStatus = $root.gcg.UpdateDataRoomStatusRequest.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.getVerificationKey = $root.gcg.GetVerificationKeyRequest.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.dcrAction = $root.gcg.DcrActionRequest.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.createApiToken = $root.gcg.CreateApiTokenRequest.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.getApiTokens = $root.gcg.GetApiTokensRequest.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.deleteApiToken = $root.gcg.DeleteApiTokenRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.accessToken != null && t.hasOwnProperty("accessToken") && (n.token = 1, !$util.isString(t.accessToken)))
        return "accessToken: string expected";
      if (t.apiToken != null && t.hasOwnProperty("apiToken")) {
        if (n.token === 1)
          return "token: multiple values";
        if (n.token = 1, !$util.isString(t.apiToken))
          return "apiToken: string expected";
      }
      if (t.createPolicy != null && t.hasOwnProperty("createPolicy")) {
        n.request = 1;
        {
          let r = $root.gcg.CreatePolicyRequest.verify(t.createPolicy);
          if (r)
            return "createPolicy." + r;
        }
      }
      if (t.secretStore != null && t.hasOwnProperty("secretStore")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.secret_store_api.SecretStoreRequest.verify(t.secretStore);
          if (r)
            return "secretStore." + r;
        }
      }
      if (t.updateStatus != null && t.hasOwnProperty("updateStatus")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.UpdateDataRoomStatusRequest.verify(t.updateStatus);
          if (r)
            return "updateStatus." + r;
        }
      }
      if (t.getVerificationKey != null && t.hasOwnProperty("getVerificationKey")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.GetVerificationKeyRequest.verify(t.getVerificationKey);
          if (r)
            return "getVerificationKey." + r;
        }
      }
      if (t.dcrAction != null && t.hasOwnProperty("dcrAction")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.DcrActionRequest.verify(t.dcrAction);
          if (r)
            return "dcrAction." + r;
        }
      }
      if (t.createApiToken != null && t.hasOwnProperty("createApiToken")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.CreateApiTokenRequest.verify(t.createApiToken);
          if (r)
            return "createApiToken." + r;
        }
      }
      if (t.getApiTokens != null && t.hasOwnProperty("getApiTokens")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.GetApiTokensRequest.verify(t.getApiTokens);
          if (r)
            return "getApiTokens." + r;
        }
      }
      if (t.deleteApiToken != null && t.hasOwnProperty("deleteApiToken")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.DeleteApiTokenRequest.verify(t.deleteApiToken);
          if (r)
            return "deleteApiToken." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.AuthenticatedRequest)
        return t;
      let n = new $root.gcg.AuthenticatedRequest();
      if (t.accessToken != null && (n.accessToken = String(t.accessToken)), t.apiToken != null && (n.apiToken = String(t.apiToken)), t.createPolicy != null) {
        if (typeof t.createPolicy != "object")
          throw TypeError(".gcg.AuthenticatedRequest.createPolicy: object expected");
        n.createPolicy = $root.gcg.CreatePolicyRequest.fromObject(t.createPolicy);
      }
      if (t.secretStore != null) {
        if (typeof t.secretStore != "object")
          throw TypeError(".gcg.AuthenticatedRequest.secretStore: object expected");
        n.secretStore = $root.secret_store_api.SecretStoreRequest.fromObject(t.secretStore);
      }
      if (t.updateStatus != null) {
        if (typeof t.updateStatus != "object")
          throw TypeError(".gcg.AuthenticatedRequest.updateStatus: object expected");
        n.updateStatus = $root.gcg.UpdateDataRoomStatusRequest.fromObject(t.updateStatus);
      }
      if (t.getVerificationKey != null) {
        if (typeof t.getVerificationKey != "object")
          throw TypeError(".gcg.AuthenticatedRequest.getVerificationKey: object expected");
        n.getVerificationKey = $root.gcg.GetVerificationKeyRequest.fromObject(t.getVerificationKey);
      }
      if (t.dcrAction != null) {
        if (typeof t.dcrAction != "object")
          throw TypeError(".gcg.AuthenticatedRequest.dcrAction: object expected");
        n.dcrAction = $root.gcg.DcrActionRequest.fromObject(t.dcrAction);
      }
      if (t.createApiToken != null) {
        if (typeof t.createApiToken != "object")
          throw TypeError(".gcg.AuthenticatedRequest.createApiToken: object expected");
        n.createApiToken = $root.gcg.CreateApiTokenRequest.fromObject(t.createApiToken);
      }
      if (t.getApiTokens != null) {
        if (typeof t.getApiTokens != "object")
          throw TypeError(".gcg.AuthenticatedRequest.getApiTokens: object expected");
        n.getApiTokens = $root.gcg.GetApiTokensRequest.fromObject(t.getApiTokens);
      }
      if (t.deleteApiToken != null) {
        if (typeof t.deleteApiToken != "object")
          throw TypeError(".gcg.AuthenticatedRequest.deleteApiToken: object expected");
        n.deleteApiToken = $root.gcg.DeleteApiTokenRequest.fromObject(t.deleteApiToken);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.accessToken != null && t.hasOwnProperty("accessToken") && (r.accessToken = t.accessToken, n.oneofs && (r.token = "accessToken")), t.apiToken != null && t.hasOwnProperty("apiToken") && (r.apiToken = t.apiToken, n.oneofs && (r.token = "apiToken")), t.createPolicy != null && t.hasOwnProperty("createPolicy") && (r.createPolicy = $root.gcg.CreatePolicyRequest.toObject(t.createPolicy, n), n.oneofs && (r.request = "createPolicy")), t.secretStore != null && t.hasOwnProperty("secretStore") && (r.secretStore = $root.secret_store_api.SecretStoreRequest.toObject(t.secretStore, n), n.oneofs && (r.request = "secretStore")), t.updateStatus != null && t.hasOwnProperty("updateStatus") && (r.updateStatus = $root.gcg.UpdateDataRoomStatusRequest.toObject(t.updateStatus, n), n.oneofs && (r.request = "updateStatus")), t.getVerificationKey != null && t.hasOwnProperty("getVerificationKey") && (r.getVerificationKey = $root.gcg.GetVerificationKeyRequest.toObject(t.getVerificationKey, n), n.oneofs && (r.request = "getVerificationKey")), t.dcrAction != null && t.hasOwnProperty("dcrAction") && (r.dcrAction = $root.gcg.DcrActionRequest.toObject(t.dcrAction, n), n.oneofs && (r.request = "dcrAction")), t.createApiToken != null && t.hasOwnProperty("createApiToken") && (r.createApiToken = $root.gcg.CreateApiTokenRequest.toObject(t.createApiToken, n), n.oneofs && (r.request = "createApiToken")), t.getApiTokens != null && t.hasOwnProperty("getApiTokens") && (r.getApiTokens = $root.gcg.GetApiTokensRequest.toObject(t.getApiTokens, n), n.oneofs && (r.request = "getApiTokens")), t.deleteApiToken != null && t.hasOwnProperty("deleteApiToken") && (r.deleteApiToken = $root.gcg.DeleteApiTokenRequest.toObject(t.deleteApiToken, n), n.oneofs && (r.request = "deleteApiToken")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.AuthenticatedRequest";
    }, o;
  }(), c.AuthenticatedResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.createPolicy = null, o.prototype.secretStore = null, o.prototype.updateStatus = null, o.prototype.getVerificationKey = null, o.prototype.dcrAction = null, o.prototype.createApiToken = null, o.prototype.getApiTokens = null, o.prototype.deleteApiToken = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["createPolicy", "secretStore", "updateStatus", "getVerificationKey", "dcrAction", "createApiToken", "getApiTokens", "deleteApiToken"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.createPolicy != null && Object.hasOwnProperty.call(t, "createPolicy") && $root.gcg.CreatePolicyResponse.encode(t.createPolicy, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.secretStore != null && Object.hasOwnProperty.call(t, "secretStore") && $root.secret_store_api.SecretStoreResponse.encode(t.secretStore, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.updateStatus != null && Object.hasOwnProperty.call(t, "updateStatus") && $root.gcg.UpdateDataRoomStatusResponse.encode(t.updateStatus, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.getVerificationKey != null && Object.hasOwnProperty.call(t, "getVerificationKey") && $root.gcg.GetVerificationKeyResponse.encode(t.getVerificationKey, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.dcrAction != null && Object.hasOwnProperty.call(t, "dcrAction") && $root.gcg.DcrActionResponse.encode(t.dcrAction, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.createApiToken != null && Object.hasOwnProperty.call(t, "createApiToken") && $root.gcg.CreateApiTokenResponse.encode(t.createApiToken, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.getApiTokens != null && Object.hasOwnProperty.call(t, "getApiTokens") && $root.gcg.GetApiTokensResponse.encode(t.getApiTokens, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.deleteApiToken != null && Object.hasOwnProperty.call(t, "deleteApiToken") && $root.gcg.DeleteApiTokenResponse.encode(t.deleteApiToken, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.AuthenticatedResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 3: {
            u.createPolicy = $root.gcg.CreatePolicyResponse.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.secretStore = $root.secret_store_api.SecretStoreResponse.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.updateStatus = $root.gcg.UpdateDataRoomStatusResponse.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.getVerificationKey = $root.gcg.GetVerificationKeyResponse.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.dcrAction = $root.gcg.DcrActionResponse.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.createApiToken = $root.gcg.CreateApiTokenResponse.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.getApiTokens = $root.gcg.GetApiTokensResponse.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.deleteApiToken = $root.gcg.DeleteApiTokenResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.createPolicy != null && t.hasOwnProperty("createPolicy")) {
        n.response = 1;
        {
          let r = $root.gcg.CreatePolicyResponse.verify(t.createPolicy);
          if (r)
            return "createPolicy." + r;
        }
      }
      if (t.secretStore != null && t.hasOwnProperty("secretStore")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.secret_store_api.SecretStoreResponse.verify(t.secretStore);
          if (r)
            return "secretStore." + r;
        }
      }
      if (t.updateStatus != null && t.hasOwnProperty("updateStatus")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.UpdateDataRoomStatusResponse.verify(t.updateStatus);
          if (r)
            return "updateStatus." + r;
        }
      }
      if (t.getVerificationKey != null && t.hasOwnProperty("getVerificationKey")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.GetVerificationKeyResponse.verify(t.getVerificationKey);
          if (r)
            return "getVerificationKey." + r;
        }
      }
      if (t.dcrAction != null && t.hasOwnProperty("dcrAction")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.DcrActionResponse.verify(t.dcrAction);
          if (r)
            return "dcrAction." + r;
        }
      }
      if (t.createApiToken != null && t.hasOwnProperty("createApiToken")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.CreateApiTokenResponse.verify(t.createApiToken);
          if (r)
            return "createApiToken." + r;
        }
      }
      if (t.getApiTokens != null && t.hasOwnProperty("getApiTokens")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.GetApiTokensResponse.verify(t.getApiTokens);
          if (r)
            return "getApiTokens." + r;
        }
      }
      if (t.deleteApiToken != null && t.hasOwnProperty("deleteApiToken")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.DeleteApiTokenResponse.verify(t.deleteApiToken);
          if (r)
            return "deleteApiToken." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.AuthenticatedResponse)
        return t;
      let n = new $root.gcg.AuthenticatedResponse();
      if (t.createPolicy != null) {
        if (typeof t.createPolicy != "object")
          throw TypeError(".gcg.AuthenticatedResponse.createPolicy: object expected");
        n.createPolicy = $root.gcg.CreatePolicyResponse.fromObject(t.createPolicy);
      }
      if (t.secretStore != null) {
        if (typeof t.secretStore != "object")
          throw TypeError(".gcg.AuthenticatedResponse.secretStore: object expected");
        n.secretStore = $root.secret_store_api.SecretStoreResponse.fromObject(t.secretStore);
      }
      if (t.updateStatus != null) {
        if (typeof t.updateStatus != "object")
          throw TypeError(".gcg.AuthenticatedResponse.updateStatus: object expected");
        n.updateStatus = $root.gcg.UpdateDataRoomStatusResponse.fromObject(t.updateStatus);
      }
      if (t.getVerificationKey != null) {
        if (typeof t.getVerificationKey != "object")
          throw TypeError(".gcg.AuthenticatedResponse.getVerificationKey: object expected");
        n.getVerificationKey = $root.gcg.GetVerificationKeyResponse.fromObject(t.getVerificationKey);
      }
      if (t.dcrAction != null) {
        if (typeof t.dcrAction != "object")
          throw TypeError(".gcg.AuthenticatedResponse.dcrAction: object expected");
        n.dcrAction = $root.gcg.DcrActionResponse.fromObject(t.dcrAction);
      }
      if (t.createApiToken != null) {
        if (typeof t.createApiToken != "object")
          throw TypeError(".gcg.AuthenticatedResponse.createApiToken: object expected");
        n.createApiToken = $root.gcg.CreateApiTokenResponse.fromObject(t.createApiToken);
      }
      if (t.getApiTokens != null) {
        if (typeof t.getApiTokens != "object")
          throw TypeError(".gcg.AuthenticatedResponse.getApiTokens: object expected");
        n.getApiTokens = $root.gcg.GetApiTokensResponse.fromObject(t.getApiTokens);
      }
      if (t.deleteApiToken != null) {
        if (typeof t.deleteApiToken != "object")
          throw TypeError(".gcg.AuthenticatedResponse.deleteApiToken: object expected");
        n.deleteApiToken = $root.gcg.DeleteApiTokenResponse.fromObject(t.deleteApiToken);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.createPolicy != null && t.hasOwnProperty("createPolicy") && (r.createPolicy = $root.gcg.CreatePolicyResponse.toObject(t.createPolicy, n), n.oneofs && (r.response = "createPolicy")), t.secretStore != null && t.hasOwnProperty("secretStore") && (r.secretStore = $root.secret_store_api.SecretStoreResponse.toObject(t.secretStore, n), n.oneofs && (r.response = "secretStore")), t.updateStatus != null && t.hasOwnProperty("updateStatus") && (r.updateStatus = $root.gcg.UpdateDataRoomStatusResponse.toObject(t.updateStatus, n), n.oneofs && (r.response = "updateStatus")), t.getVerificationKey != null && t.hasOwnProperty("getVerificationKey") && (r.getVerificationKey = $root.gcg.GetVerificationKeyResponse.toObject(t.getVerificationKey, n), n.oneofs && (r.response = "getVerificationKey")), t.dcrAction != null && t.hasOwnProperty("dcrAction") && (r.dcrAction = $root.gcg.DcrActionResponse.toObject(t.dcrAction, n), n.oneofs && (r.response = "dcrAction")), t.createApiToken != null && t.hasOwnProperty("createApiToken") && (r.createApiToken = $root.gcg.CreateApiTokenResponse.toObject(t.createApiToken, n), n.oneofs && (r.response = "createApiToken")), t.getApiTokens != null && t.hasOwnProperty("getApiTokens") && (r.getApiTokens = $root.gcg.GetApiTokensResponse.toObject(t.getApiTokens, n), n.oneofs && (r.response = "getApiTokens")), t.deleteApiToken != null && t.hasOwnProperty("deleteApiToken") && (r.deleteApiToken = $root.gcg.DeleteApiTokenResponse.toObject(t.deleteApiToken, n), n.oneofs && (r.response = "deleteApiToken")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.AuthenticatedResponse";
    }, o;
  }(), c.UnauthenticatedRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.authentication = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["authentication"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.authentication != null && Object.hasOwnProperty.call(t, "authentication") && $root.gcg.AuthenticationRequest.encode(t.authentication, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.UnauthenticatedRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.authentication = $root.gcg.AuthenticationRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.authentication != null && t.hasOwnProperty("authentication")) {
        let n = $root.gcg.AuthenticationRequest.verify(t.authentication);
        if (n)
          return "authentication." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.UnauthenticatedRequest)
        return t;
      let n = new $root.gcg.UnauthenticatedRequest();
      if (t.authentication != null) {
        if (typeof t.authentication != "object")
          throw TypeError(".gcg.UnauthenticatedRequest.authentication: object expected");
        n.authentication = $root.gcg.AuthenticationRequest.fromObject(t.authentication);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.authentication != null && t.hasOwnProperty("authentication") && (r.authentication = $root.gcg.AuthenticationRequest.toObject(t.authentication, n), n.oneofs && (r.request = "authentication")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.UnauthenticatedRequest";
    }, o;
  }(), c.GcgResponseV2 = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.success = null, o.prototype.failure = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["success", "failure"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.success != null && Object.hasOwnProperty.call(t, "success") && $root.gcg.GcgSuccessfulResponseV2.encode(t.success, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.failure != null && Object.hasOwnProperty.call(t, "failure") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.failure), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.GcgResponseV2();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.success = $root.gcg.GcgSuccessfulResponseV2.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.failure = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.success != null && t.hasOwnProperty("success")) {
        n.response = 1;
        {
          let r = $root.gcg.GcgSuccessfulResponseV2.verify(t.success);
          if (r)
            return "success." + r;
        }
      }
      if (t.failure != null && t.hasOwnProperty("failure")) {
        if (n.response === 1)
          return "response: multiple values";
        if (n.response = 1, !$util.isString(t.failure))
          return "failure: string expected";
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.GcgResponseV2)
        return t;
      let n = new $root.gcg.GcgResponseV2();
      if (t.success != null) {
        if (typeof t.success != "object")
          throw TypeError(".gcg.GcgResponseV2.success: object expected");
        n.success = $root.gcg.GcgSuccessfulResponseV2.fromObject(t.success);
      }
      return t.failure != null && (n.failure = String(t.failure)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.success != null && t.hasOwnProperty("success") && (r.success = $root.gcg.GcgSuccessfulResponseV2.toObject(t.success, n), n.oneofs && (r.response = "success")), t.failure != null && t.hasOwnProperty("failure") && (r.failure = t.failure, n.oneofs && (r.response = "failure")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.GcgResponseV2";
    }, o;
  }(), c.AuthenticationRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.emailStart = null, o.prototype.emailFinish = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["emailStart", "emailFinish"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.emailStart != null && Object.hasOwnProperty.call(t, "emailStart") && $root.gcg.EmailStartAuthenticationRequest.encode(t.emailStart, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.emailFinish != null && Object.hasOwnProperty.call(t, "emailFinish") && $root.gcg.EmailFinishAuthenticationRequest.encode(t.emailFinish, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.AuthenticationRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 2: {
            u.emailStart = $root.gcg.EmailStartAuthenticationRequest.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.emailStart != null && t.hasOwnProperty("emailStart")) {
        n.request = 1;
        {
          let r = $root.gcg.EmailStartAuthenticationRequest.verify(t.emailStart);
          if (r)
            return "emailStart." + r;
        }
      }
      if (t.emailFinish != null && t.hasOwnProperty("emailFinish")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.gcg.EmailFinishAuthenticationRequest.verify(t.emailFinish);
          if (r)
            return "emailFinish." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.AuthenticationRequest)
        return t;
      let n = new $root.gcg.AuthenticationRequest();
      if (t.emailStart != null) {
        if (typeof t.emailStart != "object")
          throw TypeError(".gcg.AuthenticationRequest.emailStart: object expected");
        n.emailStart = $root.gcg.EmailStartAuthenticationRequest.fromObject(t.emailStart);
      }
      if (t.emailFinish != null) {
        if (typeof t.emailFinish != "object")
          throw TypeError(".gcg.AuthenticationRequest.emailFinish: object expected");
        n.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.fromObject(t.emailFinish);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.emailStart != null && t.hasOwnProperty("emailStart") && (r.emailStart = $root.gcg.EmailStartAuthenticationRequest.toObject(t.emailStart, n), n.oneofs && (r.request = "emailStart")), t.emailFinish != null && t.hasOwnProperty("emailFinish") && (r.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.toObject(t.emailFinish, n), n.oneofs && (r.request = "emailFinish")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.AuthenticationRequest";
    }, o;
  }(), c.AuthenticationResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.emailStart = null, o.prototype.emailFinish = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["emailStart", "emailFinish"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.emailStart != null && Object.hasOwnProperty.call(t, "emailStart") && $root.gcg.EmailStartAuthenticationResponse.encode(t.emailStart, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.emailFinish != null && Object.hasOwnProperty.call(t, "emailFinish") && $root.gcg.EmailFinishAuthenticationResponse.encode(t.emailFinish, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.AuthenticationResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 2: {
            u.emailStart = $root.gcg.EmailStartAuthenticationResponse.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.emailStart != null && t.hasOwnProperty("emailStart")) {
        n.response = 1;
        {
          let r = $root.gcg.EmailStartAuthenticationResponse.verify(t.emailStart);
          if (r)
            return "emailStart." + r;
        }
      }
      if (t.emailFinish != null && t.hasOwnProperty("emailFinish")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.EmailFinishAuthenticationResponse.verify(t.emailFinish);
          if (r)
            return "emailFinish." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.AuthenticationResponse)
        return t;
      let n = new $root.gcg.AuthenticationResponse();
      if (t.emailStart != null) {
        if (typeof t.emailStart != "object")
          throw TypeError(".gcg.AuthenticationResponse.emailStart: object expected");
        n.emailStart = $root.gcg.EmailStartAuthenticationResponse.fromObject(t.emailStart);
      }
      if (t.emailFinish != null) {
        if (typeof t.emailFinish != "object")
          throw TypeError(".gcg.AuthenticationResponse.emailFinish: object expected");
        n.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.fromObject(t.emailFinish);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.emailStart != null && t.hasOwnProperty("emailStart") && (r.emailStart = $root.gcg.EmailStartAuthenticationResponse.toObject(t.emailStart, n), n.oneofs && (r.response = "emailStart")), t.emailFinish != null && t.hasOwnProperty("emailFinish") && (r.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.toObject(t.emailFinish, n), n.oneofs && (r.response = "emailFinish")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.AuthenticationResponse";
    }, o;
  }(), c.EmailStartAuthenticationRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.email = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailStartAuthenticationRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.email = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email) ? "email: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailStartAuthenticationRequest)
        return e;
      let t = new $root.gcg.EmailStartAuthenticationRequest();
      return e.email != null && (t.email = String(e.email)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.email = ""), e.email != null && e.hasOwnProperty("email") && (n.email = e.email), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailStartAuthenticationRequest";
    }, o;
  }(), c.EmailStartAuthenticationResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailStartAuthenticationResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.EmailStartAuthenticationResponse ? e : new $root.gcg.EmailStartAuthenticationResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailStartAuthenticationResponse";
    }, o;
  }(), c.EmailFinishAuthenticationRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.email = "", o.prototype.code = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), e.code != null && Object.hasOwnProperty.call(e, "code") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.code), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailFinishAuthenticationRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.email = e.string();
            break;
          }
          case 2: {
            r.code = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email) ? "email: string expected" : e.code != null && e.hasOwnProperty("code") && !$util.isString(e.code) ? "code: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailFinishAuthenticationRequest)
        return e;
      let t = new $root.gcg.EmailFinishAuthenticationRequest();
      return e.email != null && (t.email = String(e.email)), e.code != null && (t.code = String(e.code)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.email = "", n.code = ""), e.email != null && e.hasOwnProperty("email") && (n.email = e.email), e.code != null && e.hasOwnProperty("code") && (n.code = e.code), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationRequest";
    }, o;
  }(), c.EmailFinishAuthenticationResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.incorrectCode = null, o.prototype.notFound = null, o.prototype.success = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["incorrectCode", "notFound", "success"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.incorrectCode != null && Object.hasOwnProperty.call(t, "incorrectCode") && $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.encode(t.incorrectCode, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.notFound != null && Object.hasOwnProperty.call(t, "notFound") && $root.gcg.EmailFinishAuthenticationResponseNotFound.encode(t.notFound, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.success != null && Object.hasOwnProperty.call(t, "success") && $root.gcg.EmailFinishAuthenticationResponseSuccess.encode(t.success, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.EmailFinishAuthenticationResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.incorrectCode != null && t.hasOwnProperty("incorrectCode")) {
        n.response = 1;
        {
          let r = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.verify(t.incorrectCode);
          if (r)
            return "incorrectCode." + r;
        }
      }
      if (t.notFound != null && t.hasOwnProperty("notFound")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.EmailFinishAuthenticationResponseNotFound.verify(t.notFound);
          if (r)
            return "notFound." + r;
        }
      }
      if (t.success != null && t.hasOwnProperty("success")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.EmailFinishAuthenticationResponseSuccess.verify(t.success);
          if (r)
            return "success." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.EmailFinishAuthenticationResponse)
        return t;
      let n = new $root.gcg.EmailFinishAuthenticationResponse();
      if (t.incorrectCode != null) {
        if (typeof t.incorrectCode != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.incorrectCode: object expected");
        n.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.fromObject(t.incorrectCode);
      }
      if (t.notFound != null) {
        if (typeof t.notFound != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.notFound: object expected");
        n.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.fromObject(t.notFound);
      }
      if (t.success != null) {
        if (typeof t.success != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.success: object expected");
        n.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.fromObject(t.success);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.incorrectCode != null && t.hasOwnProperty("incorrectCode") && (r.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.toObject(t.incorrectCode, n), n.oneofs && (r.response = "incorrectCode")), t.notFound != null && t.hasOwnProperty("notFound") && (r.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.toObject(t.notFound, n), n.oneofs && (r.response = "notFound")), t.success != null && t.hasOwnProperty("success") && (r.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.toObject(t.success, n), n.oneofs && (r.response = "success")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.EmailFinishAuthenticationResponse";
    }, o;
  }(), c.EmailFinishAuthenticationResponseIncorrectCode = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailFinishAuthenticationResponseIncorrectCode();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.EmailFinishAuthenticationResponseIncorrectCode ? e : new $root.gcg.EmailFinishAuthenticationResponseIncorrectCode();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseIncorrectCode";
    }, o;
  }(), c.EmailFinishAuthenticationResponseNotFound = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailFinishAuthenticationResponseNotFound();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.EmailFinishAuthenticationResponseNotFound ? e : new $root.gcg.EmailFinishAuthenticationResponseNotFound();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseNotFound";
    }, o;
  }(), c.EmailFinishAuthenticationResponseSuccess = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.token = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.EmailFinishAuthenticationResponseSuccess();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.token = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailFinishAuthenticationResponseSuccess)
        return e;
      let t = new $root.gcg.EmailFinishAuthenticationResponseSuccess();
      return e.token != null && (t.token = String(e.token)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.token = ""), e.token != null && e.hasOwnProperty("token") && (n.token = e.token), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseSuccess";
    }, o;
  }(), c.GcgSuccessfulResponseV2 = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.unauthenticated = null, o.prototype.authenticated = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["unauthenticated", "authenticated"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.unauthenticated != null && Object.hasOwnProperty.call(t, "unauthenticated") && $root.gcg.UnauthenticatedResponse.encode(t.unauthenticated, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.authenticated != null && Object.hasOwnProperty.call(t, "authenticated") && $root.gcg.AuthenticatedResponse.encode(t.authenticated, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.GcgSuccessfulResponseV2();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.unauthenticated = $root.gcg.UnauthenticatedResponse.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.authenticated = $root.gcg.AuthenticatedResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.unauthenticated != null && t.hasOwnProperty("unauthenticated")) {
        n.response = 1;
        {
          let r = $root.gcg.UnauthenticatedResponse.verify(t.unauthenticated);
          if (r)
            return "unauthenticated." + r;
        }
      }
      if (t.authenticated != null && t.hasOwnProperty("authenticated")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.gcg.AuthenticatedResponse.verify(t.authenticated);
          if (r)
            return "authenticated." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.GcgSuccessfulResponseV2)
        return t;
      let n = new $root.gcg.GcgSuccessfulResponseV2();
      if (t.unauthenticated != null) {
        if (typeof t.unauthenticated != "object")
          throw TypeError(".gcg.GcgSuccessfulResponseV2.unauthenticated: object expected");
        n.unauthenticated = $root.gcg.UnauthenticatedResponse.fromObject(t.unauthenticated);
      }
      if (t.authenticated != null) {
        if (typeof t.authenticated != "object")
          throw TypeError(".gcg.GcgSuccessfulResponseV2.authenticated: object expected");
        n.authenticated = $root.gcg.AuthenticatedResponse.fromObject(t.authenticated);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.unauthenticated != null && t.hasOwnProperty("unauthenticated") && (r.unauthenticated = $root.gcg.UnauthenticatedResponse.toObject(t.unauthenticated, n), n.oneofs && (r.response = "unauthenticated")), t.authenticated != null && t.hasOwnProperty("authenticated") && (r.authenticated = $root.gcg.AuthenticatedResponse.toObject(t.authenticated, n), n.oneofs && (r.response = "authenticated")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.GcgSuccessfulResponseV2";
    }, o;
  }(), c.UnauthenticatedResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.authentication = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["authentication"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.authentication != null && Object.hasOwnProperty.call(t, "authentication") && $root.gcg.AuthenticationResponse.encode(t.authentication, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.UnauthenticatedResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.authentication = $root.gcg.AuthenticationResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.authentication != null && t.hasOwnProperty("authentication")) {
        let n = $root.gcg.AuthenticationResponse.verify(t.authentication);
        if (n)
          return "authentication." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.UnauthenticatedResponse)
        return t;
      let n = new $root.gcg.UnauthenticatedResponse();
      if (t.authentication != null) {
        if (typeof t.authentication != "object")
          throw TypeError(".gcg.UnauthenticatedResponse.authentication: object expected");
        n.authentication = $root.gcg.AuthenticationResponse.fromObject(t.authentication);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.authentication != null && t.hasOwnProperty("authentication") && (r.authentication = $root.gcg.AuthenticationResponse.toObject(t.authentication, n), n.oneofs && (r.response = "authentication")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.UnauthenticatedResponse";
    }, o;
  }(), c.GetVerificationKeyRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetVerificationKeyRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.GetVerificationKeyRequest ? e : new $root.gcg.GetVerificationKeyRequest();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetVerificationKeyRequest";
    }, o;
  }(), c.GetVerificationKeyResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.verificationKey = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.verificationKey != null && Object.hasOwnProperty.call(e, "verificationKey") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.verificationKey), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetVerificationKeyResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.verificationKey = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.verificationKey != null && e.hasOwnProperty("verificationKey") && !(e.verificationKey && typeof e.verificationKey.length == "number" || $util.isString(e.verificationKey)) ? "verificationKey: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetVerificationKeyResponse)
        return e;
      let t = new $root.gcg.GetVerificationKeyResponse();
      return e.verificationKey != null && (typeof e.verificationKey == "string" ? $util.base64.decode(e.verificationKey, t.verificationKey = $util.newBuffer($util.base64.length(e.verificationKey)), 0) : e.verificationKey.length >= 0 && (t.verificationKey = e.verificationKey)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.verificationKey = "" : (n.verificationKey = [], t.bytes !== Array && (n.verificationKey = $util.newBuffer(n.verificationKey)))), e.verificationKey != null && e.hasOwnProperty("verificationKey") && (n.verificationKey = t.bytes === String ? $util.base64.encode(e.verificationKey, 0, e.verificationKey.length) : t.bytes === Array ? Array.prototype.slice.call(e.verificationKey) : e.verificationKey), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetVerificationKeyResponse";
    }, o;
  }(), c.CreatePolicyRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.policy = null, o.prototype.scope = null;
    let i;
    return Object.defineProperty(o.prototype, "_scope", {
      get: $util.oneOfGetter(i = ["scope"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.policy != null && Object.hasOwnProperty.call(t, "policy") && $root.release_policy_api.ReleasePolicy.encode(t.policy, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.scope != null && Object.hasOwnProperty.call(t, "scope") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(t.scope), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.gcg.CreatePolicyRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.policy = $root.release_policy_api.ReleasePolicy.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.scope = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.policy != null && t.hasOwnProperty("policy")) {
        let n = $root.release_policy_api.ReleasePolicy.verify(t.policy);
        if (n)
          return "policy." + n;
      }
      return t.scope != null && t.hasOwnProperty("scope") && !(t.scope && typeof t.scope.length == "number" || $util.isString(t.scope)) ? "scope: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.gcg.CreatePolicyRequest)
        return t;
      let n = new $root.gcg.CreatePolicyRequest();
      if (t.policy != null) {
        if (typeof t.policy != "object")
          throw TypeError(".gcg.CreatePolicyRequest.policy: object expected");
        n.policy = $root.release_policy_api.ReleasePolicy.fromObject(t.policy);
      }
      return t.scope != null && (typeof t.scope == "string" ? $util.base64.decode(t.scope, n.scope = $util.newBuffer($util.base64.length(t.scope)), 0) : t.scope.length >= 0 && (n.scope = t.scope)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.policy = null), t.policy != null && t.hasOwnProperty("policy") && (r.policy = $root.release_policy_api.ReleasePolicy.toObject(t.policy, n)), t.scope != null && t.hasOwnProperty("scope") && (r.scope = n.bytes === String ? $util.base64.encode(t.scope, 0, t.scope.length) : n.bytes === Array ? Array.prototype.slice.call(t.scope) : t.scope, n.oneofs && (r._scope = "scope")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/gcg.CreatePolicyRequest";
    }, o;
  }(), c.CreatePolicyResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.policyId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.policyId != null && Object.hasOwnProperty.call(e, "policyId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.policyId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.CreatePolicyResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.policyId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.policyId != null && e.hasOwnProperty("policyId") && !$util.isString(e.policyId) ? "policyId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.CreatePolicyResponse)
        return e;
      let t = new $root.gcg.CreatePolicyResponse();
      return e.policyId != null && (t.policyId = String(e.policyId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.policyId = ""), e.policyId != null && e.hasOwnProperty("policyId") && (n.policyId = e.policyId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreatePolicyResponse";
    }, o;
  }(), c.DcrActionRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = $util.newBuffer([]), o.prototype.action = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.action != null && Object.hasOwnProperty.call(e, "action") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.action), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.DcrActionRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            r.action = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : e.action != null && e.hasOwnProperty("action") && !(e.action && typeof e.action.length == "number" || $util.isString(e.action)) ? "action: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.DcrActionRequest)
        return e;
      let t = new $root.gcg.DcrActionRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, t.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (t.dataRoomId = e.dataRoomId)), e.action != null && (typeof e.action == "string" ? $util.base64.decode(e.action, t.action = $util.newBuffer($util.base64.length(e.action)), 0) : e.action.length >= 0 && (t.action = e.action)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dataRoomId = "" : (n.dataRoomId = [], t.bytes !== Array && (n.dataRoomId = $util.newBuffer(n.dataRoomId))), t.bytes === String ? n.action = "" : (n.action = [], t.bytes !== Array && (n.action = $util.newBuffer(n.action)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = t.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.action != null && e.hasOwnProperty("action") && (n.action = t.bytes === String ? $util.base64.encode(e.action, 0, e.action.length) : t.bytes === Array ? Array.prototype.slice.call(e.action) : e.action), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DcrActionRequest";
    }, o;
  }(), c.DcrActionResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.response = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.response != null && Object.hasOwnProperty.call(e, "response") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.response), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.DcrActionResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.response = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.response != null && e.hasOwnProperty("response") && !(e.response && typeof e.response.length == "number" || $util.isString(e.response)) ? "response: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.DcrActionResponse)
        return e;
      let t = new $root.gcg.DcrActionResponse();
      return e.response != null && (typeof e.response == "string" ? $util.base64.decode(e.response, t.response = $util.newBuffer($util.base64.length(e.response)), 0) : e.response.length >= 0 && (t.response = e.response)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.response = "" : (n.response = [], t.bytes !== Array && (n.response = $util.newBuffer(n.response)))), e.response != null && e.hasOwnProperty("response") && (n.response = t.bytes === String ? $util.base64.encode(e.response, 0, e.response.length) : t.bytes === Array ? Array.prototype.slice.call(e.response) : e.response), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DcrActionResponse";
    }, o;
  }(), c.CreateApiTokenRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.CreateApiTokenRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateApiTokenRequest)
        return e;
      let t = new $root.gcg.CreateApiTokenRequest();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateApiTokenRequest";
    }, o;
  }(), c.CreateApiTokenResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.token = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.CreateApiTokenResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.token = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateApiTokenResponse)
        return e;
      let t = new $root.gcg.CreateApiTokenResponse();
      return e.token != null && (t.token = String(e.token)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.token = ""), e.token != null && e.hasOwnProperty("token") && (n.token = e.token), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateApiTokenResponse";
    }, o;
  }(), c.GetApiTokensRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetApiTokensRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.GetApiTokensRequest ? e : new $root.gcg.GetApiTokensRequest();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokensRequest";
    }, o;
  }(), c.GetApiTokensResponse = function() {
    function o(i) {
      if (this.tokens = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.tokens = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.tokens != null && e.tokens.length)
        for (let n = 0; n < e.tokens.length; ++n)
          $root.gcg.GetApiTokenResult.encode(e.tokens[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetApiTokensResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.tokens && r.tokens.length || (r.tokens = []), r.tokens.push($root.gcg.GetApiTokenResult.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.tokens != null && e.hasOwnProperty("tokens")) {
        if (!Array.isArray(e.tokens))
          return "tokens: array expected";
        for (let t = 0; t < e.tokens.length; ++t) {
          let n = $root.gcg.GetApiTokenResult.verify(e.tokens[t]);
          if (n)
            return "tokens." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetApiTokensResponse)
        return e;
      let t = new $root.gcg.GetApiTokensResponse();
      if (e.tokens) {
        if (!Array.isArray(e.tokens))
          throw TypeError(".gcg.GetApiTokensResponse.tokens: array expected");
        t.tokens = [];
        for (let n = 0; n < e.tokens.length; ++n) {
          if (typeof e.tokens[n] != "object")
            throw TypeError(".gcg.GetApiTokensResponse.tokens: object expected");
          t.tokens[n] = $root.gcg.GetApiTokenResult.fromObject(e.tokens[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.tokens = []), e.tokens && e.tokens.length) {
        n.tokens = [];
        for (let r = 0; r < e.tokens.length; ++r)
          n.tokens[r] = $root.gcg.GetApiTokenResult.toObject(e.tokens[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokensResponse";
    }, o;
  }(), c.GetApiTokenResult = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.prototype.token = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.token != null && Object.hasOwnProperty.call(e, "token") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.token), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.GetApiTokenResult();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          case 2: {
            r.token = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.GetApiTokenResult)
        return e;
      let t = new $root.gcg.GetApiTokenResult();
      return e.name != null && (t.name = String(e.name)), e.token != null && (t.token = String(e.token)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = "", n.token = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.token != null && e.hasOwnProperty("token") && (n.token = e.token), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokenResult";
    }, o;
  }(), c.DeleteApiTokenRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.token = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.DeleteApiTokenRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.token = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.gcg.DeleteApiTokenRequest)
        return e;
      let t = new $root.gcg.DeleteApiTokenRequest();
      return e.token != null && (t.token = String(e.token)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.token = ""), e.token != null && e.hasOwnProperty("token") && (n.token = e.token), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DeleteApiTokenRequest";
    }, o;
  }(), c.DeleteApiTokenResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.gcg.DeleteApiTokenResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.gcg.DeleteApiTokenResponse ? e : new $root.gcg.DeleteApiTokenResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DeleteApiTokenResponse";
    }, o;
  }(), c;
})(), identity_endorsement = $root.identity_endorsement = (() => {
  const c = {};
  return c.EndorsementRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.pkiEndorsementRequest = null, o.prototype.dcrSecretEndorsementRequest = null;
    let i;
    return Object.defineProperty(o.prototype, "endorsementRequest", {
      get: $util.oneOfGetter(i = ["pkiEndorsementRequest", "dcrSecretEndorsementRequest"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.pkiEndorsementRequest != null && Object.hasOwnProperty.call(t, "pkiEndorsementRequest") && $root.identity_endorsement.PkiEndorsementRequest.encode(t.pkiEndorsementRequest, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.dcrSecretEndorsementRequest != null && Object.hasOwnProperty.call(t, "dcrSecretEndorsementRequest") && $root.identity_endorsement.DcrSecretEndorsementRequest.encode(t.dcrSecretEndorsementRequest, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.identity_endorsement.EndorsementRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 2: {
            u.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.pkiEndorsementRequest != null && t.hasOwnProperty("pkiEndorsementRequest")) {
        n.endorsementRequest = 1;
        {
          let r = $root.identity_endorsement.PkiEndorsementRequest.verify(t.pkiEndorsementRequest);
          if (r)
            return "pkiEndorsementRequest." + r;
        }
      }
      if (t.dcrSecretEndorsementRequest != null && t.hasOwnProperty("dcrSecretEndorsementRequest")) {
        if (n.endorsementRequest === 1)
          return "endorsementRequest: multiple values";
        n.endorsementRequest = 1;
        {
          let r = $root.identity_endorsement.DcrSecretEndorsementRequest.verify(t.dcrSecretEndorsementRequest);
          if (r)
            return "dcrSecretEndorsementRequest." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.identity_endorsement.EndorsementRequest)
        return t;
      let n = new $root.identity_endorsement.EndorsementRequest();
      if (t.pkiEndorsementRequest != null) {
        if (typeof t.pkiEndorsementRequest != "object")
          throw TypeError(".identity_endorsement.EndorsementRequest.pkiEndorsementRequest: object expected");
        n.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.fromObject(t.pkiEndorsementRequest);
      }
      if (t.dcrSecretEndorsementRequest != null) {
        if (typeof t.dcrSecretEndorsementRequest != "object")
          throw TypeError(".identity_endorsement.EndorsementRequest.dcrSecretEndorsementRequest: object expected");
        n.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.fromObject(t.dcrSecretEndorsementRequest);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.pkiEndorsementRequest != null && t.hasOwnProperty("pkiEndorsementRequest") && (r.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.toObject(t.pkiEndorsementRequest, n), n.oneofs && (r.endorsementRequest = "pkiEndorsementRequest")), t.dcrSecretEndorsementRequest != null && t.hasOwnProperty("dcrSecretEndorsementRequest") && (r.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.toObject(t.dcrSecretEndorsementRequest, n), n.oneofs && (r.endorsementRequest = "dcrSecretEndorsementRequest")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/identity_endorsement.EndorsementRequest";
    }, o;
  }(), c.EndorsementResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.pkiEndorsementResponse = null, o.prototype.dcrSecretEndorsementResponse = null;
    let i;
    return Object.defineProperty(o.prototype, "endorsementResponse", {
      get: $util.oneOfGetter(i = ["pkiEndorsementResponse", "dcrSecretEndorsementResponse"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.pkiEndorsementResponse != null && Object.hasOwnProperty.call(t, "pkiEndorsementResponse") && $root.identity_endorsement.PkiEndorsementResponse.encode(t.pkiEndorsementResponse, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.dcrSecretEndorsementResponse != null && Object.hasOwnProperty.call(t, "dcrSecretEndorsementResponse") && $root.identity_endorsement.DcrSecretEndorsementResponse.encode(t.dcrSecretEndorsementResponse, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.identity_endorsement.EndorsementResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 2: {
            u.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.pkiEndorsementResponse != null && t.hasOwnProperty("pkiEndorsementResponse")) {
        n.endorsementResponse = 1;
        {
          let r = $root.identity_endorsement.PkiEndorsementResponse.verify(t.pkiEndorsementResponse);
          if (r)
            return "pkiEndorsementResponse." + r;
        }
      }
      if (t.dcrSecretEndorsementResponse != null && t.hasOwnProperty("dcrSecretEndorsementResponse")) {
        if (n.endorsementResponse === 1)
          return "endorsementResponse: multiple values";
        n.endorsementResponse = 1;
        {
          let r = $root.identity_endorsement.DcrSecretEndorsementResponse.verify(t.dcrSecretEndorsementResponse);
          if (r)
            return "dcrSecretEndorsementResponse." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.identity_endorsement.EndorsementResponse)
        return t;
      let n = new $root.identity_endorsement.EndorsementResponse();
      if (t.pkiEndorsementResponse != null) {
        if (typeof t.pkiEndorsementResponse != "object")
          throw TypeError(".identity_endorsement.EndorsementResponse.pkiEndorsementResponse: object expected");
        n.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.fromObject(t.pkiEndorsementResponse);
      }
      if (t.dcrSecretEndorsementResponse != null) {
        if (typeof t.dcrSecretEndorsementResponse != "object")
          throw TypeError(".identity_endorsement.EndorsementResponse.dcrSecretEndorsementResponse: object expected");
        n.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.fromObject(t.dcrSecretEndorsementResponse);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.pkiEndorsementResponse != null && t.hasOwnProperty("pkiEndorsementResponse") && (r.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.toObject(t.pkiEndorsementResponse, n), n.oneofs && (r.endorsementResponse = "pkiEndorsementResponse")), t.dcrSecretEndorsementResponse != null && t.hasOwnProperty("dcrSecretEndorsementResponse") && (r.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.toObject(t.dcrSecretEndorsementResponse, n), n.oneofs && (r.endorsementResponse = "dcrSecretEndorsementResponse")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/identity_endorsement.EndorsementResponse";
    }, o;
  }(), c.PkiEndorsementRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.certificateChainPem = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.certificateChainPem != null && Object.hasOwnProperty.call(e, "certificateChainPem") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.certificateChainPem), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.PkiEndorsementRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.certificateChainPem = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.certificateChainPem != null && e.hasOwnProperty("certificateChainPem") && !(e.certificateChainPem && typeof e.certificateChainPem.length == "number" || $util.isString(e.certificateChainPem)) ? "certificateChainPem: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiEndorsementRequest)
        return e;
      let t = new $root.identity_endorsement.PkiEndorsementRequest();
      return e.certificateChainPem != null && (typeof e.certificateChainPem == "string" ? $util.base64.decode(e.certificateChainPem, t.certificateChainPem = $util.newBuffer($util.base64.length(e.certificateChainPem)), 0) : e.certificateChainPem.length >= 0 && (t.certificateChainPem = e.certificateChainPem)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.certificateChainPem = "" : (n.certificateChainPem = [], t.bytes !== Array && (n.certificateChainPem = $util.newBuffer(n.certificateChainPem)))), e.certificateChainPem != null && e.hasOwnProperty("certificateChainPem") && (n.certificateChainPem = t.bytes === String ? $util.base64.encode(e.certificateChainPem, 0, e.certificateChainPem.length) : t.bytes === Array ? Array.prototype.slice.call(e.certificateChainPem) : e.certificateChainPem), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiEndorsementRequest";
    }, o;
  }(), c.PkiEndorsementResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.pkiEndorsement = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.pkiEndorsement != null && Object.hasOwnProperty.call(e, "pkiEndorsement") && $root.identity_endorsement.EnclaveEndorsement.encode(e.pkiEndorsement, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.PkiEndorsementResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.pkiEndorsement != null && e.hasOwnProperty("pkiEndorsement")) {
        let t = $root.identity_endorsement.EnclaveEndorsement.verify(e.pkiEndorsement);
        if (t)
          return "pkiEndorsement." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiEndorsementResponse)
        return e;
      let t = new $root.identity_endorsement.PkiEndorsementResponse();
      if (e.pkiEndorsement != null) {
        if (typeof e.pkiEndorsement != "object")
          throw TypeError(".identity_endorsement.PkiEndorsementResponse.pkiEndorsement: object expected");
        t.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.pkiEndorsement);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.pkiEndorsement = null), e.pkiEndorsement != null && e.hasOwnProperty("pkiEndorsement") && (n.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.toObject(e.pkiEndorsement, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiEndorsementResponse";
    }, o;
  }(), c.DcrSecretEndorsementRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcrSecret = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dcrSecret), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.DcrSecretEndorsementRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcrSecret = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && !$util.isString(e.dcrSecret) ? "dcrSecret: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretEndorsementRequest)
        return e;
      let t = new $root.identity_endorsement.DcrSecretEndorsementRequest();
      return e.dcrSecret != null && (t.dcrSecret = String(e.dcrSecret)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dcrSecret = ""), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (n.dcrSecret = e.dcrSecret), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretEndorsementRequest";
    }, o;
  }(), c.DcrSecretEndorsementResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcrSecretEndorsement = null, o.prototype.dcrSecretId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcrSecretEndorsement != null && Object.hasOwnProperty.call(e, "dcrSecretEndorsement") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dcrSecretEndorsement, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcrSecretId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.DcrSecretEndorsementResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dcrSecretEndorsement != null && e.hasOwnProperty("dcrSecretEndorsement")) {
        let t = $root.identity_endorsement.EnclaveEndorsement.verify(e.dcrSecretEndorsement);
        if (t)
          return "dcrSecretEndorsement." + t;
      }
      return e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretEndorsementResponse)
        return e;
      let t = new $root.identity_endorsement.DcrSecretEndorsementResponse();
      if (e.dcrSecretEndorsement != null) {
        if (typeof e.dcrSecretEndorsement != "object")
          throw TypeError(".identity_endorsement.DcrSecretEndorsementResponse.dcrSecretEndorsement: object expected");
        t.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dcrSecretEndorsement);
      }
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, t.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (t.dcrSecretId = e.dcrSecretId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dcrSecretEndorsement = null, t.bytes === String ? n.dcrSecretId = "" : (n.dcrSecretId = [], t.bytes !== Array && (n.dcrSecretId = $util.newBuffer(n.dcrSecretId)))), e.dcrSecretEndorsement != null && e.hasOwnProperty("dcrSecretEndorsement") && (n.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dcrSecretEndorsement, t)), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (n.dcrSecretId = t.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretEndorsementResponse";
    }, o;
  }(), c.EnclaveEndorsements = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.personalPki = null, o.prototype.dqPki = null, o.prototype.dcrSecret = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.personalPki != null && Object.hasOwnProperty.call(e, "personalPki") && $root.identity_endorsement.EnclaveEndorsement.encode(e.personalPki, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dqPki != null && Object.hasOwnProperty.call(e, "dqPki") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dqPki, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dcrSecret, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.EnclaveEndorsements();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.personalPki = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.dqPki = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.personalPki != null && e.hasOwnProperty("personalPki")) {
        let t = $root.identity_endorsement.EnclaveEndorsement.verify(e.personalPki);
        if (t)
          return "personalPki." + t;
      }
      if (e.dqPki != null && e.hasOwnProperty("dqPki")) {
        let t = $root.identity_endorsement.EnclaveEndorsement.verify(e.dqPki);
        if (t)
          return "dqPki." + t;
      }
      if (e.dcrSecret != null && e.hasOwnProperty("dcrSecret")) {
        let t = $root.identity_endorsement.EnclaveEndorsement.verify(e.dcrSecret);
        if (t)
          return "dcrSecret." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.EnclaveEndorsements)
        return e;
      let t = new $root.identity_endorsement.EnclaveEndorsements();
      if (e.personalPki != null) {
        if (typeof e.personalPki != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.personalPki: object expected");
        t.personalPki = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.personalPki);
      }
      if (e.dqPki != null) {
        if (typeof e.dqPki != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.dqPki: object expected");
        t.dqPki = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dqPki);
      }
      if (e.dcrSecret != null) {
        if (typeof e.dcrSecret != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.dcrSecret: object expected");
        t.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dcrSecret);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.personalPki = null, n.dqPki = null, n.dcrSecret = null), e.personalPki != null && e.hasOwnProperty("personalPki") && (n.personalPki = $root.identity_endorsement.EnclaveEndorsement.toObject(e.personalPki, t)), e.dqPki != null && e.hasOwnProperty("dqPki") && (n.dqPki = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dqPki, t)), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (n.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dcrSecret, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.EnclaveEndorsements";
    }, o;
  }(), c.EnclaveEndorsement = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.endorsementCertificateDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.endorsementCertificateDer != null && Object.hasOwnProperty.call(e, "endorsementCertificateDer") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.endorsementCertificateDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.EnclaveEndorsement();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.endorsementCertificateDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.endorsementCertificateDer != null && e.hasOwnProperty("endorsementCertificateDer") && !(e.endorsementCertificateDer && typeof e.endorsementCertificateDer.length == "number" || $util.isString(e.endorsementCertificateDer)) ? "endorsementCertificateDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.EnclaveEndorsement)
        return e;
      let t = new $root.identity_endorsement.EnclaveEndorsement();
      return e.endorsementCertificateDer != null && (typeof e.endorsementCertificateDer == "string" ? $util.base64.decode(e.endorsementCertificateDer, t.endorsementCertificateDer = $util.newBuffer($util.base64.length(e.endorsementCertificateDer)), 0) : e.endorsementCertificateDer.length >= 0 && (t.endorsementCertificateDer = e.endorsementCertificateDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.endorsementCertificateDer = "" : (n.endorsementCertificateDer = [], t.bytes !== Array && (n.endorsementCertificateDer = $util.newBuffer(n.endorsementCertificateDer)))), e.endorsementCertificateDer != null && e.hasOwnProperty("endorsementCertificateDer") && (n.endorsementCertificateDer = t.bytes === String ? $util.base64.encode(e.endorsementCertificateDer, 0, e.endorsementCertificateDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.endorsementCertificateDer) : e.endorsementCertificateDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.EnclaveEndorsement";
    }, o;
  }(), c.PkiClaim = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.rootCertificateDer = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.rootCertificateDer != null && Object.hasOwnProperty.call(e, "rootCertificateDer") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.rootCertificateDer), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.PkiClaim();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.rootCertificateDer = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.rootCertificateDer != null && e.hasOwnProperty("rootCertificateDer") && !(e.rootCertificateDer && typeof e.rootCertificateDer.length == "number" || $util.isString(e.rootCertificateDer)) ? "rootCertificateDer: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiClaim)
        return e;
      let t = new $root.identity_endorsement.PkiClaim();
      return e.rootCertificateDer != null && (typeof e.rootCertificateDer == "string" ? $util.base64.decode(e.rootCertificateDer, t.rootCertificateDer = $util.newBuffer($util.base64.length(e.rootCertificateDer)), 0) : e.rootCertificateDer.length >= 0 && (t.rootCertificateDer = e.rootCertificateDer)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.rootCertificateDer = "" : (n.rootCertificateDer = [], t.bytes !== Array && (n.rootCertificateDer = $util.newBuffer(n.rootCertificateDer)))), e.rootCertificateDer != null && e.hasOwnProperty("rootCertificateDer") && (n.rootCertificateDer = t.bytes === String ? $util.base64.encode(e.rootCertificateDer, 0, e.rootCertificateDer.length) : t.bytes === Array ? Array.prototype.slice.call(e.rootCertificateDer) : e.rootCertificateDer), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiClaim";
    }, o;
  }(), c.DcrSecretClaim = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dcrSecretId = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcrSecretId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.identity_endorsement.DcrSecretClaim();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretClaim)
        return e;
      let t = new $root.identity_endorsement.DcrSecretClaim();
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, t.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (t.dcrSecretId = e.dcrSecretId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.dcrSecretId = "" : (n.dcrSecretId = [], t.bytes !== Array && (n.dcrSecretId = $util.newBuffer(n.dcrSecretId)))), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (n.dcrSecretId = t.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : t.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretClaim";
    }, o;
  }(), c;
})(), release_policy_api = $root.release_policy_api = (() => {
  const c = {};
  return c.DcrComputeContext = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.release_policy_api.DcrComputeContext();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !$util.isString(e.dataRoomId) ? "dataRoomId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.DcrComputeContext)
        return e;
      let t = new $root.release_policy_api.DcrComputeContext();
      return e.dataRoomId != null && (t.dataRoomId = String(e.dataRoomId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dataRoomId = ""), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (n.dataRoomId = e.dataRoomId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.DcrComputeContext";
    }, o;
  }(), c.AllowedComputeContext = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dcr = null;
    let i;
    return Object.defineProperty(o.prototype, "kind", {
      get: $util.oneOfGetter(i = ["dcr"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dcr != null && Object.hasOwnProperty.call(t, "dcr") && $root.release_policy_api.DcrComputeContext.encode(t.dcr, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.release_policy_api.AllowedComputeContext();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dcr = $root.release_policy_api.DcrComputeContext.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.dcr != null && t.hasOwnProperty("dcr")) {
        let n = $root.release_policy_api.DcrComputeContext.verify(t.dcr);
        if (n)
          return "dcr." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.release_policy_api.AllowedComputeContext)
        return t;
      let n = new $root.release_policy_api.AllowedComputeContext();
      if (t.dcr != null) {
        if (typeof t.dcr != "object")
          throw TypeError(".release_policy_api.AllowedComputeContext.dcr: object expected");
        n.dcr = $root.release_policy_api.DcrComputeContext.fromObject(t.dcr);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.dcr != null && t.hasOwnProperty("dcr") && (r.dcr = $root.release_policy_api.DcrComputeContext.toObject(t.dcr, n), n.oneofs && (r.kind = "dcr")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/release_policy_api.AllowedComputeContext";
    }, o;
  }(), c.ReleasePolicyV0 = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.secretSource = null, o.prototype.allowedComputeContext = null, o.prototype.dataSource = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.secretSource != null && Object.hasOwnProperty.call(e, "secretSource") && $root.release_policy_api.SecretSource.encode(e.secretSource, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.allowedComputeContext != null && Object.hasOwnProperty.call(e, "allowedComputeContext") && $root.release_policy_api.AllowedComputeContext.encode(e.allowedComputeContext, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.dataSource != null && Object.hasOwnProperty.call(e, "dataSource") && $root.release_policy_api.DataSource.encode(e.dataSource, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.release_policy_api.ReleasePolicyV0();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.secretSource = $root.release_policy_api.SecretSource.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.dataSource = $root.release_policy_api.DataSource.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secretSource != null && e.hasOwnProperty("secretSource")) {
        let t = $root.release_policy_api.SecretSource.verify(e.secretSource);
        if (t)
          return "secretSource." + t;
      }
      if (e.allowedComputeContext != null && e.hasOwnProperty("allowedComputeContext")) {
        let t = $root.release_policy_api.AllowedComputeContext.verify(e.allowedComputeContext);
        if (t)
          return "allowedComputeContext." + t;
      }
      if (e.dataSource != null && e.hasOwnProperty("dataSource")) {
        let t = $root.release_policy_api.DataSource.verify(e.dataSource);
        if (t)
          return "dataSource." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.ReleasePolicyV0)
        return e;
      let t = new $root.release_policy_api.ReleasePolicyV0();
      if (e.secretSource != null) {
        if (typeof e.secretSource != "object")
          throw TypeError(".release_policy_api.ReleasePolicyV0.secretSource: object expected");
        t.secretSource = $root.release_policy_api.SecretSource.fromObject(e.secretSource);
      }
      if (e.allowedComputeContext != null) {
        if (typeof e.allowedComputeContext != "object")
          throw TypeError(".release_policy_api.ReleasePolicyV0.allowedComputeContext: object expected");
        t.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.fromObject(e.allowedComputeContext);
      }
      if (e.dataSource != null) {
        if (typeof e.dataSource != "object")
          throw TypeError(".release_policy_api.ReleasePolicyV0.dataSource: object expected");
        t.dataSource = $root.release_policy_api.DataSource.fromObject(e.dataSource);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.secretSource = null, n.allowedComputeContext = null, n.dataSource = null), e.secretSource != null && e.hasOwnProperty("secretSource") && (n.secretSource = $root.release_policy_api.SecretSource.toObject(e.secretSource, t)), e.allowedComputeContext != null && e.hasOwnProperty("allowedComputeContext") && (n.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.toObject(e.allowedComputeContext, t)), e.dataSource != null && e.hasOwnProperty("dataSource") && (n.dataSource = $root.release_policy_api.DataSource.toObject(e.dataSource, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.ReleasePolicyV0";
    }, o;
  }(), c.ReleasePolicy = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.v0 = null;
    let i;
    return Object.defineProperty(o.prototype, "version", {
      get: $util.oneOfGetter(i = ["v0"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.v0 != null && Object.hasOwnProperty.call(t, "v0") && $root.release_policy_api.ReleasePolicyV0.encode(t.v0, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.release_policy_api.ReleasePolicy();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.v0 = $root.release_policy_api.ReleasePolicyV0.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.v0 != null && t.hasOwnProperty("v0")) {
        let n = $root.release_policy_api.ReleasePolicyV0.verify(t.v0);
        if (n)
          return "v0." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.release_policy_api.ReleasePolicy)
        return t;
      let n = new $root.release_policy_api.ReleasePolicy();
      if (t.v0 != null) {
        if (typeof t.v0 != "object")
          throw TypeError(".release_policy_api.ReleasePolicy.v0: object expected");
        n.v0 = $root.release_policy_api.ReleasePolicyV0.fromObject(t.v0);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.v0 != null && t.hasOwnProperty("v0") && (r.v0 = $root.release_policy_api.ReleasePolicyV0.toObject(t.v0, n), n.oneofs && (r.version = "v0")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/release_policy_api.ReleasePolicy";
    }, o;
  }(), c.ComputationResultReference = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.jobId = "", o.prototype.resultHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.jobId), e.resultHash != null && Object.hasOwnProperty.call(e, "resultHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.resultHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.release_policy_api.ComputationResultReference();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.jobId = e.string();
            break;
          }
          case 2: {
            r.resultHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !$util.isString(e.jobId) ? "jobId: string expected" : e.resultHash != null && e.hasOwnProperty("resultHash") && !$util.isString(e.resultHash) ? "resultHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.ComputationResultReference)
        return e;
      let t = new $root.release_policy_api.ComputationResultReference();
      return e.jobId != null && (t.jobId = String(e.jobId)), e.resultHash != null && (t.resultHash = String(e.resultHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.jobId = "", n.resultHash = ""), e.jobId != null && e.hasOwnProperty("jobId") && (n.jobId = e.jobId), e.resultHash != null && e.hasOwnProperty("resultHash") && (n.resultHash = e.resultHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.ComputationResultReference";
    }, o;
  }(), c.SecretSource = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.secretStoreId = null;
    let i;
    return Object.defineProperty(o.prototype, "kind", {
      get: $util.oneOfGetter(i = ["secretStoreId"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.secretStoreId != null && Object.hasOwnProperty.call(t, "secretStoreId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.secretStoreId), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.release_policy_api.SecretSource();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.secretStoreId = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.secretStoreId != null && t.hasOwnProperty("secretStoreId") && !$util.isString(t.secretStoreId) ? "secretStoreId: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.release_policy_api.SecretSource)
        return t;
      let n = new $root.release_policy_api.SecretSource();
      return t.secretStoreId != null && (n.secretStoreId = String(t.secretStoreId)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.secretStoreId != null && t.hasOwnProperty("secretStoreId") && (r.secretStoreId = t.secretStoreId, n.oneofs && (r.kind = "secretStoreId")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/release_policy_api.SecretSource";
    }, o;
  }(), c.DataSource = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dataset = null, o.prototype.computeResult = null;
    let i;
    return Object.defineProperty(o.prototype, "kind", {
      get: $util.oneOfGetter(i = ["dataset", "computeResult"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dataset != null && Object.hasOwnProperty.call(t, "dataset") && $root.release_policy_api.DatasetDataSource.encode(t.dataset, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.computeResult != null && Object.hasOwnProperty.call(t, "computeResult") && $root.release_policy_api.ComputeResultDataSource.encode(t.computeResult, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.release_policy_api.DataSource();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dataset = $root.release_policy_api.DatasetDataSource.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.computeResult = $root.release_policy_api.ComputeResultDataSource.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dataset != null && t.hasOwnProperty("dataset")) {
        n.kind = 1;
        {
          let r = $root.release_policy_api.DatasetDataSource.verify(t.dataset);
          if (r)
            return "dataset." + r;
        }
      }
      if (t.computeResult != null && t.hasOwnProperty("computeResult")) {
        if (n.kind === 1)
          return "kind: multiple values";
        n.kind = 1;
        {
          let r = $root.release_policy_api.ComputeResultDataSource.verify(t.computeResult);
          if (r)
            return "computeResult." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.release_policy_api.DataSource)
        return t;
      let n = new $root.release_policy_api.DataSource();
      if (t.dataset != null) {
        if (typeof t.dataset != "object")
          throw TypeError(".release_policy_api.DataSource.dataset: object expected");
        n.dataset = $root.release_policy_api.DatasetDataSource.fromObject(t.dataset);
      }
      if (t.computeResult != null) {
        if (typeof t.computeResult != "object")
          throw TypeError(".release_policy_api.DataSource.computeResult: object expected");
        n.computeResult = $root.release_policy_api.ComputeResultDataSource.fromObject(t.computeResult);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.dataset != null && t.hasOwnProperty("dataset") && (r.dataset = $root.release_policy_api.DatasetDataSource.toObject(t.dataset, n), n.oneofs && (r.kind = "dataset")), t.computeResult != null && t.hasOwnProperty("computeResult") && (r.computeResult = $root.release_policy_api.ComputeResultDataSource.toObject(t.computeResult, n), n.oneofs && (r.kind = "computeResult")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/release_policy_api.DataSource";
    }, o;
  }(), c.DatasetDataSource = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.manifestHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.manifestHash != null && Object.hasOwnProperty.call(e, "manifestHash") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.manifestHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.release_policy_api.DatasetDataSource();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.manifestHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.manifestHash != null && e.hasOwnProperty("manifestHash") && !$util.isString(e.manifestHash) ? "manifestHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.DatasetDataSource)
        return e;
      let t = new $root.release_policy_api.DatasetDataSource();
      return e.manifestHash != null && (t.manifestHash = String(e.manifestHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.manifestHash = ""), e.manifestHash != null && e.hasOwnProperty("manifestHash") && (n.manifestHash = e.manifestHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.DatasetDataSource";
    }, o;
  }(), c.ComputeResultDataSource = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.resultHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.resultHash != null && Object.hasOwnProperty.call(e, "resultHash") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.resultHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.release_policy_api.ComputeResultDataSource();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.resultHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.resultHash != null && e.hasOwnProperty("resultHash") && !$util.isString(e.resultHash) ? "resultHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.ComputeResultDataSource)
        return e;
      let t = new $root.release_policy_api.ComputeResultDataSource();
      return e.resultHash != null && (t.resultHash = String(e.resultHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.resultHash = ""), e.resultHash != null && e.hasOwnProperty("resultHash") && (n.resultHash = e.resultHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.ComputeResultDataSource";
    }, o;
  }(), c;
})(), secret_store_api = $root.secret_store_api = (() => {
  const c = {};
  return c.SecretStoreEntry = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.content = $util.newBuffer([]), o.prototype.state = $util.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.content), e.state != null && Object.hasOwnProperty.call(e, "state") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.state), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.SecretStoreEntry();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.content = e.bytes();
            break;
          }
          case 2: {
            r.state = e.bytes();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.content != null && e.hasOwnProperty("content") && !(e.content && typeof e.content.length == "number" || $util.isString(e.content)) ? "content: buffer expected" : e.state != null && e.hasOwnProperty("state") && !(e.state && typeof e.state.length == "number" || $util.isString(e.state)) ? "state: buffer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.SecretStoreEntry)
        return e;
      let t = new $root.secret_store_api.SecretStoreEntry();
      return e.content != null && (typeof e.content == "string" ? $util.base64.decode(e.content, t.content = $util.newBuffer($util.base64.length(e.content)), 0) : e.content.length >= 0 && (t.content = e.content)), e.state != null && (typeof e.state == "string" ? $util.base64.decode(e.state, t.state = $util.newBuffer($util.base64.length(e.state)), 0) : e.state.length >= 0 && (t.state = e.state)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (t.bytes === String ? n.content = "" : (n.content = [], t.bytes !== Array && (n.content = $util.newBuffer(n.content))), t.bytes === String ? n.state = "" : (n.state = [], t.bytes !== Array && (n.state = $util.newBuffer(n.state)))), e.content != null && e.hasOwnProperty("content") && (n.content = t.bytes === String ? $util.base64.encode(e.content, 0, e.content.length) : t.bytes === Array ? Array.prototype.slice.call(e.content) : e.content), e.state != null && e.hasOwnProperty("state") && (n.state = t.bytes === String ? $util.base64.encode(e.state, 0, e.state.length) : t.bytes === Array ? Array.prototype.slice.call(e.state) : e.state), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.SecretStoreEntry";
    }, o;
  }(), c.CreateSecretRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.secret = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.secret != null && Object.hasOwnProperty.call(e, "secret") && $root.secret_store_api.SecretStoreEntry.encode(e.secret, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.CreateSecretRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.secret = $root.secret_store_api.SecretStoreEntry.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secret != null && e.hasOwnProperty("secret")) {
        let t = $root.secret_store_api.SecretStoreEntry.verify(e.secret);
        if (t)
          return "secret." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.CreateSecretRequest)
        return e;
      let t = new $root.secret_store_api.CreateSecretRequest();
      if (e.secret != null) {
        if (typeof e.secret != "object")
          throw TypeError(".secret_store_api.CreateSecretRequest.secret: object expected");
        t.secret = $root.secret_store_api.SecretStoreEntry.fromObject(e.secret);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.secret = null), e.secret != null && e.hasOwnProperty("secret") && (n.secret = $root.secret_store_api.SecretStoreEntry.toObject(e.secret, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.CreateSecretRequest";
    }, o;
  }(), c.CreateSecretResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.CreateSecretResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.CreateSecretResponse)
        return e;
      let t = new $root.secret_store_api.CreateSecretResponse();
      return e.id != null && (t.id = String(e.id)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.CreateSecretResponse";
    }, o;
  }(), c.GetSecretRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.version = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.version != null && Object.hasOwnProperty.call(e, "version") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.version), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.GetSecretRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.version = e.uint32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.GetSecretRequest)
        return e;
      let t = new $root.secret_store_api.GetSecretRequest();
      return e.id != null && (t.id = String(e.id)), e.version != null && (t.version = e.version >>> 0), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = "", n.version = 0), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.version != null && e.hasOwnProperty("version") && (n.version = e.version), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.GetSecretRequest";
    }, o;
  }(), c.GetSecretResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.secret = null, o.prototype.casIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.secret != null && Object.hasOwnProperty.call(e, "secret") && $root.secret_store_api.SecretStoreEntry.encode(e.secret, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.casIndex != null && Object.hasOwnProperty.call(e, "casIndex") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.casIndex), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.GetSecretResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.secret = $root.secret_store_api.SecretStoreEntry.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.casIndex = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secret != null && e.hasOwnProperty("secret")) {
        let t = $root.secret_store_api.SecretStoreEntry.verify(e.secret);
        if (t)
          return "secret." + t;
      }
      return e.casIndex != null && e.hasOwnProperty("casIndex") && !$util.isInteger(e.casIndex) && !(e.casIndex && $util.isInteger(e.casIndex.low) && $util.isInteger(e.casIndex.high)) ? "casIndex: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.GetSecretResponse)
        return e;
      let t = new $root.secret_store_api.GetSecretResponse();
      if (e.secret != null) {
        if (typeof e.secret != "object")
          throw TypeError(".secret_store_api.GetSecretResponse.secret: object expected");
        t.secret = $root.secret_store_api.SecretStoreEntry.fromObject(e.secret);
      }
      return e.casIndex != null && ($util.Long ? (t.casIndex = $util.Long.fromValue(e.casIndex)).unsigned = !0 : typeof e.casIndex == "string" ? t.casIndex = parseInt(e.casIndex, 10) : typeof e.casIndex == "number" ? t.casIndex = e.casIndex : typeof e.casIndex == "object" && (t.casIndex = new $util.LongBits(e.casIndex.low >>> 0, e.casIndex.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if (n.secret = null, $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.casIndex = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.casIndex = t.longs === String ? "0" : 0;
      return e.secret != null && e.hasOwnProperty("secret") && (n.secret = $root.secret_store_api.SecretStoreEntry.toObject(e.secret, t)), e.casIndex != null && e.hasOwnProperty("casIndex") && (typeof e.casIndex == "number" ? n.casIndex = t.longs === String ? String(e.casIndex) : e.casIndex : n.casIndex = t.longs === String ? $util.Long.prototype.toString.call(e.casIndex) : t.longs === Number ? new $util.LongBits(e.casIndex.low >>> 0, e.casIndex.high >>> 0).toNumber(!0) : e.casIndex), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.GetSecretResponse";
    }, o;
  }(), c.RemoveSecretRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.expectedCasIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.expectedCasIndex != null && Object.hasOwnProperty.call(e, "expectedCasIndex") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.expectedCasIndex), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.RemoveSecretRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.expectedCasIndex = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && !$util.isInteger(e.expectedCasIndex) && !(e.expectedCasIndex && $util.isInteger(e.expectedCasIndex.low) && $util.isInteger(e.expectedCasIndex.high)) ? "expectedCasIndex: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.RemoveSecretRequest)
        return e;
      let t = new $root.secret_store_api.RemoveSecretRequest();
      return e.id != null && (t.id = String(e.id)), e.expectedCasIndex != null && ($util.Long ? (t.expectedCasIndex = $util.Long.fromValue(e.expectedCasIndex)).unsigned = !0 : typeof e.expectedCasIndex == "string" ? t.expectedCasIndex = parseInt(e.expectedCasIndex, 10) : typeof e.expectedCasIndex == "number" ? t.expectedCasIndex = e.expectedCasIndex : typeof e.expectedCasIndex == "object" && (t.expectedCasIndex = new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if (n.id = "", $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.expectedCasIndex = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.expectedCasIndex = t.longs === String ? "0" : 0;
      return e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && (typeof e.expectedCasIndex == "number" ? n.expectedCasIndex = t.longs === String ? String(e.expectedCasIndex) : e.expectedCasIndex : n.expectedCasIndex = t.longs === String ? $util.Long.prototype.toString.call(e.expectedCasIndex) : t.longs === Number ? new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0) : e.expectedCasIndex), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.RemoveSecretRequest";
    }, o;
  }(), c.RemoveSecretResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.removed = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.removed != null && Object.hasOwnProperty.call(e, "removed") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.removed), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.RemoveSecretResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.removed = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.removed != null && e.hasOwnProperty("removed") && typeof e.removed != "boolean" ? "removed: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.RemoveSecretResponse)
        return e;
      let t = new $root.secret_store_api.RemoveSecretResponse();
      return e.removed != null && (t.removed = !!e.removed), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.removed = !1), e.removed != null && e.hasOwnProperty("removed") && (n.removed = e.removed), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.RemoveSecretResponse";
    }, o;
  }(), c.UpdateSecretAclRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.newAcl = $util.newBuffer([]), o.prototype.version = 0, o.prototype.expectedCasIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.newAcl != null && Object.hasOwnProperty.call(e, "newAcl") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.newAcl), e.version != null && Object.hasOwnProperty.call(e, "version") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.version), e.expectedCasIndex != null && Object.hasOwnProperty.call(e, "expectedCasIndex") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).uint64(e.expectedCasIndex), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.UpdateSecretAclRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.newAcl = e.bytes();
            break;
          }
          case 3: {
            r.version = e.uint32();
            break;
          }
          case 4: {
            r.expectedCasIndex = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.newAcl != null && e.hasOwnProperty("newAcl") && !(e.newAcl && typeof e.newAcl.length == "number" || $util.isString(e.newAcl)) ? "newAcl: buffer expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && !$util.isInteger(e.expectedCasIndex) && !(e.expectedCasIndex && $util.isInteger(e.expectedCasIndex.low) && $util.isInteger(e.expectedCasIndex.high)) ? "expectedCasIndex: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.UpdateSecretAclRequest)
        return e;
      let t = new $root.secret_store_api.UpdateSecretAclRequest();
      return e.id != null && (t.id = String(e.id)), e.newAcl != null && (typeof e.newAcl == "string" ? $util.base64.decode(e.newAcl, t.newAcl = $util.newBuffer($util.base64.length(e.newAcl)), 0) : e.newAcl.length >= 0 && (t.newAcl = e.newAcl)), e.version != null && (t.version = e.version >>> 0), e.expectedCasIndex != null && ($util.Long ? (t.expectedCasIndex = $util.Long.fromValue(e.expectedCasIndex)).unsigned = !0 : typeof e.expectedCasIndex == "string" ? t.expectedCasIndex = parseInt(e.expectedCasIndex, 10) : typeof e.expectedCasIndex == "number" ? t.expectedCasIndex = e.expectedCasIndex : typeof e.expectedCasIndex == "object" && (t.expectedCasIndex = new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if (n.id = "", t.bytes === String ? n.newAcl = "" : (n.newAcl = [], t.bytes !== Array && (n.newAcl = $util.newBuffer(n.newAcl))), n.version = 0, $util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.expectedCasIndex = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.expectedCasIndex = t.longs === String ? "0" : 0;
      return e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.newAcl != null && e.hasOwnProperty("newAcl") && (n.newAcl = t.bytes === String ? $util.base64.encode(e.newAcl, 0, e.newAcl.length) : t.bytes === Array ? Array.prototype.slice.call(e.newAcl) : e.newAcl), e.version != null && e.hasOwnProperty("version") && (n.version = e.version), e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && (typeof e.expectedCasIndex == "number" ? n.expectedCasIndex = t.longs === String ? String(e.expectedCasIndex) : e.expectedCasIndex : n.expectedCasIndex = t.longs === String ? $util.Long.prototype.toString.call(e.expectedCasIndex) : t.longs === Number ? new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0) : e.expectedCasIndex), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.UpdateSecretAclRequest";
    }, o;
  }(), c.UpdateSecretAclResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.updated = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.updated != null && Object.hasOwnProperty.call(e, "updated") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.updated), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.secret_store_api.UpdateSecretAclResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.updated = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.updated != null && e.hasOwnProperty("updated") && typeof e.updated != "boolean" ? "updated: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.UpdateSecretAclResponse)
        return e;
      let t = new $root.secret_store_api.UpdateSecretAclResponse();
      return e.updated != null && (t.updated = !!e.updated), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.updated = !1), e.updated != null && e.hasOwnProperty("updated") && (n.updated = e.updated), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.UpdateSecretAclResponse";
    }, o;
  }(), c.SecretStoreRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.createSecret = null, o.prototype.getSecret = null, o.prototype.removeSecret = null, o.prototype.updateSecretAcl = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["createSecret", "getSecret", "removeSecret", "updateSecretAcl"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.createSecret != null && Object.hasOwnProperty.call(t, "createSecret") && $root.secret_store_api.CreateSecretRequest.encode(t.createSecret, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.getSecret != null && Object.hasOwnProperty.call(t, "getSecret") && $root.secret_store_api.GetSecretRequest.encode(t.getSecret, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.removeSecret != null && Object.hasOwnProperty.call(t, "removeSecret") && $root.secret_store_api.RemoveSecretRequest.encode(t.removeSecret, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.updateSecretAcl != null && Object.hasOwnProperty.call(t, "updateSecretAcl") && $root.secret_store_api.UpdateSecretAclRequest.encode(t.updateSecretAcl, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.secret_store_api.SecretStoreRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.createSecret = $root.secret_store_api.CreateSecretRequest.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.getSecret = $root.secret_store_api.GetSecretRequest.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.removeSecret = $root.secret_store_api.RemoveSecretRequest.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.createSecret != null && t.hasOwnProperty("createSecret")) {
        n.request = 1;
        {
          let r = $root.secret_store_api.CreateSecretRequest.verify(t.createSecret);
          if (r)
            return "createSecret." + r;
        }
      }
      if (t.getSecret != null && t.hasOwnProperty("getSecret")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.secret_store_api.GetSecretRequest.verify(t.getSecret);
          if (r)
            return "getSecret." + r;
        }
      }
      if (t.removeSecret != null && t.hasOwnProperty("removeSecret")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.secret_store_api.RemoveSecretRequest.verify(t.removeSecret);
          if (r)
            return "removeSecret." + r;
        }
      }
      if (t.updateSecretAcl != null && t.hasOwnProperty("updateSecretAcl")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.secret_store_api.UpdateSecretAclRequest.verify(t.updateSecretAcl);
          if (r)
            return "updateSecretAcl." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.secret_store_api.SecretStoreRequest)
        return t;
      let n = new $root.secret_store_api.SecretStoreRequest();
      if (t.createSecret != null) {
        if (typeof t.createSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.createSecret: object expected");
        n.createSecret = $root.secret_store_api.CreateSecretRequest.fromObject(t.createSecret);
      }
      if (t.getSecret != null) {
        if (typeof t.getSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.getSecret: object expected");
        n.getSecret = $root.secret_store_api.GetSecretRequest.fromObject(t.getSecret);
      }
      if (t.removeSecret != null) {
        if (typeof t.removeSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.removeSecret: object expected");
        n.removeSecret = $root.secret_store_api.RemoveSecretRequest.fromObject(t.removeSecret);
      }
      if (t.updateSecretAcl != null) {
        if (typeof t.updateSecretAcl != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.updateSecretAcl: object expected");
        n.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.fromObject(t.updateSecretAcl);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.createSecret != null && t.hasOwnProperty("createSecret") && (r.createSecret = $root.secret_store_api.CreateSecretRequest.toObject(t.createSecret, n), n.oneofs && (r.request = "createSecret")), t.getSecret != null && t.hasOwnProperty("getSecret") && (r.getSecret = $root.secret_store_api.GetSecretRequest.toObject(t.getSecret, n), n.oneofs && (r.request = "getSecret")), t.removeSecret != null && t.hasOwnProperty("removeSecret") && (r.removeSecret = $root.secret_store_api.RemoveSecretRequest.toObject(t.removeSecret, n), n.oneofs && (r.request = "removeSecret")), t.updateSecretAcl != null && t.hasOwnProperty("updateSecretAcl") && (r.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.toObject(t.updateSecretAcl, n), n.oneofs && (r.request = "updateSecretAcl")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/secret_store_api.SecretStoreRequest";
    }, o;
  }(), c.SecretStoreResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.createSecret = null, o.prototype.getSecret = null, o.prototype.removeSecret = null, o.prototype.updateSecretAcl = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["createSecret", "getSecret", "removeSecret", "updateSecretAcl"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.createSecret != null && Object.hasOwnProperty.call(t, "createSecret") && $root.secret_store_api.CreateSecretResponse.encode(t.createSecret, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.getSecret != null && Object.hasOwnProperty.call(t, "getSecret") && $root.secret_store_api.GetSecretResponse.encode(t.getSecret, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.removeSecret != null && Object.hasOwnProperty.call(t, "removeSecret") && $root.secret_store_api.RemoveSecretResponse.encode(t.removeSecret, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.updateSecretAcl != null && Object.hasOwnProperty.call(t, "updateSecretAcl") && $root.secret_store_api.UpdateSecretAclResponse.encode(t.updateSecretAcl, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.secret_store_api.SecretStoreResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.createSecret = $root.secret_store_api.CreateSecretResponse.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.getSecret = $root.secret_store_api.GetSecretResponse.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.removeSecret = $root.secret_store_api.RemoveSecretResponse.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.createSecret != null && t.hasOwnProperty("createSecret")) {
        n.response = 1;
        {
          let r = $root.secret_store_api.CreateSecretResponse.verify(t.createSecret);
          if (r)
            return "createSecret." + r;
        }
      }
      if (t.getSecret != null && t.hasOwnProperty("getSecret")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.secret_store_api.GetSecretResponse.verify(t.getSecret);
          if (r)
            return "getSecret." + r;
        }
      }
      if (t.removeSecret != null && t.hasOwnProperty("removeSecret")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.secret_store_api.RemoveSecretResponse.verify(t.removeSecret);
          if (r)
            return "removeSecret." + r;
        }
      }
      if (t.updateSecretAcl != null && t.hasOwnProperty("updateSecretAcl")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.secret_store_api.UpdateSecretAclResponse.verify(t.updateSecretAcl);
          if (r)
            return "updateSecretAcl." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.secret_store_api.SecretStoreResponse)
        return t;
      let n = new $root.secret_store_api.SecretStoreResponse();
      if (t.createSecret != null) {
        if (typeof t.createSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.createSecret: object expected");
        n.createSecret = $root.secret_store_api.CreateSecretResponse.fromObject(t.createSecret);
      }
      if (t.getSecret != null) {
        if (typeof t.getSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.getSecret: object expected");
        n.getSecret = $root.secret_store_api.GetSecretResponse.fromObject(t.getSecret);
      }
      if (t.removeSecret != null) {
        if (typeof t.removeSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.removeSecret: object expected");
        n.removeSecret = $root.secret_store_api.RemoveSecretResponse.fromObject(t.removeSecret);
      }
      if (t.updateSecretAcl != null) {
        if (typeof t.updateSecretAcl != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.updateSecretAcl: object expected");
        n.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.fromObject(t.updateSecretAcl);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.createSecret != null && t.hasOwnProperty("createSecret") && (r.createSecret = $root.secret_store_api.CreateSecretResponse.toObject(t.createSecret, n), n.oneofs && (r.response = "createSecret")), t.getSecret != null && t.hasOwnProperty("getSecret") && (r.getSecret = $root.secret_store_api.GetSecretResponse.toObject(t.getSecret, n), n.oneofs && (r.response = "getSecret")), t.removeSecret != null && t.hasOwnProperty("removeSecret") && (r.removeSecret = $root.secret_store_api.RemoveSecretResponse.toObject(t.removeSecret, n), n.oneofs && (r.response = "removeSecret")), t.updateSecretAcl != null && t.hasOwnProperty("updateSecretAcl") && (r.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.toObject(t.updateSecretAcl, n), n.oneofs && (r.response = "updateSecretAcl")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/secret_store_api.SecretStoreResponse";
    }, o;
  }(), c;
})(), google_ad_manager = $root.google_ad_manager = (() => {
  const c = {};
  return c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_ad_manager.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.google_ad_manager.SingleFile)
        return e;
      let t = new $root.google_ad_manager.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_ad_manager.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.google_ad_manager.RawFile ? e : new $root.google_ad_manager.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.google_ad_manager.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.google_ad_manager.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.google_ad_manager.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.google_ad_manager.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.google_ad_manager.ZipFile)
        return t;
      let n = new $root.google_ad_manager.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".google_ad_manager.ZipFile.singleFile: object expected");
        n.singleFile = $root.google_ad_manager.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.google_ad_manager.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/google_ad_manager.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.google_ad_manager.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.google_ad_manager.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.google_ad_manager.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.google_ad_manager.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.google_ad_manager.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.google_ad_manager.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.google_ad_manager.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.google_ad_manager.SinkInput)
        return t;
      let n = new $root.google_ad_manager.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".google_ad_manager.SinkInput.raw: object expected");
        n.raw = $root.google_ad_manager.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".google_ad_manager.SinkInput.zip: object expected");
        n.zip = $root.google_ad_manager.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.google_ad_manager.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.google_ad_manager.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/google_ad_manager.SinkInput";
    }, o;
  }(), c.GoogleAdManagerWorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.prototype.credentialsDependency = "", o.prototype.identifierKind = "", o.prototype.listId = "", o.prototype.inputHasHeaders = !1, o.prototype.bucket = "", o.prototype.objectName = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.google_ad_manager.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.identifierKind != null && Object.hasOwnProperty.call(e, "identifierKind") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.identifierKind), e.listId != null && Object.hasOwnProperty.call(e, "listId") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.listId), e.inputHasHeaders != null && Object.hasOwnProperty.call(e, "inputHasHeaders") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.inputHasHeaders), e.bucket != null && Object.hasOwnProperty.call(e, "bucket") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.bucket), e.objectName != null && Object.hasOwnProperty.call(e, "objectName") && t.uint32(
        /* id 7, wireType 2 =*/
        58
      ).string(e.objectName), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_ad_manager.GoogleAdManagerWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.google_ad_manager.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.credentialsDependency = e.string();
            break;
          }
          case 3: {
            r.identifierKind = e.string();
            break;
          }
          case 4: {
            r.listId = e.string();
            break;
          }
          case 5: {
            r.inputHasHeaders = e.bool();
            break;
          }
          case 6: {
            r.bucket = e.string();
            break;
          }
          case 7: {
            r.objectName = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.google_ad_manager.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : e.identifierKind != null && e.hasOwnProperty("identifierKind") && !$util.isString(e.identifierKind) ? "identifierKind: string expected" : e.listId != null && e.hasOwnProperty("listId") && !$util.isString(e.listId) ? "listId: string expected" : e.inputHasHeaders != null && e.hasOwnProperty("inputHasHeaders") && typeof e.inputHasHeaders != "boolean" ? "inputHasHeaders: boolean expected" : e.bucket != null && e.hasOwnProperty("bucket") && !$util.isString(e.bucket) ? "bucket: string expected" : e.objectName != null && e.hasOwnProperty("objectName") && !$util.isString(e.objectName) ? "objectName: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.google_ad_manager.GoogleAdManagerWorkerConfiguration)
        return e;
      let t = new $root.google_ad_manager.GoogleAdManagerWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".google_ad_manager.GoogleAdManagerWorkerConfiguration.input: object expected");
        t.input = $root.google_ad_manager.SinkInput.fromObject(e.input);
      }
      return e.credentialsDependency != null && (t.credentialsDependency = String(e.credentialsDependency)), e.identifierKind != null && (t.identifierKind = String(e.identifierKind)), e.listId != null && (t.listId = String(e.listId)), e.inputHasHeaders != null && (t.inputHasHeaders = !!e.inputHasHeaders), e.bucket != null && (t.bucket = String(e.bucket)), e.objectName != null && (t.objectName = String(e.objectName)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null, n.credentialsDependency = "", n.identifierKind = "", n.listId = "", n.inputHasHeaders = !1, n.bucket = "", n.objectName = ""), e.input != null && e.hasOwnProperty("input") && (n.input = $root.google_ad_manager.SinkInput.toObject(e.input, t)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (n.credentialsDependency = e.credentialsDependency), e.identifierKind != null && e.hasOwnProperty("identifierKind") && (n.identifierKind = e.identifierKind), e.listId != null && e.hasOwnProperty("listId") && (n.listId = e.listId), e.inputHasHeaders != null && e.hasOwnProperty("inputHasHeaders") && (n.inputHasHeaders = e.inputHasHeaders), e.bucket != null && e.hasOwnProperty("bucket") && (n.bucket = e.bucket), e.objectName != null && e.hasOwnProperty("objectName") && (n.objectName = e.objectName), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.GoogleAdManagerWorkerConfiguration";
    }, o;
  }(), c;
})(), google_dv_360_sink = $root.google_dv_360_sink = (() => {
  const c = {};
  return c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_dv_360_sink.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.google_dv_360_sink.SingleFile)
        return e;
      let t = new $root.google_dv_360_sink.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_dv_360_sink.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.google_dv_360_sink.RawFile ? e : new $root.google_dv_360_sink.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.google_dv_360_sink.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.google_dv_360_sink.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.google_dv_360_sink.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.google_dv_360_sink.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.google_dv_360_sink.ZipFile)
        return t;
      let n = new $root.google_dv_360_sink.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".google_dv_360_sink.ZipFile.singleFile: object expected");
        n.singleFile = $root.google_dv_360_sink.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.google_dv_360_sink.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/google_dv_360_sink.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.google_dv_360_sink.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.google_dv_360_sink.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.google_dv_360_sink.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.google_dv_360_sink.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.google_dv_360_sink.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.google_dv_360_sink.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.google_dv_360_sink.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.google_dv_360_sink.SinkInput)
        return t;
      let n = new $root.google_dv_360_sink.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".google_dv_360_sink.SinkInput.raw: object expected");
        n.raw = $root.google_dv_360_sink.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".google_dv_360_sink.SinkInput.zip: object expected");
        n.zip = $root.google_dv_360_sink.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.google_dv_360_sink.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.google_dv_360_sink.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/google_dv_360_sink.SinkInput";
    }, o;
  }(), c.GoogleDv360SinkWorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.prototype.credentialsDependency = "", o.prototype.advertiserId = "", o.prototype.displayName = "", o.prototype.description = "", o.prototype.membershipDurationDays = "", o.prototype.userConsentGiven = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.google_dv_360_sink.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.advertiserId != null && Object.hasOwnProperty.call(e, "advertiserId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.advertiserId), e.displayName != null && Object.hasOwnProperty.call(e, "displayName") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.displayName), e.description != null && Object.hasOwnProperty.call(e, "description") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.description), e.membershipDurationDays != null && Object.hasOwnProperty.call(e, "membershipDurationDays") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.membershipDurationDays), e.userConsentGiven != null && Object.hasOwnProperty.call(e, "userConsentGiven") && t.uint32(
        /* id 7, wireType 0 =*/
        56
      ).bool(e.userConsentGiven), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.google_dv_360_sink.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.credentialsDependency = e.string();
            break;
          }
          case 3: {
            r.advertiserId = e.string();
            break;
          }
          case 4: {
            r.displayName = e.string();
            break;
          }
          case 5: {
            r.description = e.string();
            break;
          }
          case 6: {
            r.membershipDurationDays = e.string();
            break;
          }
          case 7: {
            r.userConsentGiven = e.bool();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.google_dv_360_sink.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : e.advertiserId != null && e.hasOwnProperty("advertiserId") && !$util.isString(e.advertiserId) ? "advertiserId: string expected" : e.displayName != null && e.hasOwnProperty("displayName") && !$util.isString(e.displayName) ? "displayName: string expected" : e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description) ? "description: string expected" : e.membershipDurationDays != null && e.hasOwnProperty("membershipDurationDays") && !$util.isString(e.membershipDurationDays) ? "membershipDurationDays: string expected" : e.userConsentGiven != null && e.hasOwnProperty("userConsentGiven") && typeof e.userConsentGiven != "boolean" ? "userConsentGiven: boolean expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration)
        return e;
      let t = new $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".google_dv_360_sink.GoogleDv360SinkWorkerConfiguration.input: object expected");
        t.input = $root.google_dv_360_sink.SinkInput.fromObject(e.input);
      }
      return e.credentialsDependency != null && (t.credentialsDependency = String(e.credentialsDependency)), e.advertiserId != null && (t.advertiserId = String(e.advertiserId)), e.displayName != null && (t.displayName = String(e.displayName)), e.description != null && (t.description = String(e.description)), e.membershipDurationDays != null && (t.membershipDurationDays = String(e.membershipDurationDays)), e.userConsentGiven != null && (t.userConsentGiven = !!e.userConsentGiven), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null, n.credentialsDependency = "", n.advertiserId = "", n.displayName = "", n.description = "", n.membershipDurationDays = "", n.userConsentGiven = !1), e.input != null && e.hasOwnProperty("input") && (n.input = $root.google_dv_360_sink.SinkInput.toObject(e.input, t)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (n.credentialsDependency = e.credentialsDependency), e.advertiserId != null && e.hasOwnProperty("advertiserId") && (n.advertiserId = e.advertiserId), e.displayName != null && e.hasOwnProperty("displayName") && (n.displayName = e.displayName), e.description != null && e.hasOwnProperty("description") && (n.description = e.description), e.membershipDurationDays != null && e.hasOwnProperty("membershipDurationDays") && (n.membershipDurationDays = e.membershipDurationDays), e.userConsentGiven != null && e.hasOwnProperty("userConsentGiven") && (n.userConsentGiven = e.userConsentGiven), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.GoogleDv360SinkWorkerConfiguration";
    }, o;
  }(), c;
})(), meta_sink = $root.meta_sink = (() => {
  const c = {};
  return c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.meta_sink.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.meta_sink.SingleFile)
        return e;
      let t = new $root.meta_sink.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/meta_sink.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.meta_sink.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.meta_sink.RawFile ? e : new $root.meta_sink.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/meta_sink.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.meta_sink.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.meta_sink.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.meta_sink.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.meta_sink.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.meta_sink.ZipFile)
        return t;
      let n = new $root.meta_sink.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".meta_sink.ZipFile.singleFile: object expected");
        n.singleFile = $root.meta_sink.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.meta_sink.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/meta_sink.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.meta_sink.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.meta_sink.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.meta_sink.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.meta_sink.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.meta_sink.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.meta_sink.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.meta_sink.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.meta_sink.SinkInput)
        return t;
      let n = new $root.meta_sink.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".meta_sink.SinkInput.raw: object expected");
        n.raw = $root.meta_sink.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".meta_sink.SinkInput.zip: object expected");
        n.zip = $root.meta_sink.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.meta_sink.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.meta_sink.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/meta_sink.SinkInput";
    }, o;
  }(), c.MetaSinkWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.input = null, o.prototype.accessTokenDependency = "", o.prototype.adAccountId = "", o.prototype.audienceName = "", o.prototype.apiVersion = null;
    let i;
    return Object.defineProperty(o.prototype, "_apiVersion", {
      get: $util.oneOfGetter(i = ["apiVersion"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.input != null && Object.hasOwnProperty.call(t, "input") && $root.meta_sink.SinkInput.encode(t.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.accessTokenDependency != null && Object.hasOwnProperty.call(t, "accessTokenDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.accessTokenDependency), t.adAccountId != null && Object.hasOwnProperty.call(t, "adAccountId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.adAccountId), t.audienceName != null && Object.hasOwnProperty.call(t, "audienceName") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.audienceName), t.apiVersion != null && Object.hasOwnProperty.call(t, "apiVersion") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.apiVersion), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.meta_sink.MetaSinkWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.input = $root.meta_sink.SinkInput.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.accessTokenDependency = t.string();
            break;
          }
          case 3: {
            u.adAccountId = t.string();
            break;
          }
          case 4: {
            u.audienceName = t.string();
            break;
          }
          case 5: {
            u.apiVersion = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.input != null && t.hasOwnProperty("input")) {
        let n = $root.meta_sink.SinkInput.verify(t.input);
        if (n)
          return "input." + n;
      }
      return t.accessTokenDependency != null && t.hasOwnProperty("accessTokenDependency") && !$util.isString(t.accessTokenDependency) ? "accessTokenDependency: string expected" : t.adAccountId != null && t.hasOwnProperty("adAccountId") && !$util.isString(t.adAccountId) ? "adAccountId: string expected" : t.audienceName != null && t.hasOwnProperty("audienceName") && !$util.isString(t.audienceName) ? "audienceName: string expected" : t.apiVersion != null && t.hasOwnProperty("apiVersion") && !$util.isString(t.apiVersion) ? "apiVersion: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.meta_sink.MetaSinkWorkerConfiguration)
        return t;
      let n = new $root.meta_sink.MetaSinkWorkerConfiguration();
      if (t.input != null) {
        if (typeof t.input != "object")
          throw TypeError(".meta_sink.MetaSinkWorkerConfiguration.input: object expected");
        n.input = $root.meta_sink.SinkInput.fromObject(t.input);
      }
      return t.accessTokenDependency != null && (n.accessTokenDependency = String(t.accessTokenDependency)), t.adAccountId != null && (n.adAccountId = String(t.adAccountId)), t.audienceName != null && (n.audienceName = String(t.audienceName)), t.apiVersion != null && (n.apiVersion = String(t.apiVersion)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.input = null, r.accessTokenDependency = "", r.adAccountId = "", r.audienceName = ""), t.input != null && t.hasOwnProperty("input") && (r.input = $root.meta_sink.SinkInput.toObject(t.input, n)), t.accessTokenDependency != null && t.hasOwnProperty("accessTokenDependency") && (r.accessTokenDependency = t.accessTokenDependency), t.adAccountId != null && t.hasOwnProperty("adAccountId") && (r.adAccountId = t.adAccountId), t.audienceName != null && t.hasOwnProperty("audienceName") && (r.audienceName = t.audienceName), t.apiVersion != null && t.hasOwnProperty("apiVersion") && (r.apiVersion = t.apiVersion, n.oneofs && (r._apiVersion = "apiVersion")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/meta_sink.MetaSinkWorkerConfiguration";
    }, o;
  }(), c;
})(), metering = $root.metering = (() => {
  const c = {};
  return c.EnclaveInfo = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.attestationSpecHashHex = "", o.prototype.taskQueueName = null;
    let i;
    return Object.defineProperty(o.prototype, "_taskQueueName", {
      get: $util.oneOfGetter(i = ["taskQueueName"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.attestationSpecHashHex != null && Object.hasOwnProperty.call(t, "attestationSpecHashHex") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.attestationSpecHashHex), t.taskQueueName != null && Object.hasOwnProperty.call(t, "taskQueueName") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.taskQueueName), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.EnclaveInfo();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.attestationSpecHashHex = t.string();
            break;
          }
          case 2: {
            u.taskQueueName = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.attestationSpecHashHex != null && t.hasOwnProperty("attestationSpecHashHex") && !$util.isString(t.attestationSpecHashHex) ? "attestationSpecHashHex: string expected" : t.taskQueueName != null && t.hasOwnProperty("taskQueueName") && !$util.isString(t.taskQueueName) ? "taskQueueName: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.EnclaveInfo)
        return t;
      let n = new $root.metering.EnclaveInfo();
      return t.attestationSpecHashHex != null && (n.attestationSpecHashHex = String(t.attestationSpecHashHex)), t.taskQueueName != null && (n.taskQueueName = String(t.taskQueueName)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.attestationSpecHashHex = ""), t.attestationSpecHashHex != null && t.hasOwnProperty("attestationSpecHashHex") && (r.attestationSpecHashHex = t.attestationSpecHashHex), t.taskQueueName != null && t.hasOwnProperty("taskQueueName") && (r.taskQueueName = t.taskQueueName, n.oneofs && (r._taskQueueName = "taskQueueName")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.EnclaveInfo";
    }, o;
  }(), c.MeteringRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.createDcr = null, o.prototype.createDcrCommit = null, o.prototype.stopDcr = null, o.prototype.publishDataset = null, o.prototype.unpublishDataset = null, o.prototype.workerMetadata = null, o.prototype.submitWorkerExecutionTime = null, o.prototype.dcrInteraction = null, o.prototype.createDataset = null, o.prototype.getOrCreateDatasetScope = null, o.prototype.mergeDcrCommit = null, o.prototype.getDataConnectorCredentials = null, o.prototype.integrityStore = null, o.prototype.getAzureCommunicationCredentials = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["createDcr", "createDcrCommit", "stopDcr", "publishDataset", "unpublishDataset", "workerMetadata", "submitWorkerExecutionTime", "dcrInteraction", "createDataset", "getOrCreateDatasetScope", "mergeDcrCommit", "getDataConnectorCredentials", "integrityStore", "getAzureCommunicationCredentials"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.createDcr != null && Object.hasOwnProperty.call(t, "createDcr") && $root.metering.CreateDcrRequest.encode(t.createDcr, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.createDcrCommit != null && Object.hasOwnProperty.call(t, "createDcrCommit") && $root.metering.CreateDcrCommitRequest.encode(t.createDcrCommit, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.stopDcr != null && Object.hasOwnProperty.call(t, "stopDcr") && $root.metering.StopDcrRequest.encode(t.stopDcr, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.publishDataset != null && Object.hasOwnProperty.call(t, "publishDataset") && $root.metering.PublishDatasetRequest.encode(t.publishDataset, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.unpublishDataset != null && Object.hasOwnProperty.call(t, "unpublishDataset") && $root.metering.UnpublishDatasetRequest.encode(t.unpublishDataset, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.workerMetadata != null && Object.hasOwnProperty.call(t, "workerMetadata") && $root.metering.WorkerMetadataRequest.encode(t.workerMetadata, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.submitWorkerExecutionTime != null && Object.hasOwnProperty.call(t, "submitWorkerExecutionTime") && $root.metering.SubmitWorkerExecutionTimeRequest.encode(t.submitWorkerExecutionTime, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.dcrInteraction != null && Object.hasOwnProperty.call(t, "dcrInteraction") && $root.metering.DcrInteractionRequest.encode(t.dcrInteraction, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.createDataset != null && Object.hasOwnProperty.call(t, "createDataset") && $root.metering.CreateDatasetRequest.encode(t.createDataset, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.getOrCreateDatasetScope != null && Object.hasOwnProperty.call(t, "getOrCreateDatasetScope") && $root.metering.GetOrCreateDatasetScopeRequest.encode(t.getOrCreateDatasetScope, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), t.mergeDcrCommit != null && Object.hasOwnProperty.call(t, "mergeDcrCommit") && $root.metering.MergeDcrCommitRequest.encode(t.mergeDcrCommit, n.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), t.getDataConnectorCredentials != null && Object.hasOwnProperty.call(t, "getDataConnectorCredentials") && $root.metering.GetDataConnectorCredentialsRequest.encode(t.getDataConnectorCredentials, n.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), t.integrityStore != null && Object.hasOwnProperty.call(t, "integrityStore") && $root.integrity_store_api.IntegrityStoreRequest.encode(t.integrityStore, n.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), t.getAzureCommunicationCredentials != null && Object.hasOwnProperty.call(t, "getAzureCommunicationCredentials") && $root.metering.GetAzureCommunicationCredentialsRequest.encode(t.getAzureCommunicationCredentials, n.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.MeteringRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.createDcr = $root.metering.CreateDcrRequest.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.createDcrCommit = $root.metering.CreateDcrCommitRequest.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.stopDcr = $root.metering.StopDcrRequest.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.publishDataset = $root.metering.PublishDatasetRequest.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.unpublishDataset = $root.metering.UnpublishDatasetRequest.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.workerMetadata = $root.metering.WorkerMetadataRequest.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.dcrInteraction = $root.metering.DcrInteractionRequest.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.createDataset = $root.metering.CreateDatasetRequest.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.decode(t, t.uint32());
            break;
          }
          case 11: {
            u.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.decode(t, t.uint32());
            break;
          }
          case 12: {
            u.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.decode(t, t.uint32());
            break;
          }
          case 13: {
            u.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.decode(t, t.uint32());
            break;
          }
          case 14: {
            u.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.createDcr != null && t.hasOwnProperty("createDcr")) {
        n.request = 1;
        {
          let r = $root.metering.CreateDcrRequest.verify(t.createDcr);
          if (r)
            return "createDcr." + r;
        }
      }
      if (t.createDcrCommit != null && t.hasOwnProperty("createDcrCommit")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.CreateDcrCommitRequest.verify(t.createDcrCommit);
          if (r)
            return "createDcrCommit." + r;
        }
      }
      if (t.stopDcr != null && t.hasOwnProperty("stopDcr")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.StopDcrRequest.verify(t.stopDcr);
          if (r)
            return "stopDcr." + r;
        }
      }
      if (t.publishDataset != null && t.hasOwnProperty("publishDataset")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.PublishDatasetRequest.verify(t.publishDataset);
          if (r)
            return "publishDataset." + r;
        }
      }
      if (t.unpublishDataset != null && t.hasOwnProperty("unpublishDataset")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.UnpublishDatasetRequest.verify(t.unpublishDataset);
          if (r)
            return "unpublishDataset." + r;
        }
      }
      if (t.workerMetadata != null && t.hasOwnProperty("workerMetadata")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.WorkerMetadataRequest.verify(t.workerMetadata);
          if (r)
            return "workerMetadata." + r;
        }
      }
      if (t.submitWorkerExecutionTime != null && t.hasOwnProperty("submitWorkerExecutionTime")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.SubmitWorkerExecutionTimeRequest.verify(t.submitWorkerExecutionTime);
          if (r)
            return "submitWorkerExecutionTime." + r;
        }
      }
      if (t.dcrInteraction != null && t.hasOwnProperty("dcrInteraction")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.DcrInteractionRequest.verify(t.dcrInteraction);
          if (r)
            return "dcrInteraction." + r;
        }
      }
      if (t.createDataset != null && t.hasOwnProperty("createDataset")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.CreateDatasetRequest.verify(t.createDataset);
          if (r)
            return "createDataset." + r;
        }
      }
      if (t.getOrCreateDatasetScope != null && t.hasOwnProperty("getOrCreateDatasetScope")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.GetOrCreateDatasetScopeRequest.verify(t.getOrCreateDatasetScope);
          if (r)
            return "getOrCreateDatasetScope." + r;
        }
      }
      if (t.mergeDcrCommit != null && t.hasOwnProperty("mergeDcrCommit")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.MergeDcrCommitRequest.verify(t.mergeDcrCommit);
          if (r)
            return "mergeDcrCommit." + r;
        }
      }
      if (t.getDataConnectorCredentials != null && t.hasOwnProperty("getDataConnectorCredentials")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.GetDataConnectorCredentialsRequest.verify(t.getDataConnectorCredentials);
          if (r)
            return "getDataConnectorCredentials." + r;
        }
      }
      if (t.integrityStore != null && t.hasOwnProperty("integrityStore")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.integrity_store_api.IntegrityStoreRequest.verify(t.integrityStore);
          if (r)
            return "integrityStore." + r;
        }
      }
      if (t.getAzureCommunicationCredentials != null && t.hasOwnProperty("getAzureCommunicationCredentials")) {
        if (n.request === 1)
          return "request: multiple values";
        n.request = 1;
        {
          let r = $root.metering.GetAzureCommunicationCredentialsRequest.verify(t.getAzureCommunicationCredentials);
          if (r)
            return "getAzureCommunicationCredentials." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.MeteringRequest)
        return t;
      let n = new $root.metering.MeteringRequest();
      if (t.createDcr != null) {
        if (typeof t.createDcr != "object")
          throw TypeError(".metering.MeteringRequest.createDcr: object expected");
        n.createDcr = $root.metering.CreateDcrRequest.fromObject(t.createDcr);
      }
      if (t.createDcrCommit != null) {
        if (typeof t.createDcrCommit != "object")
          throw TypeError(".metering.MeteringRequest.createDcrCommit: object expected");
        n.createDcrCommit = $root.metering.CreateDcrCommitRequest.fromObject(t.createDcrCommit);
      }
      if (t.stopDcr != null) {
        if (typeof t.stopDcr != "object")
          throw TypeError(".metering.MeteringRequest.stopDcr: object expected");
        n.stopDcr = $root.metering.StopDcrRequest.fromObject(t.stopDcr);
      }
      if (t.publishDataset != null) {
        if (typeof t.publishDataset != "object")
          throw TypeError(".metering.MeteringRequest.publishDataset: object expected");
        n.publishDataset = $root.metering.PublishDatasetRequest.fromObject(t.publishDataset);
      }
      if (t.unpublishDataset != null) {
        if (typeof t.unpublishDataset != "object")
          throw TypeError(".metering.MeteringRequest.unpublishDataset: object expected");
        n.unpublishDataset = $root.metering.UnpublishDatasetRequest.fromObject(t.unpublishDataset);
      }
      if (t.workerMetadata != null) {
        if (typeof t.workerMetadata != "object")
          throw TypeError(".metering.MeteringRequest.workerMetadata: object expected");
        n.workerMetadata = $root.metering.WorkerMetadataRequest.fromObject(t.workerMetadata);
      }
      if (t.submitWorkerExecutionTime != null) {
        if (typeof t.submitWorkerExecutionTime != "object")
          throw TypeError(".metering.MeteringRequest.submitWorkerExecutionTime: object expected");
        n.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.fromObject(t.submitWorkerExecutionTime);
      }
      if (t.dcrInteraction != null) {
        if (typeof t.dcrInteraction != "object")
          throw TypeError(".metering.MeteringRequest.dcrInteraction: object expected");
        n.dcrInteraction = $root.metering.DcrInteractionRequest.fromObject(t.dcrInteraction);
      }
      if (t.createDataset != null) {
        if (typeof t.createDataset != "object")
          throw TypeError(".metering.MeteringRequest.createDataset: object expected");
        n.createDataset = $root.metering.CreateDatasetRequest.fromObject(t.createDataset);
      }
      if (t.getOrCreateDatasetScope != null) {
        if (typeof t.getOrCreateDatasetScope != "object")
          throw TypeError(".metering.MeteringRequest.getOrCreateDatasetScope: object expected");
        n.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.fromObject(t.getOrCreateDatasetScope);
      }
      if (t.mergeDcrCommit != null) {
        if (typeof t.mergeDcrCommit != "object")
          throw TypeError(".metering.MeteringRequest.mergeDcrCommit: object expected");
        n.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.fromObject(t.mergeDcrCommit);
      }
      if (t.getDataConnectorCredentials != null) {
        if (typeof t.getDataConnectorCredentials != "object")
          throw TypeError(".metering.MeteringRequest.getDataConnectorCredentials: object expected");
        n.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.fromObject(t.getDataConnectorCredentials);
      }
      if (t.integrityStore != null) {
        if (typeof t.integrityStore != "object")
          throw TypeError(".metering.MeteringRequest.integrityStore: object expected");
        n.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.fromObject(t.integrityStore);
      }
      if (t.getAzureCommunicationCredentials != null) {
        if (typeof t.getAzureCommunicationCredentials != "object")
          throw TypeError(".metering.MeteringRequest.getAzureCommunicationCredentials: object expected");
        n.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.fromObject(t.getAzureCommunicationCredentials);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.createDcr != null && t.hasOwnProperty("createDcr") && (r.createDcr = $root.metering.CreateDcrRequest.toObject(t.createDcr, n), n.oneofs && (r.request = "createDcr")), t.createDcrCommit != null && t.hasOwnProperty("createDcrCommit") && (r.createDcrCommit = $root.metering.CreateDcrCommitRequest.toObject(t.createDcrCommit, n), n.oneofs && (r.request = "createDcrCommit")), t.stopDcr != null && t.hasOwnProperty("stopDcr") && (r.stopDcr = $root.metering.StopDcrRequest.toObject(t.stopDcr, n), n.oneofs && (r.request = "stopDcr")), t.publishDataset != null && t.hasOwnProperty("publishDataset") && (r.publishDataset = $root.metering.PublishDatasetRequest.toObject(t.publishDataset, n), n.oneofs && (r.request = "publishDataset")), t.unpublishDataset != null && t.hasOwnProperty("unpublishDataset") && (r.unpublishDataset = $root.metering.UnpublishDatasetRequest.toObject(t.unpublishDataset, n), n.oneofs && (r.request = "unpublishDataset")), t.workerMetadata != null && t.hasOwnProperty("workerMetadata") && (r.workerMetadata = $root.metering.WorkerMetadataRequest.toObject(t.workerMetadata, n), n.oneofs && (r.request = "workerMetadata")), t.submitWorkerExecutionTime != null && t.hasOwnProperty("submitWorkerExecutionTime") && (r.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.toObject(t.submitWorkerExecutionTime, n), n.oneofs && (r.request = "submitWorkerExecutionTime")), t.dcrInteraction != null && t.hasOwnProperty("dcrInteraction") && (r.dcrInteraction = $root.metering.DcrInteractionRequest.toObject(t.dcrInteraction, n), n.oneofs && (r.request = "dcrInteraction")), t.createDataset != null && t.hasOwnProperty("createDataset") && (r.createDataset = $root.metering.CreateDatasetRequest.toObject(t.createDataset, n), n.oneofs && (r.request = "createDataset")), t.getOrCreateDatasetScope != null && t.hasOwnProperty("getOrCreateDatasetScope") && (r.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.toObject(t.getOrCreateDatasetScope, n), n.oneofs && (r.request = "getOrCreateDatasetScope")), t.mergeDcrCommit != null && t.hasOwnProperty("mergeDcrCommit") && (r.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.toObject(t.mergeDcrCommit, n), n.oneofs && (r.request = "mergeDcrCommit")), t.getDataConnectorCredentials != null && t.hasOwnProperty("getDataConnectorCredentials") && (r.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.toObject(t.getDataConnectorCredentials, n), n.oneofs && (r.request = "getDataConnectorCredentials")), t.integrityStore != null && t.hasOwnProperty("integrityStore") && (r.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.toObject(t.integrityStore, n), n.oneofs && (r.request = "integrityStore")), t.getAzureCommunicationCredentials != null && t.hasOwnProperty("getAzureCommunicationCredentials") && (r.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.toObject(t.getAzureCommunicationCredentials, n), n.oneofs && (r.request = "getAzureCommunicationCredentials")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.MeteringRequest";
    }, o;
  }(), c.MeteringSuccessResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.createDcr = null, o.prototype.createDcrCommit = null, o.prototype.stopDcr = null, o.prototype.publishDataset = null, o.prototype.unpublishDataset = null, o.prototype.workerMetadata = null, o.prototype.submitWorkerExecutionTime = null, o.prototype.dcrInteraction = null, o.prototype.createDataset = null, o.prototype.getOrCreateDatasetScope = null, o.prototype.mergeDcrCommit = null, o.prototype.dataConnectorCredentials = null, o.prototype.integrityStore = null, o.prototype.getAzureCommunicationCredentials = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["createDcr", "createDcrCommit", "stopDcr", "publishDataset", "unpublishDataset", "workerMetadata", "submitWorkerExecutionTime", "dcrInteraction", "createDataset", "getOrCreateDatasetScope", "mergeDcrCommit", "dataConnectorCredentials", "integrityStore", "getAzureCommunicationCredentials"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.createDcr != null && Object.hasOwnProperty.call(t, "createDcr") && $root.metering.CreateDcrResponse.encode(t.createDcr, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.createDcrCommit != null && Object.hasOwnProperty.call(t, "createDcrCommit") && $root.metering.CreateDcrCommitResponse.encode(t.createDcrCommit, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.stopDcr != null && Object.hasOwnProperty.call(t, "stopDcr") && $root.metering.StopDcrResponse.encode(t.stopDcr, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.publishDataset != null && Object.hasOwnProperty.call(t, "publishDataset") && $root.metering.PublishDatasetResponse.encode(t.publishDataset, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t.unpublishDataset != null && Object.hasOwnProperty.call(t, "unpublishDataset") && $root.metering.UnpublishDatasetResponse.encode(t.unpublishDataset, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t.workerMetadata != null && Object.hasOwnProperty.call(t, "workerMetadata") && $root.metering.WorkerMetadataResponse.encode(t.workerMetadata, n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), t.submitWorkerExecutionTime != null && Object.hasOwnProperty.call(t, "submitWorkerExecutionTime") && $root.metering.SubmitWorkerExecutionTimeResponse.encode(t.submitWorkerExecutionTime, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), t.dcrInteraction != null && Object.hasOwnProperty.call(t, "dcrInteraction") && $root.metering.DcrInteractionResponse.encode(t.dcrInteraction, n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t.createDataset != null && Object.hasOwnProperty.call(t, "createDataset") && $root.metering.CreateDatasetResponse.encode(t.createDataset, n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), t.getOrCreateDatasetScope != null && Object.hasOwnProperty.call(t, "getOrCreateDatasetScope") && $root.metering.GetOrCreateDatasetScopeResponse.encode(t.getOrCreateDatasetScope, n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), t.mergeDcrCommit != null && Object.hasOwnProperty.call(t, "mergeDcrCommit") && $root.metering.MergeDcrCommitResponse.encode(t.mergeDcrCommit, n.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), t.dataConnectorCredentials != null && Object.hasOwnProperty.call(t, "dataConnectorCredentials") && $root.metering.GetDataConnectorCredentialsResponse.encode(t.dataConnectorCredentials, n.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), t.integrityStore != null && Object.hasOwnProperty.call(t, "integrityStore") && $root.integrity_store_api.IntegrityStoreResponse.encode(t.integrityStore, n.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), t.getAzureCommunicationCredentials != null && Object.hasOwnProperty.call(t, "getAzureCommunicationCredentials") && $root.metering.GetAzureCommunicationCredentialsResponse.encode(t.getAzureCommunicationCredentials, n.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.MeteringSuccessResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.createDcr = $root.metering.CreateDcrResponse.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.createDcrCommit = $root.metering.CreateDcrCommitResponse.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.stopDcr = $root.metering.StopDcrResponse.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.publishDataset = $root.metering.PublishDatasetResponse.decode(t, t.uint32());
            break;
          }
          case 5: {
            u.unpublishDataset = $root.metering.UnpublishDatasetResponse.decode(t, t.uint32());
            break;
          }
          case 6: {
            u.workerMetadata = $root.metering.WorkerMetadataResponse.decode(t, t.uint32());
            break;
          }
          case 7: {
            u.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.decode(t, t.uint32());
            break;
          }
          case 8: {
            u.dcrInteraction = $root.metering.DcrInteractionResponse.decode(t, t.uint32());
            break;
          }
          case 9: {
            u.createDataset = $root.metering.CreateDatasetResponse.decode(t, t.uint32());
            break;
          }
          case 10: {
            u.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.decode(t, t.uint32());
            break;
          }
          case 11: {
            u.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.decode(t, t.uint32());
            break;
          }
          case 12: {
            u.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.decode(t, t.uint32());
            break;
          }
          case 13: {
            u.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.decode(t, t.uint32());
            break;
          }
          case 14: {
            u.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.createDcr != null && t.hasOwnProperty("createDcr")) {
        n.response = 1;
        {
          let r = $root.metering.CreateDcrResponse.verify(t.createDcr);
          if (r)
            return "createDcr." + r;
        }
      }
      if (t.createDcrCommit != null && t.hasOwnProperty("createDcrCommit")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.CreateDcrCommitResponse.verify(t.createDcrCommit);
          if (r)
            return "createDcrCommit." + r;
        }
      }
      if (t.stopDcr != null && t.hasOwnProperty("stopDcr")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.StopDcrResponse.verify(t.stopDcr);
          if (r)
            return "stopDcr." + r;
        }
      }
      if (t.publishDataset != null && t.hasOwnProperty("publishDataset")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.PublishDatasetResponse.verify(t.publishDataset);
          if (r)
            return "publishDataset." + r;
        }
      }
      if (t.unpublishDataset != null && t.hasOwnProperty("unpublishDataset")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.UnpublishDatasetResponse.verify(t.unpublishDataset);
          if (r)
            return "unpublishDataset." + r;
        }
      }
      if (t.workerMetadata != null && t.hasOwnProperty("workerMetadata")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.WorkerMetadataResponse.verify(t.workerMetadata);
          if (r)
            return "workerMetadata." + r;
        }
      }
      if (t.submitWorkerExecutionTime != null && t.hasOwnProperty("submitWorkerExecutionTime")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.SubmitWorkerExecutionTimeResponse.verify(t.submitWorkerExecutionTime);
          if (r)
            return "submitWorkerExecutionTime." + r;
        }
      }
      if (t.dcrInteraction != null && t.hasOwnProperty("dcrInteraction")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.DcrInteractionResponse.verify(t.dcrInteraction);
          if (r)
            return "dcrInteraction." + r;
        }
      }
      if (t.createDataset != null && t.hasOwnProperty("createDataset")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.CreateDatasetResponse.verify(t.createDataset);
          if (r)
            return "createDataset." + r;
        }
      }
      if (t.getOrCreateDatasetScope != null && t.hasOwnProperty("getOrCreateDatasetScope")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.GetOrCreateDatasetScopeResponse.verify(t.getOrCreateDatasetScope);
          if (r)
            return "getOrCreateDatasetScope." + r;
        }
      }
      if (t.mergeDcrCommit != null && t.hasOwnProperty("mergeDcrCommit")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.MergeDcrCommitResponse.verify(t.mergeDcrCommit);
          if (r)
            return "mergeDcrCommit." + r;
        }
      }
      if (t.dataConnectorCredentials != null && t.hasOwnProperty("dataConnectorCredentials")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.GetDataConnectorCredentialsResponse.verify(t.dataConnectorCredentials);
          if (r)
            return "dataConnectorCredentials." + r;
        }
      }
      if (t.integrityStore != null && t.hasOwnProperty("integrityStore")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.integrity_store_api.IntegrityStoreResponse.verify(t.integrityStore);
          if (r)
            return "integrityStore." + r;
        }
      }
      if (t.getAzureCommunicationCredentials != null && t.hasOwnProperty("getAzureCommunicationCredentials")) {
        if (n.response === 1)
          return "response: multiple values";
        n.response = 1;
        {
          let r = $root.metering.GetAzureCommunicationCredentialsResponse.verify(t.getAzureCommunicationCredentials);
          if (r)
            return "getAzureCommunicationCredentials." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.MeteringSuccessResponse)
        return t;
      let n = new $root.metering.MeteringSuccessResponse();
      if (t.createDcr != null) {
        if (typeof t.createDcr != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDcr: object expected");
        n.createDcr = $root.metering.CreateDcrResponse.fromObject(t.createDcr);
      }
      if (t.createDcrCommit != null) {
        if (typeof t.createDcrCommit != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDcrCommit: object expected");
        n.createDcrCommit = $root.metering.CreateDcrCommitResponse.fromObject(t.createDcrCommit);
      }
      if (t.stopDcr != null) {
        if (typeof t.stopDcr != "object")
          throw TypeError(".metering.MeteringSuccessResponse.stopDcr: object expected");
        n.stopDcr = $root.metering.StopDcrResponse.fromObject(t.stopDcr);
      }
      if (t.publishDataset != null) {
        if (typeof t.publishDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.publishDataset: object expected");
        n.publishDataset = $root.metering.PublishDatasetResponse.fromObject(t.publishDataset);
      }
      if (t.unpublishDataset != null) {
        if (typeof t.unpublishDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.unpublishDataset: object expected");
        n.unpublishDataset = $root.metering.UnpublishDatasetResponse.fromObject(t.unpublishDataset);
      }
      if (t.workerMetadata != null) {
        if (typeof t.workerMetadata != "object")
          throw TypeError(".metering.MeteringSuccessResponse.workerMetadata: object expected");
        n.workerMetadata = $root.metering.WorkerMetadataResponse.fromObject(t.workerMetadata);
      }
      if (t.submitWorkerExecutionTime != null) {
        if (typeof t.submitWorkerExecutionTime != "object")
          throw TypeError(".metering.MeteringSuccessResponse.submitWorkerExecutionTime: object expected");
        n.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.fromObject(t.submitWorkerExecutionTime);
      }
      if (t.dcrInteraction != null) {
        if (typeof t.dcrInteraction != "object")
          throw TypeError(".metering.MeteringSuccessResponse.dcrInteraction: object expected");
        n.dcrInteraction = $root.metering.DcrInteractionResponse.fromObject(t.dcrInteraction);
      }
      if (t.createDataset != null) {
        if (typeof t.createDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDataset: object expected");
        n.createDataset = $root.metering.CreateDatasetResponse.fromObject(t.createDataset);
      }
      if (t.getOrCreateDatasetScope != null) {
        if (typeof t.getOrCreateDatasetScope != "object")
          throw TypeError(".metering.MeteringSuccessResponse.getOrCreateDatasetScope: object expected");
        n.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.fromObject(t.getOrCreateDatasetScope);
      }
      if (t.mergeDcrCommit != null) {
        if (typeof t.mergeDcrCommit != "object")
          throw TypeError(".metering.MeteringSuccessResponse.mergeDcrCommit: object expected");
        n.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.fromObject(t.mergeDcrCommit);
      }
      if (t.dataConnectorCredentials != null) {
        if (typeof t.dataConnectorCredentials != "object")
          throw TypeError(".metering.MeteringSuccessResponse.dataConnectorCredentials: object expected");
        n.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.fromObject(t.dataConnectorCredentials);
      }
      if (t.integrityStore != null) {
        if (typeof t.integrityStore != "object")
          throw TypeError(".metering.MeteringSuccessResponse.integrityStore: object expected");
        n.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.fromObject(t.integrityStore);
      }
      if (t.getAzureCommunicationCredentials != null) {
        if (typeof t.getAzureCommunicationCredentials != "object")
          throw TypeError(".metering.MeteringSuccessResponse.getAzureCommunicationCredentials: object expected");
        n.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.fromObject(t.getAzureCommunicationCredentials);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.createDcr != null && t.hasOwnProperty("createDcr") && (r.createDcr = $root.metering.CreateDcrResponse.toObject(t.createDcr, n), n.oneofs && (r.response = "createDcr")), t.createDcrCommit != null && t.hasOwnProperty("createDcrCommit") && (r.createDcrCommit = $root.metering.CreateDcrCommitResponse.toObject(t.createDcrCommit, n), n.oneofs && (r.response = "createDcrCommit")), t.stopDcr != null && t.hasOwnProperty("stopDcr") && (r.stopDcr = $root.metering.StopDcrResponse.toObject(t.stopDcr, n), n.oneofs && (r.response = "stopDcr")), t.publishDataset != null && t.hasOwnProperty("publishDataset") && (r.publishDataset = $root.metering.PublishDatasetResponse.toObject(t.publishDataset, n), n.oneofs && (r.response = "publishDataset")), t.unpublishDataset != null && t.hasOwnProperty("unpublishDataset") && (r.unpublishDataset = $root.metering.UnpublishDatasetResponse.toObject(t.unpublishDataset, n), n.oneofs && (r.response = "unpublishDataset")), t.workerMetadata != null && t.hasOwnProperty("workerMetadata") && (r.workerMetadata = $root.metering.WorkerMetadataResponse.toObject(t.workerMetadata, n), n.oneofs && (r.response = "workerMetadata")), t.submitWorkerExecutionTime != null && t.hasOwnProperty("submitWorkerExecutionTime") && (r.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.toObject(t.submitWorkerExecutionTime, n), n.oneofs && (r.response = "submitWorkerExecutionTime")), t.dcrInteraction != null && t.hasOwnProperty("dcrInteraction") && (r.dcrInteraction = $root.metering.DcrInteractionResponse.toObject(t.dcrInteraction, n), n.oneofs && (r.response = "dcrInteraction")), t.createDataset != null && t.hasOwnProperty("createDataset") && (r.createDataset = $root.metering.CreateDatasetResponse.toObject(t.createDataset, n), n.oneofs && (r.response = "createDataset")), t.getOrCreateDatasetScope != null && t.hasOwnProperty("getOrCreateDatasetScope") && (r.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.toObject(t.getOrCreateDatasetScope, n), n.oneofs && (r.response = "getOrCreateDatasetScope")), t.mergeDcrCommit != null && t.hasOwnProperty("mergeDcrCommit") && (r.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.toObject(t.mergeDcrCommit, n), n.oneofs && (r.response = "mergeDcrCommit")), t.dataConnectorCredentials != null && t.hasOwnProperty("dataConnectorCredentials") && (r.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.toObject(t.dataConnectorCredentials, n), n.oneofs && (r.response = "dataConnectorCredentials")), t.integrityStore != null && t.hasOwnProperty("integrityStore") && (r.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.toObject(t.integrityStore, n), n.oneofs && (r.response = "integrityStore")), t.getAzureCommunicationCredentials != null && t.hasOwnProperty("getAzureCommunicationCredentials") && (r.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.toObject(t.getAzureCommunicationCredentials, n), n.oneofs && (r.response = "getAzureCommunicationCredentials")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.MeteringSuccessResponse";
    }, o;
  }(), c.MeteringResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.success = null, o.prototype.failure = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["success", "failure"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.success != null && Object.hasOwnProperty.call(t, "success") && $root.metering.MeteringSuccessResponse.encode(t.success, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.failure != null && Object.hasOwnProperty.call(t, "failure") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.failure), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.MeteringResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.success = $root.metering.MeteringSuccessResponse.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.failure = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.success != null && t.hasOwnProperty("success")) {
        n.response = 1;
        {
          let r = $root.metering.MeteringSuccessResponse.verify(t.success);
          if (r)
            return "success." + r;
        }
      }
      if (t.failure != null && t.hasOwnProperty("failure")) {
        if (n.response === 1)
          return "response: multiple values";
        if (n.response = 1, !$util.isString(t.failure))
          return "failure: string expected";
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.MeteringResponse)
        return t;
      let n = new $root.metering.MeteringResponse();
      if (t.success != null) {
        if (typeof t.success != "object")
          throw TypeError(".metering.MeteringResponse.success: object expected");
        n.success = $root.metering.MeteringSuccessResponse.fromObject(t.success);
      }
      return t.failure != null && (n.failure = String(t.failure)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.success != null && t.hasOwnProperty("success") && (r.success = $root.metering.MeteringSuccessResponse.toObject(t.success, n), n.oneofs && (r.response = "success")), t.failure != null && t.hasOwnProperty("failure") && (r.failure = t.failure, n.oneofs && (r.response = "failure")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.MeteringResponse";
    }, o;
  }(), c.CreateDcrPurpose = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "STANDARD"] = 0, i[o[1] = "VALIDATION"] = 1, i[o[2] = "DATA_IMPORT"] = 2, i[o[3] = "DATA_EXPORT"] = 3, i[o[4] = "DATA_LAB"] = 4, i;
  }(), c.CreateDcrKind = function() {
    const o = {}, i = Object.create(o);
    return i[o[0] = "EXPERT"] = 0, i[o[1] = "DATASCIENCE"] = 1, i[o[2] = "MEDIA"] = 2, i[o[3] = "LOOKALIKE_MEDIA"] = 3, i[o[4] = "MEDIA_INSIGHTS"] = 4, i[o[5] = "AB_MEDIA"] = 5, i;
  }(), c.DcrMetadata = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.purpose = 0, o.prototype.showOrganizationLogo = !1, o.prototype.requirePassword = !1, o.prototype.kind = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.purpose != null && Object.hasOwnProperty.call(e, "purpose") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.purpose), e.showOrganizationLogo != null && Object.hasOwnProperty.call(e, "showOrganizationLogo") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.showOrganizationLogo), e.requirePassword != null && Object.hasOwnProperty.call(e, "requirePassword") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.requirePassword), e.kind != null && Object.hasOwnProperty.call(e, "kind") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(e.kind), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.DcrMetadata();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.purpose = e.int32();
            break;
          }
          case 2: {
            r.showOrganizationLogo = e.bool();
            break;
          }
          case 3: {
            r.requirePassword = e.bool();
            break;
          }
          case 4: {
            r.kind = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.purpose != null && e.hasOwnProperty("purpose"))
        switch (e.purpose) {
          default:
            return "purpose: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (e.showOrganizationLogo != null && e.hasOwnProperty("showOrganizationLogo") && typeof e.showOrganizationLogo != "boolean")
        return "showOrganizationLogo: boolean expected";
      if (e.requirePassword != null && e.hasOwnProperty("requirePassword") && typeof e.requirePassword != "boolean")
        return "requirePassword: boolean expected";
      if (e.kind != null && e.hasOwnProperty("kind"))
        switch (e.kind) {
          default:
            return "kind: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.DcrMetadata)
        return e;
      let t = new $root.metering.DcrMetadata();
      switch (e.purpose) {
        default:
          if (typeof e.purpose == "number") {
            t.purpose = e.purpose;
            break;
          }
          break;
        case "STANDARD":
        case 0:
          t.purpose = 0;
          break;
        case "VALIDATION":
        case 1:
          t.purpose = 1;
          break;
        case "DATA_IMPORT":
        case 2:
          t.purpose = 2;
          break;
        case "DATA_EXPORT":
        case 3:
          t.purpose = 3;
          break;
        case "DATA_LAB":
        case 4:
          t.purpose = 4;
          break;
      }
      switch (e.showOrganizationLogo != null && (t.showOrganizationLogo = !!e.showOrganizationLogo), e.requirePassword != null && (t.requirePassword = !!e.requirePassword), e.kind) {
        default:
          if (typeof e.kind == "number") {
            t.kind = e.kind;
            break;
          }
          break;
        case "EXPERT":
        case 0:
          t.kind = 0;
          break;
        case "DATASCIENCE":
        case 1:
          t.kind = 1;
          break;
        case "MEDIA":
        case 2:
          t.kind = 2;
          break;
        case "LOOKALIKE_MEDIA":
        case 3:
          t.kind = 3;
          break;
        case "MEDIA_INSIGHTS":
        case 4:
          t.kind = 4;
          break;
        case "AB_MEDIA":
        case 5:
          t.kind = 5;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.purpose = t.enums === String ? "STANDARD" : 0, n.showOrganizationLogo = !1, n.requirePassword = !1, n.kind = t.enums === String ? "EXPERT" : 0), e.purpose != null && e.hasOwnProperty("purpose") && (n.purpose = t.enums === String ? $root.metering.CreateDcrPurpose[e.purpose] === void 0 ? e.purpose : $root.metering.CreateDcrPurpose[e.purpose] : e.purpose), e.showOrganizationLogo != null && e.hasOwnProperty("showOrganizationLogo") && (n.showOrganizationLogo = e.showOrganizationLogo), e.requirePassword != null && e.hasOwnProperty("requirePassword") && (n.requirePassword = e.requirePassword), e.kind != null && e.hasOwnProperty("kind") && (n.kind = t.enums === String ? $root.metering.CreateDcrKind[e.kind] === void 0 ? e.kind : $root.metering.CreateDcrKind[e.kind] : e.kind), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrMetadata";
    }, o;
  }(), c.CreateDcrRequest = function() {
    function o(e) {
      if (this.participantEmails = [], this.enclaveInfo = [], e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.idHex = "", o.prototype.name = "", o.prototype.driverAttestationHash = "", o.prototype.participantEmails = $util.emptyArray, o.prototype.metadata = null, o.prototype.enclaveInfo = $util.emptyArray;
    let i;
    return Object.defineProperty(o.prototype, "_metadata", {
      get: $util.oneOfGetter(i = ["metadata"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      if (n || (n = $Writer.create()), t.idHex != null && Object.hasOwnProperty.call(t, "idHex") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.idHex), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.driverAttestationHash != null && Object.hasOwnProperty.call(t, "driverAttestationHash") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.driverAttestationHash), t.participantEmails != null && t.participantEmails.length)
        for (let r = 0; r < t.participantEmails.length; ++r)
          n.uint32(
            /* id 4, wireType 2 =*/
            34
          ).string(t.participantEmails[r]);
      if (t.metadata != null && Object.hasOwnProperty.call(t, "metadata") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(t.metadata), t.enclaveInfo != null && t.enclaveInfo.length)
        for (let r = 0; r < t.enclaveInfo.length; ++r)
          $root.metering.EnclaveInfo.encode(t.enclaveInfo[r], n.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.CreateDcrRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.idHex = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.driverAttestationHash = t.string();
            break;
          }
          case 4: {
            u.participantEmails && u.participantEmails.length || (u.participantEmails = []), u.participantEmails.push(t.string());
            break;
          }
          case 5: {
            u.metadata = t.bytes();
            break;
          }
          case 6: {
            u.enclaveInfo && u.enclaveInfo.length || (u.enclaveInfo = []), u.enclaveInfo.push($root.metering.EnclaveInfo.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.idHex != null && t.hasOwnProperty("idHex") && !$util.isString(t.idHex))
        return "idHex: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.driverAttestationHash != null && t.hasOwnProperty("driverAttestationHash") && !$util.isString(t.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (t.participantEmails != null && t.hasOwnProperty("participantEmails")) {
        if (!Array.isArray(t.participantEmails))
          return "participantEmails: array expected";
        for (let n = 0; n < t.participantEmails.length; ++n)
          if (!$util.isString(t.participantEmails[n]))
            return "participantEmails: string[] expected";
      }
      if (t.metadata != null && t.hasOwnProperty("metadata") && !(t.metadata && typeof t.metadata.length == "number" || $util.isString(t.metadata)))
        return "metadata: buffer expected";
      if (t.enclaveInfo != null && t.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(t.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let n = 0; n < t.enclaveInfo.length; ++n) {
          let r = $root.metering.EnclaveInfo.verify(t.enclaveInfo[n]);
          if (r)
            return "enclaveInfo." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.CreateDcrRequest)
        return t;
      let n = new $root.metering.CreateDcrRequest();
      if (t.idHex != null && (n.idHex = String(t.idHex)), t.name != null && (n.name = String(t.name)), t.driverAttestationHash != null && (n.driverAttestationHash = String(t.driverAttestationHash)), t.participantEmails) {
        if (!Array.isArray(t.participantEmails))
          throw TypeError(".metering.CreateDcrRequest.participantEmails: array expected");
        n.participantEmails = [];
        for (let r = 0; r < t.participantEmails.length; ++r)
          n.participantEmails[r] = String(t.participantEmails[r]);
      }
      if (t.metadata != null && (typeof t.metadata == "string" ? $util.base64.decode(t.metadata, n.metadata = $util.newBuffer($util.base64.length(t.metadata)), 0) : t.metadata.length >= 0 && (n.metadata = t.metadata)), t.enclaveInfo) {
        if (!Array.isArray(t.enclaveInfo))
          throw TypeError(".metering.CreateDcrRequest.enclaveInfo: array expected");
        n.enclaveInfo = [];
        for (let r = 0; r < t.enclaveInfo.length; ++r) {
          if (typeof t.enclaveInfo[r] != "object")
            throw TypeError(".metering.CreateDcrRequest.enclaveInfo: object expected");
          n.enclaveInfo[r] = $root.metering.EnclaveInfo.fromObject(t.enclaveInfo[r]);
        }
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      if ((n.arrays || n.defaults) && (r.participantEmails = [], r.enclaveInfo = []), n.defaults && (r.idHex = "", r.name = "", r.driverAttestationHash = ""), t.idHex != null && t.hasOwnProperty("idHex") && (r.idHex = t.idHex), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.driverAttestationHash != null && t.hasOwnProperty("driverAttestationHash") && (r.driverAttestationHash = t.driverAttestationHash), t.participantEmails && t.participantEmails.length) {
        r.participantEmails = [];
        for (let u = 0; u < t.participantEmails.length; ++u)
          r.participantEmails[u] = t.participantEmails[u];
      }
      if (t.metadata != null && t.hasOwnProperty("metadata") && (r.metadata = n.bytes === String ? $util.base64.encode(t.metadata, 0, t.metadata.length) : n.bytes === Array ? Array.prototype.slice.call(t.metadata) : t.metadata, n.oneofs && (r._metadata = "metadata")), t.enclaveInfo && t.enclaveInfo.length) {
        r.enclaveInfo = [];
        for (let u = 0; u < t.enclaveInfo.length; ++u)
          r.enclaveInfo[u] = $root.metering.EnclaveInfo.toObject(t.enclaveInfo[u], n);
      }
      return r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.CreateDcrRequest";
    }, o;
  }(), c.ExecuteComputationNodeInteraction = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.nodeId = "", o.prototype.rateLimiting = null;
    let i;
    return Object.defineProperty(o.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(i = ["rateLimiting"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.nodeId != null && Object.hasOwnProperty.call(t, "nodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.nodeId), t.rateLimiting != null && Object.hasOwnProperty.call(t, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(t.rateLimiting, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.ExecuteComputationNodeInteraction();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.nodeId = t.string();
            break;
          }
          case 2: {
            u.rateLimiting = $root.data_room.RateLimitingConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.nodeId != null && t.hasOwnProperty("nodeId") && !$util.isString(t.nodeId))
        return "nodeId: string expected";
      if (t.rateLimiting != null && t.hasOwnProperty("rateLimiting")) {
        let n = $root.data_room.RateLimitingConfig.verify(t.rateLimiting);
        if (n)
          return "rateLimiting." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.ExecuteComputationNodeInteraction)
        return t;
      let n = new $root.metering.ExecuteComputationNodeInteraction();
      if (t.nodeId != null && (n.nodeId = String(t.nodeId)), t.rateLimiting != null) {
        if (typeof t.rateLimiting != "object")
          throw TypeError(".metering.ExecuteComputationNodeInteraction.rateLimiting: object expected");
        n.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(t.rateLimiting);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.nodeId = ""), t.nodeId != null && t.hasOwnProperty("nodeId") && (r.nodeId = t.nodeId), t.rateLimiting != null && t.hasOwnProperty("rateLimiting") && (r.rateLimiting = $root.data_room.RateLimitingConfig.toObject(t.rateLimiting, n), n.oneofs && (r._rateLimiting = "rateLimiting")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.ExecuteComputationNodeInteraction";
    }, o;
  }(), c.ExecuteComputationInteraction = function() {
    function o(i) {
      if (this.nodes = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.nodes = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.nodes != null && e.nodes.length)
        for (let n = 0; n < e.nodes.length; ++n)
          $root.metering.ExecuteComputationNodeInteraction.encode(e.nodes[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.ExecuteComputationInteraction();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.nodes && r.nodes.length || (r.nodes = []), r.nodes.push($root.metering.ExecuteComputationNodeInteraction.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.nodes != null && e.hasOwnProperty("nodes")) {
        if (!Array.isArray(e.nodes))
          return "nodes: array expected";
        for (let t = 0; t < e.nodes.length; ++t) {
          let n = $root.metering.ExecuteComputationNodeInteraction.verify(e.nodes[t]);
          if (n)
            return "nodes." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.ExecuteComputationInteraction)
        return e;
      let t = new $root.metering.ExecuteComputationInteraction();
      if (e.nodes) {
        if (!Array.isArray(e.nodes))
          throw TypeError(".metering.ExecuteComputationInteraction.nodes: array expected");
        t.nodes = [];
        for (let n = 0; n < e.nodes.length; ++n) {
          if (typeof e.nodes[n] != "object")
            throw TypeError(".metering.ExecuteComputationInteraction.nodes: object expected");
          t.nodes[n] = $root.metering.ExecuteComputationNodeInteraction.fromObject(e.nodes[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.nodes = []), e.nodes && e.nodes.length) {
        n.nodes = [];
        for (let r = 0; r < e.nodes.length; ++r)
          n.nodes[r] = $root.metering.ExecuteComputationNodeInteraction.toObject(e.nodes[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.ExecuteComputationInteraction";
    }, o;
  }(), c.PublishDatasetInteraction = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.nodeId = "", o.prototype.rateLimiting = null;
    let i;
    return Object.defineProperty(o.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(i = ["rateLimiting"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.nodeId != null && Object.hasOwnProperty.call(t, "nodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.nodeId), t.rateLimiting != null && Object.hasOwnProperty.call(t, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(t.rateLimiting, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.PublishDatasetInteraction();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.nodeId = t.string();
            break;
          }
          case 2: {
            u.rateLimiting = $root.data_room.RateLimitingConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.nodeId != null && t.hasOwnProperty("nodeId") && !$util.isString(t.nodeId))
        return "nodeId: string expected";
      if (t.rateLimiting != null && t.hasOwnProperty("rateLimiting")) {
        let n = $root.data_room.RateLimitingConfig.verify(t.rateLimiting);
        if (n)
          return "rateLimiting." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.PublishDatasetInteraction)
        return t;
      let n = new $root.metering.PublishDatasetInteraction();
      if (t.nodeId != null && (n.nodeId = String(t.nodeId)), t.rateLimiting != null) {
        if (typeof t.rateLimiting != "object")
          throw TypeError(".metering.PublishDatasetInteraction.rateLimiting: object expected");
        n.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(t.rateLimiting);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.nodeId = ""), t.nodeId != null && t.hasOwnProperty("nodeId") && (r.nodeId = t.nodeId), t.rateLimiting != null && t.hasOwnProperty("rateLimiting") && (r.rateLimiting = $root.data_room.RateLimitingConfig.toObject(t.rateLimiting, n), n.oneofs && (r._rateLimiting = "rateLimiting")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.PublishDatasetInteraction";
    }, o;
  }(), c.DcrInteractionKind = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.executeComputation = null, o.prototype.publishDataset = null;
    let i;
    return Object.defineProperty(o.prototype, "kind", {
      get: $util.oneOfGetter(i = ["executeComputation", "publishDataset"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.executeComputation != null && Object.hasOwnProperty.call(t, "executeComputation") && $root.metering.ExecuteComputationInteraction.encode(t.executeComputation, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.publishDataset != null && Object.hasOwnProperty.call(t, "publishDataset") && $root.metering.PublishDatasetInteraction.encode(t.publishDataset, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.DcrInteractionKind();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.executeComputation = $root.metering.ExecuteComputationInteraction.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.publishDataset = $root.metering.PublishDatasetInteraction.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.executeComputation != null && t.hasOwnProperty("executeComputation")) {
        n.kind = 1;
        {
          let r = $root.metering.ExecuteComputationInteraction.verify(t.executeComputation);
          if (r)
            return "executeComputation." + r;
        }
      }
      if (t.publishDataset != null && t.hasOwnProperty("publishDataset")) {
        if (n.kind === 1)
          return "kind: multiple values";
        n.kind = 1;
        {
          let r = $root.metering.PublishDatasetInteraction.verify(t.publishDataset);
          if (r)
            return "publishDataset." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.DcrInteractionKind)
        return t;
      let n = new $root.metering.DcrInteractionKind();
      if (t.executeComputation != null) {
        if (typeof t.executeComputation != "object")
          throw TypeError(".metering.DcrInteractionKind.executeComputation: object expected");
        n.executeComputation = $root.metering.ExecuteComputationInteraction.fromObject(t.executeComputation);
      }
      if (t.publishDataset != null) {
        if (typeof t.publishDataset != "object")
          throw TypeError(".metering.DcrInteractionKind.publishDataset: object expected");
        n.publishDataset = $root.metering.PublishDatasetInteraction.fromObject(t.publishDataset);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.executeComputation != null && t.hasOwnProperty("executeComputation") && (r.executeComputation = $root.metering.ExecuteComputationInteraction.toObject(t.executeComputation, n), n.oneofs && (r.kind = "executeComputation")), t.publishDataset != null && t.hasOwnProperty("publishDataset") && (r.publishDataset = $root.metering.PublishDatasetInteraction.toObject(t.publishDataset, n), n.oneofs && (r.kind = "publishDataset")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.DcrInteractionKind";
    }, o;
  }(), c.DcrInteractionRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomHash = "", o.prototype.driverAttestationHash = "", o.prototype.scopeId = "", o.prototype.interaction = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.driverAttestationHash), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.scopeId), e.interaction != null && Object.hasOwnProperty.call(e, "interaction") && $root.metering.DcrInteractionKind.encode(e.interaction, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.DcrInteractionRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomHash = e.string();
            break;
          }
          case 2: {
            r.driverAttestationHash = e.string();
            break;
          }
          case 3: {
            r.scopeId = e.string();
            break;
          }
          case 4: {
            r.interaction = $root.metering.DcrInteractionKind.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash))
        return "dataRoomHash: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId))
        return "scopeId: string expected";
      if (e.interaction != null && e.hasOwnProperty("interaction")) {
        let t = $root.metering.DcrInteractionKind.verify(e.interaction);
        if (t)
          return "interaction." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.DcrInteractionRequest)
        return e;
      let t = new $root.metering.DcrInteractionRequest();
      if (e.dataRoomHash != null && (t.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), e.scopeId != null && (t.scopeId = String(e.scopeId)), e.interaction != null) {
        if (typeof e.interaction != "object")
          throw TypeError(".metering.DcrInteractionRequest.interaction: object expected");
        t.interaction = $root.metering.DcrInteractionKind.fromObject(e.interaction);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dataRoomHash = "", n.driverAttestationHash = "", n.scopeId = "", n.interaction = null), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (n.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), e.scopeId != null && e.hasOwnProperty("scopeId") && (n.scopeId = e.scopeId), e.interaction != null && e.hasOwnProperty("interaction") && (n.interaction = $root.metering.DcrInteractionKind.toObject(e.interaction, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrInteractionRequest";
    }, o;
  }(), c.PublishDatasetRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.computeNodeId = "", o.prototype.manifestHash = "", o.prototype.dataRoomHash = "", o.prototype.driverAttestationHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), e.manifestHash != null && Object.hasOwnProperty.call(e, "manifestHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.manifestHash), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.driverAttestationHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.PublishDatasetRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.computeNodeId = e.string();
            break;
          }
          case 2: {
            r.manifestHash = e.string();
            break;
          }
          case 3: {
            r.dataRoomHash = e.string();
            break;
          }
          case 4: {
            r.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : e.manifestHash != null && e.hasOwnProperty("manifestHash") && !$util.isString(e.manifestHash) ? "manifestHash: string expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.PublishDatasetRequest)
        return e;
      let t = new $root.metering.PublishDatasetRequest();
      return e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), e.manifestHash != null && (t.manifestHash = String(e.manifestHash)), e.dataRoomHash != null && (t.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.computeNodeId = "", n.manifestHash = "", n.dataRoomHash = "", n.driverAttestationHash = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), e.manifestHash != null && e.hasOwnProperty("manifestHash") && (n.manifestHash = e.manifestHash), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (n.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.PublishDatasetRequest";
    }, o;
  }(), c.CreateDatasetRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.manifestHash = "", o.prototype.manifest = null, o.prototype.scopeId = "", o.prototype.name = "", o.prototype.description = null, o.prototype.sizeBytes = null, o.prototype.statistics = null, o.prototype.datasetImportId = null;
    let i;
    return Object.defineProperty(o.prototype, "_manifest", {
      get: $util.oneOfGetter(i = ["manifest"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_description", {
      get: $util.oneOfGetter(i = ["description"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_sizeBytes", {
      get: $util.oneOfGetter(i = ["sizeBytes"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_statistics", {
      get: $util.oneOfGetter(i = ["statistics"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_datasetImportId", {
      get: $util.oneOfGetter(i = ["datasetImportId"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.manifestHash != null && Object.hasOwnProperty.call(t, "manifestHash") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.manifestHash), t.manifest != null && Object.hasOwnProperty.call(t, "manifest") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.manifest), t.scopeId != null && Object.hasOwnProperty.call(t, "scopeId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.scopeId), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.name), t.description != null && Object.hasOwnProperty.call(t, "description") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.description), t.sizeBytes != null && Object.hasOwnProperty.call(t, "sizeBytes") && n.uint32(
        /* id 6, wireType 0 =*/
        48
      ).uint64(t.sizeBytes), t.statistics != null && Object.hasOwnProperty.call(t, "statistics") && n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).string(t.statistics), t.datasetImportId != null && Object.hasOwnProperty.call(t, "datasetImportId") && n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).string(t.datasetImportId), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.CreateDatasetRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.manifestHash = t.string();
            break;
          }
          case 2: {
            u.manifest = t.string();
            break;
          }
          case 3: {
            u.scopeId = t.string();
            break;
          }
          case 4: {
            u.name = t.string();
            break;
          }
          case 5: {
            u.description = t.string();
            break;
          }
          case 6: {
            u.sizeBytes = t.uint64();
            break;
          }
          case 7: {
            u.statistics = t.string();
            break;
          }
          case 8: {
            u.datasetImportId = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.manifestHash != null && t.hasOwnProperty("manifestHash") && !$util.isString(t.manifestHash) ? "manifestHash: string expected" : t.manifest != null && t.hasOwnProperty("manifest") && !$util.isString(t.manifest) ? "manifest: string expected" : t.scopeId != null && t.hasOwnProperty("scopeId") && !$util.isString(t.scopeId) ? "scopeId: string expected" : t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name) ? "name: string expected" : t.description != null && t.hasOwnProperty("description") && !$util.isString(t.description) ? "description: string expected" : t.sizeBytes != null && t.hasOwnProperty("sizeBytes") && !$util.isInteger(t.sizeBytes) && !(t.sizeBytes && $util.isInteger(t.sizeBytes.low) && $util.isInteger(t.sizeBytes.high)) ? "sizeBytes: integer|Long expected" : t.statistics != null && t.hasOwnProperty("statistics") && !$util.isString(t.statistics) ? "statistics: string expected" : t.datasetImportId != null && t.hasOwnProperty("datasetImportId") && !$util.isString(t.datasetImportId) ? "datasetImportId: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.CreateDatasetRequest)
        return t;
      let n = new $root.metering.CreateDatasetRequest();
      return t.manifestHash != null && (n.manifestHash = String(t.manifestHash)), t.manifest != null && (n.manifest = String(t.manifest)), t.scopeId != null && (n.scopeId = String(t.scopeId)), t.name != null && (n.name = String(t.name)), t.description != null && (n.description = String(t.description)), t.sizeBytes != null && ($util.Long ? (n.sizeBytes = $util.Long.fromValue(t.sizeBytes)).unsigned = !0 : typeof t.sizeBytes == "string" ? n.sizeBytes = parseInt(t.sizeBytes, 10) : typeof t.sizeBytes == "number" ? n.sizeBytes = t.sizeBytes : typeof t.sizeBytes == "object" && (n.sizeBytes = new $util.LongBits(t.sizeBytes.low >>> 0, t.sizeBytes.high >>> 0).toNumber(!0))), t.statistics != null && (n.statistics = String(t.statistics)), t.datasetImportId != null && (n.datasetImportId = String(t.datasetImportId)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.manifestHash = "", r.scopeId = "", r.name = ""), t.manifestHash != null && t.hasOwnProperty("manifestHash") && (r.manifestHash = t.manifestHash), t.manifest != null && t.hasOwnProperty("manifest") && (r.manifest = t.manifest, n.oneofs && (r._manifest = "manifest")), t.scopeId != null && t.hasOwnProperty("scopeId") && (r.scopeId = t.scopeId), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.description != null && t.hasOwnProperty("description") && (r.description = t.description, n.oneofs && (r._description = "description")), t.sizeBytes != null && t.hasOwnProperty("sizeBytes") && (typeof t.sizeBytes == "number" ? r.sizeBytes = n.longs === String ? String(t.sizeBytes) : t.sizeBytes : r.sizeBytes = n.longs === String ? $util.Long.prototype.toString.call(t.sizeBytes) : n.longs === Number ? new $util.LongBits(t.sizeBytes.low >>> 0, t.sizeBytes.high >>> 0).toNumber(!0) : t.sizeBytes, n.oneofs && (r._sizeBytes = "sizeBytes")), t.statistics != null && t.hasOwnProperty("statistics") && (r.statistics = t.statistics, n.oneofs && (r._statistics = "statistics")), t.datasetImportId != null && t.hasOwnProperty("datasetImportId") && (r.datasetImportId = t.datasetImportId, n.oneofs && (r._datasetImportId = "datasetImportId")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.CreateDatasetRequest";
    }, o;
  }(), c.GetOrCreateDatasetScopeRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.manifestHash = null;
    let i;
    return Object.defineProperty(o.prototype, "_manifestHash", {
      get: $util.oneOfGetter(i = ["manifestHash"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.manifestHash != null && Object.hasOwnProperty.call(t, "manifestHash") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.manifestHash), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.GetOrCreateDatasetScopeRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.manifestHash = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.manifestHash != null && t.hasOwnProperty("manifestHash") && !$util.isString(t.manifestHash) ? "manifestHash: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.GetOrCreateDatasetScopeRequest)
        return t;
      let n = new $root.metering.GetOrCreateDatasetScopeRequest();
      return t.manifestHash != null && (n.manifestHash = String(t.manifestHash)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.manifestHash != null && t.hasOwnProperty("manifestHash") && (r.manifestHash = t.manifestHash, n.oneofs && (r._manifestHash = "manifestHash")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.GetOrCreateDatasetScopeRequest";
    }, o;
  }(), c.UnpublishDatasetRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.computeNodeId = "", o.prototype.dataRoomHash = "", o.prototype.driverAttestationHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.UnpublishDatasetRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.computeNodeId = e.string();
            break;
          }
          case 2: {
            r.dataRoomHash = e.string();
            break;
          }
          case 3: {
            r.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.UnpublishDatasetRequest)
        return e;
      let t = new $root.metering.UnpublishDatasetRequest();
      return e.computeNodeId != null && (t.computeNodeId = String(e.computeNodeId)), e.dataRoomHash != null && (t.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.computeNodeId = "", n.dataRoomHash = "", n.driverAttestationHash = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (n.computeNodeId = e.computeNodeId), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (n.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.UnpublishDatasetRequest";
    }, o;
  }(), c.StopDcrRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.dataRoomHash = "", o.prototype.driverAttestationHash = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.driverAttestationHash), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.StopDcrRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.dataRoomHash = e.string();
            break;
          }
          case 2: {
            r.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.StopDcrRequest)
        return e;
      let t = new $root.metering.StopDcrRequest();
      return e.dataRoomHash != null && (t.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.dataRoomHash = "", n.driverAttestationHash = ""), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (n.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.StopDcrRequest";
    }, o;
  }(), c.CreateDcrCommitRequest = function() {
    function o(i) {
      if (this.enclaveInfo = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.dcrIdHex = "", o.prototype.driverAttestationHash = "", o.prototype.enclaveInfo = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.dcrIdHex != null && Object.hasOwnProperty.call(e, "dcrIdHex") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dcrIdHex), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), e.enclaveInfo != null && e.enclaveInfo.length)
        for (let n = 0; n < e.enclaveInfo.length; ++n)
          $root.metering.EnclaveInfo.encode(e.enclaveInfo[n], t.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.CreateDcrCommitRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.dcrIdHex = e.string();
            break;
          }
          case 3: {
            r.driverAttestationHash = e.string();
            break;
          }
          case 6: {
            r.enclaveInfo && r.enclaveInfo.length || (r.enclaveInfo = []), r.enclaveInfo.push($root.metering.EnclaveInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && !$util.isString(e.dcrIdHex))
        return "dcrIdHex: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.enclaveInfo != null && e.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(e.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let t = 0; t < e.enclaveInfo.length; ++t) {
          let n = $root.metering.EnclaveInfo.verify(e.enclaveInfo[t]);
          if (n)
            return "enclaveInfo." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.CreateDcrCommitRequest)
        return e;
      let t = new $root.metering.CreateDcrCommitRequest();
      if (e.id != null && (t.id = String(e.id)), e.dcrIdHex != null && (t.dcrIdHex = String(e.dcrIdHex)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), e.enclaveInfo) {
        if (!Array.isArray(e.enclaveInfo))
          throw TypeError(".metering.CreateDcrCommitRequest.enclaveInfo: array expected");
        t.enclaveInfo = [];
        for (let n = 0; n < e.enclaveInfo.length; ++n) {
          if (typeof e.enclaveInfo[n] != "object")
            throw TypeError(".metering.CreateDcrCommitRequest.enclaveInfo: object expected");
          t.enclaveInfo[n] = $root.metering.EnclaveInfo.fromObject(e.enclaveInfo[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.enclaveInfo = []), t.defaults && (n.id = "", n.dcrIdHex = "", n.driverAttestationHash = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && (n.dcrIdHex = e.dcrIdHex), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), e.enclaveInfo && e.enclaveInfo.length) {
        n.enclaveInfo = [];
        for (let r = 0; r < e.enclaveInfo.length; ++r)
          n.enclaveInfo[r] = $root.metering.EnclaveInfo.toObject(e.enclaveInfo[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrCommitRequest";
    }, o;
  }(), c.MergeDcrCommitRequest = function() {
    function o(i) {
      if (this.enclaveInfo = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.prototype.dcrIdHex = "", o.prototype.driverAttestationHash = "", o.prototype.enclaveInfo = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.dcrIdHex != null && Object.hasOwnProperty.call(e, "dcrIdHex") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dcrIdHex), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), e.enclaveInfo != null && e.enclaveInfo.length)
        for (let n = 0; n < e.enclaveInfo.length; ++n)
          $root.metering.EnclaveInfo.encode(e.enclaveInfo[n], t.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.MergeDcrCommitRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          case 2: {
            r.dcrIdHex = e.string();
            break;
          }
          case 3: {
            r.driverAttestationHash = e.string();
            break;
          }
          case 6: {
            r.enclaveInfo && r.enclaveInfo.length || (r.enclaveInfo = []), r.enclaveInfo.push($root.metering.EnclaveInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && !$util.isString(e.dcrIdHex))
        return "dcrIdHex: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.enclaveInfo != null && e.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(e.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let t = 0; t < e.enclaveInfo.length; ++t) {
          let n = $root.metering.EnclaveInfo.verify(e.enclaveInfo[t]);
          if (n)
            return "enclaveInfo." + n;
        }
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.MergeDcrCommitRequest)
        return e;
      let t = new $root.metering.MergeDcrCommitRequest();
      if (e.id != null && (t.id = String(e.id)), e.dcrIdHex != null && (t.dcrIdHex = String(e.dcrIdHex)), e.driverAttestationHash != null && (t.driverAttestationHash = String(e.driverAttestationHash)), e.enclaveInfo) {
        if (!Array.isArray(e.enclaveInfo))
          throw TypeError(".metering.MergeDcrCommitRequest.enclaveInfo: array expected");
        t.enclaveInfo = [];
        for (let n = 0; n < e.enclaveInfo.length; ++n) {
          if (typeof e.enclaveInfo[n] != "object")
            throw TypeError(".metering.MergeDcrCommitRequest.enclaveInfo: object expected");
          t.enclaveInfo[n] = $root.metering.EnclaveInfo.fromObject(e.enclaveInfo[n]);
        }
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.enclaveInfo = []), t.defaults && (n.id = "", n.dcrIdHex = "", n.driverAttestationHash = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && (n.dcrIdHex = e.dcrIdHex), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (n.driverAttestationHash = e.driverAttestationHash), e.enclaveInfo && e.enclaveInfo.length) {
        n.enclaveInfo = [];
        for (let r = 0; r < e.enclaveInfo.length; ++r)
          n.enclaveInfo[r] = $root.metering.EnclaveInfo.toObject(e.enclaveInfo[r], t);
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MergeDcrCommitRequest";
    }, o;
  }(), c.CreateDcrResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.CreateDcrResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.CreateDcrResponse ? e : new $root.metering.CreateDcrResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrResponse";
    }, o;
  }(), c.GetOrCreateDatasetScopeResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.GetOrCreateDatasetScopeResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.GetOrCreateDatasetScopeResponse)
        return e;
      let t = new $root.metering.GetOrCreateDatasetScopeResponse();
      return e.id != null && (t.id = String(e.id)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetOrCreateDatasetScopeResponse";
    }, o;
  }(), c.DcrInteractionResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.DcrInteractionResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.DcrInteractionResponse ? e : new $root.metering.DcrInteractionResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrInteractionResponse";
    }, o;
  }(), c.CreateDcrCommitResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.CreateDcrCommitResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.CreateDcrCommitResponse ? e : new $root.metering.CreateDcrCommitResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrCommitResponse";
    }, o;
  }(), c.MergeDcrCommitResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.MergeDcrCommitResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.MergeDcrCommitResponse ? e : new $root.metering.MergeDcrCommitResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MergeDcrCommitResponse";
    }, o;
  }(), c.StopDcrResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.StopDcrResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.StopDcrResponse ? e : new $root.metering.StopDcrResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.StopDcrResponse";
    }, o;
  }(), c.PublishDatasetResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.PublishDatasetResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.PublishDatasetResponse ? e : new $root.metering.PublishDatasetResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.PublishDatasetResponse";
    }, o;
  }(), c.CreateDatasetResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.CreateDatasetResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.CreateDatasetResponse)
        return e;
      let t = new $root.metering.CreateDatasetResponse();
      return e.id != null && (t.id = String(e.id)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDatasetResponse";
    }, o;
  }(), c.UnpublishDatasetResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.UnpublishDatasetResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.UnpublishDatasetResponse ? e : new $root.metering.UnpublishDatasetResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.UnpublishDatasetResponse";
    }, o;
  }(), c.WorkerMetadataRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.attestationSpec = null, o.prototype.scopeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.attestationSpec != null && Object.hasOwnProperty.call(e, "attestationSpec") && $root.attestation.AttestationSpecification.encode(e.attestationSpec, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.scopeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.WorkerMetadataRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.attestationSpec = $root.attestation.AttestationSpecification.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.scopeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.attestationSpec != null && e.hasOwnProperty("attestationSpec")) {
        let t = $root.attestation.AttestationSpecification.verify(e.attestationSpec);
        if (t)
          return "attestationSpec." + t;
      }
      return e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId) ? "scopeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.WorkerMetadataRequest)
        return e;
      let t = new $root.metering.WorkerMetadataRequest();
      if (e.attestationSpec != null) {
        if (typeof e.attestationSpec != "object")
          throw TypeError(".metering.WorkerMetadataRequest.attestationSpec: object expected");
        t.attestationSpec = $root.attestation.AttestationSpecification.fromObject(e.attestationSpec);
      }
      return e.scopeId != null && (t.scopeId = String(e.scopeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.attestationSpec = null, n.scopeId = ""), e.attestationSpec != null && e.hasOwnProperty("attestationSpec") && (n.attestationSpec = $root.attestation.AttestationSpecification.toObject(e.attestationSpec, t)), e.scopeId != null && e.hasOwnProperty("scopeId") && (n.scopeId = e.scopeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.WorkerMetadataRequest";
    }, o;
  }(), c.WorkerMetadataResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.maxExecutionSeconds = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.maxExecutionSeconds != null && Object.hasOwnProperty.call(e, "maxExecutionSeconds") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.maxExecutionSeconds), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.WorkerMetadataResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.maxExecutionSeconds = e.uint64();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.maxExecutionSeconds != null && e.hasOwnProperty("maxExecutionSeconds") && !$util.isInteger(e.maxExecutionSeconds) && !(e.maxExecutionSeconds && $util.isInteger(e.maxExecutionSeconds.low) && $util.isInteger(e.maxExecutionSeconds.high)) ? "maxExecutionSeconds: integer|Long expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.WorkerMetadataResponse)
        return e;
      let t = new $root.metering.WorkerMetadataResponse();
      return e.maxExecutionSeconds != null && ($util.Long ? (t.maxExecutionSeconds = $util.Long.fromValue(e.maxExecutionSeconds)).unsigned = !0 : typeof e.maxExecutionSeconds == "string" ? t.maxExecutionSeconds = parseInt(e.maxExecutionSeconds, 10) : typeof e.maxExecutionSeconds == "number" ? t.maxExecutionSeconds = e.maxExecutionSeconds : typeof e.maxExecutionSeconds == "object" && (t.maxExecutionSeconds = new $util.LongBits(e.maxExecutionSeconds.low >>> 0, e.maxExecutionSeconds.high >>> 0).toNumber(!0))), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if (t.defaults)
        if ($util.Long) {
          let r = new $util.Long(0, 0, !0);
          n.maxExecutionSeconds = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
        } else
          n.maxExecutionSeconds = t.longs === String ? "0" : 0;
      return e.maxExecutionSeconds != null && e.hasOwnProperty("maxExecutionSeconds") && (typeof e.maxExecutionSeconds == "number" ? n.maxExecutionSeconds = t.longs === String ? String(e.maxExecutionSeconds) : e.maxExecutionSeconds : n.maxExecutionSeconds = t.longs === String ? $util.Long.prototype.toString.call(e.maxExecutionSeconds) : t.longs === Number ? new $util.LongBits(e.maxExecutionSeconds.low >>> 0, e.maxExecutionSeconds.high >>> 0).toNumber(!0) : e.maxExecutionSeconds), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.WorkerMetadataResponse";
    }, o;
  }(), c.SubmitWorkerExecutionTimeRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.executionTimeSeconds = 0, o.prototype.attestationSpec = null, o.prototype.scopeId = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.executionTimeSeconds != null && Object.hasOwnProperty.call(e, "executionTimeSeconds") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.executionTimeSeconds), e.attestationSpec != null && Object.hasOwnProperty.call(e, "attestationSpec") && $root.attestation.AttestationSpecification.encode(e.attestationSpec, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.scopeId), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.SubmitWorkerExecutionTimeRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.executionTimeSeconds = e.uint32();
            break;
          }
          case 2: {
            r.attestationSpec = $root.attestation.AttestationSpecification.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.scopeId = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.executionTimeSeconds != null && e.hasOwnProperty("executionTimeSeconds") && !$util.isInteger(e.executionTimeSeconds))
        return "executionTimeSeconds: integer expected";
      if (e.attestationSpec != null && e.hasOwnProperty("attestationSpec")) {
        let t = $root.attestation.AttestationSpecification.verify(e.attestationSpec);
        if (t)
          return "attestationSpec." + t;
      }
      return e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId) ? "scopeId: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.SubmitWorkerExecutionTimeRequest)
        return e;
      let t = new $root.metering.SubmitWorkerExecutionTimeRequest();
      if (e.executionTimeSeconds != null && (t.executionTimeSeconds = e.executionTimeSeconds >>> 0), e.attestationSpec != null) {
        if (typeof e.attestationSpec != "object")
          throw TypeError(".metering.SubmitWorkerExecutionTimeRequest.attestationSpec: object expected");
        t.attestationSpec = $root.attestation.AttestationSpecification.fromObject(e.attestationSpec);
      }
      return e.scopeId != null && (t.scopeId = String(e.scopeId)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.executionTimeSeconds = 0, n.attestationSpec = null, n.scopeId = ""), e.executionTimeSeconds != null && e.hasOwnProperty("executionTimeSeconds") && (n.executionTimeSeconds = e.executionTimeSeconds), e.attestationSpec != null && e.hasOwnProperty("attestationSpec") && (n.attestationSpec = $root.attestation.AttestationSpecification.toObject(e.attestationSpec, t)), e.scopeId != null && e.hasOwnProperty("scopeId") && (n.scopeId = e.scopeId), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SubmitWorkerExecutionTimeRequest";
    }, o;
  }(), c.SubmitWorkerExecutionTimeResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.SubmitWorkerExecutionTimeResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.SubmitWorkerExecutionTimeResponse ? e : new $root.metering.SubmitWorkerExecutionTimeResponse();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SubmitWorkerExecutionTimeResponse";
    }, o;
  }(), c.SplickyCredentials = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.SplickyCredentials();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.SplickyCredentials ? e : new $root.metering.SplickyCredentials();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SplickyCredentials";
    }, o;
  }(), c.MicrosoftDspMember = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.member = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.member != null && Object.hasOwnProperty.call(e, "member") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.member), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.MicrosoftDspMember();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.member = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.member != null && e.hasOwnProperty("member") && !$util.isString(e.member) ? "member: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.MicrosoftDspMember)
        return e;
      let t = new $root.metering.MicrosoftDspMember();
      return e.member != null && (t.member = String(e.member)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.member = ""), e.member != null && e.hasOwnProperty("member") && (n.member = e.member), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MicrosoftDspMember";
    }, o;
  }(), c.CredentialsKind = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.splicky = null, o.prototype.microsoftDspMember = null;
    let i;
    return Object.defineProperty(o.prototype, "credentials", {
      get: $util.oneOfGetter(i = ["splicky", "microsoftDspMember"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.splicky != null && Object.hasOwnProperty.call(t, "splicky") && $root.metering.SplickyCredentials.encode(t.splicky, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.microsoftDspMember != null && Object.hasOwnProperty.call(t, "microsoftDspMember") && $root.metering.MicrosoftDspMember.encode(t.microsoftDspMember, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.metering.CredentialsKind();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.splicky = $root.metering.SplickyCredentials.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.microsoftDspMember = $root.metering.MicrosoftDspMember.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.splicky != null && t.hasOwnProperty("splicky")) {
        n.credentials = 1;
        {
          let r = $root.metering.SplickyCredentials.verify(t.splicky);
          if (r)
            return "splicky." + r;
        }
      }
      if (t.microsoftDspMember != null && t.hasOwnProperty("microsoftDspMember")) {
        if (n.credentials === 1)
          return "credentials: multiple values";
        n.credentials = 1;
        {
          let r = $root.metering.MicrosoftDspMember.verify(t.microsoftDspMember);
          if (r)
            return "microsoftDspMember." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.metering.CredentialsKind)
        return t;
      let n = new $root.metering.CredentialsKind();
      if (t.splicky != null) {
        if (typeof t.splicky != "object")
          throw TypeError(".metering.CredentialsKind.splicky: object expected");
        n.splicky = $root.metering.SplickyCredentials.fromObject(t.splicky);
      }
      if (t.microsoftDspMember != null) {
        if (typeof t.microsoftDspMember != "object")
          throw TypeError(".metering.CredentialsKind.microsoftDspMember: object expected");
        n.microsoftDspMember = $root.metering.MicrosoftDspMember.fromObject(t.microsoftDspMember);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.splicky != null && t.hasOwnProperty("splicky") && (r.splicky = $root.metering.SplickyCredentials.toObject(t.splicky, n), n.oneofs && (r.credentials = "splicky")), t.microsoftDspMember != null && t.hasOwnProperty("microsoftDspMember") && (r.microsoftDspMember = $root.metering.MicrosoftDspMember.toObject(t.microsoftDspMember, n), n.oneofs && (r.credentials = "microsoftDspMember")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/metering.CredentialsKind";
    }, o;
  }(), c.GetDataConnectorCredentialsRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.kind = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.kind != null && Object.hasOwnProperty.call(e, "kind") && $root.metering.CredentialsKind.encode(e.kind, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.GetDataConnectorCredentialsRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.kind = $root.metering.CredentialsKind.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.kind != null && e.hasOwnProperty("kind")) {
        let t = $root.metering.CredentialsKind.verify(e.kind);
        if (t)
          return "kind." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.GetDataConnectorCredentialsRequest)
        return e;
      let t = new $root.metering.GetDataConnectorCredentialsRequest();
      if (e.kind != null) {
        if (typeof e.kind != "object")
          throw TypeError(".metering.GetDataConnectorCredentialsRequest.kind: object expected");
        t.kind = $root.metering.CredentialsKind.fromObject(e.kind);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.kind = null), e.kind != null && e.hasOwnProperty("kind") && (n.kind = $root.metering.CredentialsKind.toObject(e.kind, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetDataConnectorCredentialsRequest";
    }, o;
  }(), c.GetDataConnectorCredentialsResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.credentials = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.credentials != null && Object.hasOwnProperty.call(e, "credentials") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.credentials), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.GetDataConnectorCredentialsResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.credentials = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.credentials != null && e.hasOwnProperty("credentials") && !$util.isString(e.credentials) ? "credentials: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.GetDataConnectorCredentialsResponse)
        return e;
      let t = new $root.metering.GetDataConnectorCredentialsResponse();
      return e.credentials != null && (t.credentials = String(e.credentials)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.credentials = ""), e.credentials != null && e.hasOwnProperty("credentials") && (n.credentials = e.credentials), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetDataConnectorCredentialsResponse";
    }, o;
  }(), c.GetAzureCommunicationCredentialsRequest = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.GetAzureCommunicationCredentialsRequest();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.metering.GetAzureCommunicationCredentialsRequest ? e : new $root.metering.GetAzureCommunicationCredentialsRequest();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetAzureCommunicationCredentialsRequest";
    }, o;
  }(), c.GetAzureCommunicationCredentialsResponse = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.endpoint = "", o.prototype.accessKey = "", o.prototype.senderEmail = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.endpoint != null && Object.hasOwnProperty.call(e, "endpoint") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.endpoint), e.accessKey != null && Object.hasOwnProperty.call(e, "accessKey") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.accessKey), e.senderEmail != null && Object.hasOwnProperty.call(e, "senderEmail") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.senderEmail), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.metering.GetAzureCommunicationCredentialsResponse();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.endpoint = e.string();
            break;
          }
          case 2: {
            r.accessKey = e.string();
            break;
          }
          case 3: {
            r.senderEmail = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.endpoint != null && e.hasOwnProperty("endpoint") && !$util.isString(e.endpoint) ? "endpoint: string expected" : e.accessKey != null && e.hasOwnProperty("accessKey") && !$util.isString(e.accessKey) ? "accessKey: string expected" : e.senderEmail != null && e.hasOwnProperty("senderEmail") && !$util.isString(e.senderEmail) ? "senderEmail: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.metering.GetAzureCommunicationCredentialsResponse)
        return e;
      let t = new $root.metering.GetAzureCommunicationCredentialsResponse();
      return e.endpoint != null && (t.endpoint = String(e.endpoint)), e.accessKey != null && (t.accessKey = String(e.accessKey)), e.senderEmail != null && (t.senderEmail = String(e.senderEmail)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.endpoint = "", n.accessKey = "", n.senderEmail = ""), e.endpoint != null && e.hasOwnProperty("endpoint") && (n.endpoint = e.endpoint), e.accessKey != null && e.hasOwnProperty("accessKey") && (n.accessKey = e.accessKey), e.senderEmail != null && e.hasOwnProperty("senderEmail") && (n.senderEmail = e.senderEmail), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetAzureCommunicationCredentialsResponse";
    }, o;
  }(), c;
})(), integrity_store_api = $root.integrity_store_api = (() => {
  const c = {};
  return c.IntegrityStoreRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.cas = null;
    let i;
    return Object.defineProperty(o.prototype, "request", {
      get: $util.oneOfGetter(i = ["cas"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.cas != null && Object.hasOwnProperty.call(t, "cas") && $root.integrity_store_api.CompareAndSwapRequest.encode(t.cas, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.integrity_store_api.IntegrityStoreRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.cas = $root.integrity_store_api.CompareAndSwapRequest.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.cas != null && t.hasOwnProperty("cas")) {
        let n = $root.integrity_store_api.CompareAndSwapRequest.verify(t.cas);
        if (n)
          return "cas." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.integrity_store_api.IntegrityStoreRequest)
        return t;
      let n = new $root.integrity_store_api.IntegrityStoreRequest();
      if (t.cas != null) {
        if (typeof t.cas != "object")
          throw TypeError(".integrity_store_api.IntegrityStoreRequest.cas: object expected");
        n.cas = $root.integrity_store_api.CompareAndSwapRequest.fromObject(t.cas);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.cas != null && t.hasOwnProperty("cas") && (r.cas = $root.integrity_store_api.CompareAndSwapRequest.toObject(t.cas, n), n.oneofs && (r.request = "cas")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/integrity_store_api.IntegrityStoreRequest";
    }, o;
  }(), c.IntegrityStoreResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.cas = null;
    let i;
    return Object.defineProperty(o.prototype, "response", {
      get: $util.oneOfGetter(i = ["cas"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.cas != null && Object.hasOwnProperty.call(t, "cas") && $root.integrity_store_api.CompareAndSwapResponse.encode(t.cas, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.integrity_store_api.IntegrityStoreResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.cas = $root.integrity_store_api.CompareAndSwapResponse.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.cas != null && t.hasOwnProperty("cas")) {
        let n = $root.integrity_store_api.CompareAndSwapResponse.verify(t.cas);
        if (n)
          return "cas." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.integrity_store_api.IntegrityStoreResponse)
        return t;
      let n = new $root.integrity_store_api.IntegrityStoreResponse();
      if (t.cas != null) {
        if (typeof t.cas != "object")
          throw TypeError(".integrity_store_api.IntegrityStoreResponse.cas: object expected");
        n.cas = $root.integrity_store_api.CompareAndSwapResponse.fromObject(t.cas);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.cas != null && t.hasOwnProperty("cas") && (r.cas = $root.integrity_store_api.CompareAndSwapResponse.toObject(t.cas, n), n.oneofs && (r.response = "cas")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/integrity_store_api.IntegrityStoreResponse";
    }, o;
  }(), c.CompareAndSwapRequest = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.id = "", o.prototype.contentType = "", o.prototype.expectedCasIndex = null, o.prototype.newValue = null;
    let i;
    return Object.defineProperty(o.prototype, "_expectedCasIndex", {
      get: $util.oneOfGetter(i = ["expectedCasIndex"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_newValue", {
      get: $util.oneOfGetter(i = ["newValue"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.id), t.contentType != null && Object.hasOwnProperty.call(t, "contentType") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.contentType), t.expectedCasIndex != null && Object.hasOwnProperty.call(t, "expectedCasIndex") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(t.expectedCasIndex), t.newValue != null && Object.hasOwnProperty.call(t, "newValue") && $root.integrity_store_api.IntegrityStoreValue.encode(t.newValue, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.integrity_store_api.CompareAndSwapRequest();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.id = t.string();
            break;
          }
          case 2: {
            u.contentType = t.string();
            break;
          }
          case 3: {
            u.expectedCasIndex = t.uint64();
            break;
          }
          case 4: {
            u.newValue = $root.integrity_store_api.IntegrityStoreValue.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
        return "id: string expected";
      if (t.contentType != null && t.hasOwnProperty("contentType") && !$util.isString(t.contentType))
        return "contentType: string expected";
      if (t.expectedCasIndex != null && t.hasOwnProperty("expectedCasIndex") && !$util.isInteger(t.expectedCasIndex) && !(t.expectedCasIndex && $util.isInteger(t.expectedCasIndex.low) && $util.isInteger(t.expectedCasIndex.high)))
        return "expectedCasIndex: integer|Long expected";
      if (t.newValue != null && t.hasOwnProperty("newValue")) {
        let n = $root.integrity_store_api.IntegrityStoreValue.verify(t.newValue);
        if (n)
          return "newValue." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.integrity_store_api.CompareAndSwapRequest)
        return t;
      let n = new $root.integrity_store_api.CompareAndSwapRequest();
      if (t.id != null && (n.id = String(t.id)), t.contentType != null && (n.contentType = String(t.contentType)), t.expectedCasIndex != null && ($util.Long ? (n.expectedCasIndex = $util.Long.fromValue(t.expectedCasIndex)).unsigned = !0 : typeof t.expectedCasIndex == "string" ? n.expectedCasIndex = parseInt(t.expectedCasIndex, 10) : typeof t.expectedCasIndex == "number" ? n.expectedCasIndex = t.expectedCasIndex : typeof t.expectedCasIndex == "object" && (n.expectedCasIndex = new $util.LongBits(t.expectedCasIndex.low >>> 0, t.expectedCasIndex.high >>> 0).toNumber(!0))), t.newValue != null) {
        if (typeof t.newValue != "object")
          throw TypeError(".integrity_store_api.CompareAndSwapRequest.newValue: object expected");
        n.newValue = $root.integrity_store_api.IntegrityStoreValue.fromObject(t.newValue);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.id = "", r.contentType = ""), t.id != null && t.hasOwnProperty("id") && (r.id = t.id), t.contentType != null && t.hasOwnProperty("contentType") && (r.contentType = t.contentType), t.expectedCasIndex != null && t.hasOwnProperty("expectedCasIndex") && (typeof t.expectedCasIndex == "number" ? r.expectedCasIndex = n.longs === String ? String(t.expectedCasIndex) : t.expectedCasIndex : r.expectedCasIndex = n.longs === String ? $util.Long.prototype.toString.call(t.expectedCasIndex) : n.longs === Number ? new $util.LongBits(t.expectedCasIndex.low >>> 0, t.expectedCasIndex.high >>> 0).toNumber(!0) : t.expectedCasIndex, n.oneofs && (r._expectedCasIndex = "expectedCasIndex")), t.newValue != null && t.hasOwnProperty("newValue") && (r.newValue = $root.integrity_store_api.IntegrityStoreValue.toObject(t.newValue, n), n.oneofs && (r._newValue = "newValue")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/integrity_store_api.CompareAndSwapRequest";
    }, o;
  }(), c.CompareAndSwapResponse = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.swapped = !1, o.prototype.previousCasIndex = null, o.prototype.previousValue = null;
    let i;
    return Object.defineProperty(o.prototype, "_previousCasIndex", {
      get: $util.oneOfGetter(i = ["previousCasIndex"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_previousValue", {
      get: $util.oneOfGetter(i = ["previousValue"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.swapped != null && Object.hasOwnProperty.call(t, "swapped") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(t.swapped), t.previousCasIndex != null && Object.hasOwnProperty.call(t, "previousCasIndex") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(t.previousCasIndex), t.previousValue != null && Object.hasOwnProperty.call(t, "previousValue") && $root.integrity_store_api.IntegrityStoreValue.encode(t.previousValue, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.integrity_store_api.CompareAndSwapResponse();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.swapped = t.bool();
            break;
          }
          case 2: {
            u.previousCasIndex = t.uint64();
            break;
          }
          case 3: {
            u.previousValue = $root.integrity_store_api.IntegrityStoreValue.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.swapped != null && t.hasOwnProperty("swapped") && typeof t.swapped != "boolean")
        return "swapped: boolean expected";
      if (t.previousCasIndex != null && t.hasOwnProperty("previousCasIndex") && !$util.isInteger(t.previousCasIndex) && !(t.previousCasIndex && $util.isInteger(t.previousCasIndex.low) && $util.isInteger(t.previousCasIndex.high)))
        return "previousCasIndex: integer|Long expected";
      if (t.previousValue != null && t.hasOwnProperty("previousValue")) {
        let n = $root.integrity_store_api.IntegrityStoreValue.verify(t.previousValue);
        if (n)
          return "previousValue." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.integrity_store_api.CompareAndSwapResponse)
        return t;
      let n = new $root.integrity_store_api.CompareAndSwapResponse();
      if (t.swapped != null && (n.swapped = !!t.swapped), t.previousCasIndex != null && ($util.Long ? (n.previousCasIndex = $util.Long.fromValue(t.previousCasIndex)).unsigned = !0 : typeof t.previousCasIndex == "string" ? n.previousCasIndex = parseInt(t.previousCasIndex, 10) : typeof t.previousCasIndex == "number" ? n.previousCasIndex = t.previousCasIndex : typeof t.previousCasIndex == "object" && (n.previousCasIndex = new $util.LongBits(t.previousCasIndex.low >>> 0, t.previousCasIndex.high >>> 0).toNumber(!0))), t.previousValue != null) {
        if (typeof t.previousValue != "object")
          throw TypeError(".integrity_store_api.CompareAndSwapResponse.previousValue: object expected");
        n.previousValue = $root.integrity_store_api.IntegrityStoreValue.fromObject(t.previousValue);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.swapped = !1), t.swapped != null && t.hasOwnProperty("swapped") && (r.swapped = t.swapped), t.previousCasIndex != null && t.hasOwnProperty("previousCasIndex") && (typeof t.previousCasIndex == "number" ? r.previousCasIndex = n.longs === String ? String(t.previousCasIndex) : t.previousCasIndex : r.previousCasIndex = n.longs === String ? $util.Long.prototype.toString.call(t.previousCasIndex) : n.longs === Number ? new $util.LongBits(t.previousCasIndex.low >>> 0, t.previousCasIndex.high >>> 0).toNumber(!0) : t.previousCasIndex, n.oneofs && (r._previousCasIndex = "previousCasIndex")), t.previousValue != null && t.hasOwnProperty("previousValue") && (r.previousValue = $root.integrity_store_api.IntegrityStoreValue.toObject(t.previousValue, n), n.oneofs && (r._previousValue = "previousValue")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/integrity_store_api.CompareAndSwapResponse";
    }, o;
  }(), c.IntegrityStoreValue = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.version = 0, o.prototype.plaintextContent = null, o.prototype.plaintextSignature = null, o.prototype.encryptedContent = null;
    let i;
    return Object.defineProperty(o.prototype, "_plaintextContent", {
      get: $util.oneOfGetter(i = ["plaintextContent"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_plaintextSignature", {
      get: $util.oneOfGetter(i = ["plaintextSignature"]),
      set: $util.oneOfSetter(i)
    }), Object.defineProperty(o.prototype, "_encryptedContent", {
      get: $util.oneOfGetter(i = ["encryptedContent"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.version != null && Object.hasOwnProperty.call(t, "version") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(t.version), t.plaintextContent != null && Object.hasOwnProperty.call(t, "plaintextContent") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.plaintextContent), t.plaintextSignature != null && Object.hasOwnProperty.call(t, "plaintextSignature") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(t.plaintextSignature), t.encryptedContent != null && Object.hasOwnProperty.call(t, "encryptedContent") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(t.encryptedContent), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.integrity_store_api.IntegrityStoreValue();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.version = t.uint32();
            break;
          }
          case 2: {
            u.plaintextContent = t.string();
            break;
          }
          case 3: {
            u.plaintextSignature = t.bytes();
            break;
          }
          case 4: {
            u.encryptedContent = t.bytes();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.version != null && t.hasOwnProperty("version") && !$util.isInteger(t.version) ? "version: integer expected" : t.plaintextContent != null && t.hasOwnProperty("plaintextContent") && !$util.isString(t.plaintextContent) ? "plaintextContent: string expected" : t.plaintextSignature != null && t.hasOwnProperty("plaintextSignature") && !(t.plaintextSignature && typeof t.plaintextSignature.length == "number" || $util.isString(t.plaintextSignature)) ? "plaintextSignature: buffer expected" : t.encryptedContent != null && t.hasOwnProperty("encryptedContent") && !(t.encryptedContent && typeof t.encryptedContent.length == "number" || $util.isString(t.encryptedContent)) ? "encryptedContent: buffer expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.integrity_store_api.IntegrityStoreValue)
        return t;
      let n = new $root.integrity_store_api.IntegrityStoreValue();
      return t.version != null && (n.version = t.version >>> 0), t.plaintextContent != null && (n.plaintextContent = String(t.plaintextContent)), t.plaintextSignature != null && (typeof t.plaintextSignature == "string" ? $util.base64.decode(t.plaintextSignature, n.plaintextSignature = $util.newBuffer($util.base64.length(t.plaintextSignature)), 0) : t.plaintextSignature.length >= 0 && (n.plaintextSignature = t.plaintextSignature)), t.encryptedContent != null && (typeof t.encryptedContent == "string" ? $util.base64.decode(t.encryptedContent, n.encryptedContent = $util.newBuffer($util.base64.length(t.encryptedContent)), 0) : t.encryptedContent.length >= 0 && (n.encryptedContent = t.encryptedContent)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.version = 0), t.version != null && t.hasOwnProperty("version") && (r.version = t.version), t.plaintextContent != null && t.hasOwnProperty("plaintextContent") && (r.plaintextContent = t.plaintextContent, n.oneofs && (r._plaintextContent = "plaintextContent")), t.plaintextSignature != null && t.hasOwnProperty("plaintextSignature") && (r.plaintextSignature = n.bytes === String ? $util.base64.encode(t.plaintextSignature, 0, t.plaintextSignature.length) : n.bytes === Array ? Array.prototype.slice.call(t.plaintextSignature) : t.plaintextSignature, n.oneofs && (r._plaintextSignature = "plaintextSignature")), t.encryptedContent != null && t.hasOwnProperty("encryptedContent") && (r.encryptedContent = n.bytes === String ? $util.base64.encode(t.encryptedContent, 0, t.encryptedContent.length) : n.bytes === Array ? Array.prototype.slice.call(t.encryptedContent) : t.encryptedContent, n.oneofs && (r._encryptedContent = "encryptedContent")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/integrity_store_api.IntegrityStoreValue";
    }, o;
  }(), c;
})(), permutive = $root.permutive = (() => {
  const c = {};
  return c.ImportRole = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.permutive.ImportRole();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.permutive.ImportRole ? e : new $root.permutive.ImportRole();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.ImportRole";
    }, o;
  }(), c.ExportRole = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.permutive.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.permutive.ExportRole();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.permutive.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.permutive.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.permutive.ExportRole)
        return e;
      let t = new $root.permutive.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".permutive.ExportRole.input: object expected");
        t.input = $root.permutive.SinkInput.fromObject(e.input);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null), e.input != null && e.hasOwnProperty("input") && (n.input = $root.permutive.SinkInput.toObject(e.input, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.ExportRole";
    }, o;
  }(), c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.permutive.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.permutive.SingleFile)
        return e;
      let t = new $root.permutive.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.permutive.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.permutive.RawFile ? e : new $root.permutive.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.permutive.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.permutive.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.permutive.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.permutive.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.permutive.ZipFile)
        return t;
      let n = new $root.permutive.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".permutive.ZipFile.singleFile: object expected");
        n.singleFile = $root.permutive.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.permutive.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/permutive.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.permutive.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.permutive.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.permutive.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.permutive.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.permutive.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.permutive.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.permutive.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.permutive.SinkInput)
        return t;
      let n = new $root.permutive.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".permutive.SinkInput.raw: object expected");
        n.raw = $root.permutive.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".permutive.SinkInput.zip: object expected");
        n.zip = $root.permutive.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.permutive.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.permutive.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/permutive.SinkInput";
    }, o;
  }(), c.PermutiveWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.credentialsDependency = "", o.prototype.importRole = null, o.prototype.exportRole = null, o.prototype.importId = "", o.prototype.segmentName = "", o.prototype.segmentCode = "", o.prototype.inputHasHeaders = !1;
    let i;
    return Object.defineProperty(o.prototype, "role", {
      get: $util.oneOfGetter(i = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.credentialsDependency != null && Object.hasOwnProperty.call(t, "credentialsDependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.credentialsDependency), t.importRole != null && Object.hasOwnProperty.call(t, "importRole") && $root.permutive.ImportRole.encode(t.importRole, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.exportRole != null && Object.hasOwnProperty.call(t, "exportRole") && $root.permutive.ExportRole.encode(t.exportRole, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.importId != null && Object.hasOwnProperty.call(t, "importId") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.importId), t.segmentName != null && Object.hasOwnProperty.call(t, "segmentName") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.segmentName), t.segmentCode != null && Object.hasOwnProperty.call(t, "segmentCode") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(t.segmentCode), t.inputHasHeaders != null && Object.hasOwnProperty.call(t, "inputHasHeaders") && n.uint32(
        /* id 7, wireType 0 =*/
        56
      ).bool(t.inputHasHeaders), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.permutive.PermutiveWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.credentialsDependency = t.string();
            break;
          }
          case 2: {
            u.importRole = $root.permutive.ImportRole.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.exportRole = $root.permutive.ExportRole.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.importId = t.string();
            break;
          }
          case 5: {
            u.segmentName = t.string();
            break;
          }
          case 6: {
            u.segmentCode = t.string();
            break;
          }
          case 7: {
            u.inputHasHeaders = t.bool();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && !$util.isString(t.credentialsDependency))
        return "credentialsDependency: string expected";
      if (t.importRole != null && t.hasOwnProperty("importRole")) {
        n.role = 1;
        {
          let r = $root.permutive.ImportRole.verify(t.importRole);
          if (r)
            return "importRole." + r;
        }
      }
      if (t.exportRole != null && t.hasOwnProperty("exportRole")) {
        if (n.role === 1)
          return "role: multiple values";
        n.role = 1;
        {
          let r = $root.permutive.ExportRole.verify(t.exportRole);
          if (r)
            return "exportRole." + r;
        }
      }
      return t.importId != null && t.hasOwnProperty("importId") && !$util.isString(t.importId) ? "importId: string expected" : t.segmentName != null && t.hasOwnProperty("segmentName") && !$util.isString(t.segmentName) ? "segmentName: string expected" : t.segmentCode != null && t.hasOwnProperty("segmentCode") && !$util.isString(t.segmentCode) ? "segmentCode: string expected" : t.inputHasHeaders != null && t.hasOwnProperty("inputHasHeaders") && typeof t.inputHasHeaders != "boolean" ? "inputHasHeaders: boolean expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.permutive.PermutiveWorkerConfiguration)
        return t;
      let n = new $root.permutive.PermutiveWorkerConfiguration();
      if (t.credentialsDependency != null && (n.credentialsDependency = String(t.credentialsDependency)), t.importRole != null) {
        if (typeof t.importRole != "object")
          throw TypeError(".permutive.PermutiveWorkerConfiguration.importRole: object expected");
        n.importRole = $root.permutive.ImportRole.fromObject(t.importRole);
      }
      if (t.exportRole != null) {
        if (typeof t.exportRole != "object")
          throw TypeError(".permutive.PermutiveWorkerConfiguration.exportRole: object expected");
        n.exportRole = $root.permutive.ExportRole.fromObject(t.exportRole);
      }
      return t.importId != null && (n.importId = String(t.importId)), t.segmentName != null && (n.segmentName = String(t.segmentName)), t.segmentCode != null && (n.segmentCode = String(t.segmentCode)), t.inputHasHeaders != null && (n.inputHasHeaders = !!t.inputHasHeaders), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.credentialsDependency = "", r.importId = "", r.segmentName = "", r.segmentCode = "", r.inputHasHeaders = !1), t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && (r.credentialsDependency = t.credentialsDependency), t.importRole != null && t.hasOwnProperty("importRole") && (r.importRole = $root.permutive.ImportRole.toObject(t.importRole, n), n.oneofs && (r.role = "importRole")), t.exportRole != null && t.hasOwnProperty("exportRole") && (r.exportRole = $root.permutive.ExportRole.toObject(t.exportRole, n), n.oneofs && (r.role = "exportRole")), t.importId != null && t.hasOwnProperty("importId") && (r.importId = t.importId), t.segmentName != null && t.hasOwnProperty("segmentName") && (r.segmentName = t.segmentName), t.segmentCode != null && t.hasOwnProperty("segmentCode") && (r.segmentCode = t.segmentCode), t.inputHasHeaders != null && t.hasOwnProperty("inputHasHeaders") && (r.inputHasHeaders = t.inputHasHeaders), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/permutive.PermutiveWorkerConfiguration";
    }, o;
  }(), c;
})(), salesforce = $root.salesforce = (() => {
  const c = {};
  return c.Core = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.salesforce.Core();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.salesforce.Core ? e : new $root.salesforce.Core();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.Core";
    }, o;
  }(), c.MarketingCloud = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.salesforce.MarketingCloud();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.salesforce.MarketingCloud ? e : new $root.salesforce.MarketingCloud();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.MarketingCloud";
    }, o;
  }(), c.ImportRole = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.core = null, o.prototype.marketingCloud = null;
    let i;
    return Object.defineProperty(o.prototype, "productType", {
      get: $util.oneOfGetter(i = ["core", "marketingCloud"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.core != null && Object.hasOwnProperty.call(t, "core") && $root.salesforce.Core.encode(t.core, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t.marketingCloud != null && Object.hasOwnProperty.call(t, "marketingCloud") && $root.salesforce.MarketingCloud.encode(t.marketingCloud, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.salesforce.ImportRole();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.core = $root.salesforce.Core.decode(t, t.uint32());
            break;
          }
          case 2: {
            u.marketingCloud = $root.salesforce.MarketingCloud.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.core != null && t.hasOwnProperty("core")) {
        n.productType = 1;
        {
          let r = $root.salesforce.Core.verify(t.core);
          if (r)
            return "core." + r;
        }
      }
      if (t.marketingCloud != null && t.hasOwnProperty("marketingCloud")) {
        if (n.productType === 1)
          return "productType: multiple values";
        n.productType = 1;
        {
          let r = $root.salesforce.MarketingCloud.verify(t.marketingCloud);
          if (r)
            return "marketingCloud." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.salesforce.ImportRole)
        return t;
      let n = new $root.salesforce.ImportRole();
      if (t.core != null) {
        if (typeof t.core != "object")
          throw TypeError(".salesforce.ImportRole.core: object expected");
        n.core = $root.salesforce.Core.fromObject(t.core);
      }
      if (t.marketingCloud != null) {
        if (typeof t.marketingCloud != "object")
          throw TypeError(".salesforce.ImportRole.marketingCloud: object expected");
        n.marketingCloud = $root.salesforce.MarketingCloud.fromObject(t.marketingCloud);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.core != null && t.hasOwnProperty("core") && (r.core = $root.salesforce.Core.toObject(t.core, n), n.oneofs && (r.productType = "core")), t.marketingCloud != null && t.hasOwnProperty("marketingCloud") && (r.marketingCloud = $root.salesforce.MarketingCloud.toObject(t.marketingCloud, n), n.oneofs && (r.productType = "marketingCloud")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/salesforce.ImportRole";
    }, o;
  }(), c.ExportRole = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.salesforce.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.salesforce.ExportRole();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.salesforce.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.salesforce.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.salesforce.ExportRole)
        return e;
      let t = new $root.salesforce.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".salesforce.ExportRole.input: object expected");
        t.input = $root.salesforce.SinkInput.fromObject(e.input);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null), e.input != null && e.hasOwnProperty("input") && (n.input = $root.salesforce.SinkInput.toObject(e.input, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.ExportRole";
    }, o;
  }(), c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.salesforce.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.salesforce.SingleFile)
        return e;
      let t = new $root.salesforce.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.salesforce.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.salesforce.RawFile ? e : new $root.salesforce.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.salesforce.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.salesforce.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.salesforce.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.salesforce.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.salesforce.ZipFile)
        return t;
      let n = new $root.salesforce.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".salesforce.ZipFile.singleFile: object expected");
        n.singleFile = $root.salesforce.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.salesforce.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/salesforce.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.salesforce.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.salesforce.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.salesforce.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.salesforce.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.salesforce.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.salesforce.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.salesforce.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.salesforce.SinkInput)
        return t;
      let n = new $root.salesforce.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".salesforce.SinkInput.raw: object expected");
        n.raw = $root.salesforce.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".salesforce.SinkInput.zip: object expected");
        n.zip = $root.salesforce.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.salesforce.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.salesforce.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/salesforce.SinkInput";
    }, o;
  }(), c.SalesforceWorkerConfiguration = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.credentialsDependency = "", o.prototype.importRole = null, o.prototype.exportRole = null, o.prototype.domainUrl = "", o.prototype.apiName = "";
    let i;
    return Object.defineProperty(o.prototype, "role", {
      get: $util.oneOfGetter(i = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.credentialsDependency != null && Object.hasOwnProperty.call(t, "credentialsDependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.credentialsDependency), t.importRole != null && Object.hasOwnProperty.call(t, "importRole") && $root.salesforce.ImportRole.encode(t.importRole, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.exportRole != null && Object.hasOwnProperty.call(t, "exportRole") && $root.salesforce.ExportRole.encode(t.exportRole, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.domainUrl != null && Object.hasOwnProperty.call(t, "domainUrl") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.domainUrl), t.apiName != null && Object.hasOwnProperty.call(t, "apiName") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.apiName), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.salesforce.SalesforceWorkerConfiguration();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.credentialsDependency = t.string();
            break;
          }
          case 2: {
            u.importRole = $root.salesforce.ImportRole.decode(t, t.uint32());
            break;
          }
          case 3: {
            u.exportRole = $root.salesforce.ExportRole.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.domainUrl = t.string();
            break;
          }
          case 5: {
            u.apiName = t.string();
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && !$util.isString(t.credentialsDependency))
        return "credentialsDependency: string expected";
      if (t.importRole != null && t.hasOwnProperty("importRole")) {
        n.role = 1;
        {
          let r = $root.salesforce.ImportRole.verify(t.importRole);
          if (r)
            return "importRole." + r;
        }
      }
      if (t.exportRole != null && t.hasOwnProperty("exportRole")) {
        if (n.role === 1)
          return "role: multiple values";
        n.role = 1;
        {
          let r = $root.salesforce.ExportRole.verify(t.exportRole);
          if (r)
            return "exportRole." + r;
        }
      }
      return t.domainUrl != null && t.hasOwnProperty("domainUrl") && !$util.isString(t.domainUrl) ? "domainUrl: string expected" : t.apiName != null && t.hasOwnProperty("apiName") && !$util.isString(t.apiName) ? "apiName: string expected" : null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.salesforce.SalesforceWorkerConfiguration)
        return t;
      let n = new $root.salesforce.SalesforceWorkerConfiguration();
      if (t.credentialsDependency != null && (n.credentialsDependency = String(t.credentialsDependency)), t.importRole != null) {
        if (typeof t.importRole != "object")
          throw TypeError(".salesforce.SalesforceWorkerConfiguration.importRole: object expected");
        n.importRole = $root.salesforce.ImportRole.fromObject(t.importRole);
      }
      if (t.exportRole != null) {
        if (typeof t.exportRole != "object")
          throw TypeError(".salesforce.SalesforceWorkerConfiguration.exportRole: object expected");
        n.exportRole = $root.salesforce.ExportRole.fromObject(t.exportRole);
      }
      return t.domainUrl != null && (n.domainUrl = String(t.domainUrl)), t.apiName != null && (n.apiName = String(t.apiName)), n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.credentialsDependency = "", r.domainUrl = "", r.apiName = ""), t.credentialsDependency != null && t.hasOwnProperty("credentialsDependency") && (r.credentialsDependency = t.credentialsDependency), t.importRole != null && t.hasOwnProperty("importRole") && (r.importRole = $root.salesforce.ImportRole.toObject(t.importRole, n), n.oneofs && (r.role = "importRole")), t.exportRole != null && t.hasOwnProperty("exportRole") && (r.exportRole = $root.salesforce.ExportRole.toObject(t.exportRole, n), n.oneofs && (r.role = "exportRole")), t.domainUrl != null && t.hasOwnProperty("domainUrl") && (r.domainUrl = t.domainUrl), t.apiName != null && t.hasOwnProperty("apiName") && (r.apiName = t.apiName), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/salesforce.SalesforceWorkerConfiguration";
    }, o;
  }(), c;
})(), synth_data = $root.synth_data = (() => {
  const c = {};
  return c.SyntheticDataConf = function() {
    function o(i) {
      if (this.columns = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.columns = $util.emptyArray, o.prototype.outputOriginalDataStats = !1, o.prototype.epsilon = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.columns != null && e.columns.length)
        for (let n = 0; n < e.columns.length; ++n)
          $root.synth_data.Column.encode(e.columns[n], t.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e.outputOriginalDataStats != null && Object.hasOwnProperty.call(e, "outputOriginalDataStats") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.outputOriginalDataStats), e.epsilon != null && Object.hasOwnProperty.call(e, "epsilon") && t.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(e.epsilon), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.synth_data.SyntheticDataConf();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.columns && r.columns.length || (r.columns = []), r.columns.push($root.synth_data.Column.decode(e, e.uint32()));
            break;
          }
          case 2: {
            r.outputOriginalDataStats = e.bool();
            break;
          }
          case 3: {
            r.epsilon = e.float();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.columns != null && e.hasOwnProperty("columns")) {
        if (!Array.isArray(e.columns))
          return "columns: array expected";
        for (let t = 0; t < e.columns.length; ++t) {
          let n = $root.synth_data.Column.verify(e.columns[t]);
          if (n)
            return "columns." + n;
        }
      }
      return e.outputOriginalDataStats != null && e.hasOwnProperty("outputOriginalDataStats") && typeof e.outputOriginalDataStats != "boolean" ? "outputOriginalDataStats: boolean expected" : e.epsilon != null && e.hasOwnProperty("epsilon") && typeof e.epsilon != "number" ? "epsilon: number expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.synth_data.SyntheticDataConf)
        return e;
      let t = new $root.synth_data.SyntheticDataConf();
      if (e.columns) {
        if (!Array.isArray(e.columns))
          throw TypeError(".synth_data.SyntheticDataConf.columns: array expected");
        t.columns = [];
        for (let n = 0; n < e.columns.length; ++n) {
          if (typeof e.columns[n] != "object")
            throw TypeError(".synth_data.SyntheticDataConf.columns: object expected");
          t.columns[n] = $root.synth_data.Column.fromObject(e.columns[n]);
        }
      }
      return e.outputOriginalDataStats != null && (t.outputOriginalDataStats = !!e.outputOriginalDataStats), e.epsilon != null && (t.epsilon = Number(e.epsilon)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.columns = []), t.defaults && (n.outputOriginalDataStats = !1, n.epsilon = 0), e.columns && e.columns.length) {
        n.columns = [];
        for (let r = 0; r < e.columns.length; ++r)
          n.columns[r] = $root.synth_data.Column.toObject(e.columns[r], t);
      }
      return e.outputOriginalDataStats != null && e.hasOwnProperty("outputOriginalDataStats") && (n.outputOriginalDataStats = e.outputOriginalDataStats), e.epsilon != null && e.hasOwnProperty("epsilon") && (n.epsilon = t.json && !isFinite(e.epsilon) ? String(e.epsilon) : e.epsilon), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.SyntheticDataConf";
    }, o;
  }(), c.Mask = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.format = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.format), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.synth_data.Mask();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.format = e.int32();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.format != null && e.hasOwnProperty("format"))
        switch (e.format) {
          default:
            return "format: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
            break;
        }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.synth_data.Mask)
        return e;
      let t = new $root.synth_data.Mask();
      switch (e.format) {
        default:
          if (typeof e.format == "number") {
            t.format = e.format;
            break;
          }
          break;
        case "GENERIC_STRING":
        case 0:
          t.format = 0;
          break;
        case "GENERIC_NUMBER":
        case 1:
          t.format = 1;
          break;
        case "NAME":
        case 2:
          t.format = 2;
          break;
        case "ADDRESS":
        case 3:
          t.format = 3;
          break;
        case "POSTCODE":
        case 4:
          t.format = 4;
          break;
        case "PHONE_NUMBER":
        case 5:
          t.format = 5;
          break;
        case "SOCIAL_SECURITY_NUMBER":
        case 6:
          t.format = 6;
          break;
        case "EMAIL":
        case 7:
          t.format = 7;
          break;
        case "DATE":
        case 8:
          t.format = 8;
          break;
        case "TIMESTAMP":
        case 9:
          t.format = 9;
          break;
        case "IBAN":
        case 10:
          t.format = 10;
          break;
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.format = t.enums === String ? "GENERIC_STRING" : 0), e.format != null && e.hasOwnProperty("format") && (n.format = t.enums === String ? $root.synth_data.Mask.MaskFormat[e.format] === void 0 ? e.format : $root.synth_data.Mask.MaskFormat[e.format] : e.format), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.Mask";
    }, o.MaskFormat = function() {
      const i = {}, e = Object.create(i);
      return e[i[0] = "GENERIC_STRING"] = 0, e[i[1] = "GENERIC_NUMBER"] = 1, e[i[2] = "NAME"] = 2, e[i[3] = "ADDRESS"] = 3, e[i[4] = "POSTCODE"] = 4, e[i[5] = "PHONE_NUMBER"] = 5, e[i[6] = "SOCIAL_SECURITY_NUMBER"] = 6, e[i[7] = "EMAIL"] = 7, e[i[8] = "DATE"] = 8, e[i[9] = "TIMESTAMP"] = 9, e[i[10] = "IBAN"] = 10, e;
    }(), o;
  }(), c.Column = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.index = 0, o.prototype.type = null, o.prototype.mask = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.index != null && Object.hasOwnProperty.call(e, "index") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.index), e.type != null && Object.hasOwnProperty.call(e, "type") && $root.compute_sql.ColumnType.encode(e.type, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.mask != null && Object.hasOwnProperty.call(e, "mask") && $root.synth_data.Mask.encode(e.mask, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.synth_data.Column();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.index = e.int32();
            break;
          }
          case 2: {
            r.type = $root.compute_sql.ColumnType.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.mask = $root.synth_data.Mask.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.index != null && e.hasOwnProperty("index") && !$util.isInteger(e.index))
        return "index: integer expected";
      if (e.type != null && e.hasOwnProperty("type")) {
        let t = $root.compute_sql.ColumnType.verify(e.type);
        if (t)
          return "type." + t;
      }
      if (e.mask != null && e.hasOwnProperty("mask")) {
        let t = $root.synth_data.Mask.verify(e.mask);
        if (t)
          return "mask." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.synth_data.Column)
        return e;
      let t = new $root.synth_data.Column();
      if (e.index != null && (t.index = e.index | 0), e.type != null) {
        if (typeof e.type != "object")
          throw TypeError(".synth_data.Column.type: object expected");
        t.type = $root.compute_sql.ColumnType.fromObject(e.type);
      }
      if (e.mask != null) {
        if (typeof e.mask != "object")
          throw TypeError(".synth_data.Column.mask: object expected");
        t.mask = $root.synth_data.Mask.fromObject(e.mask);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.index = 0, n.type = null, n.mask = null), e.index != null && e.hasOwnProperty("index") && (n.index = e.index), e.type != null && e.hasOwnProperty("type") && (n.type = $root.compute_sql.ColumnType.toObject(e.type, t)), e.mask != null && e.hasOwnProperty("mask") && (n.mask = $root.synth_data.Mask.toObject(e.mask, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.Column";
    }, o;
  }(), c;
})(), adform_dsp = $root.adform_dsp = (() => {
  const c = {};
  return c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.adform_dsp.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.adform_dsp.SingleFile)
        return e;
      let t = new $root.adform_dsp.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.adform_dsp.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.adform_dsp.RawFile ? e : new $root.adform_dsp.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.adform_dsp.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.adform_dsp.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.adform_dsp.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.adform_dsp.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.adform_dsp.ZipFile)
        return t;
      let n = new $root.adform_dsp.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".adform_dsp.ZipFile.singleFile: object expected");
        n.singleFile = $root.adform_dsp.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.adform_dsp.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/adform_dsp.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.adform_dsp.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.adform_dsp.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.adform_dsp.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.adform_dsp.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.adform_dsp.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.adform_dsp.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.adform_dsp.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.adform_dsp.SinkInput)
        return t;
      let n = new $root.adform_dsp.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".adform_dsp.SinkInput.raw: object expected");
        n.raw = $root.adform_dsp.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".adform_dsp.SinkInput.zip: object expected");
        n.zip = $root.adform_dsp.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.adform_dsp.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.adform_dsp.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/adform_dsp.SinkInput";
    }, o;
  }(), c.AdformDspWorkerConfiguration = function() {
    function o(i) {
      if (this.segmentOwners = [], i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.prototype.segmentOwners = $util.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      if (t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.adform_dsp.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.segmentOwners != null && e.segmentOwners.length)
        for (let n = 0; n < e.segmentOwners.length; ++n)
          t.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.segmentOwners[n]);
      return t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.adform_dsp.AdformDspWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.adform_dsp.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.segmentOwners && r.segmentOwners.length || (r.segmentOwners = []), r.segmentOwners.push(e.string());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.adform_dsp.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      if (e.segmentOwners != null && e.hasOwnProperty("segmentOwners")) {
        if (!Array.isArray(e.segmentOwners))
          return "segmentOwners: array expected";
        for (let t = 0; t < e.segmentOwners.length; ++t)
          if (!$util.isString(e.segmentOwners[t]))
            return "segmentOwners: string[] expected";
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.adform_dsp.AdformDspWorkerConfiguration)
        return e;
      let t = new $root.adform_dsp.AdformDspWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".adform_dsp.AdformDspWorkerConfiguration.input: object expected");
        t.input = $root.adform_dsp.SinkInput.fromObject(e.input);
      }
      if (e.segmentOwners) {
        if (!Array.isArray(e.segmentOwners))
          throw TypeError(".adform_dsp.AdformDspWorkerConfiguration.segmentOwners: array expected");
        t.segmentOwners = [];
        for (let n = 0; n < e.segmentOwners.length; ++n)
          t.segmentOwners[n] = String(e.segmentOwners[n]);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.segmentOwners = []), t.defaults && (n.input = null), e.input != null && e.hasOwnProperty("input") && (n.input = $root.adform_dsp.SinkInput.toObject(e.input, t)), e.segmentOwners && e.segmentOwners.length) {
        n.segmentOwners = [];
        for (let r = 0; r < e.segmentOwners.length; ++r)
          n.segmentOwners[r] = e.segmentOwners[r];
      }
      return n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.AdformDspWorkerConfiguration";
    }, o;
  }(), c;
})(), microsoft_dsp = $root.microsoft_dsp = (() => {
  const c = {};
  return c.SingleFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.microsoft_dsp.SingleFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.SingleFile)
        return e;
      let t = new $root.microsoft_dsp.SingleFile();
      return e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = ""), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.SingleFile";
    }, o;
  }(), c.RawFile = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.microsoft_dsp.RawFile();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, o.fromObject = function(e) {
      return e instanceof $root.microsoft_dsp.RawFile ? e : new $root.microsoft_dsp.RawFile();
    }, o.toObject = function() {
      return {};
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.RawFile";
    }, o;
  }(), c.ZipFile = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.singleFile = null;
    let i;
    return Object.defineProperty(o.prototype, "selection", {
      get: $util.oneOfGetter(i = ["singleFile"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.singleFile != null && Object.hasOwnProperty.call(t, "singleFile") && $root.microsoft_dsp.SingleFile.encode(t.singleFile, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.microsoft_dsp.ZipFile();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.singleFile = $root.microsoft_dsp.SingleFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.singleFile != null && t.hasOwnProperty("singleFile")) {
        let n = $root.microsoft_dsp.SingleFile.verify(t.singleFile);
        if (n)
          return "singleFile." + n;
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.microsoft_dsp.ZipFile)
        return t;
      let n = new $root.microsoft_dsp.ZipFile();
      if (t.singleFile != null) {
        if (typeof t.singleFile != "object")
          throw TypeError(".microsoft_dsp.ZipFile.singleFile: object expected");
        n.singleFile = $root.microsoft_dsp.SingleFile.fromObject(t.singleFile);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return t.singleFile != null && t.hasOwnProperty("singleFile") && (r.singleFile = $root.microsoft_dsp.SingleFile.toObject(t.singleFile, n), n.oneofs && (r.selection = "singleFile")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/microsoft_dsp.ZipFile";
    }, o;
  }(), c.SinkInput = function() {
    function o(e) {
      if (e)
        for (let t = Object.keys(e), n = 0; n < t.length; ++n)
          e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    o.prototype.dependency = "", o.prototype.name = "", o.prototype.raw = null, o.prototype.zip = null;
    let i;
    return Object.defineProperty(o.prototype, "file", {
      get: $util.oneOfGetter(i = ["raw", "zip"]),
      set: $util.oneOfSetter(i)
    }), o.create = function(t) {
      return new o(t);
    }, o.encode = function(t, n) {
      return n || (n = $Writer.create()), t.dependency != null && Object.hasOwnProperty.call(t, "dependency") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.dependency), t.name != null && Object.hasOwnProperty.call(t, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.name), t.raw != null && Object.hasOwnProperty.call(t, "raw") && $root.microsoft_dsp.RawFile.encode(t.raw, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t.zip != null && Object.hasOwnProperty.call(t, "zip") && $root.microsoft_dsp.ZipFile.encode(t.zip, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, o.encodeDelimited = function(t, n) {
      return this.encode(t, n).ldelim();
    }, o.decode = function(t, n) {
      t instanceof $Reader || (t = $Reader.create(t));
      let r = n === void 0 ? t.len : t.pos + n, u = new $root.microsoft_dsp.SinkInput();
      for (; t.pos < r; ) {
        let l = t.uint32();
        switch (l >>> 3) {
          case 1: {
            u.dependency = t.string();
            break;
          }
          case 2: {
            u.name = t.string();
            break;
          }
          case 3: {
            u.raw = $root.microsoft_dsp.RawFile.decode(t, t.uint32());
            break;
          }
          case 4: {
            u.zip = $root.microsoft_dsp.ZipFile.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(l & 7);
            break;
        }
      }
      return u;
    }, o.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, o.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      let n = {};
      if (t.dependency != null && t.hasOwnProperty("dependency") && !$util.isString(t.dependency))
        return "dependency: string expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.raw != null && t.hasOwnProperty("raw")) {
        n.file = 1;
        {
          let r = $root.microsoft_dsp.RawFile.verify(t.raw);
          if (r)
            return "raw." + r;
        }
      }
      if (t.zip != null && t.hasOwnProperty("zip")) {
        if (n.file === 1)
          return "file: multiple values";
        n.file = 1;
        {
          let r = $root.microsoft_dsp.ZipFile.verify(t.zip);
          if (r)
            return "zip." + r;
        }
      }
      return null;
    }, o.fromObject = function(t) {
      if (t instanceof $root.microsoft_dsp.SinkInput)
        return t;
      let n = new $root.microsoft_dsp.SinkInput();
      if (t.dependency != null && (n.dependency = String(t.dependency)), t.name != null && (n.name = String(t.name)), t.raw != null) {
        if (typeof t.raw != "object")
          throw TypeError(".microsoft_dsp.SinkInput.raw: object expected");
        n.raw = $root.microsoft_dsp.RawFile.fromObject(t.raw);
      }
      if (t.zip != null) {
        if (typeof t.zip != "object")
          throw TypeError(".microsoft_dsp.SinkInput.zip: object expected");
        n.zip = $root.microsoft_dsp.ZipFile.fromObject(t.zip);
      }
      return n;
    }, o.toObject = function(t, n) {
      n || (n = {});
      let r = {};
      return n.defaults && (r.dependency = "", r.name = ""), t.dependency != null && t.hasOwnProperty("dependency") && (r.dependency = t.dependency), t.name != null && t.hasOwnProperty("name") && (r.name = t.name), t.raw != null && t.hasOwnProperty("raw") && (r.raw = $root.microsoft_dsp.RawFile.toObject(t.raw, n), n.oneofs && (r.file = "raw")), t.zip != null && t.hasOwnProperty("zip") && (r.zip = $root.microsoft_dsp.ZipFile.toObject(t.zip, n), n.oneofs && (r.file = "zip")), r;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/microsoft_dsp.SinkInput";
    }, o;
  }(), c.MemberInfo = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.id = 0, o.prototype.name = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.microsoft_dsp.MemberInfo();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.id = e.int32();
            break;
          }
          case 2: {
            r.name = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isInteger(e.id) ? "id: integer expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.MemberInfo)
        return e;
      let t = new $root.microsoft_dsp.MemberInfo();
      return e.id != null && (t.id = e.id | 0), e.name != null && (t.name = String(e.name)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.id = 0, n.name = ""), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.MemberInfo";
    }, o;
  }(), c.SegmentInfo = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.shortName = "", o.prototype.code = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.shortName != null && Object.hasOwnProperty.call(e, "shortName") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.shortName), e.code != null && Object.hasOwnProperty.call(e, "code") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.code), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.microsoft_dsp.SegmentInfo();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.shortName = e.string();
            break;
          }
          case 2: {
            r.code = e.string();
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.shortName != null && e.hasOwnProperty("shortName") && !$util.isString(e.shortName) ? "shortName: string expected" : e.code != null && e.hasOwnProperty("code") && !$util.isString(e.code) ? "code: string expected" : null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.SegmentInfo)
        return e;
      let t = new $root.microsoft_dsp.SegmentInfo();
      return e.shortName != null && (t.shortName = String(e.shortName)), e.code != null && (t.code = String(e.code)), t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.shortName = "", n.code = ""), e.shortName != null && e.hasOwnProperty("shortName") && (n.shortName = e.shortName), e.code != null && e.hasOwnProperty("code") && (n.code = e.code), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.SegmentInfo";
    }, o;
  }(), c.MicrosoftDspWorkerConfiguration = function() {
    function o(i) {
      if (i)
        for (let e = Object.keys(i), t = 0; t < e.length; ++t)
          i[e[t]] != null && (this[e[t]] = i[e[t]]);
    }
    return o.prototype.input = null, o.prototype.memberInfo = null, o.prototype.segmentInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, t) {
      return t || (t = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.microsoft_dsp.SinkInput.encode(e.input, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.memberInfo != null && Object.hasOwnProperty.call(e, "memberInfo") && $root.microsoft_dsp.MemberInfo.encode(e.memberInfo, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.segmentInfo != null && Object.hasOwnProperty.call(e, "segmentInfo") && $root.microsoft_dsp.SegmentInfo.encode(e.segmentInfo, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), t;
    }, o.encodeDelimited = function(e, t) {
      return this.encode(e, t).ldelim();
    }, o.decode = function(e, t) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, r = new $root.microsoft_dsp.MicrosoftDspWorkerConfiguration();
      for (; e.pos < n; ) {
        let u = e.uint32();
        switch (u >>> 3) {
          case 1: {
            r.input = $root.microsoft_dsp.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            r.memberInfo = $root.microsoft_dsp.MemberInfo.decode(e, e.uint32());
            break;
          }
          case 3: {
            r.segmentInfo = $root.microsoft_dsp.SegmentInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(u & 7);
            break;
        }
      }
      return r;
    }, o.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, o.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let t = $root.microsoft_dsp.SinkInput.verify(e.input);
        if (t)
          return "input." + t;
      }
      if (e.memberInfo != null && e.hasOwnProperty("memberInfo")) {
        let t = $root.microsoft_dsp.MemberInfo.verify(e.memberInfo);
        if (t)
          return "memberInfo." + t;
      }
      if (e.segmentInfo != null && e.hasOwnProperty("segmentInfo")) {
        let t = $root.microsoft_dsp.SegmentInfo.verify(e.segmentInfo);
        if (t)
          return "segmentInfo." + t;
      }
      return null;
    }, o.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.MicrosoftDspWorkerConfiguration)
        return e;
      let t = new $root.microsoft_dsp.MicrosoftDspWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.input: object expected");
        t.input = $root.microsoft_dsp.SinkInput.fromObject(e.input);
      }
      if (e.memberInfo != null) {
        if (typeof e.memberInfo != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.memberInfo: object expected");
        t.memberInfo = $root.microsoft_dsp.MemberInfo.fromObject(e.memberInfo);
      }
      if (e.segmentInfo != null) {
        if (typeof e.segmentInfo != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.segmentInfo: object expected");
        t.segmentInfo = $root.microsoft_dsp.SegmentInfo.fromObject(e.segmentInfo);
      }
      return t;
    }, o.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.input = null, n.memberInfo = null, n.segmentInfo = null), e.input != null && e.hasOwnProperty("input") && (n.input = $root.microsoft_dsp.SinkInput.toObject(e.input, t)), e.memberInfo != null && e.hasOwnProperty("memberInfo") && (n.memberInfo = $root.microsoft_dsp.MemberInfo.toObject(e.memberInfo, t)), e.segmentInfo != null && e.hasOwnProperty("segmentInfo") && (n.segmentInfo = $root.microsoft_dsp.SegmentInfo.toObject(e.segmentInfo, t)), n;
    }, o.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.MicrosoftDspWorkerConfiguration";
    }, o;
  }(), c;
})(), index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  adform_dsp,
  attestation,
  azure_blob_storage,
  compute_container,
  compute_post,
  compute_s3_sink,
  compute_sql,
  data_room,
  data_source_s3,
  data_source_snowflake,
  dataset_sink,
  default: $root,
  delta_enclave_api,
  gcg,
  google_ad_manager,
  google_dv_360_sink,
  identity_endorsement,
  integrity_store_api,
  meta_sink,
  metering,
  microsoft_dsp,
  permutive,
  release_policy_api,
  salesforce,
  secret_store_api,
  synth_data
}, Symbol.toStringTag, { value: "Module" }));
export {
  data_room as a,
  attestation as b,
  minimal as c,
  delta_enclave_api as d,
  compute_container as e,
  compute_post as f,
  gcg as g,
  compute_s3_sink as h,
  identity_endorsement as i,
  compute_sql as j,
  adform_dsp as k,
  azure_blob_storage as l,
  metering as m,
  data_source_s3 as n,
  data_source_snowflake as o,
  dataset_sink as p,
  google_ad_manager as q,
  google_dv_360_sink as r,
  secret_store_api as s,
  meta_sink as t,
  microsoft_dsp as u,
  permutive as v,
  salesforce as w,
  synth_data as x,
  index as y
};
//# sourceMappingURL=index-Dvb-FM3N.js.map
